/**
 * Actively wait for an element present and displayed up to specTimeoutMs
 * ignoring useless webdriver errors like StaleElementError.
 *
 * Usage:
 * Add `require('./waitReady.js');` in your onPrepare block or file.
 *
 * @example
 * expect($('.some-html-class').waitReady()).toBeTruthy();
 */
'use strict';

// Config
var specTimeoutMs = 15000; // 15 seconds

/**
 * Current workaround until https://github.com/angular/protractor/issues/1102
 * @type {Function}
 */
var ElementFinder = $('').constructor;

ElementFinder.prototype.waitReady = function(opt_optStr) {
	var self = this;
	var driverWaitIterations = 0;
	var lastWebdriverError;

	function _throwError() {
		throw new Error(
			"Expected '" +
				self.locator().toString() +
				"' to be present and visible. " +
				'After ' +
				driverWaitIterations +
				' driverWaitIterations. ' +
				'Last webdriver error: ' +
				lastWebdriverError
		);
	}

	function _isPresentError(err) {
		lastWebdriverError = err != null ? err.toString() : err;
		return false;
	}

	return browser.driver
		.wait(function() {
			driverWaitIterations++;
			if (opt_optStr === 'withRefresh') {
				// Refresh page after more than some retries
				if (driverWaitIterations > 7) {
					_refreshPage();
				}
			}
			return self.isPresent().then(function(present) {
				if (present) {
					return self.isDisplayed().then(function(visible) {
						lastWebdriverError = 'visible:' + visible;
						return visible;
					}, _isPresentError);
				} else {
					lastWebdriverError = 'present:' + present;
					return false;
				}
			}, _isPresentError);
		}, specTimeoutMs)
		.then(
			function(waitResult) {
				if (!waitResult) {
					_throwError();
				}
				return waitResult;
			},
			function(err) {
				_isPresentError(err);
				_throwError();
				return false;
			}
		);
};

// Helpers
function _refreshPage() {
	// Swallow useless refresh page webdriver errors
	browser
		.navigate()
		.refresh()
		.then(
			function() {},
			function(e) {}
		);
}

'use strict';

(function() {
	angular.module('new-web', [
		'ngAnimate',
		'ngCookies',
		'ngDraggable',
		'ngTouch',
		'ui.router',
		'ui.bootstrap',
		/*'ui.footable',*/ 'angular.bind.notifier',
		'toastr',
	]);
})();

'use strict';

angular
	.module('new-web')
	.controller('MainController', function(
		$rootScope,
		$scope,
		CoreApiService,
		SessionService,
		PlansApiService,
		RolesApiService,
		CustomsApiService,
		$log,
		$timeout,
		$state,
		$location,
		MenusApiService,
		UserApiService,
		$sce,
		$q,
		PeopleApiService,
		CustomersApiService,
		UtilsService,
		toastr
	) {
		var vm = this;

		var _path = window.location.pathname.split('/')[1] || '';
		var baseHref = ($rootScope.baseHref = '/' + (_path.length ? _path + '/' : ''));

		vm.state = function() {
			return $state;
		};

		vm.relativePath = function() {
			return $location.path().replace(/\/\?(\w+\=[\S\d]+)*/, '');
		}; // .replace(baseHref.substring(1), '') ???

		var fetchMenus = function() {
			$timeout(function() {
				$rootScope.fetchMenus();
			});
		};

		var user = SessionService.getSession();

		var refreshMenu = function() {
			user = SessionService.getSession();

			if (user) {
				fetchMenus();
			}
		};

		vm.customs = {};

		var avatar_images = {};

		var refreshUser = function() {
			user = SessionService.getSession();

			if (user) {
				$timeout(function() {
					vm.show_customers = true;
				});

				var us = SessionService.getCustomer();

				CustomersApiService.getCustomer({
					id: user.effective_customer || user.customer,
				}).then(function(response) {
					$timeout(function() {
						vm.customerName = response.data.name;
						if (!us) {
							vm.mainCustomerName = vm.customerName;
						}
						vm.customerAvatar =
							avatar_images[vm.customerName] ||
							(avatar_images[vm.customerName] = UtilsService.avatarImage(vm.customerName, 50, 2));
						$rootScope.$broadcast('$$rebind::allCustomers');
					});
				});

				us &&
					CustomersApiService.getCustomer({
						id: user.login_customer,
					}).then(function(response) {
						$timeout(function() {
							vm.mainCustomerName = response.data.name;
							$rootScope.$broadcast('$$rebind::allCustomers');
						});
					});

				RolesApiService.getAccessForRole({
					role: user.role,
					privilege: 'commerce',
				}).then(function(response) {
					$timeout(function() {
						vm.show_customers = Number(response.data || 0) == 1;
					});
				});

				$timeout(function() {
					vm.customers = SessionService.getDisplayedCustomers();
					// $log.debug('customers: ', vm.customers);
					vm.customer = angular.copy(us);
					vm.authUserName = user.login_username;
					//vm.currentUser = vm.customer ? (vm.customer.name ? ('[' + vm.customer.name + ']') : vm.customer.username) : user.auth_username;
					$rootScope.$broadcast('$$rebind::allCustomers');
					// $log.debug(user, vm.customer);
				});
			}
		};

		var lang = $rootScope.languageString;

		vm.relative_path = vm.relativePath();

		$rootScope.$on('$stateChangeSuccess', function() {
			$timeout(function() {
				vm.relative_path = vm.relativePath();
				$rootScope.$broadcast('$$rebind::relative_path');
			});
		});

		var refreshFields = function() {
			user = SessionService.getSession();

			$timeout(function() {
				vm.current_plan = user ? user.effective_plan || user.plan : '';
				vm.show_help_hint = !!vm.page_help_url;
				vm.show_plan_customs_link = user && !vm.customer && vm.allow_system;

				vm.home_body = vm.customs['home_body'] ? vm.customs['home_body'].value : '';

				vm.home_title = vm.customs['home_title'] ? vm.customs['home_title'].value : lang('home_title_default');

				vm.footer_text = vm.customs['footer_text'] ? vm.customs['footer_text'].value : lang('footer_text_default');
				$rootScope.footer_text = vm.footer_text;

				vm.footer_url = vm.customs['footer_url'] ? vm.customs['footer_url'].value : lang('footer_url_default');
				$rootScope.footer_url = vm.footer_url;

				vm.product_name = vm.customs['product_name'] ? vm.customs['product_name'].value : lang('product_name_default');

				$rootScope.product_name = vm.product_name;
				if (document.title.lastIndexOf('::') > -1) {
					// update page title
					document.title = document.title.substring(0, document.title.lastIndexOf('::') + 2) + ' ' + vm.product_name;
				} // $rootScope.title!

				// console.log('customs: ', vm.customs);
				vm.login_bg_image_url = vm.customs['login_bg_image_url']
					? vm.customs['login_bg_image_url'].value
					: '/assets/images/default/login_bg.jpg';

				vm.title_image_link = vm.customs['title_image_link']
					? vm.customs['title_image_link'].value
					: location.protocol +
					  '//' +
					  location.hostname +
					  (location.port && Number(location.port) != 80 ? ':' + location.port : '') +
					  (baseHref.length > 1 ? baseHref : '');

				var title_image_url = vm.customs['title_image_url']
					? vm.customs['title_image_url'].value
					: 'assets/images/enswitch.svg';
				if (title_image_url == lang('title_image_url_default')) {
					title_image_url = 'assets/images/enswitch.svg';
				} else {
					title_image_url = title_image_url;
				}

				var extension = '';
				if (/\.[^.]*$/.test(title_image_url)) {
					extension = title_image_url.match(/\.([^.]*)$/)[1] || '';
					extension = extension.replace(/\?.*?$/, '');
					if (extension == 'svg') {
						extension = '';
					}
				}

				vm.title_image_url_default_extension = extension;

				vm.title_image_url = title_image_url;

				var icon_url = vm.customs['icon_url'] ? vm.customs['icon_url'].value : '';
				vm.icon_url =
					icon_url ||
					location.protocol +
						'//' +
						location.hostname +
						(location.port && Number(location.port) != 80 ? ':' + location.port : '') +
						'/favicon.ico';

				/*Change favicon if needed*/
				(function() {
					var head = document.getElementsByTagName('head')[0];

					if (head) {
						var linkNodes = head.getElementsByTagName('link');

						angular.forEach(angular.element(linkNodes), function(node) {
							if (node.type == 'image/x-icon' && node.rel == 'shortcut icon') {
								angular.element(node).remove();
							}
						});

						var link = document.createElement('link');
						link.type = 'image/x-icon';
						link.rel = 'shortcut icon';
						link.href = vm.icon_url;

						head.appendChild(link);
						//$log.debug('added favicon');
					}
				})();

				var page_help_url = vm.customs['page_help_url'] ? vm.customs['page_help_url'].value : '';

				// page_help_url = 'localhost:3000/index/'; // debug
				// page_help_url = 'https://integrics.com/enswitch/guides/3.13/'; // debug
				if (page_help_url) {
					page_help_url = page_help_url.replace(/\/$/, ''); // remove trailing slash (if exists)
				}

				vm.page_help_url = page_help_url;

				vm.local_css_url = vm.customs['local_css_url'] ? vm.customs['local_css_url'].value : '';

				var head = document.getElementsByTagName('head')[0];

				var linkNodes = head.getElementsByTagName('link');

				var customCSSSame = false;

				angular.forEach(angular.element(linkNodes), function(node) {
					// remove other custom stylesheet(s)
					var fullUrl =
						location.protocol +
						'//' +
						location.hostname +
						(location.port && Number(location.port) != 80 ? ':' + location.port : '');

					var prodCSSFilesRegex = new RegExp(
						'^' +
							fullUrl
								.replace(/\//g, '\\/')
								.replace(/\:/g, '\\:')
								.replace(/\./g, '\\.') +
							'[\\/\\w+?]*?' +
							'\\/styles\\/(app|vendor)\\.css(\\?v\\=\\d+)?$',
						'i'
					);
					//console.log(prodCSSFilesRegex);

					var filesSame =
						vm.local_css_url &&
						node.href.replace(fullUrl, '').replace(/^\//, '') ===
							vm.local_css_url.replace(fullUrl, '').replace(/^\//, '');
					customCSSSame = customCSSSame || filesSame;
					if (
						!filesSame &&
						node.rel == 'stylesheet' &&
						node.href.indexOf(fullUrl + '/bower_components/') < 0 &&
						node.href.indexOf(fullUrl + '/app/index.css') < 0 &&
						!prodCSSFilesRegex.test(node.href)
					) {
						// $log.debug('removing stylesheet: ' + node.href);
						angular.element(node).remove();
					}
				});

				if (vm.local_css_url && !customCSSSame) {
					var link = document.createElement('link');
					link.rel = 'stylesheet';
					link.href = vm.local_css_url;

					head.appendChild(link);

					var img = document.createElement('img');
					document.body.appendChild(img);

					img.onerror = img.onload = function() {
						img.onerror = img.onload = null;
						document.body.removeChild(img);
						img = null;
						$timeout(function() {
							$rootScope.contentHidden = false;
							$rootScope.customCSSPromise.resolve();
						});
					};

					img.src = vm.local_css_url;

					head = null;
					linkNodes = null;
				} else {
					$timeout(function() {
						$rootScope.contentHidden = false;
					});
					$rootScope.customCSSPromise.resolve();
				}

				$rootScope.$broadcast('$$rebind::plan_customs');
			});
		};

		var refreshPlan = function() {
			// console.log('refreshPlan');

			$timeout(function() {
				$rootScope.contentHidden = true;
			});

			if ($rootScope.customCSSPromise) {
				$rootScope.customCSSPromise.resolve();
			}

			$rootScope.customCSSPromise = $q.defer();

			user = SessionService.getSession();

			var planId = user ? user.effective_plan || user.plan : $rootScope.custom_display_plan || 1;

			var requests = {};

			var currentLanguage = $rootScope.currentLanguage || $rootScope.default_language || 'en';

			requests['home_body'] = CustomsApiService.get({
				name: 'home_body',
				plan: planId,
				language: currentLanguage,
				value: 1,
			});
			requests['home_title'] = CustomsApiService.get({
				name: 'home_title',
				plan: planId,
				language: currentLanguage,
				value: 1,
			});
			requests['footer_text'] = CustomsApiService.get({
				name: 'footer_text',
				plan: planId,
				language: currentLanguage,
				value: 1,
			});
			requests['footer_url'] = CustomsApiService.get({
				name: 'footer_url',
				plan: planId,
				language: currentLanguage,
				value: 1,
			});
			requests['login_bg_image_url'] = CustomsApiService.get({
				name: 'login_bg_image_url',
				plan: planId,
				language: currentLanguage,
				value: 1,
			});
			requests['product_name'] = CustomsApiService.get({
				name: 'product_name',
				plan: planId,
				language: currentLanguage,
				value: 1,
			});
			requests['title_image_link'] = CustomsApiService.get({
				name: 'title_image_link',
				plan: planId,
				language: currentLanguage,
				value: 1,
			});
			requests['title_image_url'] = CustomsApiService.get({
				name: 'title_image_url',
				plan: planId,
				language: currentLanguage,
				value: 1,
			});
			requests['icon_url'] = CustomsApiService.get({
				name: 'icon_url',
				plan: planId,
				language: currentLanguage,
				value: 1,
			});
			requests['page_help_url'] = CustomsApiService.get({
				name: 'page_help_url',
				plan: planId,
				language: currentLanguage,
				value: 1,
			});
			requests['local_css_url'] = CustomsApiService.get({
				name: 'local_css_url',
				plan: planId,
				language: currentLanguage,
				value: 1,
			});

			vm.customs = vm.customs || {};

			for (var key in vm.customs) {
				vm.customs[key] = {
					value: '',
				};
			}

			return $q.all(requests).then(
				function(responses) {
					for (var key in responses) {
						vm.customs[key] = responses[key].data;
					}

					refreshFields();
				},
				function(error) {
					CustomsApiService.defaultErrorHandler(error);
					refreshFields();
				}
			);
		};

		var checkCustomers = function() {
			if (!SessionService.getSession()) {
				return;
			}

			var customers = SessionService.getDisplayedCustomers() || [];

			customers.forEach(function(c) {
				var method = c.name ? CustomersApiService.getCustomer : PeopleApiService.get;

				method({
					id: c.id,
					check: 1,
				}).then(function(response) {
					if (!Number(response.data.found)) {
						$timeout(function() {
							SessionService.removeCustomer(c);
						});
					}
				});
			});
		};

		vm.refresh = function(firstLoad) {
			if ($rootScope.offline) {
				return;
			}

			user = SessionService.getSession();

			if (!user) {
				return;
			}

			$rootScope.resourcesLoaded.then(function() {
				// console.log('resourcesLoaded!', firstLoad);
				firstLoad && checkCustomers();

				user = SessionService.getSession();
				user &&
					RolesApiService.getAccessForRole({
						role: user.effective_role || user.role,
						privilege: 'system',
					}).then(function(response) {
						$timeout(function() {
							vm.allow_system = !!Number(response.data);

							refreshUser();

							if (!firstLoad) {
								refreshMenu();
							}
							refreshPlan();
						});
					});
			});
		};

		vm.show_customers = false;

		$scope.$on('EffectivePlanUpdated', vm.refresh);

		$scope.$on('WillLogOut', function() {
			user = null;
			$timeout(function() {
				vm.customer = null;
			});
			refreshPlan();
		});

		$scope.$on('RefreshCustomersDropdown', refreshUser);

		vm.switchCustomer = function(customer) {
			// $log.debug('Customer: ', customer);

			if (
				(!vm.customer && !customer) ||
				(vm.customer && customer && vm.customer.id == customer.id && vm.customer.name === customer.name)
			) {
				return;
			}

			var user = SessionService.getSession();
			var params = {};

			if (!customer) {
				params.username = user.login_username;
			} else if (customer.name) {
				params.username = '[' + customer.name + ']';
			} else {
				if (customer.id == user.id) {
					params.username = user.auth_username;
					customer = null;
				} else {
					params.id = customer.id;
				}
			}

			params.auth_username = user.auth_username;
			params.auth_password = user.auth_password;

			//$log.debug(params);
			return UserApiService.switchUser(params).then(function(response) {
				// $log.debug(response.data, customer);
				SessionService.setSession(response.data);
				SessionService.setCustomer(customer);

				$rootScope.$broadcast('AuthSuccess', {
					switched: true,
					showWarning: true,
				});

				return response;
			}, UserApiService.defaultErrorHandler);
		};

		var channel = null;
		try {
			channel = new BroadcastChannel('user_switched_notification');
		} catch (error) {
			console.error(error);
		}

		$rootScope.$on('AuthSuccess', function(event, params) {
			if (params && params.showWarning && channel) {
				var latestCustomers = SessionService.getLatestCustomers();
				var latestUsers = SessionService.getLatestUsers();
				channel.postMessage({ latestUsers: latestUsers, latestCustomers: latestCustomers });
			}
		});

		if (channel) {
			channel.onmessage = function(event) {
				if (!event.data.latestUsers || !event.data.latestCustomers) {
					return;
				}
				$rootScope.allUsers = event.data.latestUsers;
				$rootScope.$broadcast('$$rebind::allUsers');
				$rootScope.allCustomers = event.data.latestCustomers;
				$rootScope.$broadcast('$$rebind::allCustomers');
				refreshUser();
				toastr.clear();
				toastr.options = {
					closeButton: true,
					debug: false,
					newestOnTop: false,
					progressBar: false,
					positionClass: 'toast-top-left',
					preventDuplicates: false,
					onclick: null,
					showDuration: '300',
					hideDuration: '1000',
					timeOut: 0, // the timeout before the toasts disappear
					extendedTimeOut: 1000, // the timeout after you hover a toast
					showEasing: 'swing',
					hideEasing: 'linear',
					showMethod: 'fadeIn',
					hideMethod: 'fadeOut',
				};
				toastr.warning(lang('customer_switched_please_refresh'));
			};
		}

		$scope.$on('EnswitchCustomFieldChanged', function(event, obj) {
			if (obj && obj.name) {
				if (
					!vm.customs[obj.name] ||
					Number(obj.min_level || 0) == 1 ||
					Number(vm.customs[obj.name].min_level || 2) >= Number(obj.min_level || 0)
				) {
					$timeout(function() {
						vm.customs[obj.name] = obj;
						refreshFields();
					});
				}
			} else {
				refreshPlan();
			}
		});

		vm.parseHTML = function(html) {
			return $sce.trustAsHtml((html || '').replace(/\r\n|\r|\n/g, '<br />'));
		};

		if (!user) {
			$rootScope.resourcesLoaded.then(function() {
				refreshPlan();
			});
		}

		$rootScope.$on('languageChanged', function() {
			$state.go(
				$state.current,
				{},
				{
					reload: true,
					inherit: true,
				}
			); // alternatives: http://stackoverflow.com/a/23609343/1630623
			// add stateParams (or inherit: true)

			vm.refresh();
		});

		vm.refresh(true);
	});

'use strict';

angular
	.module('new-web')

	.factory('UtilsService', function(
		SessionService,
		$filter,
		CoreApiService,
		RolesApiService,
		NotesApiService,
		$q,
		$rootScope,
		$timeout,
		variables,
		$http,
		SwalService,
		$templateCache,
		$uibModal,
		FileDownloadService,
		$state,
		$stateParams
	) {
		var lang = angular.identity;
		var swal = angular.identity;

		$timeout(function() {
			lang = $rootScope.languageString;
			swal = SwalService.popup;
		});

		var user;
		var customer;
		var timezone;
		var offset;
		var country;
		var date_format;
		var time_format;

		var seconds_in_day = 60 * 60 * 24;

		var parseDate = function(date) {
			var _date;

			if (date instanceof Date) {
				_date = date;
			} else if (typeof date == 'number') {
				_date = new Date(date * 1000); // unix timestamp!
			} else if (!isNaN(Number(date))) {
				_date = new Date(Number(date) * 1000);
			} else
				try {
					_date = new Date(date);
				} catch (e) {}

			return _date || new Date();
		};

		var zone;
		var getOffset = function(date) {
			var _date = parseDate(date);
			if (_date instanceof Date) {
				return zone.utcOffset(_date) - _date.getTimezoneOffset();
			}
			return offset;
		};

		var adjustZoneAndFormats = function() {
			user = SessionService.getSession();
			customer = SessionService.getCustomer();

			timezone = (customer || user || {}).timezone || moment.tz.guess();

			var now = new Date();
			zone = moment.tz.zone(timezone);
			offset = zone.utcOffset(now) - now.getTimezoneOffset();

			country = (customer || {}).country || (user || {}).country || ''; // US?

			var default_date_format = 'DD/MM/YYYY';

			if (country.toUpperCase() == 'US') {
				default_date_format = 'MM/DD/YYYY';
			}

			date_format = (customer || {}).date_format || (user || {}).date_format || default_date_format;

			var default_time_format = '24';

			if (country.toUpperCase() == 'US') {
				default_time_format = '12';
			}

			time_format =
				((customer || {}).time_format || (user || {}).time_format || default_time_format) == '12'
					? 'hh:mm:ssa'
					: 'HH:mm:ss';
		};

		adjustZoneAndFormats();

		$rootScope.$on('AuthSuccess', adjustZoneAndFormats);
		$rootScope.$on('SessionInfoUpdated', adjustZoneAndFormats);
		$rootScope.$on('LoggedOut', adjustZoneAndFormats);

		var scriptLoaded = {};

		var loadScript = function(url, disableVersionTimestamp) {
			var deferred = $q.defer();

			if (scriptLoaded[url]) {
				$timeout(function() {
					deferred.resolve();
				});
				return deferred.promise;
			}

			var el = document.createElement('script');

			var loaded = false;

			el.onload = el.onreadystatechange = function(e) {
				if ((el.readyState && el.readyState !== 'complete' && el.readyState !== 'loaded') || loaded) {
					return false;
				}

				el.onload = el.onreadystatechange = null;
				loaded = true;
				// done!

				scriptLoaded[url] = true;

				$timeout(function() {
					el = null;
					deferred.resolve();
				});
			};

			el.onerror = function(error) {
				// console.log('onerror');
				el = null;
				deferred.reject(error);
			};

			el.async = true;
			el.src = url + (disableVersionTimestamp ? '' : '?v=' + String(variables.versionTimestamp || 0));
			document.getElementsByTagName('body')[0].appendChild(el);

			return deferred.promise;
		};

		$rootScope.$on('$destroy', function() {
			scriptLoaded = null;
		});

		var randomString = function(type, length) {
			if (typeof length == 'undefined' || !length) {
				length = 6;
			}

			var v = '';

			if (typeof type == 'undefined' || !type) {
				return v;
			}

			var start = 'a'.charCodeAt(0);

			for (var i = 0; i < length; i++) {
				if (type == 'numeric') {
					var c = Math.floor(Math.random() * 10);
					if (c == 10) {
						c = 0;
					}

					v += String(c);
				} else if (type == 'alphanumeric') {
					var c = Math.floor(Math.random() * 36);
					if (c == 36) {
						c = 0;
					}

					if (c > 9) {
						var s = String.fromCharCode(c + start - 10);
						if (Math.random() < 0.5) {
							s = s.toUpperCase();
						}

						v += s;
					} else {
						v += String(c);
					}
				} else if (type == 'alpha') {
					var c = Math.floor(Math.random() * 26);
					if (c == 26) {
						c = 0;
					}

					var s = String.fromCharCode(c + start);
					if (Math.random() < 0.5) {
						s = s.toUpperCase();
					}

					v += s;
				}
			}

			return v;
		};

		var regexFromString = function(pattern) {
			var parts = pattern.split('/'),
				regex = pattern,
				options = '';
			if (parts.length > 1) {
				regex = parts[1];
				options = parts[2];
			}
			return new RegExp(regex, options);
		};

		var createPassword = function(pattern, account, re) {
			if (typeof pattern == 'undefined' || !pattern) {
				return '';
			}

			if (pattern == 'account') {
				if (typeof account == 'undefined' || !account) {
					return '';
				}
				return account;
			}

			var _regex = /^(numeric|alpha|alphanumeric)(\d*)$/;
			var found = pattern.match(_regex);

			if (found && found.length > 1) {
				var password = '';
				var regex;

				if (re instanceof RegExp) {
					regex = re;
				} else if (re) {
					try {
						regex = regexFromString(re);
					} catch (e) {
						// console.log('invalid password validation regex: ', e);
						regex = /.*/;
					}
				}

				for (var i = 0; i < 100; i++) {
					password = randomString(found[1], Number(found[2])); // 1, 2

					if (regex) {
						if (password.match(regex)) {
							return password;
						}
					} else {
						return password;
					}
				}

				return password;
			}

			return pattern;
		};

		var format_date = function(date) {
			if (!date || date === '0') {
				return '';
			}

			var _date = parseDate(date);

			return moment(_date)
				.tz(timezone)
				.format(date_format);
		};

		var stripSeconds = function(str) {
			return str.replace(/\:\d\d(am|pm)?$/, '$1');
		};

		var format_time = function(date, hideSeconds) {
			var f = hideSeconds ? stripSeconds : angular.identity;

			if (!date || date === '0') {
				return '';
			}

			var _date = parseDate(date);

			return f(
				moment(_date)
					.tz(timezone)
					.format(time_format)
			);
		};

		var format_date_time = function(date, hideSeconds) {
			if (!date || date === '0') {
				return '';
			}

			return format_date(date) + ' ' + format_time(date, hideSeconds);
		};

		var newDate = function(datetime) {
			var date = datetime || datetime === 0 ? parseDate(datetime) : new Date();

			return moment(date)
				.subtract(getOffset(date), 'minutes')
				.toDate();
		};

		var newStartDate = function(timestamp) {
			var _date = newDate(timestamp);
			_date.setHours(0, 0, 0, 0);
			return _date;
		};

		var newEndDate = function(timestamp) {
			timestamp = Math.floor(Number(timestamp));
			var _date = newDate(timestamp - (timestamp % 3600 ? 0 : 1));
			_date.setHours(23, 59, 59, 0);
			return _date;
		};

		var format_month = function(date) {
			if (!date || date === '0') {
				return '';
			}

			var _date;

			if (date instanceof Date) {
				_date = newDate(date);
			} else if (typeof date == 'number') {
				_date = newDate(date);
			} else if (!isNaN(Number(date))) {
				_date = newDate(Number(date));
			} else {
				_date = newDate(date);
			}

			var m = _date.getMonth() + 1;
			var sm = (m < 10 ? '0' : '') + String(m);

			var y = _date.getFullYear();
			var sy = String(y);

			if (date_format == 'DD/MM/YYYY' || date_format == 'MM/DD/YYYY') {
				return sm + '/' + sy;
			}

			return sy + '-' + sm;
		};

		var systemTimestamp = function(userDate) {
			var original = angular.copy(userDate);

			if (userDate) {
				userDate = Number(userDate);

				if (userDate && !isNaN(userDate) && isFinite(userDate)) {
					var date = new Date(userDate * 1000);

					return (date - (date % 1000)) / 1000 + getOffset(date) * 60;
				}

				return original;
			}

			return original;
		};

		var day_start = function(timestamp) {
			var d = new Date(Number(timestamp) * 1000);
			d.setHours(0, 0, 0, 0);
			return d / 1000;
		};

		var day_end = function(timestamp) {
			var d = new Date((Number(timestamp) - (timestamp % 3600 ? 0 : 1)) * 1000);
			d.setHours(23, 59, 59, 0);
			return d / 1000;
		};

		var trim_money = function(x, d) {
			if (d !== 0) {
				d = d || 6;
			}
			if (d < 2) {
				d = 2;
			}

			var factor = Math.pow(10, Math.min(d, 8));

			var retVal = parseFloat(Math.round(Number(x) * factor) / factor).toFixed(d);

			if (d > 2) {
				return retVal.replace(/(\.\d[\d]+?)0+$/, '$1');
			}

			return retVal;
		};

		var objectToCSVRow = function(dataObject, fields, separator) {
			var dataArray = new Array();
			var hasFields = fields instanceof Array && fields.length;

			var fieldNames = hasFields
				? fields.map(function(item) {
						return item.name;
				  })
				: [];

			for (var key in hasFields ? fieldNames : dataObject) {
				var v = dataObject[hasFields ? fieldNames[key] : key];

				var innerValue =
					typeof v == 'undefined' || v == null
						? ''
						: v instanceof Date
						? format_date(v) + ' ' + format_time(v)
						: String(v);

				if (typeof v != 'number') {
					innerValue = '"' + innerValue.replace(/"/g, '""') + '"';
				}

				dataArray.push(innerValue);
			}

			return dataArray.join(separator || ',') + '\r\n';
		};

		var contentToObjectUrl = function(fileContents, type) {
			var fileBlob = new Blob([fileContents], {
				type: type || '',
			});
			return URL.createObjectURL(fileBlob);
		};

		var exportToCSV = function(items, filename, fields, options, hideHeader) {
			if (typeof items == 'undefined' || !items || !items.length) {
				swal({
					title: lang('error_no_items_export'),
					type: 'warning',
				});
				return;
			}

			options = options || {};

			fields = fields.filter(function(f) {
				var shouldShow = true;
				if (f.show_if !== undefined) {
					shouldShow = options[f.show_if] && options[f.show_if] != '0';
				}
				if (shouldShow && f.hide_if !== undefined) {
					shouldShow = !options[f.hide_if] || options[f.hide_if] == '0';
				}
				return shouldShow;
			});

			return CoreApiService.makeApiCall('POST', 'configs/get/', {
				name: 'csv_separator',
				default: ',',
			}).then(function(response) {
				var separator = response.data.value;

				var csvContent = '';

				// headers
				//csvContent += objectToCSVRow(Object.keys(items[0]), separator);

				if (hideHeader !== true && fields instanceof Array && fields.length) {
					csvContent += objectToCSVRow(
						fields.map(function(item) {
							return item.display;
						}),
						undefined,
						separator
					);
				}

				items.forEach(function(item) {
					csvContent += objectToCSVRow(item, fields, separator);
				});

				var blobUrl = contentToObjectUrl(csvContent, 'text/csv');

				var link = document.createElement('a');
				link.setAttribute('href', blobUrl);

				if (typeof filename != 'string' || !filename) {
					filename = 'features.csv';
				}

				if (filename.indexOf('.csv') != filename.length - 4) {
					filename += '.csv';
				}

				if (typeof filename && filename) {
					link.setAttribute('download', filename);
				}

				document.body.appendChild(link); // Required for FF
				link.click();
				document.body.removeChild(link);
			}, CoreApiService.defaultErrorHandler);
		};

		var CSVToArray = function(strData, strDelimiter) {
			// Check to see if the delimiter is defined. If not,
			// then default to comma.
			strDelimiter = strDelimiter || ',';

			// Create a regular expression to parse the CSV values.
			var objPattern = new RegExp(
				// Delimiters.
				'(\\' +
					strDelimiter +
					'|\\r?\\n|\\r|^)' +
					// Quoted fields.
					'(?:"([^"]*(?:""[^"]*)*)"|' +
					// Standard fields.
					'([^"\\' +
					strDelimiter +
					'\\r\\n]*))',
				// Flags
				'gi'
			);

			// Create an array to hold our data. Give the array
			// a default empty first row.
			var arrData = [[]];

			// Create an array to hold our individual pattern
			// matching groups.
			var arrMatches = null;
			var counter = 0;

			// Keep looping over the regular expression matches
			// until we can no longer find a match.
			while ((arrMatches = objPattern.exec(strData))) {
				// Get the delimiter that was found.
				var strMatchedDelimiter = arrMatches[1];

				// Check to see if the given delimiter has a length
				// (is not the start of string) and if it matches
				// field delimiter. If id does not, then we know
				// that this delimiter is a row delimiter.
				if (strMatchedDelimiter.length && strMatchedDelimiter !== strDelimiter) {
					// Since we have reached a new row of data,
					// add an empty row to our data array.
					arrData.push([]);
				}

				var strMatchedValue;

				// Now that we have our delimiter out of the way,
				// let's check to see which kind of value we
				// captured (quoted or unquoted).
				if (arrMatches[2]) {
					// We found a quoted value. When we capture
					// this value, unescape any double quotes.
					strMatchedValue = arrMatches[2].replace(new RegExp('""', 'g'), '"');
				} else {
					// We found a non-quoted value.
					strMatchedValue = arrMatches[3];
				}

				if (counter == 0 && arrMatches[0].charAt(0) == strMatchedDelimiter) {
					arrData[arrData.length - 1].push('');
				}

				// Now that we have our value string, let's add
				// it to the data array.
				arrData[arrData.length - 1].push(strMatchedValue);

				counter++;
			}

			// Return the parsed data.
			return arrData;
		};

		var parseCSVFile = function(rows, fields, separator) {
			separator = separator || ',';

			//var _separator = new RegExp('(".*?"|[^"' + separator + '\\s]*)(?=\\s*' + separator + '|\\s*$)', 'g'); // /(".*?"|[^",\s]*)(?=\s*,|\s*$)/g; // /(".*?"|[^",]+)(?=\s*,|\s*$)/gi;

			var result = [];

			//console.log(rows);

			var errorLine = -1;

			rows.some(function(row, index) {
				//var values = (row+',').split('""').join('"').match(_separator);
				//values = (values || []).filter(function(item, index) { return (index == 0) || (item != '') || (values[index - 1] == ''); });

				row = String(row || '').trim();

				if (!/(\d|@|"(no)?"|yes)/i.test(row)) {
					// considering this non-data row (header etc.)
					return false;
				}

				var values = CSVToArray(row, separator)[0];

				if (!values || values.length < 2) {
					// empty row, skip!
					return false;
				}

				/*
				if (values.length < fields.length) {
				  errorLine = index;
				  result = [];
				  return true; // invalid row, stop parsing
				}
				*/

				var rowObj = {};

				var isHeader = index == 0;

				values.forEach(function(value, index) {
					if (index < fields.length) {
						values[index] = value = (value || '').replace(/^\"/, '').replace(/\"$/, ''); // remove quotes
						rowObj[fields[index].name] = value == null ? '' : value;
					}
				});

				if (isHeader) {
					// just in case
					fields.some(function(field) {
						if (values.indexOf(field.display) < 0) {
							isHeader = false;
							return true;
						}
					});
				}

				if (!isHeader) {
					result.push(rowObj);
				}
			});

			if (errorLine > -1) {
				swal({
					title: lang('invalid_line') + ': ' + String(errorLine + 1) + '.',
					type: 'error',
				});
			}

			return result;
		};

		var getLink = function(name, url, value) {
			var set = 0;

			//url = url.replace(/\?[a-z0-9]+=/, '');

			//console.log(name + ', ' + url + ' ' + String(value));

			var nvalue = Number(value);

			if (name == 'cos') {
				if (nvalue > 1) {
					set = 1;
				}
			} else if (name == 'customer') {
				if (!isNaN(nvalue) && nvalue > 0) {
					set = 1;
				}
			} else if (nvalue > 0) {
				set = 1;
			}

			return set ? (url.indexOf('../') == 0 ? '' : '#') + url + String(value) : '';
		};

		var web_display_destination = function(ref) {
			if (!ref || !ref.length) {
				return $q.resolve([]);
			}

			var requests = [];

			ref.forEach(function(d, key) {
				var dtype = d.dtype || '';
				d.dnumber_display = d.dnumber;

				if (!/^(callback|faxtoemail|sipuri)$/.test(dtype)) {
					if (
						/^(huntgroup|ivr|pagegroup|patternmenu|plugin|queue|url|pickupgroup|timegroup|sound|alert|file|product|field|menu|plugin|ingroup|outgroup|region|role|plan)$/.test(
							dtype
						)
					) {
						requests.push(
							CoreApiService.makeApiCall('POST', dtype + 's/get/', {
								id: d.dnumber,
							}).then(function(response) {
								d.dnumber_display = response.data.name;
							}, angular.identity)
						);
					} else if (dtype == 'code' || /^conference(_.+)?$/.test(dtype)) {
						requests.push(
							CoreApiService.makeApiCall('POST', dtype.replace(/_.*$/, '') + 's/get/', {
								code: d.dnumber,
							}).then(function(response) {
								d.dnumber_display = response.data.display;
							}, angular.identity)
						);
					} else if (dtype == 'mailbox' || dtype == 'voicemailbox' || dtype == 'voicemailboxpin' || dtype == 'faxbox') {
						requests.push(
							CoreApiService.makeApiCall('POST', 'mailboxes/get/', {
								mailbox: d.dnumber,
							}).then(function(response) {
								d.dnumber_display = response.data.display;
							}, angular.identity)
						);
					} else if (dtype == 'number' || dtype == 'forward') {
						requests.push(
							CoreApiService.makeApiCall('POST', 'numbers/get/', {
								number: d.dnumber,
							}).then(function(response) {
								d.dnumber_display = response.data.display;
							}, angular.identity)
						);
					} else if (dtype == 'peer' && /^([\s\S]*\@)(\d+)$/.test(d.dnumber)) {
						var found = d.dnumber.match(/^([\s\S]*\@)(\d+)$/);
						var number = found[1];

						requests.push(
							CoreApiService.makeApiCall('POST', 'peers/get/', {
								id: found[2],
								destination: 1,
							}).then(function(response) {
								d.dnumber_display = number + response.data.name;
							}, angular.identity)
						);
					} else if (dtype == 'phone') {
						requests.push(
							CoreApiService.makeApiCall('POST', 'phones/get/', {
								name: d.dnumber,
							}).then(function(response) {
								d.dnumber_display = response.data.display;
								//console.log(d);
							}, angular.identity)
						);
					} else if (dtype == 'record' || dtype == 'recordgroup') {
						requests.push(
							CoreApiService.makeApiCall('POST', 'recording/groups/get/', {
								id: d.dnumber,
							}).then(function(response) {
								d.dnumber_display = response.data.name;
							}, angular.identity)
						);
					} else if (dtype == 'unlimited_access') {
						requests.push(
							CoreApiService.makeApiCall('POST', 'unlimited/get/', {
								id: d.dnumber,
							}).then(function(response) {
								d.dnumber_display = response.data.name;
							}, angular.identity)
						);
					} else if (dtype == 'update_routing') {
						if (d.dnumber == '') {
							d.dnumber_display = lang('update_routing_normal');
						} else if (d.dnumber == 'default') {
							d.dnumber_display = lang('update_routing_default');
						} else if (/^timegroup_(\d+)$/.test(d.dnumber)) {
							var found = d.dnumber.match(/^timegroup_(\d+)$/);

							requests.push(
								CoreApiService.makeApiCall('POST', 'timegroups/get/', {
									id: found[1],
								}).then(function(response) {
									d.dnumber_display = response.data.name;
								}, angular.identity)
							);
						} else if (/^\d+$/.test(d.dnumber)) {
							requests.push(
								CoreApiService.makeApiCall('POST', 'timegroups/get/', {
									id: d.dnumber,
								}).then(function(response) {
									d.dnumber_display = response.data.name;
								}, angular.identity)
							);
						}
					} else if (dtype == 'customer') {
						requests.push(
							CoreApiService.makeApiCall('POST', 'customers/get/', {
								id: d.dnumber,
							}).then(function(response) {
								d.dnumber_display = response.data.name;
							}, angular.identity)
						);
					} else if (dtype == 'prefix') {
						requests.push(
							CoreApiService.makeApiCall('POST', 'prefixes/get/', {
								id: d.dnumber,
							}).then(function(response) {
								var plural = Number(response.data.called_max) !== 1;
								d.dnumber_display =
									response.data.prefix +
									', ' +
									response.data.called_min +
									' ' +
									lang('to') +
									' ' +
									response.data.called_max +
									' ' +
									lang(plural ? 'digits' : 'digit');
							}, angular.identity)
						);
					} else if (dtype == 'bulk') {
						requests.push(
							CoreApiService.makeApiCall('POST', 'bulk/campaigns/get/', {
								id: d.dnumber,
							}).then(function(response) {
								d.dnumber_display = response.data.name;
							}, angular.identity)
						);
					} else if (dtype == 'speeddial') {
						requests.push(
							CoreApiService.makeApiCall('POST', 'speeddials/get/', {
								id: d.dnumber,
							}).then(function(response) {
								d.dnumber_display = response.data.sdial;
							}, angular.identity)
						);
					} else if (dtype == 'address') {
						requests.push(
							CoreApiService.makeApiCall('POST', 'addresses/get/', {
								id: d.dnumber,
							}).then(function(response) {
								d.dnumber_display = response.data.user + '@' + response.data.domain;
							}, angular.identity)
						);
					} else if (dtype == 'class' || dtype == 'tax') {
						requests.push(
							CoreApiService.makeApiCall('POST', dtype + 'es/get/', {
								id: d.dnumber,
							}).then(function(response) {
								d.dnumber_display = response.data.name;
							}, angular.identity)
						);
					} else if (dtype == 'peer') {
						requests.push(
							CoreApiService.makeApiCall('POST', 'peers/get/', {
								id: d.dnumber,
							}).then(function(response) {
								d.dnumber_display = response.data.name;
							}, angular.identity)
						);
					} else if (dtype == 'outroute') {
						requests.push(
							CoreApiService.makeApiCall('POST', 'routes/get/', {
								id: d.dnumber,
							}).then(function(response) {
								var r = response.data;
								var plural = Number(r.called_max) !== 1;
								r.media_display = lang('media_' + r.media);
								d.dnumber_display =
									(r.called_prefix || lang('select_default')) +
									', ' +
									r.called_min +
									' ' +
									lang('to') +
									' ' +
									response.data.called_max +
									' ' +
									lang(plural ? 'digits' : 'digit') +
									', ' +
									(r.caller_prefix ? r.caller_prefix + ', ' : '') +
									r.media_display;
							}, angular.identity)
						);
					} else if (dtype == 'machine') {
						requests.push(
							CoreApiService.makeApiCall('POST', 'machines/get/', {
								id: d.dnumber,
							}).then(function(response) {
								d.dnumber_display = response.data.server + (response.data.domain ? '.' + response.data.domain : '');
							}, angular.identity)
						);
					} else if (dtype == 'domain') {
						requests.push(
							CoreApiService.makeApiCall('POST', 'domains/get/', {
								id: d.dnumber,
							}).then(function(response) {
								d.dnumber_display = response.data.domain;
							}, angular.identity)
						);
					} else if (dtype == 'voucher_batch') {
						requests.push(
							CoreApiService.makeApiCall('POST', 'vouchers/batches/get/', {
								id: d.dnumber,
							}).then(function(response) {
								d.dnumber_display = response.data.name;
							}, angular.identity)
						);
					} else if (dtype == 'cardgroup') {
						requests.push(
							CoreApiService.makeApiCall('POST', 'cards/groups/get/', {
								id: d.dnumber,
							}).then(function(response) {
								d.dnumber_display = response.data.name;
							}, angular.identity)
						);
					} else if (dtype != 'hangup' && d.dnumber) {
						// cos, ...
						requests.push(
							CoreApiService.makeApiCall('POST', dtype + '/get/', {
								id: d.dnumber,
							}).then(function(response) {
								d.dnumber_display = response.data[dtype == 'people' ? 'username' : 'name'];
							}, angular.identity)
						);
					}
				}

				d.dtype_display = lang((dtype == 'peer' && !/^([\s\S]*\@)(\d+)$/.test(d.dnumber) ? '' : 'dtype_') + dtype);
			});

			if (requests.length) {
				return $q.all(requests).then(
					function() {
						return ref;
					},
					function() {
						return ref;
					}
				);
			} else {
				return $q.resolve(ref);
			}
		};

		var copyNotes = function(stype, snumber, newSnumber, customer) {
			if (!customer) {
				var me = SessionService.getSession();
				var effective_customer = me.effective_customer || me.customer;
				customer = effective_customer;
			}

			return NotesApiService.getNotesList({
				stype: stype,
				snumber: snumber,
			}).then(function(response) {
				var _actions = [];

				response.data.forEach(function(note) {
					note.snumber = newSnumber;
					note.customer = customer;
					delete note.id;

					_actions.push(NotesApiService.createNote(note).then(angular.identity, angular.identity));
				});

				return _actions.length ? $q.all(_actions) : response;
			});
		};

		var setNewExpiry = function(old, plan, expiry_dom) {
			//saved_prefs, set_prefs,...?

			expiry_dom = Number(expiry_dom || 1);

			var oldExpiry = moment(old);
			var newExpiry = moment(old);

			var _new;

			switch (plan.period) {
				case 'daily': {
					newExpiry = oldExpiry.add(1, 'days');
					_new = newExpiry.toDate();
					break;
				}

				case 'weekly': {
					newExpiry = oldExpiry.add(1, 'weeks');
					_new = newExpiry.toDate();
					break;
				}

				case 'monthly': {
					newExpiry = oldExpiry.add(1, 'months');
					_new = newExpiry.toDate();
					break;
				}

				case '2_monthly': {
					newExpiry = oldExpiry.add(2, 'months');
					_new = newExpiry.toDate();
					break;
				}

				case '3_monthly': {
					newExpiry = oldExpiry.add(3, 'months');
					_new = newExpiry.toDate();
					break;
				}

				case '6_monthly': {
					newExpiry = oldExpiry.add(6, 'months');
					_new = newExpiry.toDate();
					break;
				}

				case 'annualy': {
					newExpiry = oldExpiry.add(12, 'months');
					_new = newExpiry.toDate();
					_new.setMonth(0);
					break;
				}

				default: {
					return {}; //?
				}
			}

			var fraction = 1;

			if (plan.period_starts == 'start') {
				var _full = angular.copy(_new);

				_new.setDate(expiry_dom);
				_new.setHours(0, 0, 0, 0);

				if (_full - old < 1000) {
					fraction = 0;
				} else {
					fraction = (_new - old) / (_full - old);
				}
			}

			return {
				expiry: _new,
				fraction: fraction,
			};
		};

		/*
		sub web_role_allowed {
		  my ( $own, $required ) = @_;
		  ref $own and $own = $own->{ 'role' };

		  foreach my $privilege ( 'system', 'commerce', 'admin' ) {
		    my $access = web_api( 'roles/access/get', undef, { role => $required, privilege => $privilege } );
		    $access or next;
		    $access = web_api( 'roles/access/get', undef, { role => $own, privilege => $privilege } );
		    $access or return 0;
		  }
		  return 1;
		}
		*/

		var web_role_allowed = function(required, own) {
			var deferred = $q.defer();
			var me = SessionService.getSession();
			own = own || me.role; // just role?
			var resolved = false;

			$q.all(
				['system', 'commerce', 'admin'].map(function(privilege) {
					return RolesApiService.getAccessForRole({
						role: required,
						privilege: privilege,
					}).then(function(response) {
						return !Number(response.data)
							? response
							: RolesApiService.getAccessForRole({
									role: own,
									privilege: privilege,
							  }).then(
									function(response) {
										if (!Number(response.data)) {
											resolved || deferred.resolve(false);
											resolved = true;
										}
										return response;
									},
									function(error) {
										resolved || deferred.resolve(false);
										resolved = true;
										return error;
									}
							  );
					});
				})
			).then(
				function() {
					resolved || deferred.resolve(true);
				},
				function() {
					resolved || deferred.resolve(false);
				}
			);

			return deferred.promise;
		};

		var check_allow_admin = function() {
			if (!user) {
				return $timeout(function() {
					$rootScope.allow_admin = false;
				});
			}

			return RolesApiService.getAccessForRole({
				role: user.role,
				privilege: 'admin',
			}).then(function(response) {
				if (Number(response.data)) {
					return $timeout(function() {
						$rootScope.allow_admin = true;
					});
				} else {
					return RolesApiService.getAccessForRole({
						role: user.role,
						privilege: 'wholesale',
					}).then(function(response) {
						return $timeout(function() {
							$rootScope.allow_admin = !!Number(response.data);
						});
					}, angular.identity);
				}
			}, angular.identity);
		};

		var checkMaximumFeatures = function(feature, currentUrl) {
			var deferred = $q.defer();

			var me = SessionService.getSession();

			CoreApiService.makeApiCall('POST', 'plans/features/maximum/', {
				feature: feature,
				customer: me.effective_customer || me.customer,
			}).then(function(response) {
				var maxFeatures = Number(response.data.maximum);
				var featureList;

				if (maxFeatures == 0) {
					swal({
						title: lang('error_plan_feature_forbidden'),
						type: 'warning',
					})
						.then($rootScope.goBack)
						.done();
					deferred.reject();
				} else {
					currentUrl = currentUrl || feature + '/list/';
					var params = {};
					if (feature == 'phones') {
						params.owner = me.effective_id || me.id;
					}
					CoreApiService.makeApiCall('POST', currentUrl, params).then(
						function(response) {
							featureList = response.data;

							if (maxFeatures > 0 && maxFeatures <= featureList.length) {
								swal({
									title: lang('error_plan_feature_maximum'),
									type: 'warning',
								})
									.then($rootScope.goBack)
									.done();
								deferred.reject();
							} else {
								deferred.resolve();
							}
						},
						function(error) {
							var error_message = error ? error.message || lang(error.key) : lang('cdr_status_error'); // ?

							swal({
								title: error_message,
								type: 'warning',
							})
								.then($rootScope.goBack)
								.done();
							deferred.reject();
						}
					);
				}
			}, CoreApiService.defaultErrorHandler);

			return deferred.promise;
		};

		var format_interval = function(interval) {
			interval = String(interval || '');

			if (!interval) {
				return '';
			}

			var found = interval.match(/^(\d+)_(\w+)$/);

			if (!found || found.length < 2) {
				return '';
			}

			var num = found[1];
			var name = found[2];

			var retVal = '';

			['day', 'week', 'month', 'year'].some(function(key) {
				if (name.indexOf(key) > -1) {
					retVal = num + ' ' + lang(num == '1' ? key : key + 's');
					return true;
				}
				return false;
			});

			return retVal;
		};

		var getOffsetLeft = function(el, fromParent) {
			if (!el) {
				return 0;
			}

			fromParent = fromParent || document.body;

			var offsetLeft = el.offsetLeft || 0;

			var elem = el;

			while ((elem = elem.offsetParent)) {
				offsetLeft += elem.offsetLeft;
				if (elem === fromParent) {
					return offsetLeft;
				}
			}

			return offsetLeft;
		};

		var getOffsetTop = function(el, fromParent) {
			if (!el) {
				return 0;
			}

			fromParent = fromParent || document.body;

			var offsetTop = el.offsetTop || 0;

			var elem = el;

			while ((elem = elem.offsetParent)) {
				offsetTop += elem.offsetTop;
				if (elem === fromParent) {
					return offsetTop;
				}
			}

			return offsetTop;
		};

		var scrollToInput = function(name) {
			if (!name) {
				return;
			}

			var input = $('input[name="' + name + '"]');
			// console.log(input);

			var offsetTop = getOffsetTop(input);

			offsetTop = Math.min(document.body.scrollTop, offsetTop - 30);

			$('html, body').animate(
				{
					scrollTop: Math.max(offsetTop, 0),
				},
				{
					duration: 300 * $rootScope.animationDurationMultiplier,
					complete: function() {
						if (input) {
							try {
								input.focus();
							} catch (e) {}
							input = null;
						}
					},
				}
			);
		};

		var stripHTMLTags = function(str) {
			if (str && typeof str === 'string') {
				str = str.replace(/<script[^>]*>([\S\s]*?)<\/script>/gim, '');
				str = str.replace(/<\/?\w(?:[^"'>]|"[^"]*"|'[^']*')*>/gim, '');
			}

			return str;
		};

		var decodeEntities = (function() {
			// this prevents any overhead from creating the object each time
			var element = document.createElement('div'); // textarea?

			var decodeHTMLEntities = function(str) {
				if (str && typeof str === 'string') {
					// strip script/html tags // do it only if second parameter true?
					str = stripHTMLTags(str);

					element.innerHTML = str;
					str = element.textContent;
					element.textContent = '';
				}

				return str;
			};

			$rootScope.$on('$destroy', function() {
				element = null;
			});

			return decodeHTMLEntities;
		})();

		var numArray = function(start, end) {
			start = start || 0;
			end = end || 0;

			if (end < start) {
				end = start;
			}

			var arr = [];

			for (var i = start; i <= end; i++) {
				arr.push(i);
			}

			return arr;
		};

		var locationOf = function(element, array, start, end, key) {
			start = start || 0;
			end = end || array.length;
			if (!end) return -1;
			var pivot = Math.floor(start + (end - start) / 2, 10);
			var pivotVal = String(key ? array[pivot][key] : array[pivot]);
			var val = String(key ? element[key] : element);
			if (pivotVal === val) return pivot;
			var cmp = pivotVal.localeCompare(val);
			if (end - start <= 1) return cmp > 0 ? pivot - 1 : pivot;
			if (cmp < 0) {
				return locationOf(element, array, pivot, end, key);
			} else {
				return locationOf(element, array, start, pivot, key);
			}
		};

		var addItemToSortedArray = function(arr, item, key) {
			return arr.splice(locationOf(item, arr, 0, arr.length, key) + 1, 0, key ? item[key] : item);
		};

		var addItemsToSortedArray = function(arr, items, key) {
			if (!items || !items.length) {
				return 0;
			}
			for (var i in items) {
				addItemToSortedArray(arr, items[i], key);
			}
			return items.length;
		};

		var hasClass = function(element, cls) {
			return (' ' + element.className + ' ').indexOf(' ' + cls + ' ') > -1;
		};

		var checkIfFileExists = function(filename) {
			/*
			var deferred = $q.defer();

			$.ajax({
			  url: filename,
			  type:'HEAD',
			  error: deferred.reject,
			  success: deferred.resolve
			});

			return deferred.promise;
			*/

			// use $sce.trustAsResourceUrl(url)?
			return $http.head(filename);
		};

		var cancelPendingApiRequests = function() {
			$http.pendingRequests.forEach(function(request) {
				if (request.cancel) {
					request.cancel.resolve();
				}
			});
		};

		var openModalAudioPlayer = function(audioFilePromise, title) {
			var audioPlayerModalScope = $rootScope.$new(true);
			audioPlayerModalScope.title = title;

			var audioPlayerModalInstance;

			var audioPlayerModal = {
				scope: audioPlayerModalScope,

				keyboard: false,
				backdrop: 'static',

				/** @ngInject */
				controller: function($scope) {
					$scope.close = function() {
						$scope.audioLoaded = false;
						$scope.data = null;
						audioPlayerModalInstance.close();
						audioPlayerModalScope.$destroy();
					};

					$scope.downloadAudio = function() {
						if (!$scope.data) {
							return;
						}
						FileDownloadService.downloadFile($scope.data.name, $scope.data.data, $scope.data.mimetype);
					};

					audioFilePromise.then(
						function(response) {
							$timeout(function() {
								$scope.data = response.data;
								$scope.audioLoaded = true;
							});
						},
						function(error) {
							$scope.audioError = CoreApiService.getErrorMessage(error);
						}
					);
				},

				templateUrl: 'app/components/common/audioModal.html',
			};

			audioPlayerModalInstance = $uibModal.open(audioPlayerModal);
		};

		var openEditPageInModal = function(stateConfig, stateParams, scopeOpts, cb) {
			var baseUrl = '/app/components/';
			var original = stateConfig.data.originalTemplate;
			var currentLanguage = $rootScope.currentLanguage || $rootScope.default_language || 'en';
			var templatesFolder =
				($rootScope.installedLanguages && $rootScope.installedLanguages[currentLanguage]
					? $rootScope.installedLanguages[currentLanguage].templates
					: currentLanguage) || currentLanguage;
			var templateUrl = $rootScope.templatesFolder
				? original.replace(baseUrl, $rootScope.templatesFolder + templatesFolder + '/')
				: original;

			var currentTitle = $rootScope.title;
			var currentState = $rootScope.currentState;
			var currentPageTitle = $rootScope.currentPageTitle;

			var oldGoBack = $rootScope.goBack;

			var modalInstance, scope, response, requestParams;
			var u,
				confirmed = false;

			var currentIndex = $rootScope.openEditModalsCount + 1;
			var indexStr = String(currentIndex - 1);

			var checkFormDirty = function() {
				var modal = angular.element('#edit-features-modal-' + indexStr);
				var forms = modal.find('form');
				var foundDirty = false;
				Array.from(forms).some(function(form) {
					return (foundDirty = angular.element(form).hasClass('ng-dirty'));
				});
				forms = null;
				modal = null;
				return foundDirty;
			};

			var scopeProperties = angular.extend(scopeOpts || {}, {
				title: stateConfig.title || stateConfig.data.pageTitle,
				options: {
					loaded: false,
				},
				cancel: function() {
					// console.log('cancel:', arguments);
					if (
						!confirmed &&
						currentIndex === $rootScope.openEditModalsCount &&
						arguments[0] &&
						arguments[0].name === '$stateChangeStart'
					) {
						var event = arguments[0];
						var toState = arguments[1];
						var toParams = arguments[2];
						//var fromState = arguments[3];
						//var fromParams = arguments[4];
						//var options = arguments[5];
						event.preventDefault();
						SwalService.popup({
							title: $rootScope.languageString('form_leave_prompt'),
							type: 'question',
							showCancelButton: true,
						})
							.then(function() {
								//confirmed = true;
								$rootScope.$broadcast('NavigationConfirmed');
								$timeout(function() {
									$state.go(toState, toParams); // @TODO: do the same in form directive?
								});
							}, angular.identity)
							.done();
						return false;
					}
					if (confirmed || arguments[0] === 'discard') {
						response = null;
						requestParams = null;
					}
					if (arguments[0] === 'closeOn') {
						response = response || 'closeOn';
					}
					if (arguments[0] === 'discard' && !confirmed && checkFormDirty()) {
						SwalService.popup({
							title: $rootScope.languageString('form_leave_prompt'),
							type: 'question',
							showCancelButton: true,
						})
							.then(function() {
								confirmed = true;
								$timeout(function() {
									scope.cancel('discard');
								});
							}, angular.identity)
							.done();
						return false;
					}
					modalInstance && modalInstance.close();
					return $timeout(function() {
						if (modalInstance) {
							$rootScope.$broadcast('EditModalClosed', {
								stateName: stateConfig.name,
								discard: arguments[0] === 'discard',
								response: response,
							});
							modalInstance = null;
							u();
							scope.$$destroyed || scope.$destroy();
							$rootScope.title = currentTitle;
							$rootScope.currentState = currentState;
							$rootScope.currentPageTitle = currentPageTitle;
							$rootScope.goBack = oldGoBack;
							$rootScope.openEditModalsCount && $rootScope.editModals.pop();
							$rootScope.openEditModalsCount = Math.max(0, --$rootScope.openEditModalsCount);
							(cb || angular.noop)(response, requestParams);
							response = null;
							requestParams = null;
							stateParams = null;
							stateConfig = null;
							scopeOpts = null;
							cb = null;
						}
					});
				},
			});

			scope = angular.extend($rootScope.$new(true), scopeProperties);

			scope.$on('NavigationConfirmed', function() {
				confirmed = true;
			});

			var setZIndex;

			scope.$on('EditModalResponse', function(event, data) {
				var _data = angular.copy(data.data);
				_data.modalInfo = {
					event: event,
					path: original.replace(baseUrl.substring(1), ''),
					params: stateParams,
					data: scopeOpts,
				};
				response = _data;
				requestParams = data.originalParams;
				setZIndex && setZIndex();
			});

			scope.$on('$includeContentLoaded', function() {
				$timeout(function() {
					scope.options.loaded = true;
					//var _vm = scope.$$childHead[stateConfig.controllerAs]; // reference to controller object; we can use it to extend the confirm method, fetch the result and return it to the caller;
				});
			});

			var modal;

			var refresh = function(stateConfig, newParams, scopeOpts, cb) {
				$timeout(function() {
					// console.log('refresh: ', stateConfig, newParams, scopeOpts, cb);
					openEditPageInModal(stateConfig, newParams, angular.copy(scopeOpts), cb);
				}, 150);
			};

			u = scope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams, options) {
				if (
					options.reload ||
					options.location == 'replace' ||
					(/^index\.customers\.customers-(new|ingroup|choose)$/.test(stateConfig.name) &&
						toParams.modal &&
						toParams.modal !== '0')
				) {
					event.preventDefault();
					$rootScope.$broadcast('NavigationConfirmed');
					var params = angular.extend(angular.copy(stateParams), angular.copy(toParams), {
						modal: true,
					});
					refresh(
						angular.copy(options.reload ? stateConfig : $state.get(toState.name || toState) || stateConfig),
						params,
						angular.copy(scopeOpts),
						angular.copy(cb)
					);
					$timeout(function() {
						scope.cancel('discard');
					});
				} else {
					scope.cancel.apply(scope, arguments);
				}
			});

			var resolveTemplateUrl = function(templateUrl) {
				return $timeout(function() {
					return (scope.pageTemplateUrl = templateUrl);
				});
			};

			stateParams = stateParams || {};
			stateParams.modal = true;

			modal = {
				size: 'lg',
				backdrop: 'static',
				keyboard: false,
				scope: scope,
				controller: stateConfig.controller,
				controllerAs: stateConfig.controllerAs,
				template:
					'<div class="inmodal" id="edit-features-modal-' +
					indexStr +
					'" style="z-index: ' +
					String(2050 + $rootScope.openEditModalsCount * 10) +
					'">\
	<div class="modal-header" ng-if="!hideHeader">\
		<!--<i ng-if="!hideHeaderIcon" class="fa modal-icon{{::(!!headerIcon?(\' \'+headerIcon):\'\')}}" ng-class="::(!!headerIcon?{}:{\'fa-edit\': updating, \'fa-file-o\': !updating})"></i>-->\
		<h1>{{' +
					stateConfig.controllerAs +
					'.title||title||$root.title}}</h1>\
	</div>\
	<div class="modal-body edit-modal" style="padding: 0px !important; min-height: 50px;">\
		<div ng-if="!options.loaded" class="modal-loading">\
			<div class="sk-spinner sk-spinner-wave" ng-if="!options.loaded" style="display: block;">\
				<div class="sk-rect1"></div>\
				<div class="sk-rect2"></div>\
				<div class="sk-rect3"></div>\
				<div class="sk-rect4"></div>\
				<div class="sk-rect5"></div>\
			</div>\
		</div>\
		<div ng-include="pageTemplateUrl"></div>\
	</div>\
	<div class="modal-footer">\
		<button ng-if="!(updating||' +
					stateConfig.controllerAs +
					'.updating)" type="button" class="btn btn-white" ng-click="cancel(\'discard\')">Cancel</button>\
		<button ng-if="updating||' +
					stateConfig.controllerAs +
					'.updating" type="button" class="btn btn-white" ng-click="cancel(\'discard\')">Done</button>\
	</div>\
</div>',
				resolve: angular.extend(stateConfig.resolve, {
					pageTemplateUrl: [
						'$http',
						'$timeout',
						function($http, $timeout) {
							return $http
								.head(templateUrl)
								.then(
									function(response) {
										return (response.config.url || original) + '?v=' + variables.versionTimestamp;
									},
									$rootScope.templatesFolder
										? function() {
												// @TODO handle offline use case
												return original + '?v=' + variables.versionTimestamp;
										  }
										: angular.noop
								)
								.then(function(templateUrl) {
									var cachedTemplate = $templateCache.get(templateUrl);
									if (cachedTemplate) {
										return resolveTemplateUrl(templateUrl);
									}
									return $http.get(templateUrl).then(function(tpl) {
										$templateCache.put(templateUrl, tpl.data);
										return resolveTemplateUrl(templateUrl);
									});
								}, angular.noop);
						},
					],
					$stateParams: stateParams || {},
				}),
			};

			$rootScope.goBack = scope.cancel; // temp override

			// console.log('closeOn: ', scopeOpts.closeOn);
			if (scopeOpts.closeOn) {
				scope.$on(scopeOpts.closeOn, function() {
					confirmed = true;
					$timeout(function() {
						scope.cancel('closeOn');
					});
				});
			}

			modalInstance = $uibModal.open(modal);

			var triesLeft = 10;
			(setZIndex = function() {
				$timeout(function() {
					var _modal = angular.element('#edit-features-modal-' + String($rootScope.openEditModalsCount - 1));
					// console.log(_modal);
					_modal.length || (--triesLeft && setZIndex());
					_modal.length &&
						_modal
							.parent()
							.parent()
							.parent()
							.css({
								'z-index': String(2050 + $rootScope.openEditModalsCount * 10),
							})
							.addClass('edit-modal-container');
					_modal = null;
				}, 40);
			})();

			$rootScope.editModals.push({
				stateConfig: stateConfig,
				stateParams: stateParams || {},
				modal: modal,
				instance: modalInstance,
			});
			$rootScope.openEditModalsCount++;

			return modalInstance;
		};

		var getCurrentState = function() {
			return $rootScope.openEditModalsCount
				? $rootScope.editModals[$rootScope.openEditModalsCount - 1].stateConfig
				: $state.current;
		};

		var getCurrentStateParams = function() {
			return $rootScope.openEditModalsCount
				? $rootScope.editModals[$rootScope.openEditModalsCount - 1].stateParams
				: $stateParams;
		};

		var getPreselectOptions = function() {
			var preselect = getCurrentStateParams().preselect;
			return preselect
				? preselect
						.split(';')
						.filter(function(item) {
							return /.+\=.*/.test(item);
						})
						.map(function(item) {
							var matches = item.match(/(.+)\=(.*)/);
							return {
								name: matches[1],
								value: matches[2],
							};
						})
				: [];
		};

		var addSlashIfNeeded = function(s) {
			return /\/$/.test(s) ? s : s + '/';
		};

		var pixelRatio = window.devicePixelRatio || 1;
		var mql = window.matchMedia('screen and (min-resolution: 1.5dppx)');

		var handleDensityChange = function(e) {
			if (e.matches) {
				pixelRatio = 2;
			} else {
				pixelRatio = 1;
			}
			// console.log('handleDensityChange', e, pixelRatio, window.devicePixelRatio);
		};

		mql.addListener(handleDensityChange);

		$rootScope.$on('$destroy', function() {
			mql.removeListener(handleDensityChange);
			mql = null;
		});

		var avatarImage = function(str, size, lettersCount) {
			var canvas = document.createElement('canvas');
			var scale = pixelRatio;

			var context = canvas.getContext('2d');
			//context.scale(scale, scale); // not working properly!
			str = String((str === 0 ? '0' : str) || '').trim();
			size = (size || 60) * scale;
			lettersCount = Math.min(lettersCount || 2, str.length);
			var letters = str.substring(0, lettersCount).trim();

			// Generate a random color every time function is called
			var rand = 0.1 + Math.random() * 0.8;
			var color = '#' + ((rand * 0xffffff) << 0).toString(16);

			canvas.width = size;
			canvas.height = size;

			context.font = String(Math.round(canvas.width / 2)) + 'px Arial'; // + window.getComputedStyle(document.body, null).getPropertyValue('font-family');

			context.fillStyle = color;
			context.fillRect(0, 0, size, size);
			context.fillStyle = '#FFF';
			context.textAlign = 'center';
			context.textBaseline = 'middle';
			context.fillText(letters, size / 2, size / 2);

			var dataURI = canvas.toDataURL();

			canvas = null;

			return dataURI;
		};

		var copyToClipboard = (function() {
			var textarea = document.createElement('textarea');
			textarea.setAttribute('readonly', '');
			textarea.style.position = 'absolute';
			textarea.style.left = '-9999px';
			$rootScope.$on('$destroy', function() {
				textarea = null;
			});
			return function(text) {
				// Check if there is any content selected previously so we can restore it
				var selected = document.getSelection().rangeCount > 0 ? document.getSelection().getRangeAt(0) : false;
				textarea.value = text;
				document.body.appendChild(textarea);
				textarea.select();
				document.execCommand('copy');
				textarea.value = '';
				document.body.removeChild(textarea);
				if (selected) {
					// If a selection existed before copying, unselect everything on the HTML document and restore the original selection
					document.getSelection().removeAllRanges();
					document.getSelection().addRange(selected);
				}
				return text;
			};
		})();

		var starFeature = function(dtype, dnumber, value, ref) {
			var endpoint = value ? 'starred/set' : 'starred/unset';
			return CoreApiService.makeApiCall('POST', endpoint, {
				dtype: dtype,
				dnumber: dnumber,
			}).then(function() {
				ref &&
					ref instanceof Object &&
					$timeout(function() {
						ref.isStarred = value;
					});
			}, CoreApiService.defaultErrorHandler);
		};

		var checkStarred = function(dtype, dnumber) {
			return CoreApiService.makeApiCall('POST', 'starred/get', {
				dtype: dtype,
				dnumber: dnumber,
			}).then(function(response) {
				return !!Number(response.data.set);
			}, angular.identity);
		};

		var regexLastIndexOf = function(str, regex) {
			regex = regex.global
				? regex
				: new RegExp(regex.source, 'g' + (regex.ignoreCase ? 'i' : '') + (regex.multiLine ? 'm' : ''));
			var lastIndexOf = -1;
			var nextStop = 0;
			var result;
			while ((result = regex.exec(str)) != null) {
				lastIndexOf = result.index;
				regex.lastIndex = ++nextStop;
			}
			return lastIndexOf;
		};

		var sameParameters = function(stateParams, newParams) {
			var params = angular.copy(stateParams);
			delete params['#'];
			delete params.preselect;
			delete params.modal;

			var _params = angular.copy(newParams);
			for (var i in _params)
				if (!(i in params)) delete _params[i];
				else if (_params[i] === 0) {
					_params[i] = '0';
				} else {
					_params[i] = String(_params[i] || '');
				}

			return angular.equals(params, _params);
		};

		var getMinimumFontSize = function() {
			var ta = document.createElement('div');
			ta.style.fontSize = '6px';
			ta.style.lineHeight = '1';
			ta.innerHTML = 'a';
			document.body.appendChild(ta);
			var minimumFontSize = ta.clientHeight;
			document.body.removeChild(ta);
			ta = null;
			return minimumFontSize;
		};

		return {
			loadScript: loadScript,
			randomString: randomString,
			regexFromString: regexFromString,
			createPassword: createPassword,
			exportToCSV: exportToCSV,
			parseCSVFile: parseCSVFile,
			getTimezoneOffset: getOffset,
			format_date: format_date,
			format_time: format_time,
			format_date_time: format_date_time,
			format_month: format_month,
			newDate: newDate,
			newStartDate: newStartDate,
			newEndDate: newEndDate,
			systemTimestamp: systemTimestamp,
			day_start: day_start,
			day_end: day_end,
			trim_money: trim_money,
			getLink: getLink,
			web_display_destination: web_display_destination,
			copyNotes: copyNotes,
			setNewExpiry: setNewExpiry,
			web_role_allowed: web_role_allowed,
			checkAllowAdmin: check_allow_admin,
			checkMaximumFeatures: checkMaximumFeatures,
			format_interval: format_interval,
			getOffsetLeft: getOffsetLeft,
			getOffsetTop: getOffsetTop,
			scrollToInput: scrollToInput,
			decodeEntities: decodeEntities,
			stripHTMLTags: stripHTMLTags,
			numArray: numArray,
			addItemToSortedArray: addItemToSortedArray,
			addItemsToSortedArray: addItemsToSortedArray,
			hasClass: hasClass,
			checkIfFileExists: checkIfFileExists,
			cancelPendingApiRequests: cancelPendingApiRequests,
			openModalAudioPlayer: openModalAudioPlayer,
			openEditPageInModal: openEditPageInModal,
			getCurrentState: getCurrentState,
			getCurrentStateParams: getCurrentStateParams,
			getPreselectOptions: getPreselectOptions,
			addSlashIfNeeded: addSlashIfNeeded,
			avatarImage: avatarImage,
			copyToClipboard: copyToClipboard,
			starFeature: starFeature,
			checkStarred: checkStarred,
			regexLastIndexOf: regexLastIndexOf,
			sameParameters: sameParameters,
			getMinimumFontSize: getMinimumFontSize,
		};
	});

'use strict';

angular
	.module('new-web')

	.factory('TimezonesService', function() {
		var timezones = [
			{
				value: 'Dateline Standard Time',
				abbr: 'DST',
				offset: -12,
				isdst: false,
				text: '(UTC-12:00) International Date Line West',
				utc: ['Etc/GMT+12'],
			},
			{
				value: 'UTC-11',
				abbr: 'U',
				offset: -11,
				isdst: false,
				text: '(UTC-11:00) Coordinated Universal Time-11',
				utc: ['Etc/GMT+11', 'Pacific/Midway', 'Pacific/Niue', 'Pacific/Pago_Pago'],
			},
			{
				value: 'Hawaiian Standard Time',
				abbr: 'HST',
				offset: -10,
				isdst: false,
				text: '(UTC-10:00) Hawaii',
				utc: ['Etc/GMT+10', 'Pacific/Honolulu', 'Pacific/Johnston', 'Pacific/Rarotonga', 'Pacific/Tahiti'],
			},
			{
				value: 'Alaskan Standard Time',
				abbr: 'AKDT',
				offset: -8,
				isdst: true,
				text: '(UTC-09:00) Alaska',
				utc: ['America/Anchorage', 'America/Juneau', 'America/Nome', 'America/Sitka', 'America/Yakutat'],
			},
			{
				value: 'Pacific Standard Time (Mexico)',
				abbr: 'PDT',
				offset: -7,
				isdst: true,
				text: '(UTC-08:00) Baja California',
				utc: ['America/Santa_Isabel'],
			},
			{
				value: 'Pacific Daylight Time',
				abbr: 'PDT',
				offset: -7,
				isdst: true,
				text: '(UTC-07:00) Pacific Time (US & Canada)',
				utc: ['America/Dawson', 'America/Los_Angeles', 'America/Tijuana', 'America/Vancouver', 'America/Whitehorse'],
			},
			{
				value: 'Pacific Standard Time',
				abbr: 'PST',
				offset: -8,
				isdst: false,
				text: '(UTC-08:00) Pacific Time (US & Canada)',
				utc: [
					'America/Dawson',
					'America/Los_Angeles',
					'America/Tijuana',
					'America/Vancouver',
					'America/Whitehorse',
					'PST8PDT',
				],
			},
			{
				value: 'US Mountain Standard Time',
				abbr: 'UMST',
				offset: -7,
				isdst: false,
				text: '(UTC-07:00) Arizona',
				utc: ['America/Creston', 'America/Dawson_Creek', 'America/Hermosillo', 'America/Phoenix', 'Etc/GMT+7'],
			},
			{
				value: 'Mountain Standard Time (Mexico)',
				abbr: 'MDT',
				offset: -6,
				isdst: true,
				text: '(UTC-07:00) Chihuahua, La Paz, Mazatlan',
				utc: ['America/Chihuahua', 'America/Mazatlan'],
			},
			{
				value: 'Mountain Standard Time',
				abbr: 'MDT',
				offset: -6,
				isdst: true,
				text: '(UTC-07:00) Mountain Time (US & Canada)',
				utc: [
					'America/Boise',
					'America/Cambridge_Bay',
					'America/Denver',
					'America/Edmonton',
					'America/Inuvik',
					'America/Ojinaga',
					'America/Yellowknife',
					'MST7MDT',
				],
			},
			{
				value: 'Central America Standard Time',
				abbr: 'CAST',
				offset: -6,
				isdst: false,
				text: '(UTC-06:00) Central America',
				utc: [
					'America/Belize',
					'America/Costa_Rica',
					'America/El_Salvador',
					'America/Guatemala',
					'America/Managua',
					'America/Tegucigalpa',
					'Etc/GMT+6',
					'Pacific/Galapagos',
				],
			},
			{
				value: 'Central Standard Time',
				abbr: 'CDT',
				offset: -5,
				isdst: true,
				text: '(UTC-06:00) Central Time (US & Canada)',
				utc: [
					'America/Chicago',
					'America/Indiana/Knox',
					'America/Indiana/Tell_City',
					'America/Matamoros',
					'America/Menominee',
					'America/North_Dakota/Beulah',
					'America/North_Dakota/Center',
					'America/North_Dakota/New_Salem',
					'America/Rainy_River',
					'America/Rankin_Inlet',
					'America/Resolute',
					'America/Winnipeg',
					'CST6CDT',
				],
			},
			{
				value: 'Central Standard Time (Mexico)',
				abbr: 'CDT',
				offset: -5,
				isdst: true,
				text: '(UTC-06:00) Guadalajara, Mexico City, Monterrey',
				utc: ['America/Bahia_Banderas', 'America/Cancun', 'America/Merida', 'America/Mexico_City', 'America/Monterrey'],
			},
			{
				value: 'Canada Central Standard Time',
				abbr: 'CCST',
				offset: -6,
				isdst: false,
				text: '(UTC-06:00) Saskatchewan',
				utc: ['America/Regina', 'America/Swift_Current'],
			},
			{
				value: 'SA Pacific Standard Time',
				abbr: 'SPST',
				offset: -5,
				isdst: false,
				text: '(UTC-05:00) Bogota, Lima, Quito',
				utc: [
					'America/Bogota',
					'America/Cayman',
					'America/Coral_Harbour',
					'America/Eirunepe',
					'America/Guayaquil',
					'America/Jamaica',
					'America/Lima',
					'America/Panama',
					'America/Rio_Branco',
					'Etc/GMT+5',
				],
			},
			{
				value: 'Eastern Standard Time',
				abbr: 'EDT',
				offset: -4,
				isdst: true,
				text: '(UTC-05:00) Eastern Time (US & Canada)',
				utc: [
					'America/Detroit',
					'America/Havana',
					'America/Indiana/Petersburg',
					'America/Indiana/Vincennes',
					'America/Indiana/Winamac',
					'America/Iqaluit',
					'America/Kentucky/Monticello',
					'America/Louisville',
					'America/Montreal',
					'America/Nassau',
					'America/New_York',
					'America/Nipigon',
					'America/Pangnirtung',
					'America/Port-au-Prince',
					'America/Thunder_Bay',
					'America/Toronto',
					'EST5EDT',
				],
			},
			{
				value: 'US Eastern Standard Time',
				abbr: 'UEDT',
				offset: -4,
				isdst: true,
				text: '(UTC-05:00) Indiana (East)',
				utc: ['America/Indiana/Marengo', 'America/Indiana/Vevay', 'America/Indianapolis'],
			},
			{
				value: 'Venezuela Standard Time',
				abbr: 'VST',
				offset: -4.5,
				isdst: false,
				text: '(UTC-04:30) Caracas',
				utc: ['America/Caracas'],
			},
			{
				value: 'Paraguay Standard Time',
				abbr: 'PYT',
				offset: -4,
				isdst: false,
				text: '(UTC-04:00) Asuncion',
				utc: ['America/Asuncion'],
			},
			{
				value: 'Atlantic Standard Time',
				abbr: 'ADT',
				offset: -3,
				isdst: true,
				text: '(UTC-04:00) Atlantic Time (Canada)',
				utc: [
					'America/Glace_Bay',
					'America/Goose_Bay',
					'America/Halifax',
					'America/Moncton',
					'America/Thule',
					'Atlantic/Bermuda',
				],
			},
			{
				value: 'Central Brazilian Standard Time',
				abbr: 'CBST',
				offset: -4,
				isdst: false,
				text: '(UTC-04:00) Cuiaba',
				utc: ['America/Campo_Grande', 'America/Cuiaba'],
			},
			{
				value: 'SA Western Standard Time',
				abbr: 'SWST',
				offset: -4,
				isdst: false,
				text: '(UTC-04:00) Georgetown, La Paz, Manaus, San Juan',
				utc: [
					'America/Anguilla',
					'America/Antigua',
					'America/Aruba',
					'America/Barbados',
					'America/Blanc-Sablon',
					'America/Boa_Vista',
					'America/Curacao',
					'America/Dominica',
					'America/Grand_Turk',
					'America/Grenada',
					'America/Guadeloupe',
					'America/Guyana',
					'America/Kralendijk',
					'America/La_Paz',
					'America/Lower_Princes',
					'America/Manaus',
					'America/Marigot',
					'America/Martinique',
					'America/Montserrat',
					'America/Port_of_Spain',
					'America/Porto_Velho',
					'America/Puerto_Rico',
					'America/Santo_Domingo',
					'America/St_Barthelemy',
					'America/St_Kitts',
					'America/St_Lucia',
					'America/St_Thomas',
					'America/St_Vincent',
					'America/Tortola',
					'Etc/GMT+4',
				],
			},
			{
				value: 'Pacific SA Standard Time',
				abbr: 'PSST',
				offset: -4,
				isdst: false,
				text: '(UTC-04:00) Santiago',
				utc: ['America/Santiago', 'Antarctica/Palmer'],
			},
			{
				value: 'Newfoundland Standard Time',
				abbr: 'NDT',
				offset: -2.5,
				isdst: true,
				text: '(UTC-03:30) Newfoundland',
				utc: ['America/St_Johns'],
			},
			{
				value: 'E. South America Standard Time',
				abbr: 'ESAST',
				offset: -3,
				isdst: false,
				text: '(UTC-03:00) Brasilia',
				utc: ['America/Sao_Paulo'],
			},
			{
				value: 'Argentina Standard Time',
				abbr: 'ART',
				offset: -3,
				isdst: false,
				text: '(UTC-03:00) Buenos Aires',
				utc: [
					'America/Argentina/La_Rioja',
					'America/Argentina/Rio_Gallegos',
					'America/Argentina/Salta',
					'America/Argentina/San_Juan',
					'America/Argentina/San_Luis',
					'America/Argentina/Tucuman',
					'America/Argentina/Ushuaia',
					'America/Buenos_Aires',
					'America/Catamarca',
					'America/Cordoba',
					'America/Jujuy',
					'America/Mendoza',
				],
			},
			{
				value: 'SA Eastern Standard Time',
				abbr: 'SEST',
				offset: -3,
				isdst: false,
				text: '(UTC-03:00) Cayenne, Fortaleza',
				utc: [
					'America/Araguaina',
					'America/Belem',
					'America/Cayenne',
					'America/Fortaleza',
					'America/Maceio',
					'America/Paramaribo',
					'America/Recife',
					'America/Santarem',
					'Antarctica/Rothera',
					'Atlantic/Stanley',
					'Etc/GMT+3',
				],
			},
			{
				value: 'Greenland Standard Time',
				abbr: 'GDT',
				offset: -3,
				isdst: true,
				text: '(UTC-03:00) Greenland',
				utc: ['America/Godthab'],
			},
			{
				value: 'Montevideo Standard Time',
				abbr: 'MST',
				offset: -3,
				isdst: false,
				text: '(UTC-03:00) Montevideo',
				utc: ['America/Montevideo'],
			},
			{
				value: 'Bahia Standard Time',
				abbr: 'BST',
				offset: -3,
				isdst: false,
				text: '(UTC-03:00) Salvador',
				utc: ['America/Bahia'],
			},
			{
				value: 'UTC-02',
				abbr: 'U',
				offset: -2,
				isdst: false,
				text: '(UTC-02:00) Coordinated Universal Time-02',
				utc: ['America/Noronha', 'Atlantic/South_Georgia', 'Etc/GMT+2'],
			},
			{
				value: 'Mid-Atlantic Standard Time',
				abbr: 'MDT',
				offset: -1,
				isdst: true,
				text: '(UTC-02:00) Mid-Atlantic - Old',
				utc: [],
			},
			{
				value: 'Azores Standard Time',
				abbr: 'AZOT',
				offset: 0,
				isdst: true,
				text: '(UTC-01:00) Azores',
				utc: ['America/Scoresbysund', 'Atlantic/Azores'],
			},
			{
				value: 'Cape Verde Standard Time',
				abbr: 'CVST',
				offset: -1,
				isdst: false,
				text: '(UTC-01:00) Cape Verde Is.',
				utc: ['Atlantic/Cape_Verde', 'Etc/GMT+1'],
			},
			{
				value: 'Morocco Standard Time',
				abbr: 'MDT',
				offset: 1,
				isdst: true,
				text: '(UTC) Casablanca',
				utc: ['Africa/Casablanca', 'Africa/El_Aaiun'],
			},
			{
				value: 'UTC',
				abbr: 'UTC',
				offset: 0,
				isdst: false,
				text: '(UTC) Coordinated Universal Time',
				utc: ['America/Danmarkshavn', 'Etc/GMT'],
			},
			{
				value: 'GMT Standard Time',
				abbr: 'GMT',
				offset: 0,
				isdst: false,
				text: '(UTC) Edinburgh, London',
				utc: ['Europe/Isle_of_Man', 'Europe/Guernsey', 'Europe/Jersey', 'Europe/London'],
			},
			{
				value: 'British Summer Time',
				abbr: 'BST',
				offset: 1,
				isdst: true,
				text: '(UTC+01:00) Edinburgh, London',
				utc: ['Europe/Isle_of_Man', 'Europe/Guernsey', 'Europe/Jersey', 'Europe/London'],
			},
			{
				value: 'GMT Standard Time',
				abbr: 'GDT',
				offset: 1,
				isdst: true,
				text: '(UTC) Dublin, Lisbon',
				utc: ['Atlantic/Canary', 'Atlantic/Faeroe', 'Atlantic/Madeira', 'Europe/Dublin', 'Europe/Lisbon'],
			},
			{
				value: 'Greenwich Standard Time',
				abbr: 'GST',
				offset: 0,
				isdst: false,
				text: '(UTC) Monrovia, Reykjavik',
				utc: [
					'Africa/Abidjan',
					'Africa/Accra',
					'Africa/Bamako',
					'Africa/Banjul',
					'Africa/Bissau',
					'Africa/Conakry',
					'Africa/Dakar',
					'Africa/Freetown',
					'Africa/Lome',
					'Africa/Monrovia',
					'Africa/Nouakchott',
					'Africa/Ouagadougou',
					'Africa/Sao_Tome',
					'Atlantic/Reykjavik',
					'Atlantic/St_Helena',
				],
			},
			{
				value: 'W. Europe Standard Time',
				abbr: 'WEDT',
				offset: 2,
				isdst: true,
				text: '(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna',
				utc: [
					'Arctic/Longyearbyen',
					'Europe/Amsterdam',
					'Europe/Andorra',
					'Europe/Berlin',
					'Europe/Busingen',
					'Europe/Gibraltar',
					'Europe/Luxembourg',
					'Europe/Malta',
					'Europe/Monaco',
					'Europe/Oslo',
					'Europe/Rome',
					'Europe/San_Marino',
					'Europe/Stockholm',
					'Europe/Vaduz',
					'Europe/Vatican',
					'Europe/Vienna',
					'Europe/Zurich',
				],
			},
			{
				value: 'Central Europe Standard Time',
				abbr: 'CEDT',
				offset: 2,
				isdst: true,
				text: '(UTC+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague',
				utc: [
					'Europe/Belgrade',
					'Europe/Bratislava',
					'Europe/Budapest',
					'Europe/Ljubljana',
					'Europe/Podgorica',
					'Europe/Prague',
					'Europe/Tirane',
				],
			},
			{
				value: 'Romance Standard Time',
				abbr: 'RDT',
				offset: 2,
				isdst: true,
				text: '(UTC+01:00) Brussels, Copenhagen, Madrid, Paris',
				utc: ['Africa/Ceuta', 'Europe/Brussels', 'Europe/Copenhagen', 'Europe/Madrid', 'Europe/Paris'],
			},
			{
				value: 'Central European Standard Time',
				abbr: 'CEDT',
				offset: 2,
				isdst: true,
				text: '(UTC+01:00) Sarajevo, Skopje, Warsaw, Zagreb',
				utc: ['Europe/Sarajevo', 'Europe/Skopje', 'Europe/Warsaw', 'Europe/Zagreb'],
			},
			{
				value: 'W. Central Africa Standard Time',
				abbr: 'WCAST',
				offset: 1,
				isdst: false,
				text: '(UTC+01:00) West Central Africa',
				utc: [
					'Africa/Algiers',
					'Africa/Bangui',
					'Africa/Brazzaville',
					'Africa/Douala',
					'Africa/Kinshasa',
					'Africa/Lagos',
					'Africa/Libreville',
					'Africa/Luanda',
					'Africa/Malabo',
					'Africa/Ndjamena',
					'Africa/Niamey',
					'Africa/Porto-Novo',
					'Africa/Tunis',
					'Etc/GMT-1',
				],
			},
			{
				value: 'Namibia Standard Time',
				abbr: 'NST',
				offset: 1,
				isdst: false,
				text: '(UTC+01:00) Windhoek',
				utc: ['Africa/Windhoek'],
			},
			{
				value: 'GTB Standard Time',
				abbr: 'GDT',
				offset: 3,
				isdst: true,
				text: '(UTC+02:00) Athens, Bucharest',
				utc: ['Asia/Nicosia', 'Europe/Athens', 'Europe/Bucharest', 'Europe/Chisinau'],
			},
			{
				value: 'Middle East Standard Time',
				abbr: 'MEDT',
				offset: 3,
				isdst: true,
				text: '(UTC+02:00) Beirut',
				utc: ['Asia/Beirut'],
			},
			{
				value: 'Egypt Standard Time',
				abbr: 'EST',
				offset: 2,
				isdst: false,
				text: '(UTC+02:00) Cairo',
				utc: ['Africa/Cairo'],
			},
			{
				value: 'Syria Standard Time',
				abbr: 'SDT',
				offset: 3,
				isdst: true,
				text: '(UTC+02:00) Damascus',
				utc: ['Asia/Damascus'],
			},
			{
				value: 'E. Europe Standard Time',
				abbr: 'EEDT',
				offset: 3,
				isdst: true,
				text: '(UTC+02:00) E. Europe',
				utc: [
					'Asia/Nicosia',
					'Europe/Athens',
					'Europe/Bucharest',
					'Europe/Chisinau',
					'Europe/Helsinki',
					'Europe/Kiev',
					'Europe/Mariehamn',
					'Europe/Nicosia',
					'Europe/Riga',
					'Europe/Sofia',
					'Europe/Tallinn',
					'Europe/Uzhgorod',
					'Europe/Vilnius',
					'Europe/Zaporozhye',
				],
			},
			{
				value: 'South Africa Standard Time',
				abbr: 'SAST',
				offset: 2,
				isdst: false,
				text: '(UTC+02:00) Harare, Pretoria',
				utc: [
					'Africa/Blantyre',
					'Africa/Bujumbura',
					'Africa/Gaborone',
					'Africa/Harare',
					'Africa/Johannesburg',
					'Africa/Kigali',
					'Africa/Lubumbashi',
					'Africa/Lusaka',
					'Africa/Maputo',
					'Africa/Maseru',
					'Africa/Mbabane',
					'Etc/GMT-2',
				],
			},
			{
				value: 'FLE Standard Time',
				abbr: 'FDT',
				offset: 3,
				isdst: true,
				text: '(UTC+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius',
				utc: [
					'Europe/Helsinki',
					'Europe/Kiev',
					'Europe/Mariehamn',
					'Europe/Riga',
					'Europe/Sofia',
					'Europe/Tallinn',
					'Europe/Uzhgorod',
					'Europe/Vilnius',
					'Europe/Zaporozhye',
				],
			},
			{
				value: 'Turkey Standard Time',
				abbr: 'TDT',
				offset: 3,
				isdst: false,
				text: '(UTC+03:00) Istanbul',
				utc: ['Europe/Istanbul'],
			},
			{
				value: 'Israel Standard Time',
				abbr: 'JDT',
				offset: 3,
				isdst: true,
				text: '(UTC+02:00) Jerusalem',
				utc: ['Asia/Jerusalem'],
			},
			{
				value: 'Libya Standard Time',
				abbr: 'LST',
				offset: 2,
				isdst: false,
				text: '(UTC+02:00) Tripoli',
				utc: ['Africa/Tripoli'],
			},
			{
				value: 'Jordan Standard Time',
				abbr: 'JST',
				offset: 3,
				isdst: false,
				text: '(UTC+03:00) Amman',
				utc: ['Asia/Amman'],
			},
			{
				value: 'Arabic Standard Time',
				abbr: 'AST',
				offset: 3,
				isdst: false,
				text: '(UTC+03:00) Baghdad',
				utc: ['Asia/Baghdad'],
			},
			{
				value: 'Kaliningrad Standard Time',
				abbr: 'KST',
				offset: 3,
				isdst: false,
				text: '(UTC+02:00) Kaliningrad',
				utc: ['Europe/Kaliningrad'],
			},
			{
				value: 'Arab Standard Time',
				abbr: 'AST',
				offset: 3,
				isdst: false,
				text: '(UTC+03:00) Kuwait, Riyadh',
				utc: ['Asia/Aden', 'Asia/Bahrain', 'Asia/Kuwait', 'Asia/Qatar', 'Asia/Riyadh'],
			},
			{
				value: 'E. Africa Standard Time',
				abbr: 'EAST',
				offset: 3,
				isdst: false,
				text: '(UTC+03:00) Nairobi',
				utc: [
					'Africa/Addis_Ababa',
					'Africa/Asmera',
					'Africa/Dar_es_Salaam',
					'Africa/Djibouti',
					'Africa/Juba',
					'Africa/Kampala',
					'Africa/Khartoum',
					'Africa/Mogadishu',
					'Africa/Nairobi',
					'Antarctica/Syowa',
					'Etc/GMT-3',
					'Indian/Antananarivo',
					'Indian/Comoro',
					'Indian/Mayotte',
				],
			},
			{
				value: 'Moscow Standard Time',
				abbr: 'MSK',
				offset: 3,
				isdst: false,
				text: '(UTC+03:00) Moscow, St. Petersburg, Volgograd, Minsk',
				utc: ['Europe/Kirov', 'Europe/Moscow', 'Europe/Simferopol', 'Europe/Volgograd', 'Europe/Minsk'],
			},
			{
				value: 'Samara Time',
				abbr: 'SAMT',
				offset: 4,
				isdst: false,
				text: '(UTC+04:00) Samara, Ulyanovsk, Saratov',
				utc: ['Europe/Astrakhan', 'Europe/Samara', 'Europe/Ulyanovsk'],
			},
			{
				value: 'Iran Standard Time',
				abbr: 'IDT',
				offset: 4.5,
				isdst: true,
				text: '(UTC+03:30) Tehran',
				utc: ['Asia/Tehran'],
			},
			{
				value: 'Arabian Standard Time',
				abbr: 'AST',
				offset: 4,
				isdst: false,
				text: '(UTC+04:00) Abu Dhabi, Muscat',
				utc: ['Asia/Dubai', 'Asia/Muscat', 'Etc/GMT-4'],
			},
			{
				value: 'Azerbaijan Standard Time',
				abbr: 'AZT',
				offset: 5,
				isdst: true,
				text: '(UTC+04:00) Baku',
				utc: ['Asia/Baku'],
			},
			{
				value: 'Mauritius Standard Time',
				abbr: 'MST',
				offset: 4,
				isdst: false,
				text: '(UTC+04:00) Port Louis',
				utc: ['Indian/Mahe', 'Indian/Mauritius', 'Indian/Reunion'],
			},
			{
				value: 'Georgian Standard Time',
				abbr: 'GET',
				offset: 4,
				isdst: false,
				text: '(UTC+04:00) Tbilisi',
				utc: ['Asia/Tbilisi'],
			},
			{
				value: 'Caucasus Standard Time',
				abbr: 'CST',
				offset: 4,
				isdst: false,
				text: '(UTC+04:00) Yerevan',
				utc: ['Asia/Yerevan'],
			},
			{
				value: 'Afghanistan Standard Time',
				abbr: 'AFT',
				offset: 4.5,
				isdst: false,
				text: '(UTC+04:30) Kabul',
				utc: ['Asia/Kabul'],
			},
			{
				value: 'West Asia Standard Time',
				abbr: 'WAST',
				offset: 5,
				isdst: false,
				text: '(UTC+05:00) Ashgabat, Tashkent',
				utc: [
					'Antarctica/Mawson',
					'Asia/Aqtau',
					'Asia/Aqtobe',
					'Asia/Ashgabat',
					'Asia/Dushanbe',
					'Asia/Oral',
					'Asia/Samarkand',
					'Asia/Tashkent',
					'Etc/GMT-5',
					'Indian/Kerguelen',
					'Indian/Maldives',
				],
			},
			{
				value: 'Yekaterinburg Time',
				abbr: 'YEKT',
				offset: 5,
				isdst: false,
				text: '(UTC+05:00) Yekaterinburg',
				utc: ['Asia/Yekaterinburg'],
			},
			{
				value: 'Pakistan Standard Time',
				abbr: 'PKT',
				offset: 5,
				isdst: false,
				text: '(UTC+05:00) Islamabad, Karachi',
				utc: ['Asia/Karachi'],
			},
			{
				value: 'India Standard Time',
				abbr: 'IST',
				offset: 5.5,
				isdst: false,
				text: '(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi',
				utc: ['Asia/Kolkata'],
			},
			{
				value: 'Sri Lanka Standard Time',
				abbr: 'SLST',
				offset: 5.5,
				isdst: false,
				text: '(UTC+05:30) Sri Jayawardenepura',
				utc: ['Asia/Colombo'],
			},
			{
				value: 'Nepal Standard Time',
				abbr: 'NST',
				offset: 5.75,
				isdst: false,
				text: '(UTC+05:45) Kathmandu',
				utc: ['Asia/Kathmandu'],
			},
			{
				value: 'Central Asia Standard Time',
				abbr: 'CAST',
				offset: 6,
				isdst: false,
				text: '(UTC+06:00) Nur-Sultan (Astana)',
				utc: [
					'Antarctica/Vostok',
					'Asia/Almaty',
					'Asia/Bishkek',
					'Asia/Qyzylorda',
					'Asia/Urumqi',
					'Etc/GMT-6',
					'Indian/Chagos',
				],
			},
			{
				value: 'Bangladesh Standard Time',
				abbr: 'BST',
				offset: 6,
				isdst: false,
				text: '(UTC+06:00) Dhaka',
				utc: ['Asia/Dhaka', 'Asia/Thimphu'],
			},
			{
				value: 'Myanmar Standard Time',
				abbr: 'MST',
				offset: 6.5,
				isdst: false,
				text: '(UTC+06:30) Yangon (Rangoon)',
				utc: ['Asia/Rangoon', 'Indian/Cocos'],
			},
			{
				value: 'SE Asia Standard Time',
				abbr: 'SAST',
				offset: 7,
				isdst: false,
				text: '(UTC+07:00) Bangkok, Hanoi, Jakarta',
				utc: [
					'Antarctica/Davis',
					'Asia/Bangkok',
					'Asia/Hovd',
					'Asia/Jakarta',
					'Asia/Phnom_Penh',
					'Asia/Pontianak',
					'Asia/Saigon',
					'Asia/Vientiane',
					'Etc/GMT-7',
					'Indian/Christmas',
				],
			},
			{
				value: 'N. Central Asia Standard Time',
				abbr: 'NCAST',
				offset: 7,
				isdst: false,
				text: '(UTC+07:00) Novosibirsk',
				utc: ['Asia/Novokuznetsk', 'Asia/Novosibirsk', 'Asia/Omsk'],
			},
			{
				value: 'China Standard Time',
				abbr: 'CST',
				offset: 8,
				isdst: false,
				text: '(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi',
				utc: ['Asia/Hong_Kong', 'Asia/Macau', 'Asia/Shanghai'],
			},
			{
				value: 'North Asia Standard Time',
				abbr: 'NAST',
				offset: 8,
				isdst: false,
				text: '(UTC+08:00) Krasnoyarsk',
				utc: ['Asia/Krasnoyarsk'],
			},
			{
				value: 'Singapore Standard Time',
				abbr: 'MPST',
				offset: 8,
				isdst: false,
				text: '(UTC+08:00) Kuala Lumpur, Singapore',
				utc: [
					'Asia/Brunei',
					'Asia/Kuala_Lumpur',
					'Asia/Kuching',
					'Asia/Makassar',
					'Asia/Manila',
					'Asia/Singapore',
					'Etc/GMT-8',
				],
			},
			{
				value: 'W. Australia Standard Time',
				abbr: 'AWST',
				offset: 8,
				isdst: false,
				text: '(UTC+08:00) Perth',
				utc: ['Antarctica/Casey', 'Australia/Perth'],
			},
			{
				value: 'Taipei Standard Time',
				abbr: 'TST',
				offset: 8,
				isdst: false,
				text: '(UTC+08:00) Taipei',
				utc: ['Asia/Taipei'],
			},
			{
				value: 'Ulaanbaatar Standard Time',
				abbr: 'UST',
				offset: 8,
				isdst: false,
				text: '(UTC+08:00) Ulaanbaatar',
				utc: ['Asia/Choibalsan', 'Asia/Ulaanbaatar'],
			},
			{
				value: 'North Asia East Standard Time',
				abbr: 'NAEST',
				offset: 8,
				isdst: false,
				text: '(UTC+08:00) Irkutsk',
				utc: ['Asia/Irkutsk'],
			},
			{
				value: 'Japan Standard Time',
				abbr: 'JST',
				offset: 9,
				isdst: false,
				text: '(UTC+09:00) Osaka, Sapporo, Tokyo',
				utc: ['Asia/Dili', 'Asia/Jayapura', 'Asia/Tokyo', 'Etc/GMT-9', 'Pacific/Palau'],
			},
			{
				value: 'Korea Standard Time',
				abbr: 'KST',
				offset: 9,
				isdst: false,
				text: '(UTC+09:00) Seoul',
				utc: ['Asia/Pyongyang', 'Asia/Seoul'],
			},
			{
				value: 'Cen. Australia Standard Time',
				abbr: 'CAST',
				offset: 9.5,
				isdst: false,
				text: '(UTC+09:30) Adelaide',
				utc: ['Australia/Adelaide', 'Australia/Broken_Hill'],
			},
			{
				value: 'AUS Central Standard Time',
				abbr: 'ACST',
				offset: 9.5,
				isdst: false,
				text: '(UTC+09:30) Darwin',
				utc: ['Australia/Darwin'],
			},
			{
				value: 'E. Australia Standard Time',
				abbr: 'EAST',
				offset: 10,
				isdst: false,
				text: '(UTC+10:00) Brisbane',
				utc: ['Australia/Brisbane', 'Australia/Lindeman'],
			},
			{
				value: 'AUS Eastern Standard Time',
				abbr: 'AEST',
				offset: 10,
				isdst: false,
				text: '(UTC+10:00) Canberra, Melbourne, Sydney',
				utc: ['Australia/Melbourne', 'Australia/Sydney'],
			},
			{
				value: 'West Pacific Standard Time',
				abbr: 'WPST',
				offset: 10,
				isdst: false,
				text: '(UTC+10:00) Guam, Port Moresby',
				utc: [
					'Antarctica/DumontDUrville',
					'Etc/GMT-10',
					'Pacific/Guam',
					'Pacific/Port_Moresby',
					'Pacific/Saipan',
					'Pacific/Truk',
				],
			},
			{
				value: 'Tasmania Standard Time',
				abbr: 'TST',
				offset: 10,
				isdst: false,
				text: '(UTC+10:00) Hobart',
				utc: ['Australia/Currie', 'Australia/Hobart'],
			},
			{
				value: 'Yakutsk Standard Time',
				abbr: 'YST',
				offset: 9,
				isdst: false,
				text: '(UTC+09:00) Yakutsk',
				utc: ['Asia/Chita', 'Asia/Khandyga', 'Asia/Yakutsk'],
			},
			{
				value: 'Central Pacific Standard Time',
				abbr: 'CPST',
				offset: 11,
				isdst: false,
				text: '(UTC+11:00) Solomon Is., New Caledonia',
				utc: [
					'Antarctica/Macquarie',
					'Etc/GMT-11',
					'Pacific/Efate',
					'Pacific/Guadalcanal',
					'Pacific/Kosrae',
					'Pacific/Norfolk',
					'Pacific/Noumea',
					'Pacific/Ponape',
				],
			},
			{
				value: 'Vladivostok Standard Time',
				abbr: 'VST',
				offset: 11,
				isdst: false,
				text: '(UTC+11:00) Vladivostok',
				utc: ['Asia/Sakhalin', 'Asia/Ust-Nera', 'Asia/Vladivostok'],
			},
			{
				value: 'New Zealand Standard Time',
				abbr: 'NZST',
				offset: 12,
				isdst: false,
				text: '(UTC+12:00) Auckland, Wellington',
				utc: ['Antarctica/McMurdo', 'Pacific/Auckland'],
			},
			{
				value: 'UTC+12',
				abbr: 'U',
				offset: 12,
				isdst: false,
				text: '(UTC+12:00) Coordinated Universal Time+12',
				utc: [
					'Etc/GMT-12',
					'Pacific/Funafuti',
					'Pacific/Kwajalein',
					'Pacific/Majuro',
					'Pacific/Nauru',
					'Pacific/Tarawa',
					'Pacific/Wake',
					'Pacific/Wallis',
				],
			},
			{
				value: 'Fiji Standard Time',
				abbr: 'FST',
				offset: 12,
				isdst: false,
				text: '(UTC+12:00) Fiji',
				utc: ['Pacific/Fiji'],
			},
			{
				value: 'Magadan Standard Time',
				abbr: 'MST',
				offset: 12,
				isdst: false,
				text: '(UTC+12:00) Magadan',
				utc: ['Asia/Anadyr', 'Asia/Kamchatka', 'Asia/Magadan', 'Asia/Srednekolymsk'],
			},
			{
				value: 'Kamchatka Standard Time',
				abbr: 'KDT',
				offset: 13,
				isdst: true,
				text: '(UTC+12:00) Petropavlovsk-Kamchatsky - Old',
				utc: ['Asia/Kamchatka'],
			},
			{
				value: 'Tonga Standard Time',
				abbr: 'TST',
				offset: 13,
				isdst: false,
				text: "(UTC+13:00) Nuku'alofa",
				utc: ['Etc/GMT-13', 'Pacific/Enderbury', 'Pacific/Fakaofo', 'Pacific/Tongatapu'],
			},
			{
				value: 'Samoa Standard Time',
				abbr: 'SST',
				offset: 13,
				isdst: false,
				text: '(UTC+13:00) Samoa',
				utc: ['Pacific/Apia'],
			},
		];
		var timezoneTouse = function(timezoneAbbr) {
			return (
				_(timezones).find(function(timezone) {
					return timezone.abbr === timezoneAbbr.toUpperCase();
				})?.utc[0] || ''
			);
		};

		return {
			timezoneTouse: timezoneTouse,
		};
	});

'use strict';

angular
	.module('new-web')

	.factory('SwalService', function($window) {
		return {
			popup: function() {
				return $window.swal.apply($window.swal, arguments);
			},
			close: function() {
				return $window.swal.close();
			},
		};
	});

'use strict';

angular
	.module('new-web')
	.factory('RunService', function(
		$log,
		$rootScope,
		SessionService,
		$state,
		$urlRouter,
		$stateRegistry,
		$urlService,
		$transitions,
		$http,
		$q,
		$window,
		variables,
		$timeout,
		config,
		CustomersApiService,
		MenusApiService,
		ConfigsApiService,
		UserApiService,
		PeopleApiService,
		UtilsService,
		DomainsApiService,
		$location,
		$sce
	) {
		return {
			run: function() {
				$rootScope.versionTimestamp = enswitchGlobals.versionTimestamp = variables.versionTimestamp;
				$rootScope.contentHidden = true;
				$rootScope.emailRegex =
					"^[a-zA-Z0-9.!#$%&'*+\\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$";
				$rootScope.emailRegexEach =
					"/^[a-zA-Z0-9.!#$%&'*+=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/";

				// migration to ui-router 1.0+
				var lastTriedPath = '';

				$transitions.onSuccess({}, function(transition) {
					var toState = transition.$to();
					var toParams = transition.params();
					var fromState = transition.$from();
					var fromParams = transition.params('from');
					var options = transition._options;
					$rootScope.$broadcast('$stateChangeSuccess', toState, toParams, fromState, fromParams, options);
				});

				$rootScope.$on('$locationChangeStart', function(event, to, from) {
					var _to = (to.match(/\/#(.+\/)(\?.*?)?$/) || [])[1] || '/';
					// console.log('$locationChangeStart, ', to, _to, from, event, $location.search());
					var params = angular.copy($location.search());
					if (params._username && params._password) {
						event.preventDefault();
						enswitchGlobals.urlRouterProvider.deferIntercept();
						return $timeout(function() {
							return $rootScope.resourcesLoaded.then(function() {
								return UserApiService.login({
									auth_username: params._username,
									auth_password: params._password,
								}).then(
									function(response) {
										SessionService.setSession(null);
										console.log('$locationChangeStart login response: ', response);
										sessionVerified(response);
										delete params._username;
										delete params._password;
										return $timeout(function() {
											var _from = from ? (from.match(/\/#(.+\/)(\?.*?)?$/) || [])[1] || '/' : '';
											console.log('aaaa: ', _to, _from, params, $rootScope.previousState, $rootScope.currentState);
											var firstLoad = !lastTriedPath;
											if ((!$rootScope.currentState && _to == _from && _to == '/') || _to == '/login/')
												$timeout(function() {
													console.log('$state.current', $state.current);
													if ($state.current && /^index\./.test($state.current.name)) $state.reload();
													else $state.go('index.home', params);
													if (firstLoad) {
														$urlRouter.sync();
														$urlRouter.listen();
													}
												}, 25);
											if (!firstLoad) {
												if (
													($state.current && !/^index\./.test($state.current.name)) ||
													!/^index\./.test($rootScope.currentState) ||
													_to == '/login/'
												) {
													$state.go('index.home', params);
												} else {
													_to == _from && $rootScope.currentState
														? $state.reload()
														: $location.path(_to).search(params);
												}
												$urlRouter.sync();
												$urlRouter.listen();
											}
										}).then(function() {
											return $timeout(function() {
												return $rootScope.$broadcast('AuthSuccess');
											});
										});
									},
									function(error) {
										console.log('$locationChangeStart login error: ', error);
										$urlRouter.sync();
										$urlRouter.listen();
										$rootScope.$broadcast('WillLogOut');
										return $rootScope.logout(error);
									}
								);
							});
						});
					}

					lastTriedPath = _to == '/404/' ? lastTriedPath : to.replace(/^.+?\#/, '');
					if (
						from &&
						/%23=.*?#/.test(to) &&
						from ==
							to
								.replace(/%23=.*?(&|#)/, '$1')
								.replace('?&', '?')
								.replace('?#', '#')
					) {
						//console.log('preventing location change...');
						event.preventDefault();
						return false;
					}
					// fix plugin transitions not working on initial page run and back/forward arrows
					var isTransitioning = !!$state.transition;
					$timeout(function() {
						isTransitioning = isTransitioning || !!$state.transition;
						//console.log('isTransitioning: ', isTransitioning);
						if (!isTransitioning) {
							$timeout(function() {
								if (plugins && plugins.length) {
									var plugin = getPluginFromPath(_to);
									plugin && !$state.transition && $state.go(plugin);
								} else {
									var u = $rootScope.$watch('menuItems', function(newValue) {
										if (newValue && newValue.length) {
											u();
											var plugin = getPluginFromPath(_to);
											plugin && !$state.transition && $state.go(plugin);
										}
									});
								}
							}, 20);
						}
					});
				});

				$transitions.onBefore(
					{},
					function(transition) {
						if (!transition.options().notify || !transition.valid() || transition.ignored()) {
							return;
						}
						var toState = transition.$to();
						//console.log('onBefore', lastTriedPath, toState, transition);
						var toParams = transition.params();
						var fromState = transition.$from();
						var fromParams = transition.params('from');
						var options = transition._options;
						if (
							$rootScope.$broadcast('$stateChangeStart', toState, toParams, fromState, fromParams, options)
								.defaultPrevented
						) {
							$rootScope.$broadcast('$stateChangeCancel', toState, toParams, fromState, fromParams, options);
							if ($state.transition == null) $urlRouter.update();
							return false;
						}
						transition.promise['catch'](function(error) {
							if (
								error &&
								(error.type === 2 /* RejectType.SUPERSEDED */ || error.type === 3) /* RejectType.ABORTED */
							) {
								return;
							}
							var evt = $rootScope.$broadcast('$stateChangeError', toState, toParams, fromState, fromParams, options);
							if (!evt.defaultPrevented) {
								$urlRouter.update();
							}
						});
					},
					{
						priority: 1000,
					}
				);

				$transitions.onError({}, function(transition) {
					//console.log('onError', arguments);
				});

				$state.onInvalid(function(to, from, injector) {
					//console.log('$state.onInvalid: ', arguments);
					var toState = to.identifier() || {};
					var toParams = to._params;
					var fromState = from._definition;
					var fromParams = from._params;
					var options = from._options;
					var redirect = {
						to: to.identifier(),
						toParams: to.params(),
						options: to.options(),
					};
					var redirectFn = function(redirectOptions) {
						redirectOptions = redirectOptions || {};
						return $state.go(
							redirectOptions.state || redirect.to,
							redirectOptions.params || redirect.toParams,
							redirect.options
						);
					};
					var e = $rootScope.$broadcast('$stateChangeError', toState, toParams, fromState, fromParams, options);
					if (e.defaultPrevented) {
						return false;
					}
					if (e.retry || !!$state.get(redirect.to)) {
						return e.retry && typeof e.retry.then === 'function' ? e.retry.then(redirectFn) : redirectFn();
					}
				});

				$state.defaultErrorHandler(function(error) {
					//console.log('state error: ', error);
					if (error.type == 6) {
						$state.go('index.error-page');
					}
				});
				//

				$rootScope.title = '';
				$rootScope.currentPageTitle = '';
				$rootScope.product_name = '';

				$rootScope.results_per_page = 100; // other default configs?
				$rootScope.pagination_max_pages = 5;

				$rootScope.openEditModalsCount = 0;
				$rootScope.editModals = [];

				$rootScope.isIEOrEdge = /(MSIE|Edge)/i.test(navigator.userAgent) || /rv:11.0/i.test(navigator.userAgent);
				// https://docs.microsoft.com/en-us/previous-versions/windows/internet-explorer/ie-developer/compatibility/hh869301(v=vs.85)

				var me;

				$rootScope.parseHelpTicket = function(html) {
					return $sce.trustAsHtml((html || '').replace(/ /g, '&nbsp;').replace(/\r\n|\r|\n/g, '<br />'));
				};

				$rootScope.parseHTML = function(html) {
					return $sce.trustAsHtml((html || '').replace(/\r\n|\r|\n/g, '\n'));
				};

				window.enswitchGlobals.waitForResource = function(res, maxTimeout) {
					var deferred = $q.defer();

					if (maxTimeout !== undefined) {
						maxTimeout = Number(maxTimeout);
						if (isNaN(maxTimeout) || !isFinite(maxTimeout) || maxTimeout < 0) {
							maxTimeout = 0;
						}
					}

					maxTimeout = Math.min(Math.max(maxTimeout || 5000, 1000), 30000); // min 1 sec, max 30 sec

					var period = 50; // less, parameter?
					var maxTries = maxTimeout / period;
					var tryCount = 0;

					var check;

					(check = function() {
						if (typeof res == 'function' ? res() : window[res]) {
							//console.log(window[res]);
							setTimeout(deferred.resolve, period);
						} else {
							if (++tryCount > maxTries) {
								deferred.reject();
							} else {
								setTimeout(check, period);
							}
						}
					})();

					return deferred.promise;
				};

				$rootScope.custom_display_plan = '';

				var customizableRedirectUrls = ['login', 'switch'];
				//$rootScope.login_redirect_url = '/login/';
				//$rootScope.loggedin_redirect_url = '/';
				$rootScope.login_redirect_url = '/';
				$rootScope.signup_redirect_url = '/signup/signup/';
				$rootScope.signedup_redirect_url = '/';
				$rootScope.switch_redirect_url = '/';

				var configFilesRequestConfig = {
					headers: {
						'Content-Type': 'text/plain;charset=utf-8',
						Accept: 'text/plain',
						// 'Cache-Control': 'max-age=43200',
					},
					responseType: 'text',
				};

				var domainsApiPromise = $q.defer();

				var resolveDomainsApiPromise = function() {
					domainsApiPromise.resolve();
				};

				enswitchGlobals.templatesFolder = $rootScope.templatesFolder = ''; // /local/templates/

				var addTimestampIfNeeded = function(_src) {
					return /\?v=\d+$/.test(_src) || /^https?:\/\//.test(_src)
						? _src
						: _src + '?v=' + String($rootScope.versionTimestamp || 0);
				};

				var getDomainsFile = function() {
					return DomainsApiService.getDomainsWebList().then(
						function(response) {
							var allDomains = {};
							var ourDomain = {};
							if (response.data && !_.isEmpty(response.data)) {
								response.data.forEach(function(domainObject) {
									var domain = _.keys(domainObject)[0];
									var domainSettings = domainObject[domain];
									if (domain != location.hostname && domain != '*') {
										return;
									}
									var current = domain == '*' ? allDomains : ourDomain;

									if ('plan' in domainSettings) {
										current.custom_display_plan = domainSettings.plan;
									}

									if ('templates' in domainSettings) {
										current.templatesFolder = UtilsService.addSlashIfNeeded(domainSettings.templates);
									}

									if ('signup' in domainSettings) {
										current.plans_available = _(domainSettings.signup)
											.split(',')
											.map(function(plan) {
												return Number(_.trim(plan));
											})
											.compact()
											.valueOf();
									}
									if ('login_redirect' in domainSettings || 'switch_redirect' in domainSettings) {
										customizableRedirectUrls.some(function(page) {
											if (domainSettings[page + '_redirect']) {
												var path = domainSettings[page + '_redirect'];

												if (!/\/$/.test(path) && path.indexOf('?') < 0) {
													path += '/';
												}

												current[page + '_redirect_url'] = path;
											}
										});
									}
								});
								var current = Object.keys(ourDomain).length ? ourDomain : allDomains;

								for (var key in current) {
									$rootScope[key] = current[key];
								}
								enswitchGlobals.templatesFolder = $rootScope.templatesFolder || '';
							}
							resolveDomainsApiPromise();
						},
						function(error) {
							resolveDomainsApiPromise();
							DomainsApiService.defaultErrorHandler(error);
						}
					);
				};

				var getConfigFile = function(path, config) {
					return $http.get(addTimestampIfNeeded(path), config);
				};

				var resourcePromises = [];

				if (!$window.Promise) {
					//console.log('loading Promise polyfill...');
					resourcePromises.push(
						UtilsService.loadScript('https://cdn.jsdelivr.net/npm/promise-polyfill@8/dist/polyfill.js').then(
							function() {
								$window.Promise.prototype.done =
									$window.Promise.prototype.done ||
									function() {
										//console.log('done() polyfill!');
									};
							}
						),
						function(error) {
							console.warn('Failed to load Promise polyfill: ', error);
							return error;
						}
					);
				}

				var configFile = '';
				var configFileLines = [];
				var configValues = {};

				var configFilePromise = $q.defer();
				var languagesFilePromise = $q.defer();
				var languagePromise = $q.defer();

				var parseConfigFile = function(response) {
					configFile = response.data;
					configFileLines = configFile.split(/\r\n|\r|\n/);

					var regex = {
						param: /^\s*([\w\.\-\_]+)\s*=\s*([\s\S]*?)\s*$/,
						comment: /^\s*#.*$/,
					};

					for (var x = 0; x < configFileLines.length; x++) {
						if (regex.comment.test(configFileLines[x])) {
							continue;
						} else if (regex.param.test(configFileLines[x])) {
							var match = configFileLines[x].match(regex.param);
							if (match && match.length > 1) {
								configValues[match[1]] = match[2];
							}
						}
					}

					var apiUrlKey = window.enswitchGlobals.e2eTesting ? 'testApiUrl' : 'apiUrl';
					config.apiUrl = configValues[apiUrlKey] || config.apiUrl;
					// console.log('config: ', configValues);

					configFilePromise.resolve();
				};

				var loadConfigFiles = function() {
					getConfigFile('local/server.conf', configFilesRequestConfig)
						.catch(function() {
							return getConfigFile('server.conf', configFilesRequestConfig);
						})
						.then(parseConfigFile, configFilePromise.resolve)
						.then(getDomainsFile, resolveDomainsApiPromise);
				};

				loadConfigFiles();

				enswitchGlobals.installedLanguages = {};

				var parseLanguagesConfigFile = function(response) {
					configFileLines = (response.data || '').split(/\r\n|\r|\n/);

					var regex = {
						param: /^\s*([\w\.\-\_]+)\s*=\s*([\s\S]*?)\s*$/,
						comment: /^\s*#.*$/,
					};

					var values = {};

					for (var x = 0; x < configFileLines.length; x++) {
						if (regex.comment.test(configFileLines[x])) {
							continue;
						} else if (regex.param.test(configFileLines[x])) {
							var match = configFileLines[x].match(regex.param);
							if (match && match.length > 1) {
								values[match[1]] = match[2];
							}
						}
					}

					var languages = {};

					for (var key in values) {
						var arr = values[key].split(',').map(function(item) {
							return item.trim();
						});

						languages[key] = {
							code: key,
							name: arr[0],
							name_html: arr[1],
							templates: arr[2],
							config_file: arr[3],
							// sounds, asterisk?
						};
					}

					$rootScope.installedLanguages = languages;
					enswitchGlobals.installedLanguages = $rootScope.installedLanguages;

					languagesFilePromise.resolve();
				};

				// load languages
				getConfigFile('local/languages.conf', configFilesRequestConfig).then(parseLanguagesConfigFile, function(error) {
					getConfigFile('languages.conf', configFilesRequestConfig).then(
						parseLanguagesConfigFile,
						languagesFilePromise.resolve
					);
				});

				var languageFile = '';
				var languageFileLines = [];
				var languageStrings = {};

				me = SessionService.getSession();

				var checkString = localStorage['currentLanguage'];
				if (checkString && checkString.length == 2) {
					localStorage.setItem('currentLanguage', '');
				}

				var lastLanguages = JSON.parse(localStorage['currentLanguage'] || '{}');
				if (!(lastLanguages instanceof Object)) {
					lastLanguages = {};
				}
				$rootScope.currentLanguage = lastLanguages[me ? me.id : '0'];
				enswitchGlobals.currentLanguage = $rootScope.currentLanguage;

				if (!$rootScope.currentLanguage && me) {
					$rootScope.currentLanguage = me.language;
					enswitchGlobals.currentLanguage = $rootScope.currentLanguage;
				}

				var loadLanguage;

				var isValidNumber = function(n) {
					return n !== undefined && !isNaN(n) && isFinite(n);
				};

				var assignConfig = function(r) {
					// @TODO check in variable if config boolean or integer
					var val = r.data.value;
					var numVal = Number(r.data.value);

					$rootScope[r.data.name] = isValidNumber(numVal) ? numVal : val;

					return r;
				};

				var getConfig = function(n) {
					return ConfigsApiService.getConfig({
						name: n,
					}).then(assignConfig, angular.identity);
				};

				var initialConfigs = [
					'results_per_page',
					'web_check_unsaved',
					'web_date_time',
					'switch_user_maximum',
					'hide_signup',
					'show_select_all',
					'maximum_upload_size',
					'web_user_sort',
					'web_timeout',
					'web_cookie_expiry',
					'web_animations',
				];

				var configsPromise = configFilePromise.promise.then(function() {
					return $q.all(initialConfigs.map(getConfig));
				}, angular.identity);

				var getFlagClass = function(s) {
					// https://tkrotoff.github.io/famfamfam_flags
					return s == 'en' ? 'england' : s;
				};

				var parseLanguageFile = function(response) {
					return $timeout(function() {
						var isDefault = response.config.url == 'languages/en.conf';

						if (isDefault) {
							// if default language file, clear old values, if /local/ overwrite
							languageStrings = {};
						}

						languageFile = response.data;
						languageFileLines = languageFile.split(/\r\n|\r|\n/);

						var regex = {
							param: /^\s*([\w\.\-\_\/]+)\s*=\s*([\s\S]*?)\s*$/,
							comment: /^\s*#.*$/,
						};

						for (var x = 0; x < languageFileLines.length; x++) {
							if (regex.comment.test(languageFileLines[x])) {
								continue;
							} else if (regex.param.test(languageFileLines[x])) {
								var match = languageFileLines[x].match(regex.param);
								if (match && match.length > 1) {
									languageStrings[match[1]] = match[2] || '';
								}
							}
						}
					});
				};

				var getDefaultLanguage = function() {
					configFilePromise.promise.then(function() {
						return getConfig('default_language');
					});
				};

				(loadLanguage = function() {
					return $q
						.all([languagesFilePromise.promise].concat($rootScope.currentLanguage ? [] : [getDefaultLanguage]))
						.then(function() {
							return $timeout(function() {
								if (!$rootScope.default_language && (me = me || SessionService.getSession())) {
									$rootScope.default_language = me.language;
								}

								$rootScope.default_language = $rootScope.default_language || 'en';
								enswitchGlobals.default_language = $rootScope.default_language;

								$rootScope.currentLanguage = $rootScope.currentLanguage || $rootScope.default_language; // just in case
								enswitchGlobals.currentLanguage = $rootScope.currentLanguage;

								$rootScope.installedLanguages = $rootScope.installedLanguages || {};

								var firstCode = Object.keys($rootScope.installedLanguages)[0];

								var found = $rootScope.installedLanguages[$rootScope.currentLanguage];
								if (!found && firstCode) {
									$rootScope.currentLanguage = (
										$rootScope.installedLanguages[$rootScope.default_language] ||
										$rootScope.installedLanguages['en'] ||
										$rootScope.installedLanguages[firstCode]
									).code;
									enswitchGlobals.currentLanguage = $rootScope.currentLanguage;
								}

								$rootScope.currentLanguageFlagClass = getFlagClass($rootScope.currentLanguage);
								$rootScope.show_language_select = Object.keys($rootScope.installedLanguages).length > 1;
								$rootScope.currentLanguageName = firstCode
									? $rootScope.installedLanguages[$rootScope.currentLanguage].name_html
									: ''; // doesn't matter if no dropdown

								var languageFileName =
									(found ? found.config_file : $rootScope.currentLanguage) || $rootScope.currentLanguage;

								lastLanguages[me ? me.id : '0'] = $rootScope.currentLanguage;
								localStorage.setItem('currentLanguage', JSON.stringify(lastLanguages).replace(/\'/g, '"'));

								getConfigFile('languages/en.conf', configFilesRequestConfig)
									.then(parseLanguageFile, angular.identity)
									.then(function() {
										// load default file first for fallback
										return languageFileName != 'en';
									})
									.then(function(response) {
										if (response) {
											return getConfigFile('languages/' + languageFileName + '.conf', configFilesRequestConfig).then(
												parseLanguageFile,
												angular.identity
											);
										}
									})
									.then(function() {
										return getConfigFile('/local/languages/' + languageFileName + '.conf', configFilesRequestConfig);
									})
									.then(parseLanguageFile, angular.identity)
									.then(languagePromise.resolve);
							});
						});
				})();

				$rootScope.customCSSPromise = $q.defer();

				resourcePromises = [
					domainsApiPromise.promise,
					configFilePromise.promise,
					languagesFilePromise.promise,
					languagePromise.promise,
					configsPromise,
				];

				$rootScope.decodeEntities = UtilsService.decodeEntities;

				$rootScope.currencyString = function(c) {
					var _c = c && c instanceof Object ? c.currency : c;

					return UtilsService.decodeEntities(
						(
							variables.currencies[(_c || (me || {}).currency || '').toUpperCase()] || {
								symbol_html: '',
							}
						).symbol_html
					);
				};

				var lang = ($rootScope.languageString = function(key, preventDecode) {
					return (preventDecode ? angular.identity : UtilsService.decodeEntities)(
						languageStrings[key] || languageStrings[key] === '' ? languageStrings[key] : key
					);
				});

				// languagePromise.promise.then(function() {
				// 	$rootScope.product_name = lang('product_name_default'); /// ???
				// });

				$rootScope.setLanguage = function(language) {
					// $log.debug('setting language to: ', language);

					if (!language) {
						language = {};
					} else {
						if (typeof language == 'string') {
							language = {
								code: language,
							};
						}
					}

					$timeout(function() {
						$rootScope.currentLanguage = language.code || $rootScope.default_language;
						enswitchGlobals.currentLanguage = $rootScope.currentLanguage;
						languagePromise = $q.defer();
						resourcePromises = [configFilePromise.promise, languagesFilePromise.promise, languagePromise.promise];
						$rootScope.resourcesLoaded = $q.all(resourcePromises).then(function() {
							$rootScope.$broadcast('languageChanged');
							return true;
						});
						loadLanguage();
					});
				};

				$rootScope.$on('AuthSuccess', function(event, params) {
					$rootScope.$broadcast('$$rebind::navigation');

					me = SessionService.getSession();

					if (me.language) {
						$rootScope.default_language = me.language;
					} else {
						$rootScope.default_language = '';
					}

					enswitchGlobals.default_language = $rootScope.default_language;

					var lastLanguages = JSON.parse(localStorage['currentLanguage'] || '{}');
					if (!(lastLanguages instanceof Object)) {
						lastLanguages = {};
					}

					var language = lastLanguages[me ? me.id : '0'] || $rootScope.default_language;

					if (language != $rootScope.currentLanguage) {
						$rootScope.setLanguage(language);
					}

					if (params && params.switched) {
						// user/customer switched
						if ($state.current.name == 'index.customerselect') {
							$state.reload();
						} else {
							var redirectTo = ($rootScope.switch_redirect_url || '/').toLowerCase();

							var samePage =
								$location.path().replace(/\/$/, '') ==
								redirectTo.replace(/\?([a-z0-9_]+=*[a-z0-9_]*\&{0,1})*/, '').replace(/\/$/, '');

							if (SessionService.getCustomer()) {
								var hasParams = redirectTo.indexOf('?') > 0;
								redirectTo += (hasParams ? '&' : '?') + 'switched=1';
							}

							$timeout(function() {
								$location.url(redirectTo);
								if (samePage) {
									$location.replace();
									// reload controller?
									$state.reload();
								}
							});
						}
					}
				});

				$rootScope.resourcesLoaded = $q.all(resourcePromises).then(function() {
					return true;
				});

				var cancelPendingApiRequests = UtilsService.cancelPendingApiRequests;

				$rootScope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams, options) {
					//console.log('$stateChangeStart: ', arguments);
					if (
						fromState &&
						toState &&
						fromState.name == toState.name &&
						angular.equals(toParams, angular.extend(angular.copy(fromParams), { '#': toParams['#'] }))
					) {
						//event.preventDefault();
						// $timeout(function() {
						// 	$location.hash(toParams['#']);
						// });
						if (toState.name == 'login') {
							// prevent re-redirect to login on first-time login // why it happens in the first place??
							event.preventDefault();
						}
						return false;
					} // prevent state change start when only hash changed! // doesn't change the hash when default prevented!!!

					$timeout(function() {
						if (!Number(document.body.scrollTop)) {
							document.documentElement.scrollTop = document.body.scrollTop = 1; // footer fix!
						}
						document.documentElement.scrollTop = document.body.scrollTop = 0;
					});

					swal.close();

					var session = SessionService.getSession();

					if (
						fromState &&
						fromState.data &&
						fromState.data.requiresAuth &&
						toState.data &&
						!toState.data.requiresAuth
					) {
						// @TODO: only if not default prevented!!
						cancelPendingApiRequests();
					}

					if (toState.data && toState.data.requiresAuth && !session) {
						event.preventDefault();
						if (fromState.name) {
							cancelPendingApiRequests();
						}

						const redirectTo = `/login/`;

						const redirectParams = { ...toParams };
						_.forEach(redirectParams, (value, key) => {
							if (_.isNil(value) || value === '') {
								delete redirectParams[key];
							}
						});

						const redirectAfterLoginParams = {
							redirect: toState.name,
						};

						if (_.keys(redirectParams).length) {
							redirectAfterLoginParams.redirectParams = JSON.stringify(redirectParams);
						}

						$timeout(() => {
							if (toState.name !== 'index.home') {
								$state.go('login', redirectAfterLoginParams);
							} else {
								$location.url(redirectTo);
							}
						});
					} else {
						Pace.restart();

						toParams = angular.copy(toParams);

						me = SessionService.getSession();

						//var results_per_page = $state.current.name == 'index.customerselect' ? 12 : $rootScope.results_per_page;
						var results_per_page = $rootScope.results_per_page;

						if (toParams.offset && results_per_page) {
							// always hit the start of the page!
							toParams.offset = Number(toParams.offset);

							if (isNaN(toParams.offset) || !isFinite(toParams.offset)) {
								toParams.offset = 0;
								event.preventDefault();
								$state.go(toState, toParams);
							} else if (toParams.offset % results_per_page != 0) {
								toParams.offset -= toParams.offset % results_per_page;
								if (toParams.offset < 0) {
									toParams.offset = 0;
								}
								event.preventDefault();
								$state.go(toState, toParams);
							} else if (fromState && fromState.data && fromState.data.requiresAuth && session) {
								initialConfigs.forEach(function(n) {
									getConfig(n);
								});
							}
						} else if (fromState && fromState.data && fromState.data.requiresAuth && session) {
							initialConfigs.forEach(function(n) {
								getConfig(n);
							});
						}
					}

					if (
						(String(toParams.modal) === '1' || String(toParams.modal) === 'true') &&
						(!$rootScope.openEditModalsCount || (options.location != 'replace' && !options.reload))
					) {
						if (event.defaultPrevented) {
							if (typeof event.defaultPrevented !== 'function' || event.defaultPrevented()) {
								return false;
							}
						}
						if ($rootScope.openEditModalsCount) {
							if (
								options.reload ||
								options.location == 'replace' ||
								(/^index\.customers\.customers-(new|ingroup|choose)$/.test(
									$rootScope.editModals[$rootScope.editModals.length - 1].stateConfig.name
								) &&
									toParams.modal &&
									toParams.modal !== '0')
							) {
								event.preventDefault();
								return false;
							}
						}
						event.preventDefault();
						if ($state.current && /^index\./.test($state.current.name)) {
							// console.log('toParams: ', toParams);
							var modalOptions = angular.copy(toParams.modalOptions);
							if (!modalOptions || !(modalOptions instanceof Object)) {
								modalOptions = {};
							}
							$timeout(function() {
								UtilsService.openEditPageInModal(
									toState,
									angular.copy(toParams),
									{
										hideHeader: modalOptions.hideHeader || false,
										hideHeaderIcon: modalOptions.hideHeaderIcon || false,
										updating: modalOptions.updating || false,
									},
									angular.noop
								);
							});
						} else {
							$timeout(function() {
								$location.url($rootScope.login_redirect_url);
								$timeout(function() {
									$state.go(toState, toParams, options);
								}, 2000);
							});
						}
					}

					swal.setDefaults({
						type: 'success',
						allowOutsideClick: false,
						allowEscapeKey: false,
						confirmButtonClass: 'btn btn-lg margin btn-success',
						cancelButtonClass: 'btn btn-lg margin btn-default',
						buttonsStyling: false,
						focusCancel: true,
						showLoaderOnConfirm: true,
						animation: false,
					});
				});

				$rootScope.previousState = '';

				$rootScope.$on('$stateChangeSuccess', function(event, toState, toParams, fromState, fromParams) {
					$rootScope.statusCode = toState.name == 'index.error-page' ? '404' : '200';

					$rootScope.previousState = fromState ? fromState.name : '';
					$rootScope.currentState = toState.name || '';

					me = SessionService.getSession();

					if (me) {
						UtilsService.checkAllowAdmin();
					} else {
						$timeout(function() {
							$rootScope.allow_admin = false;
						});
					}

					if (toState) {
						$timeout(function() {
							$rootScope.currentPageTitle = '';
							$rootScope.title =
								toState.title ||
								toState.data.pageTitle ||
								$rootScope.product_name ||
								$rootScope.product_name_default ||
								'';
						});
					}

					// remove empty parameters from url!
					//$log.debug(toParams, toState.params);
					var newParams = angular.copy(toParams) || {};
					for (var key in newParams) {
						newParams[key] =
							newParams[key] || (fromState && fromState.name == toState.name && fromParams[key] ? '' : null);
					}
					$location.search(newParams); //.replace();
					// @TODO: replace() if fromState.name == toState.name?

					$timeout(function() {
						$rootScope.hide_menu = !Number(toParams.menu || 1);
					});
				});

				$rootScope.minimalizeMenu = () => {
					$rootScope.hide_menu = !$rootScope.hide_menu;
				};
				
				var goToLogin = function(timeout) {
					//var redirectTo = ($rootScope.login_redirect_url || '/').toLowerCase();
					var redirectTo = '/login/' + (timeout ? '?timeout=1' : '');

					return $timeout(function() {
						$location.url(redirectTo);
					});
				};

				$rootScope.goToLogin = goToLogin;

				$rootScope.goBack = function() {
					var current = $state.current;
					var requiresAuth = current.data && current.data.requiresAuth;

					var previous = $state.get($rootScope.previousState);
					var requiredAuth = $rootScope.previousState && previous && previous.data && previous.data.requiresAuth;

					if ($rootScope.previousState) {
						if (requiresAuth) {
							if (requiredAuth) {
								$timeout(function() {
									history.back();
								});
							} else {
								$timeout(function() {
									$state.go('index.home');
								});
							}
						} else {
							if (requiredAuth) {
								goToLogin();
							} else {
								$timeout(function() {
									history.back();
								});
							}
						}
					} else {
						if (requiresAuth) {
							$timeout(function() {
								$state.go('index.home');
							});
						} else {
							goToLogin();
						}
					}
				};

				$rootScope.logout = function(e) {
					$rootScope.$broadcast('WillLogOut');
					SessionService.setSession(null);

					goToLogin(e && e.type && e.type === 'idle').then(function() {
						$timeout(function() {
							$rootScope.$broadcast('LoggedOut');
						});
					});
				};

				var activeHandler = function(event) {
					return true;
				};

				var idleTimerRunning = false;

				var stopIdleTimer = function() {
					if (idleTimerRunning) {
						angular.element(document).off('idle.idleTimer', $rootScope.logout);
						angular.element(document).off('active.idleTimer', activeHandler);
						idleTimerRunning = false;
					}
				};

				var startIdleTimer = function() {
					stopIdleTimer();
					idleTimerRunning = true;
					$(document).idleTimer('reset');
					angular.element(document).on('idle.idleTimer', $rootScope.logout);
					angular.element(document).on('active.idleTimer', activeHandler);
				};

				var idleTimerInitialized, u1, u2, u3;

				var destroyIdleTimer = function() {
					stopIdleTimer();

					u1 && u1();
					u2 && u2();
					u3 && u3();

					$(document).idleTimer('destroy');
				};

				var initIdleTimer = function() {
					if ($rootScope.web_timeout && Number($rootScope.web_timeout)) {
						$(document).idleTimer({
							timeout: Number($rootScope.web_timeout) * 1000,
							events: 'keydown wheel DOMMouseScroll mousewheel mousedown',
							timerSyncId: 'idleTimerSyncKey',
						});

						startIdleTimer();

						u1 = $rootScope.$on('AuthSuccess', startIdleTimer);
						u2 = $rootScope.$on('WillLogOut', stopIdleTimer);
						u3 = $rootScope.$on('$destroy', destroyIdleTimer);
					}

					idleTimerInitialized && idleTimerInitialized();
				};

				var changeIdleTimerTimeout = function(newValue, oldValue) {
					//console.log('changeIdleTimerTimeout', newValue, oldValue);
					if (newValue === oldValue) {
						return;
					}

					destroyIdleTimer();
					idleTimerInitialized = null;
					u1 = null;
					u2 = null;
					u3 = null;
					configsPromise.then(function() {
						if ((me = SessionService.getSession())) {
							initIdleTimer();
						} else {
							idleTimerInitialized = $rootScope.$on('AuthSuccess', initIdleTimer);
						}
					});
				};

				$rootScope.$watch('web_timeout', changeIdleTimerTimeout);

				$rootScope.animationDurationMultiplier = 1;
				var toggleWebAnimations = function(newValue) {
					var $body = angular.element(document.body);
					if (newValue) {
						$body.hasClass('disable-animations') && $body.removeClass('disable-animations');
						$rootScope.animationDurationMultiplier = 1;
					} else {
						$body.hasClass('disable-animations') || $body.addClass('disable-animations');
						$rootScope.animationDurationMultiplier = 0;
					}
					$body = null;
				};

				$rootScope.$watch('web_animations', toggleWebAnimations);

				var loadAllCustomers = function() {
					$timeout(function() {
						$rootScope.allCustomers = SessionService.getLatestCustomers();
						$rootScope.$broadcast('$$rebind::allCustomers');
					});
				};

				var loadAllUsers = function() {
					$timeout(function() {
						$rootScope.allUsers = SessionService.getLatestUsers();
						$rootScope.$broadcast('$$rebind::allUsers');
					});
				};

				$rootScope.$on('AuthSuccess', loadAllCustomers);
				$rootScope.$on('AuthSuccess', loadAllUsers);
				$rootScope.$on('WillLogOut', function() {
					$timeout(function() {
						$rootScope.allCustomers = [];
						$rootScope.allUsers = [];
						$rootScope.$broadcast('$$rebind::allCustomers');
						$rootScope.$broadcast('$$rebind::allUsers');
					});
				});

				$rootScope.selectCustomer = function() {
					$state.go('index.customerselect');
				};

				$rootScope.selectUser = function() {
					UtilsService.openEditPageInModal(
						$state.get('index.users.users-list'),
						{
							offset: '0',
							sort: '',
							descending: '0',
						},
						{
							closeOn: 'AuthSuccess',
							hideHeader: false,
						},
						function(response) {
							response &&
								$rootScope.$broadcast('AuthSuccess', {
									switched: true,
								});
						}
					);
				};

				var sessionVerified = function(response) {
					var me = response.data;
					var us = SessionService.getCustomer();
					if (us) {
						(us.name ? CustomersApiService.getCustomer : PeopleApiService.get)({
							id: us.id,
						}).then(
							function(response) {
								var params = {};

								var customer = response.data;
								if (customer.name) {
									params.username = '[' + customer.name + ']';
								} else {
									if (customer.id == me.id) {
										params.username = me.auth_username;
										customer = null;
									} else {
										params.id = customer.id;
									}
								}

								params.auth_username = me.auth_username;
								params.auth_password = me.auth_password;

								UserApiService.switchUser(params).then(
									function(response) {
										SessionService.setSession(response.data);
										SessionService.setCustomer(customer);
										$rootScope.$broadcast('SessionInfoUpdated');
									},
									function() {
										SessionService.setSession(me);
										SessionService.setCustomer(null);
										$rootScope.$broadcast('SessionInfoUpdated');
									}
								);
							},
							function() {
								SessionService.setSession(me);
								SessionService.setCustomer(null);
								$rootScope.$broadcast('SessionInfoUpdated');
							}
						);
					} else {
						SessionService.setSession(me);
						$rootScope.$broadcast('SessionInfoUpdated');
					}
					loadAllCustomers();
					loadAllUsers();
					return response;
				};

				var _verifySessionIfExists = function() {
					var params = $location.search();
					if (params._username && params._password) {
						return $q.resolve();
					}

					var session;

					if ((session = SessionService.getSession())) {
						return UserApiService.login({
							auth_username: session.auth_username,
							auth_password: session.auth_password,
						}).then(sessionVerified, $rootScope.logout);
					}

					return $q.reject();
				};

				$rootScope.verifySessionIfExists = function() {
					return configFilePromise.promise.then(_verifySessionIfExists);
				};

				// $window.addEventListener('storage', function(e) {
				// 	console.log('storage changed: ', e, e.srcElement === e.currentTarget);
				// 	if (e.key == 'sessionLastUpdated') {
				// 		_verifySessionIfExists();
				// 	}
				// }, false);

				var paceOptions = {
					// prevent loading indicator on http requests
					document: true,
					ajax: false,
					restartOnRequestAfter: false,
				};

				//Pace.stop();
				Pace.start(paceOptions);
				//console.log(navigator);
				$rootScope.offline = false; //!navigator.onLine;
				$window.addEventListener(
					'offline',
					function() {
						$rootScope.$apply(function() {
							$rootScope.offline = true;
							$rootScope.$broadcast('navigator-offline');
						});
					},
					false
				);

				$window.addEventListener(
					'online',
					function() {
						$rootScope.$apply(function() {
							$rootScope.offline = false;
							$rootScope.$broadcast('navigator-online');
						});
					},
					false
				);

				$rootScope.slowConnection = false;

				$rootScope.checkAllHidden = function(arr) {
					if (typeof arr == 'undefined' || !arr || !arr.length) {
						return true;
					}

					for (var i = 0; i < arr.length; i++) {
						if (!arr[i].hidden) {
							return false;
						}
					}

					return true;
				};

				$rootScope.checkAllSelected = function(arr, page, pageSize) {
					if (typeof arr == 'undefined' || !arr || !arr.length) {
						return false;
					}

					page = page || 1;
					pageSize = pageSize || arr.length;

					for (var i = (page - 1) * pageSize; i < arr.length && i < page * pageSize; i++) {
						if (!arr[i].selected) {
							return false;
						}
					}

					return true;
				};

				$rootScope.checkNoSelected = function(arr, page, pageSize) {
					if (typeof arr == 'undefined' || !arr || !arr.length) {
						return true;
					}

					page = page || 1;
					pageSize = pageSize || arr.length;

					for (var i = (page - 1) * pageSize; i < arr.length && i < page * pageSize; i++) {
						if (arr[i].selected) {
							return false;
						}
					}

					return true;
				};

				$rootScope.capitalize = function(s) {
					if (!s || !s.length) {
						return '';
					}

					return s.substr(0, 1).toUpperCase() + s.substr(1);
				};

				$rootScope.yes_no_display = function(x) {
					return Number(x) ? lang('yes') : lang('no');
				};

				angular.module('new-web').controller = enswitchGlobals.registerController; // register controllers 'normally' in runtime

				var plugins = [];

				var addPlugin = function(stateDef) {
					var baseUrl = 'local'; // 'plugins' for development
					//console.log('addPlugin: ', stateDef);
					stateDef.is_switch_redirect =
						stateDef.is_switch_redirect ||
						($rootScope.switch_redirect_url &&
							$rootScope.switch_redirect_url != '/' &&
							stateDef.path
								.replace(/\?.+$/, '')
								.replace(/^\//, '')
								.replace(/\/$/, '') ==
								$rootScope.switch_redirect_url
									.replace(/\?.+$/, '')
									.replace(/^\//, '')
									.replace(/\/$/, ''));

					var params = '';
					var defaultParams = {};
					var found = stateDef.path.match(/(\?.+)$/);
					if (found && found.length > 1) {
						params = found[1];
						if (!stateDef.is_custom_redirect) {
							// check for defaults
							var f = params.match(/(\?|\&)([^=]+)\=([^&]+)/g);
							if (f && f.length) {
								f.forEach(function(s) {
									var m = s.substring(1).replace(/^.+\&/, '');
									if (m) {
										defaultParams[m.replace(/\=.+$/, '')] = m.replace(/^.+\=/, '');
									}
								});
							}
						}
						params = params
							.replace(/(=.*?)(\&.*?)/g, function(match, cg1, cg2) {
								return cg2 || '';
							})
							.replace(/=.*?$/, '');
						if (stateDef.is_switch_redirect && params.split('&').indexOf('switched') < 0) {
							params += '&switched';
							defaultParams.switched = '';
						}
						stateDef.path = stateDef.path.replace(/\?.+$/, '');
					}

					stateDef.originPath = stateDef.path;
					stateDef.path = stateDef.path.replace(/\/$/, '') + '/';
					stateDef.path = stateDef.path.replace(/^\/?local\//, '/');

					var pluginUrl = baseUrl + (/^\//.test(stateDef.path) ? '' : '/') + stateDef.path;

					if (pluginUrl && !/\/$/.test(pluginUrl)) {
						pluginUrl += '/';
					}

					if (stateDef.is_custom_redirect) {
						var alreadyDefined = false;
						plugins.some(function(plugin) {
							if (plugin.path == stateDef.path) {
								return !!(alreadyDefined = plugin.state);
							}
							return false;
						});

						if (alreadyDefined) {
							return alreadyDefined;
						}
					}

					stateDef.tag = stateDef.tag || stateDef.path.replace(/\//g, '_');
					stateDef.state = (stateDef.parent_state ? stateDef.parent_state : 'index') + '.plugin_' + stateDef.tag; // add prefix "plugin_" to tag to prevent ambiguous states

					//// only if not custom redirect?
					stateDef.href = stateDef.path.replace(/^\//, '');

					stateDef.icon = stateDef.icon || 'default.svg';
					//stateDef.icon = stateDef.icon.replace(/\/local(\/((?!www)\S)*\/)/, '/local/www$1');

					if (!/^\/local\//.test(stateDef.icon) && !/^(\/)?app\/components\//.test(stateDef.icon)) {
						stateDef.icon = (!/^https?:\/\//.test(stateDef.icon)
							? stateDef.icon
							: ('app/components/' + stateDef.icon).replace(/\/{2,}/g, '/')
						).replace(/\.[^.]*$/, '.svg');
					}

					var wasHidden = stateDef.hidden;
					stateDef.hidden = stateDef.hidden || !(stateDef.children && stateDef.children.length);
					////

					if (wasHidden) {
						// plugin subpages
						var substateId = _(stateDef.path)
							.split('/')
							.compact()
							.tail()
							.filter(function(state) {
								return !_.includes(stateDef.tag, state);
							})
							.join('_')
							.valueOf();

						if (substateId) {
							stateDef.state += '-' + substateId;
						}
					}

					var controllerUrl = pluginUrl + 'Controller.js';
					var templateUrl = pluginUrl + 'template.html';

					var stateObj = {};

					if (params) {
						if (!/\/$/.test(stateDef.href)) {
							stateDef.href += '/';
						}
						stateDef.href += '?';
						stateObj.params = {};
						stateDef.params = {};
						params
							.substring(1)
							.split('&')
							.forEach(function(param) {
								stateObj.params[param] = {
									type: 'string',
									value: defaultParams[param] || '',
									isOptional: true,
									squash: true,
								};
								stateDef.href += param + '=&';
								stateDef.params[param] = defaultParams[param] || '';
							});
						stateDef.href = stateDef.href.slice(0, -1);
					}

					if (!$state.get(stateDef.state)) {
						// not already defined
						if (stateDef.children && stateDef.children.length) {
							// abstract state for collapsable menu items
							// what if we remove children?
							// @TODO: subsections?
							stateObj = angular.extend(stateObj, {
								abstract: true,
								template: '<div ui-view></div></div>', // <div ng-include="\'app/components/common/footer.html\'">
								data: {
									pageTitle: stateDef.name,
								},
							});

							enswitchGlobals.stateProvider.state(stateDef.state, stateObj);
						} else {
							stateDef.name = stateDef.name || $rootScope.product_name || '';

							stateObj = angular.extend(stateObj, {
								// always generate state name from path?
								url: stateDef.path + params,
								title: stateDef.name,
								data: {
									pageTitle: stateDef.name,
								},
								resolve: {
									load: function() {
										return UtilsService.loadScript(controllerUrl);
									},
								},
								templateUrl: templateUrl,
							});

							enswitchGlobals.stateProvider.localizedTemplateState(stateDef.state, stateObj);

							if (!stateDef.is_custom_redirect) {
								$q.all([UtilsService.checkIfFileExists(controllerUrl), UtilsService.checkIfFileExists(templateUrl)])
									.then(
										function(responses) {
											$timeout(function() {
												stateDef.hidden = wasHidden;
												$rootScope.$broadcast('$$rebind::navigation');
											});
										},
										function(errors) {
											stateDef.external = true;
											if (_.includes(stateDef.originPath, 'http')) {
												return $q.when();
											} else {
												return UtilsService.checkIfFileExists(stateDef.originPath);
											}
										}
									)
									.then(
										(response) => {
											$timeout(function() {
												stateDef.hidden = wasHidden;
												$rootScope.$broadcast('$$rebind::navigation');
											});
										},
										(error) => {
											enswitchGlobals.urlRouterProvider.when(stateDef.path, '/');
										}
									);

								plugins.push(stateDef);
							} else {
								//console.log('adding custom redirect state: ', stateDef, controllerUrl, templateUrl);
							}
						}
					} else if (!(stateDef.children && stateDef.children.length) && !stateDef.is_custom_redirect) {
						// already defined
						plugins.push(stateDef);
						$q.all([UtilsService.checkIfFileExists(controllerUrl), UtilsService.checkIfFileExists(templateUrl)]).then(
							function(responses) {
								$timeout(function() {
									stateDef.hidden = wasHidden; // @TODO check this
									$rootScope.$broadcast('$$rebind::navigation');
								});
							},
							function(errors) {
								$timeout(function() {
									stateDef.hidden = true;
									$rootScope.$broadcast('$$rebind::navigation');
								});
								enswitchGlobals.urlRouterProvider.when(stateDef.path, '/');
							}
						);
					}

					enswitchGlobals.urlRouterProvider.when(stateDef.path, stateDef.href || '/');
					/*
				enswitchGlobals.urlRouterProvider.when(stateDef.path, ['$match', '$stateParams', function ($match, $stateParams) {
					// console.log('urlRouterProvider.when: ', arguments);
				    $state.transitionTo(stateDef, $match, false);
				}]);
				*/
					return stateDef.state;
				};

				var clearPlugins = function() {
					// invalidate old routes
					plugins.forEach(function(plugin) {
						enswitchGlobals.urlRouterProvider.when(plugin.path, '/'); // no need to check if standard menu item's path because it wouldn't be treated as a plugin then.
					});

					plugins = [];
				};

				var adjustedPath = function(path) {
					return path.replace(/^\//, '').replace(/\/$/, '');
				};

				var pathToState = function(_path) {
					var path = (_path || '').replace(/\?.*$/, '');
					return (
						'index.' +
						adjustedPath(path)
							.replace('/groups/', '-groups/')
							.replace('/edit', '-edit')
							.replace('/new', '-new')
							.replace('/list', '-list')
							.replace(/calls\/messages\/(.+)$/, 'calls/$1')
							.replace('vouchers/batches', 'vouchers-batches')
							.split('/')
							.join('.')
					);
				};
				$rootScope.pathToState = pathToState;

				var isPlugin = function(item) {
					if (!item.path || item.path == '/') {
						return false;
					}

					return (!item.type || item.type == 'item') && !$state.get(pathToState(item.path));
				};

				var setStateTitle = function(item) {
					// @TODO set on menu click? (duplicate items), what if path manually entered??
					var state = $state.get(pathToState(item.path));
					if (state) {
						state.data = state.data || {};
						state.data.pageTitle = item.name || state.data.pageTitle || '';
					}
				};

				var getPluginFromPath = function(path) {
					//console.log('getPluginFromPath', path, plugins);
					if (!path) {
						return null;
					}
					if (!plugins || !plugins.length) {
						return null;
					}
					var _path = path
						.replace(/^\//, '')
						.replace(/\?.*?$/, '')
						.replace(/\/$/, '');
					for (var i = 0; i < plugins.length; i++) {
						var plugin = plugins[i];
						if (
							_path ==
							plugin.path
								.replace(/^\//, '')
								.replace(/\?.*?$/, '')
								.replace(/\/$/, '')
						) {
							return plugin.state;
						}
					}
					return null;
				};

				var firstRun = true;
				var checkedCustomRedirects = false;
				//var customLoginRedirectStateName;

				var checkCustomRedirects = function() {
					var pathTested = {};

					var defaultRedirectPaths = ['/', '/login/', '/signup/signup/'];

					customizableRedirectUrls.forEach(function(item) {
						var path = $rootScope[item + '_redirect_url'];
						if (!/^\//.test(path)) {
							path = '/' + path;
						}

						if (defaultRedirectPaths.indexOf(path) < 0 && !pathTested[path]) {
							pathTested[path] = true;

							if (
								isPlugin({
									path: path,
								})
							) {
								var stateDef = {
									path: path,
									parent_state: null,
									is_custom_redirect: true,
									is_switch_redirect: item == 'switch',
								};

								//customLoginRedirectStateName = addPlugin(stateDef);
								addPlugin(stateDef);
							}
						}
					});

					$timeout(function() {
						$rootScope.$broadcast('CheckedCustomRedirects');
					});
				};

				$rootScope.$on('$stateChangeError', function(event, toState, toParams, fromState, fromParams, options) {
					// console.log('$stateChangeError: ', arguments);
					var current = fromState.self ? fromState.self.url.replace(/\?.*?$/, '') : '';
					var next = lastTriedPath;
					var nextParams = {};
					var found = next.match(/(\?.+)$/);
					if (found && found.length > 1) {
						var paramsString = found[1] || '';
						var f = paramsString.match(/(\?|\&)([^=]+)\=([^&]+)/g);
						if (f && f.length) {
							f.forEach(function(s) {
								var m = s.substring(1).replace(/^.+\&/, '');
								if (m) {
									nextParams[m.replace(/\=.+$/, '')] = m.replace(/^.+\=/, '');
								}
							});
						}
					}

					var is_switch =
						$rootScope.switch_redirect_url.replace(/(\&|\?)switched=(0|1)?/, '') ==
						next.replace(/(\&|\?)switched=(0|1)?/, '');
					//console.log('$stateChangeError: ', current || '-', next || '-', nextParams);

					if (
						(current != next &&
							(/\/login\//.test(current) || (/\/signup\//.test(current) && (!toState || !toState.name)))) ||
						is_switch
					) {
						var retry = $q.defer();
						event.retry = retry.promise;
						var u = $rootScope.$on(
							checkedCustomRedirects ? '$$rebind::navigation' : 'CheckedCustomRedirects',
							function() {
								// console.log('$$rebind::navigation', $rootScope.menuItems);
								if (checkedCustomRedirects && (!$rootScope.menuItems || !$rootScope.menuItems.length)) {
									// we caught rebind event from clearing the menu!
									return;
								}
								u();
								$timeout(function() {
									var resolvedState = getPluginFromPath(next.replace(/^\/?local\//, '')) || 'index.home';
									//console.log('resolve: ', resolvedState);
									retry.resolve({ state: resolvedState, params: nextParams });
								}, 50);
							}
						);
						$rootScope.fetchMenus(); // need to do to make transition possible, but will make menu load twice!
					} else {
						event.preventDefault();
						$timeout(function() {
							if (toState.name != 'index.error-page') {
								$state.go('index.error-page');
							} else if (toState.name != 'index.home') {
								$state.go('index.home');
							}
						});
					}
				});

				var getVariableValue = function(variableName, loggedOut) {
					switch (variableName) {
						case 'customer':
							return loggedOut ? '0' : me.effective_customer || me.customer;
						case 'id':
							return loggedOut ? '0' : me.login_id || me.id;
						case 'language':
							return loggedOut
								? $rootScope.default_language || 'en'
								: me.language || $rootScope.default_language || 'en';
						case 'password':
							return loggedOut ? '' : me.auth_password;
						case 'plan':
							return loggedOut ? '0' : me.plan;
						case 'role':
							return loggedOut ? '0' : me.effective_role || me.role;
						case 'username':
							return loggedOut ? '' : me.auth_username;
						default:
							return '';
					}
				};

				var replaceVariablesFromPath = function(item) {
					var path = item.path || '';
					if (/<TMPL_VAR\sNAME\=(.+?)>/i.test(path)) {
						var re = /<TMPL_VAR\sNAME\=(.+?)>/gi;
						var loggedOut = !(me = SessionService.getSession());
						var values = [];
						item.path = path.replace(re, function(match, p1) {
							var variableName = p1.toLowerCase();
							var val = getVariableValue(variableName, loggedOut);
							values.push(val);
							return val;
						});
						// append __{var1_var2_..._varN} to item's id so link gets changed in menu because of tracking by id!
						item.id = item.id || '';
						item.id += '__' + values.join('_');
						// append $${var1_var2_..._varN} to item's tag so it's state gets redefined on switch user/customer if needed
						item.tag = item.tag || '';
						item.tag += '$$' + values.join('_');
					}
				};

				var parseMenuItems = function(items, level) {
					level = level || 0;
					var result = [];

					if (!(items instanceof Array) || !items.length) {
						return result;
					}

					items.forEach(function(item) {
						replaceVariablesFromPath(item);
						var paths = item.path.split(/[ ,]+/);
						if (paths.length < 2) {
							result.push(item);
						} else {
							var original = item;
							paths.forEach(function(path, index) {
								var copy = angular.copy(original);
								copy.path = path;
								var first = !index;
								if (!first) {
									copy.hidden = true;
									copy.id += '.' + String(index); // plugin subpages - id needs to be unique!
									copy.tag += '_' + String(index);
								}
								result.push(copy);
							});
						}

						if (!level) {
							item.children = parseMenuItems(item.children, level + 1);
						}
						var _offset = 0;
						item.children &&
							angular.copy(item.children).forEach(function(subitem, index) {
								if (subitem.children && subitem.children.length) {
									// subsection
									var _children = parseMenuItems(subitem.children, level + 1);
									subitem.children = _children; // use same reference to check for hidden items easily in menu component
									_children.forEach(function(_child, offset) {
										item.children.splice(index + offset + _offset + 1, 0, _child);
										_child.parent_subsection = _child.parent;
										_child.parent = item.id;
									});
									_offset += _children.length;
								}
							});
					});

					return result;
				};

				var parseStandardMenuItemParams = function(item) {
					// if someone overrides or adds standard menu item's params
					var state = $state.get(item.state);
					if (!state) return;
					var defaultParams = angular.copy(state.params) || {};
					var found = item.path.match(/(\?.+)$/);
					if (found && found.length > 1) {
						var params = found[1];
						var f = params.match(/(\?|\&)([^=]+)\=([^&]+)/g);
						if (f && f.length) {
							f.forEach(function(s) {
								var m = s.substring(1).replace(/^.+\&/, '');
								if (m) {
									var key = m.replace(/\=.+$/, '');
									defaultParams[key] = m.replace(/^.+\=/, '') || defaultParams[key];
								}
							});
						}
					}
					state.params = angular.copy(defaultParams);
					item.params = angular.copy(defaultParams);
					defaultParams = null;
				};

				$rootScope.menuFilter = '';
				$rootScope.applyMenuFilter = function() {
					// console.log('applyMenuFilter: ', $rootScope.menuFilter);
					$timeout(function() {
						var lcFilter = $rootScope.menuFilter.toLowerCase();
						$rootScope.menuItems &&
							$rootScope.menuItems.forEach(function(item) {
								item.filteredOut = $rootScope.menuFilter && item.name.toLowerCase().indexOf(lcFilter) < 0;
								item.filtered = $rootScope.menuFilter && !item.filteredOut;
								item.forceCollapsed = false;
								item.children &&
									item.children.forEach(function(subitem) {
										subitem.filteredOut = $rootScope.menuFilter && subitem.name.toLowerCase().indexOf(lcFilter) < 0;
										if (item.filteredOut && !item.hidden && !subitem.filteredOut && !subitem.hidden) {
											item.filteredOut = false;
											item.forceCollapsed = true;
										}
									});
							});
						$rootScope.$broadcast('$$rebind::menuFilter');
					});
				};
				$rootScope.clearMenuFilter = function() {
					$rootScope.menuFilter = '';
					$rootScope.applyMenuFilter();
				};

				$rootScope.resourcesLoaded.then(function() {
					var updateEffectivePlan = function() {
						me = SessionService.getSession();
						CustomersApiService.getCustomer({
							id: me.effective_customer || me.customer,
						}).then(function(response) {
							var us = response.data; // expose in $rootScope?
							SessionService.setEffectivePlan(us.plan);
							$rootScope.$broadcast('EffectivePlanUpdated');
						});
					};

					if ((me = SessionService.getSession())) {
						updateEffectivePlan();
					}

					$rootScope.$on('AuthSuccess', updateEffectivePlan);

					return $timeout(function() {
						($rootScope.fetchMenus = function() {
							($rootScope.clearMenu || angular.noop)();

							if (!SessionService.getSession()) {
								$urlRouter.sync();
								$urlRouter.listen();
								firstRun = false;
								return;
							}

							enswitchGlobals.urlRouterProvider.deferIntercept();

							// @TODO: if timeouts reload when online
							return MenusApiService.getAvailableMenus({
								nested: 1,
								language: $rootScope.currentLanguage || $rootScope.default_language || 'en',
							}).then(
								function(_response) {
									clearPlugins();

									// console.log('menus response: ', _response);
									var response = angular.copy(_response) || {};
									// @TODO: caches should return the copy of data?

									response.data = parseMenuItems(response.data);

									for (var i = 0; i < response.data.length; i++) {
										var item = response.data[i]; // because of the caches!

										var is_plugin = isPlugin(item);

										item.defaultExtension = '';
										if (/\.[^.]*$/.test(item.icon || '')) {
											var extension = item.icon.match(/\.([^.]*)$/)[1];
											extension = extension.replace(/\?.*?$/, '');
											//console.log('extension: ', extension);
											if (extension != 'svg') {
												item.defaultExtension = extension;
											}
										}

										if (is_plugin) {
											addPlugin(item);
										} else {
											item.icon = (item.icon || '/default.svg').replace(/\.[^.]*$/, '.svg');
											if (!/^\/local\//.test(item.icon) && !/^https?:\/\//.test(item.icon)) {
												item.icon = ('app/components/' + item.icon).replace(/\/{2,}/g, '/');
											}
											setStateTitle(item);
										}

										item.icon = item.icon ? addTimestampIfNeeded(item.icon) : item.icon;
										if (typeof item.children == 'undefined' || !item.children.length) {
											if (!is_plugin) {
												item.state = pathToState(item.path);
												item.href = adjustedPath(item.path);

												if (item.state == 'index..' || item.state == 'index.') {
													item.state = 'index.home';
													item.href = '/';
												}

												parseStandardMenuItemParams(item);
											}

											item.children = [];

											item.href = item.href.replace(/^\//, '');

											if (item.href && !/\/$/.test(item.href) && item.href.indexOf('?') < 0) {
												item.href += '/';
											}

											continue;
										}

										var parent_state = item.state;

										item.state = '';
										item.href = '#';

										for (var j = 0; j < item.children.length; j++) {
											var child = item.children[j];

											if (isPlugin(child)) {
												child.parent_state = parent_state;
												addPlugin(child);
											} else if (child.path) {
												child.state = pathToState(child.path);
												child.href = adjustedPath(child.path);
												setStateTitle(child);

												child.href = child.href.replace(/^\//, '');

												parseStandardMenuItemParams(child);
											}

											if (child.href && !/\/$/.test(child.href) && child.href.indexOf('?') < 0) {
												child.href += '/';
											}
										}
									}

									if (!checkedCustomRedirects) {
										checkedCustomRedirects = true;
										checkCustomRedirects();
									}

									$timeout(function() {
										$rootScope.menuItems = response.data;
										$rootScope.applyMenuFilter();
										$rootScope.$broadcast('$$rebind::navigation');
										$urlRouter.listen();
									}).then(function() {
										if (firstRun) {
											firstRun = false;
											$urlRouter.sync();
											return;
										}
									});

									return response;
								},
								function(error) {
									//MenusApiService.defaultErrorHandler(error); // don't show error message
									$urlRouter.sync();
									$urlRouter.listen();

									// $log.debug('menus error: ', error);
									return error;
								}
							);
						})();

						$rootScope.clearMenu = function() {
							$timeout(function() {
								$rootScope.menuItems = [];
								$rootScope.$broadcast('$$rebind::navigation');
								//firstRun = true;
							});
						};

						$rootScope.$on('AuthSuccess', $rootScope.fetchMenus);
						$rootScope.$on('languageChanged', $rootScope.fetchMenus);

						$rootScope.$on('LoggedOut', $rootScope.clearMenu);

						$rootScope.$on('refreshMenu', function() {
							$timeout(function() {
								firstRun = true;
								$rootScope.fetchMenus();
							}, 1000);
						});
					}, 100); // sometimes fails on firefox, hence the delay
				});

				$rootScope.$on('LoggedOut', function() {
					me = null;
				});

				// prevent Ladda buttons memory leak - automatically remove all instances on page change
				enswitchGlobals.waitForResource('Ladda').then(function() {
					$timeout(function() {
						var _create = Ladda.create;
						var instances = [];
						Ladda.create = function() {
							var instance;
							try {
								instance = _create.apply(this, arguments);
							} catch (e) {
								// console.log('failed to create Ladda button: ', arguments[0]);
								return {
									// fallback
									start: angular.noop,
									stop: angular.noop,
								};
							}
							var _remove = instance.remove;
							instance.remove = function() {
								instances.splice(instances.indexOf(instance), 1);
								_remove.apply(this, arguments);
								instance = null;
								_remove = null;
							};
							instances.push(instance);
							return instance;
						};
						var removeAll = function() {
							while (instances && instances.length) {
								instances[instances.length - 1].remove();
							}
							instances = [];
						};
						$rootScope.$on('$stateChangeStart', function(event) {
							$timeout(function() {
								if (event.defaultPrevented) {
									if (typeof event.defaultPrevented === 'function' && !event.defaultPrevented()) {
										removeAll();
									}
								} else {
									removeAll();
								}
							});
						});
						$rootScope.$on('$destroy', function() {
							removeAll();
							_create = null;
						});
					});
				});

				// clear jQuery cache memory leak
				$rootScope.$on('$stateChangeSuccess', function(event, toState, toParams, fromState, fromParams, options) {
					if (!fromState || !fromState.name) {
						return;
					}

					$timeout(function() {
						var cache = jQuery.domCache || jQuery.cache;

						for (var i in cache) {
							if (cache.hasOwnProperty(i)) {
								if (
									cache[i].handle &&
									cache[i].handle.elem &&
									document !== cache[i].handle.elem &&
									!jQuery.contains(document, cache[i].handle.elem)
								) {
									//we have an event handler pointing to a detached dom element! this is a memory leak!
									var detachedEl = $(cache[i].handle.elem);
									//var detachedElHtml = detachedEl.html();
									//console.log('removing leaked DOM element: ', detachedElHtml);
									$('body').append(detachedEl);
									detachedEl.off();
									detachedEl.remove();
									detachedEl = null;
								}
							}
						}

						cache = null;
					});
				});

				$rootScope.$on('$destroy', function() {
					delete enswitchGlobals.urlRouterProvider.lazyLoadedState;
					delete enswitchGlobals.urlRouterProvider.localizedTemplateState;
					for (var key in window.enswitchGlobals) {
						delete window.enswitchGlobals[key];
					}
					window.enswitchGlobals = null;
					delete window.enswitchGlobals;

					var clearAllMembers = function(obj, depth) {
						depth = depth || 0;
						if (depth > 10) {
							// prevent infinite recursion because of circular references
							return;
						}
						for (var i in obj) {
							if (obj.hasOwnProperty(i) && ('$window' != i || !depth)) {
								if (typeof obj[i] == 'object') {
									clearAllMembers(obj[i], ++depth);
								}
								if (obj) {
									if (obj[i] && obj[i] instanceof Array && obj[i].length) {
										obj[i].splice(0);
									}
									try {
										delete obj[i];
									} catch (e) {}
								}
							}
						}
					};

					setTimeout(function() {
						clearAllMembers($stateRegistry);
						clearAllMembers($urlRouter);
						clearAllMembers($urlService);
						clearAllMembers($state);
					});
				});
			},
		};
	});

'use strict';

angular
	.module('new-web')

	.factory('FileDownloadService', function() {
		var byteCharactersToBlob = function(byteCharacters, contentType, sliceSize) {
			var byteArrays = [];

			for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
				var slice = byteCharacters.slice(offset, offset + sliceSize);

				var byteNumbers = new Array(slice.length);

				for (var i = 0; i < slice.length; i++) {
					byteNumbers[i] = slice.charCodeAt(i);
				}

				var byteArray = new Uint8Array(byteNumbers);

				byteArrays.push(byteArray);
			}

			var blob = new Blob(byteArrays, {
				type: contentType,
			});
			return blob;
		};

		var b64toBlob = function(b64Data, contentType, sliceSize) {
			contentType = contentType || '';
			sliceSize = sliceSize || 512;

			var byteCharacters = atob(b64Data);

			return byteCharactersToBlob(byteCharacters, contentType, sliceSize);
		};

		var textToBlob = function(text, contentType, sliceSize) {
			contentType = contentType || 'text/plain';
			sliceSize = sliceSize || 512;

			return byteCharactersToBlob(text, contentType, sliceSize);
		};

		var downloadFile = function(filename, data, mimetype) {
			var link = document.createElement('a');

			//link.setAttribute("href", 'data:' + mimetype + ';base64,' + data);

			var blob = b64toBlob(data, mimetype);
			var blobUrl = URL.createObjectURL(blob);

			link.setAttribute('href', blobUrl);

			link.setAttribute('download', filename);
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		};

		return {
			downloadFile: downloadFile,

			downloadTextFile: function(filename, text) {
				var link = document.createElement('a');

				var blob = textToBlob(text);
				var blobUrl = URL.createObjectURL(blob);

				if (typeof filename != 'string' || !filename) {
					filename = 'export.txt';
				}

				if (filename) {
					link.setAttribute('download', filename);
				}

				link.setAttribute('href', blobUrl);

				document.body.appendChild(link); // Required for FF
				link.click();
				document.body.removeChild(link);
			},

			downloadSVGImage: function(svg, filename) {
				var serializer = new XMLSerializer();
				var source = serializer.serializeToString(svg);

				if (!source.match(/^<svg[^>]+xmlns="http\:\/\/www\.w3\.org\/2000\/svg"/)) {
					source = source.replace(/^<svg/, '<svg xmlns="http://www.w3.org/2000/svg"');
				}
				if (!source.match(/^<svg[^>]+"http\:\/\/www\.w3\.org\/1999\/xlink"/)) {
					source = source.replace(/^<svg/, '<svg xmlns:xlink="http://www.w3.org/1999/xlink"');
				}
				source = '<?xml version="1.0" standalone="no"?>\r\n' + source;

				var url = 'data:image/svg+xml;charset=utf-8;base64,' + btoa(source);
				var link = document.createElement('a');
				link.setAttribute('href', url);
				link.setAttribute('download', filename);
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			},

			downloadSVGImageAsPNG: function(svg, filename, w, h, bc) {
				svg.style.backgroundColor = bc;
				var sw = String(w) + 'px';
				var sh = String(h) + 'px';
				svg.setAttribute('width', sw);
				svg.setAttribute('height', sh);
				var serializer = new XMLSerializer();
				var source = serializer.serializeToString(svg);

				if (!source.match(/^<svg[^>]+xmlns="http\:\/\/www\.w3\.org\/2000\/svg"/)) {
					source = source.replace(/^<svg/, '<svg xmlns="http://www.w3.org/2000/svg"');
				}
				if (!source.match(/^<svg[^>]+"http\:\/\/www\.w3\.org\/1999\/xlink"/)) {
					source = source.replace(/^<svg/, '<svg xmlns:xlink="http://www.w3.org/1999/xlink"');
				}
				source = '<?xml version="1.0" standalone="no"?>\r\n' + source;

				var url = 'data:image/svg+xml;charset=utf-8;base64,' + btoa(source);
				var img = new Image();
				img.width = w;
				img.height = h;
				img.style.width = sw;
				img.style.height = sh;
				img.onload = function() {
					setTimeout(function() {
						var canvas = document.createElement('canvas');
						canvas.width = w;
						canvas.height = h;
						canvas.style.width = sw;
						canvas.style.height = sh;
						var ctx = canvas.getContext('2d', {
							preserveDrawingBuffer: true,
						});
						if (bc) {
							ctx.fillStyle = bc;
							ctx.fillRect(0, 0, w, h);
						}
						ctx.drawImage(img, 0, 0, w, h);
						downloadFile(filename, canvas.toDataURL('image/png').replace(/^.*,/, ''), 'image/png');
						//gl = null;
						ctx = null;
						img.onload = null;
						img = null;
					});
				};
				img.src = url;
			},
		};
	});

'use strict';

angular
	.module('new-web')

	.factory('DropdownDataService', function($rootScope, variables) {
		var lang = $rootScope.languageString;

		var timezonesList = function() {
			var timezones_list = [];

			variables.timezones.forEach(function(t) {
				timezones_list.push({
					value: t,
					display: lang('timezone_' + t.toLowerCase().replace(/\//g, '_')).replace('&nbsp;', ' '),
				});
			});

			return timezones_list;
		};

		var dialplans_list = function() {
			return variables.dialplans
				.map(function(d) {
					return {
						value: d,
						display: lang((d.length == 2 ? 'country_' : 'dialplan_') + d),
					};
				})
				.sort(function(a, b) {
					return (a.display || '').toLowerCase().localeCompare((b.display || '').toLowerCase());
				});
		};

		var invoice_currencies_list = function() {
			return Object.keys(variables.currencies).map(function(c) {
				return {
					value: c,
					display: lang('currency_' + c.toLowerCase()),
				};
			});
		};

		var countries_list = function() {
			return variables.countries
				.map(function(c) {
					return {
						value: c,
						display: lang('country_' + c.toLowerCase()),
					};
				})
				.sort(function(a, b) {
					return (a.display || '').toLowerCase().localeCompare((b.display || '').toLowerCase());
				});
		};

		var park_timeout_list = [];
		for (var i = 1; i < 61; i++) {
			park_timeout_list.push(60 * i);
		}

		var person_titles = function() {
			return [
				{
					value: '',
					display: lang('person_title_') || lang('select_dots'),
				},
				{
					value: 'mr',
					display: lang('person_title_' + 'mr'),
				},
				{
					value: 'ms',
					display: lang('person_title_' + 'ms'),
				},
				{
					value: 'miss',
					display: lang('person_title_' + 'miss'),
				},
				{
					value: 'mrs',
					display: lang('person_title_' + 'mrs'),
				},
				{
					value: 'dr',
					display: lang('person_title_' + 'dr'),
				},
				{
					value: 'prof',
					display: lang('person_title_' + 'prof'),
				},
				{
					value: 'rev',
					display: lang('person_title_' + 'rev'),
				},
			];
		};

		var alert_type_select = function() {
			// alert_type select
			return [
				{
					value: 'calls',
					display: lang('alert_type_calls'),
				},
				{
					value: 'peer',
					display: lang('alert_type_peer'),
				}, // am_system
				{
					value: 'concurrent',
					display: lang('alert_type_concurrent'),
				},
				{
					value: 'destinations',
					display: lang('alert_type_destinations'),
				},
				{
					value: 'huntgroup_exit',
					display: lang('alert_type_huntgroup_exit'),
				},
				{
					value: 'maximum',
					display: lang('alert_type_maximum'),
				},
				{
					value: 'registration_fail',
					display: lang('alert_type_registration_fail'),
				},
				{
					value: 'numbers',
					display: lang('alert_type_numbers'),
				},
				{
					value: 'outgroups',
					display: lang('alert_type_outgroups'),
				}, // am_system
				{
					value: 'phones',
					display: lang('alert_type_phones'),
				},
				{
					value: 'deregister',
					display: lang('alert_type_deregister'),
				},
				{
					value: 'phone_locked',
					display: lang('alert_type_phone_locked'),
				},
				{
					value: 'phone_address',
					display: lang('alert_type_phone_address'),
				},
				{
					value: 'person_locked',
					display: lang('alert_type_person_locked'),
				},
				{
					value: 'queue_auto_unavailable',
					display: lang('alert_type_queue_auto_unavailable'),
				},
				{
					value: 'queue_exit',
					display: lang('alert_type_queue_exit'),
				},
			].sort(function(a, b) {
				return (a.display || '').toLowerCase().localeCompare((b.display || '').toLowerCase());
			});
		};

		var days_of_week = function() {
			return [
				{
					value: '1',
					display: lang('day_1'),
				},
				{
					value: '2',
					display: lang('day_2'),
				},
				{
					value: '3',
					display: lang('day_3'),
				},
				{
					value: '4',
					display: lang('day_4'),
				},
				{
					value: '5',
					display: lang('day_5'),
				},
				{
					value: '6',
					display: lang('day_6'),
				},
				{
					value: '7',
					display: lang('day_7'),
				},
			];
		};

		return {
			timezonesList: timezonesList,

			dialplansList: dialplans_list,

			invoiceCurrenciesList: invoice_currencies_list,

			countriesList: countries_list,

			parkTimeoutList: function() {
				return park_timeout_list;
			}, // ???

			personTitlesList: person_titles,

			alertTypesList: alert_type_select,

			daysOfWeek: days_of_week,

			filterProperty: function(prop, arr, key, def) {
				if (typeof def === 'undefined') {
					def = '';
				}

				var currentValue = prop === undefined || prop === null || prop === false ? def : prop;

				if (!arr || !arr.length) {
					return currentValue;
				}

				var filtered = arr.filter(function(item) {
					return String(item[key]) === String(currentValue);
				})[0];

				return filtered || filtered === '' || filtered === 0 ? filtered : arr[0] || currentValue;
			},
		};
	});

'use strict';

angular
	.module('new-web')

	.factory('SessionService', function($window, $rootScope) {
		var max_users, me;

		var customers = JSON.parse($window.localStorage.getItem('displayed_customers') || 'null') || [];
		var last_accessed = [];

		var sortByName = function(a, b) {
			return (a.name || a.username).localeCompare(b.name || b.username);
		};

		var sortByDate = function(a, b) {
			return (new Date(b.switched_time) || 0) - (new Date(a.switched_time) || 0);
		};

		var getCookieExpiryDate = function(expiry) {
			var default_expiry = Number(expiry) == 0 || expiry == null;
			var date = new Date(new Date());

			if (default_expiry) {
				date.setDate(date.getDate() + 30);
			} else {
				date.setSeconds(date.getSeconds() + expiry);
			}
			// console.log('Cookie expiry date: ', date);
			return date;
		};

		var customerMapper = function(c) {
			return c
				? {
						id: c.id,
						name: c.name,
						locked: c.locked,
						account: c.account,
						parent: c.parent,
						virtual_logout: c.virtual_logout,
						timezone: c.timezone,
						date_format: c.date_format,
						time_format: c.time_format,
						signup_transaction: c.signup_transaction,
						region: c.region,
						plan: c.plan,
						language: c.language,
						expires: c.expires,
						email: c.email,
						dialplan: c.dialplan,
						directory: c.directory,
						country: c.country,
						//...
						// for people:
						customer: c.customer,
						forename: c.forename,
						surname: c.surname,
						title: c.title,
						username: c.username,
						last_login: c.last_login,
						failed_count: c.failed_count,
						extension: c.extension,
						digit_name: c.digit_name,
						switched_time: c.switched_time,
				  }
				: c;
		};

		var addOrUpdateCustomer = function(customer) {
			if (!customer) {
				return;
			}

			customer.switched_time = new Date();
			customer = customerMapper(customer);

			var found = false;

			customers.forEach(function(cust, i) {
				if (String(cust.id) == String(customer.id) && cust.name === customer.name) {
					found = true;
					customers[i] = customer;
				}
			});

			if (!found) {
				var max = $rootScope.switch_user_maximum;
				if (max) {
					max_users = max;
					if (customers.length >= max) {
						customers = customers.sort(sortByDate).reverse();
						customers.splice(0, customers.length - max + 1);
					}
				}
				customers.push(customer);
				$rootScope.$broadcast('RefreshCustomersDropdown');
			}

			$window.localStorage.setItem('displayed_customers', JSON.stringify(customers));

			if (customer.name && me) {
				found = false;
				last_accessed.forEach(function(cust, i) {
					if (String(cust.id) == String(customer.id)) {
						found = true;
						last_accessed[i] = customer;
					}
				});

				if (!found) {
					var _max = $rootScope.switch_user_maximum;
					if (_max) {
						max_users = _max;
						if (last_accessed.length >= _max) {
							last_accessed = last_accessed.sort(sortByDate).reverse();
							last_accessed.splice(0, last_accessed.length - _max + 1);
						}
					}
					last_accessed.push(customer);
					$rootScope.$broadcast('RefreshCustomersDropdown');
				}

				last_accessed = last_accessed.sort(sortByDate);

				$window.localStorage.setItem('last_accessed_customers_' + me.id, JSON.stringify(last_accessed));
			}
		};

		var removeCustomer = function(customer) {
			if (!customer) {
				return;
			}

			var index = -1;

			customers.some(function(c, i) {
				if (String(c.id) == String(customer.id) && ((!customer.name && !c.name) || customer.name == c.name)) {
					index = i;
					return true;
				}
				return false;
			});

			if (index > -1) {
				customers.splice(index, 1);
				$rootScope.$broadcast('RefreshCustomersDropdown');
			}

			$window.localStorage.setItem('displayed_customers', JSON.stringify(customers));
		};

		var clearSessionInfo = function() {
			Cookies.remove('auth_session', { sameSite: 'strict' });
			Cookies.remove('current_customer', { sameSite: 'strict' });
			$window.localStorage.removeItem('displayed_customers');
			customers = [];
		};

		var getSession = function() {
			var session = JSON.parse(Cookies.get('auth_session') || 'null');
			var auth_username = session ? session.auth_username : null;
			var auth_password = session ? session.auth_password : null;

			if (!session || !auth_username || !auth_password) {
				clearSessionInfo(); // if session expired must clean other info!
				return null;
			} else {
				return session;
			}
		};

		var loadLastAccessedCustomers = function() {
			return me ? JSON.parse($window.localStorage.getItem('last_accessed_customers_' + me.id) || 'null') || [] : [];
		};

		me = getSession();
		last_accessed = loadLastAccessedCustomers();
		$rootScope.$on('AuthSuccess', function() {
			me = getSession();
			last_accessed = loadLastAccessedCustomers();
		});
		$rootScope.$on('WillLogOut', function() {
			me = null;
			last_accessed = [];
		});

		$rootScope.$on('$stateChangeSuccess', function() {
			var max = $rootScope.switch_user_maximum;
			if (max && max !== max_users) {
				max_users = max;
				if (customers.length > max) {
					customers = customers.sort(sortByDate).reverse();
					customers.splice(0, customers.length - max + 1);
					$rootScope.$broadcast('RefreshCustomersDropdown');
				}
				if (last_accessed.length > max) {
					last_accessed = last_accessed.sort(sortByDate).reverse();
					last_accessed.splice(0, last_accessed.length - max + 1);
					last_accessed = last_accessed.sort(sortByDate);
				}
			}
		});

		return {
			getSession: getSession,

			setSession: function(session) {
				var auth_username = session ? session.auth_username : null;
				var auth_password = session ? session.auth_password : null;

				var success = !!session && !!auth_username && !!auth_password;
				if (success) {
					Cookies.set('auth_session', JSON.stringify(session), {
						expires: getCookieExpiryDate($rootScope.web_cookie_expiry),
						sameSite: 'strict',
					});
				} else {
					clearSessionInfo();
				}

				//$window.localStorage.setItem('sessionLastUpdated', Number(new Date()));

				return success;
			},

			setCustomer: function(customer) {
				addOrUpdateCustomer(customer);
				Cookies.set('current_customer', JSON.stringify(customerMapper(customer)), {
					expires: getCookieExpiryDate($rootScope.web_cookie_expiry),
					sameSite: 'strict',
				});
			},

			getCustomer: function() {
				return JSON.parse(Cookies.get('current_customer') || 'null');
			},

			getDisplayedCustomers: function() {
				return customers.sort($rootScope.web_user_sort == 'alphabetical' ? sortByName : sortByDate);
			},

			getLastAccessedCustomers: function() {
				return last_accessed;
			},

			getLatestCustomers: function() {
				return customers
					.filter(function(c) {
						return c.name;
					})
					.sort($rootScope.web_user_sort == 'alphabetical' ? sortByName : sortByDate);
			},

			getLatestUsers: function() {
				return customers
					.filter(function(c) {
						return !c.name;
					})
					.sort($rootScope.web_user_sort == 'alphabetical' ? sortByName : sortByDate);
			},

			setEffectivePlan: function(planId) {
				var session = getSession();
				if (session) {
					session.effective_plan = planId;
					Cookies.set('auth_session', JSON.stringify(session), {
						expires: getCookieExpiryDate($rootScope.web_cookie_expiry),
						sameSite: 'strict',
					}); // get old expiry?
					//console.log('updateEffectivePlan...');
				}
			},

			removeCustomer: removeCustomer,
		};
	});

'use strict';

angular
	.module('new-web')

	.factory('CoreApiService', function(
		$q,
		$http,
		$log,
		SessionService,
		$state,
		$timeout,
		config,
		$rootScope,
		SwalService,
		$compile
	) {
		var lang = angular.identity;
		var _cache = {};
		var cache;
		var me = SessionService.getSession();
		me && (cache = _cache[me.effective_id || me.id] = _cache[me.effective_id || me.id] || {});
		$rootScope.$on('AuthSuccess', function() {
			me = SessionService.getSession();
			cache = _cache[me.effective_id || me.id] = _cache[me.effective_id || me.id] || {};
		});
		$rootScope.$on('LoggedOut', function() {
			cache = null;
		});

		$timeout(function() {
			lang = $rootScope.languageString;
		});

		var addSlashIfNeeded = function(s) {
			return /\/$/.test(s) ? s : s + '/';
		};

		var _encodeURIComponent = function(str) {
			return (str || '')
				.split('#')
				.map(encodeURIComponent)
				.join('%23')
				.split('*')
				.join('%2A');
		};

		var stringifyParams = function(params) {
			params = params || {};
			var paramsString = '?';

			for (var key in params) {
				if (params.hasOwnProperty(key)) {
					paramsString += key + '=' + _encodeURIComponent(String(params[key] == null ? '' : params[key])) + '&';
				}
			}

			return paramsString.slice(0, -1);
		};

		var updateTitleIfNeeded = function(endpoint, params) {
			if ($rootScope.openEditModalsCount || !/.+\/update\/?$/.test(endpoint)) return;
			var feature = /^\/?(.+?\/)*(.+?)\/update\/?$/.exec(endpoint)[2];
			//console.log('feature: ', feature);
			var _feature = feature;
			switch (feature) {
				case 'campaigns': {
					_feature = 'bulk';
					break;
				}
				case 'timegroups': {
					_feature = 'times/groups';
					break;
				}
				case 'people': {
					_feature = 'users';
					break;
				}
				default:
					break;
			}
			if (location.href.indexOf(_feature + '/edit/') < 0) return;
			var key = 'name';
			switch (feature) {
				case 'conferences': {
					key = 'code';
					break;
				}
				case 'prefixes': {
					key = 'prefix';
					break;
				}
				case 'people': {
					key = 'username';
					break;
				}
				case 'speeddials': {
					key = 'sdial';
					break;
				}
				case 'configs':
				case 'codes':
				case 'numbers':
				case 'mailboxes':
				case 'cards':
				case 'vouchers':
				case 'requests':
				case 'incosts':
				case 'outcosts':
				case 'costs':
				case 'tickets':
				case 'cdrs':
				case 'notes':
					return;
				case 'phones': {
					key = 'name';
					break;
				}
				case 'machines': {
					key = 'server';
					break;
				}
				case 'domains': {
					key = 'domain';
					break;
				}
				case 'classes':
				case 'ingroups':
				case 'outgroups':
				case 'products':
				case 'routes':
					if (location.href.indexOf('/plans/' + feature + '/') > -1) {
						return;
					}
				default:
					break;
			}
			var controllerAs = $state.current.controllerAs;
			var theScope = null;
			var _vm = null;
			var q = [$rootScope];
			while ($q.length) {
				var scope = q.pop();
				if (scope[controllerAs]) {
					theScope = scope;
					q.splice(0);
					scope = null;
					break;
				}
				if (scope.$$childHead) {
					q.push(scope.$$childHead);
				}
				if (scope.$$nextSibling) {
					q.push(scope.$$nextSibling);
				}
				scope = null;
			}
			q = null;
			// console.log('theScope: ', theScope);
			if (theScope) {
				_vm = theScope[controllerAs];
				var oldTitle = theScope.title || $rootScope.title || '';
				if (!/\:/.test(oldTitle)) {
					oldTitle = angular
						.element('.page-heading')
						.last()
						.find('h2')
						.first()
						.text();
				}
				if (!/\:/.test(oldTitle)) return;
				var arr = /^([\w\s]*\:\s)?(.*)$/.exec(oldTitle);
				var prefix = arr[1];
				var oldName = arr[2];
				// vm.title = lang('route') + ': ' + (response.data.caller_prefix ||  lang('default')) + ', ' + response.data.called_prefix;
				var newName = params[key];
				switch (feature) {
					case 'addresses': {
						newName = params.user + '@' + params.domain;
						break;
					}
					case 'menus': {
						newName = oldTitle.replace(prefix, '').replace(/((.*?\s\»\s)*)(.+?)$/, '$1 ') + params.name;
						break;
					}
					case 'routes': {
						if (location.href.indexOf('customers/plans/routes/edit') > -1) {
							newName = _vm.prefix_display + ', ' + _vm.media_display + ' ' + lang('for') + ' ' + params.name;
						} else if (location.href.indexOf('global/outroutes/edit')) {
							newName = (params.caller_prefix || lang('default')) + ', ' + params.called_prefix;
						} else {
							theScope = null;
							_vm = null;
							return;
						}
						break;
					}
					default:
						break;
				}
				// console.log('old, new: ', oldName, newName);
				if (oldName != newName) {
					$timeout(function() {
						$rootScope.title = _vm.title = prefix + newName;
						_vm = null;
						theScope = null;
					});
				}
			}
		};

		var requestPromise = function(method, endpoint, params, _data, useCaching) {
			var deferred = $q.defer();
			var data = params || {};

			if ($rootScope.offline) {
				deferred.reject(); // silently fail when offline
				return deferred.promise;
			}

			if (endpoint.lastIndexOf('/') != endpoint.length - 1) {
				endpoint += '/';
			}

			var cancel = $q.defer();
			var request = {
				method: method,
				//url: addSlashIfNeeded(config.apiUrl) + endpoint + stringifyParams(data),
				timeout: cancel.promise,
				cancel: endpoint.indexOf('login') > -1 ? null : cancel,
			};

			request.data = _data || {};

			if (
				(!data.auth_username || !data.auth_password) &&
				endpoint != 'user/signup/' &&
				endpoint != 'user/login/' &&
				endpoint != 'user/password/lost/'
			) {
				var session = SessionService.getSession();

				var isConfig = endpoint == 'configs/get/';

				var preventAddingAuth =
					((endpoint == 'customs/get/' &&
						data.plan &&
						Number(data.value) == 1 &&
						!/^help_.+_(summary|body)$/.test(data.name)) ||
						endpoint == 'password/update/') &&
					!(request.cancel = null); // prevent canceling requests for loading plan customs and resetting password

				if (session && !preventAddingAuth) {
					var customer = SessionService.getCustomer();

					data.auth_username = session.auth_username;

					if (customer) {
						data.auth_username = (session.login_username || data.auth_username) + '|' + session.effective_username;
					}

					request.data.auth_password = session.auth_password;
				}
			} else {
				if (data.password) {
					request.data.password = data.password;
					delete data.password;
				}
				if (data.auth_password) {
					request.data.auth_password = data.auth_password;
					delete data.auth_password;
				}
			}

			request.url = endpoint + stringifyParams(data);

			if (!/^\//.test(endpoint)) {
				request.url = addSlashIfNeeded(config.apiUrl) + request.url;
			}

			if ('wrap' in data) {
				var returnTestRequest = data.wrap === 'none';

				if (returnTestRequest) {
					return $q.when(request.url + '&auth_password=' + request.data.auth_password + '&v=' + new Date().valueOf());
				}
			}

			var wasCached = false;
			(useCaching
				? (wasCached = !!cache[request.url])
					? $q.resolve(angular.copy(cache[request.url]))
					: $http(request)
				: $http(request)
			).then(
				function(_data) {
					if (useCaching && !wasCached) {
						cache[request.url] = angular.copy(_data);
						var to = setTimeout(function() {
							cache[request.url] = null;
						}, 60000);
						var u, v;
						var cancelTimeoutIfNeeded = function() {
							cache[request.url] = null;
							to && clearTimeout(to);
							to = null;
							u && u();
							v && v();
							u = null;
							v = null;
						};
						$rootScope.$on('$destroy', cancelTimeoutIfNeeded);
						u = $rootScope.$on('WillLogOut', cancelTimeoutIfNeeded);
						v = $rootScope.$on('AuthSuccess', cancelTimeoutIfNeeded);
					}

					var response = _data.data.responses[0];

					if (response.code >= 200 && response.code < 300) {
						//?
						deferred.resolve(_data.data || []);
						updateTitleIfNeeded(endpoint, data);
						if ($rootScope.openEditModalsCount && /\/(update|create|send)\/?$/.test(endpoint)) {
							var originalParams = angular.copy(data);
							delete originalParams.auth_username;
							$rootScope.$broadcast('EditModalResponse', {
								data: _data.data,
								originalParams: originalParams,
							});
						}
					} else {
						// $log.debug('api error: ', _data);
						response.originalRequest = {
							method: request.method,
							url: request.url,
						};
						response.originalParameters = angular.copy(data);
						delete response.originalParameters.auth_username;
						deferred.reject(response);
					}
				},
				function(error) {
					deferred.reject(error);
				}
			);

			return deferred.promise;
		};

		var getErrorMessage = function(error) {
			if (error.code == -1 || error.code == 401) {
				//unauthorized or invalid login
				if ($state.current.name.indexOf('index.') == 0) {
					SessionService.setSession(null);
					$rootScope.goToLogin();
				}
				return error.message || '';
			}

			var error_message = '';

			if (Number(error.status) <= 0) {
				error_message = lang('error_web_server_unreachable');
			} else if (error.message || error.key) {
				error_message += (error.key ? lang(error.key) : error.message || '') || '';
				if (error.line) {
					error_message = error_message.replace(/(.+?)\.?$/, '$1 ' + lang('at_line') + ' ' + String(error.line) + '.');
				}
			} else if (error.config && error.headers) {
				// this is Angular $http rejection
				error_message = lang('error');
			}

			return error_message;
		};

		var getRelevantParam = function(apiCall, params) {
			var paramsByRelevance = ['id', 'dnumber', 'number', 'mailbox', 'code', 'snumber', 'name'];

			params = params || {};
			var keys = Object.keys(params);

			if (!keys.length) {
				return '';
			}

			return keys.sort(function(a, b) {
				var aPoints = paramsByRelevance.indexOf(a);
				if (aPoints < 0) {
					aPoints = paramsByRelevance.length + (apiCall.indexOf(a) > -1 ? 0 : 1);
				}

				var bPoints = paramsByRelevance.indexOf(b);
				if (bPoints < 0) {
					bPoints = paramsByRelevance.length + (apiCall.indexOf(b) > -1 ? 0 : 1);
				}

				return aPoints - bPoints;
			})[0];
		};

		var getOperationName = function(apiCall) {
			var path = apiCall.split(/\//);

			if (path.length < 2 || path.length > 3 || !path[0]) {
				return lang('action_unknown');
			}

			// console.log('path: ', path);

			var action = path[path.length - 1];
			var actionStr = lang('action_' + action);

			var subfeature = path.length == 3;
			var res =
				actionStr +
				' ' +
				lang(
					(subfeature ? '' : 'type_') + path[path.length - 2].replace(/e?s$/, '').replace(/queu$/, 'queue')
				).toLowerCase();

			if (subfeature) {
				res +=
					' ' +
					lang(action == 'delete' ? 'from' : 'for') +
					' ' +
					lang('type_' + path[0].replace(/e?s$/, '').replace(/queu$/, 'queue')).toLowerCase();
			}

			return res;
		};

		var hasDetails = function(apiCall) {
			return /\/(destinations\/create|destinations\/update|phones\/add|destinations\/set)$/.test(apiCall); // delete|
		};

		var handleMultipleErrors = function(errors, callback) {
			var title = lang('multiple_errors_occured');
			var html = ''; // <ul style="text-align: left; overflow-y: auto;">

			var scope = $rootScope.$new();
			//scope.options = {};

			var errors_with_details = [];
			var other_errors = [];

			errors.forEach(function(error, index) {
				if (!error.originalRequest) {
					error.originalRequest = {};
				}

				var apiCall = (error.originalRequest.url || '')
					.replace(config.apiUrl, '')
					.replace(/\?.+$/, '')
					.replace(/^\//, '')
					.replace(/\/$/, '');
				var params = error.originalParameters;

				error.apiCall = apiCall;
				error.params = params;
				error.error_message = getErrorMessage(error);
				error.has_details = hasDetails(apiCall);
				error.operation = error.has_details ? getOperationName(apiCall) : '';
				error.relevant_param = error.has_details ? params[getRelevantParam(apiCall, params)] : '';
				error.details_shown = false;

				if (error.has_details) {
					errors_with_details.push(error);
				} else {
					other_errors.push(error);
				}
			});

			scope.errors_with_details = errors_with_details;
			scope.other_errors = other_errors;

			html += '<div ng-if="errors_with_details.length"><h4>The following requests have failed:</h4>';
			html += '<ul style="text-align: left; overflow-y: auto;">';
			html +=
				'<li style="word-wrap: break-word; white-space: initial; font-size: 15px;" ng-repeat="error in errors_with_details">{{error.operation}}: {{error.relevant_param}}' +
				'<span style="font-size: 14px;" ng-show="!error.details_shown">&nbsp;(<a ng-click="error.details_shown=true">' +
				lang('show_details') +
				'</a>)</span>' +
				'<span style="font-size: 14px;" ng-show="error.details_shown"><span style="font-size: 14px;">&nbsp;(<a ng-click="error.details_shown=false">' +
				lang('hide_details') +
				'</a>)</span>' +
				'<br/>{{error.error_message}}</span></li>';
			html += '</ul></div>';

			html += '<div ng-if="other_errors.length"><h4 ng-if="errors_with_details.length">Other errors:</h4>';
			html += '<ul style="text-align: left; overflow-y: auto;">';
			html +=
				'<li style="word-wrap: break-word; white-space: initial; font-size: 15px;" ng-repeat="error in other_errors">{{error.error_message}}</li>';
			html += '</ul></div>';

			var content = angular.element(html);

			return SwalService.popup({
				title: title,
				type: 'error',
				html: '<div id="error-list"></div>',
				onOpen: function(el) {
					$timeout(function() {
						$compile(content)(scope);
						angular.element($('#error-list')).prepend(content);
					});
				},
				onClose: function(el) {
					scope && scope.$destroy();
					content && content.remove();
					scope = null;
					content = null;
				},
			}).then(callback || angular.noop, angular.identity);
		};

		return {
			makeApiCall: function(method, endpoint, params, data, useCaching) {
				return requestPromise(method, endpoint, params, data, useCaching);
			},

			defaultErrorHandler: function(error, callback) {
				if (typeof callback != 'function') {
					callback = angular.identity;
				}

				if (typeof error === 'undefined' || !error) {
					//silently fail when no error object
					callback();
					return;
				}

				// $log.debug(error);

				if (error instanceof Array) {
					if (error.length < 2) {
						error = error[0];
					} else {
						return handleMultipleErrors(error, callback);
					}
				}

				if (!error) {
					callback();
					return;
				}

				var error_message = getErrorMessage(error);

				if (error_message) {
					$timeout(function() {
						SwalService.popup({
							title: error_message,
							type: 'error',
						}).then(callback, angular.identity); //.done();
					});
				}

				return error.data;
			},

			getErrorMessage: getErrorMessage,

			getCancelableRequests: function() {
				return $http.pendingRequests.filter(function(r) {
					return r.cancel;
				});
			},
		};
	});

'use strict';

angular
	.module('new-web')

	.factory('VouchersApiService', function(CoreApiService) {
		return {
			checkAvailableVouchers: function(params) {
				return CoreApiService.makeApiCall('POST', 'vouchers/available/check/', params);
			},

			getVouchersList: function(params) {
				return CoreApiService.makeApiCall('POST', 'vouchers/list/', params);
			},

			getVoucher: function(params) {
				return CoreApiService.makeApiCall('POST', 'vouchers/get/', params);
			},

			updateVoucher: function(params) {
				return CoreApiService.makeApiCall('POST', 'vouchers/update/', params);
			},

			useVoucher: function(params) {
				return CoreApiService.makeApiCall('POST', 'vouchers/use/', params);
			},

			deleteVoucher: function(params) {
				return CoreApiService.makeApiCall('POST', 'vouchers/delete/', params);
			},

			getBatchesList: function(params) {
				return CoreApiService.makeApiCall('POST', 'vouchers/batches/list/', params);
			},

			getBatch: function(params) {
				return CoreApiService.makeApiCall('POST', 'vouchers/batches/get/', params);
			},

			createBatch: function(params) {
				return CoreApiService.makeApiCall('POST', 'vouchers/batches/create/', params);
			},

			updateBatch: function(params) {
				return CoreApiService.makeApiCall('POST', 'vouchers/batches/update/', params);
			},

			deleteBatch: function(params) {
				return CoreApiService.makeApiCall('POST', 'vouchers/batches/delete/', params);
			},

			defaultErrorHandler: CoreApiService.defaultErrorHandler,
		};
	});

'use strict';

angular
	.module('new-web')

	.factory('UserApiService', function(CoreApiService, $rootScope) {
		return {
			login: function(params) {
				return CoreApiService.makeApiCall('POST', 'user/login/', params);
			},

			lostPassword: function(params) {
				return CoreApiService.makeApiCall('POST', 'user/password/lost/', params);
			},

			updatePassword: function(params) {
				return CoreApiService.makeApiCall('POST', 'user/password/update/', params);
			},

			signup: function(params) {
				return CoreApiService.makeApiCall('POST', 'user/signup/', params);
			},

			switchUser: function(params) {
				$rootScope.$broadcast('WillSwitchUser');
				return CoreApiService.makeApiCall('POST', 'user/switch/', params);
			},

			defaultErrorHandler: CoreApiService.defaultErrorHandler,
		};
	});

'use strict';

angular
	.module('new-web')

	.factory('UrlsApiService', function(CoreApiService) {
		return {
			getUrlsList: function(params) {
				return CoreApiService.makeApiCall('POST', 'urls/list/', params);
			},

			getUrl: function(params) {
				return CoreApiService.makeApiCall('POST', 'urls/get/', params);
			},

			createUrl: function(params) {
				return CoreApiService.makeApiCall('POST', 'urls/create/', params);
			},

			updateUrl: function(params) {
				return CoreApiService.makeApiCall('POST', 'urls/update/', params);
			},

			deleteUrl: function(params) {
				return CoreApiService.makeApiCall('POST', 'urls/delete/', params);
			},

			defaultErrorHandler: CoreApiService.defaultErrorHandler,
		};
	});

'use strict';

angular
	.module('new-web')

	.factory('UnlimitedApiService', function(CoreApiService) {
		return {
			getUnlimitedList: function(params) {
				return CoreApiService.makeApiCall('POST', 'unlimited/list/', params);
			},

			getUnlimited: function(params) {
				return CoreApiService.makeApiCall('POST', 'unlimited/get/', params);
			},

			createUnlimited: function(params) {
				return CoreApiService.makeApiCall('POST', 'unlimited/create/', params);
			},

			updateUnlimited: function(params) {
				return CoreApiService.makeApiCall('POST', 'unlimited/update/', params);
			},

			deleteUnlimited: function(params) {
				return CoreApiService.makeApiCall('POST', 'unlimited/delete/', params);
			},

			uploadFiles: function(params, data) {
				return CoreApiService.makeApiCall('POST', 'unlimited/files/upload/', params, data);
			},

			downloadFiles: function(params) {
				return CoreApiService.makeApiCall('POST', 'unlimited/files/download/', params);
			},

			deleteFiles: function(params) {
				return CoreApiService.makeApiCall('POST', 'unlimited/files/delete/', params);
			},

			defaultErrorHandler: CoreApiService.defaultErrorHandler,
		};
	});

'use strict';

angular
	.module('new-web')

	.factory('TransactionsApiService', function(CoreApiService) {
		return {
			getTransactionsList: function(params) {
				return CoreApiService.makeApiCall('POST', 'transactions/list/', params);
			},

			getTransaction: function(params) {
				return CoreApiService.makeApiCall('POST', 'transactions/get/', params);
			},

			createTransaction: function(params) {
				return CoreApiService.makeApiCall('POST', 'transactions/create/', params);
			},

			updateTransaction: function(params) {
				return CoreApiService.makeApiCall('POST', 'transactions/update/', params);
			},

			deleteTransaction: function(params) {
				return CoreApiService.makeApiCall('POST', 'transactions/delete/', params);
			},

			defaultErrorHandler: CoreApiService.defaultErrorHandler,
		};
	});

'use strict';

angular
	.module('new-web')

	.factory('TracesApiService', function(CoreApiService) {
		return {
			getTracesList: function(params) {
				return CoreApiService.makeApiCall('POST', 'traces/list/', params);
			},

			getTrace: function(params) {
				return CoreApiService.makeApiCall('POST', 'traces/get/', params);
			},

			deleteTrace: function(params) {
				return CoreApiService.makeApiCall('POST', 'traces/delete/', params);
			},

			startTrace: function(params) {
				return CoreApiService.makeApiCall('POST', 'traces/start/', params);
			},

			stopTrace: function(params) {
				return CoreApiService.makeApiCall('POST', 'traces/stop/', params);
			},

			getCallsList: function(params) {
				return CoreApiService.makeApiCall('POST', 'traces/calls/list/', params);
			},

			getCall: function(params) {
				return CoreApiService.makeApiCall('POST', 'traces/calls/get', params);
			},

			defaultErrorHandler: CoreApiService.defaultErrorHandler,
		};
	});

'use strict';

angular
	.module('new-web')

	.factory('TimegroupApiService', function(CoreApiService) {
		return {
			getTimegroupsList: function(params) {
				return CoreApiService.makeApiCall('POST', 'timegroups/list/', params);
			},

			getTimegroup: function(params) {
				return CoreApiService.makeApiCall('POST', 'timegroups/get/', params);
			},

			createTimegroup: function(params) {
				return CoreApiService.makeApiCall('POST', 'timegroups/create/', params);
			},

			updateTimegroup: function(params) {
				return CoreApiService.makeApiCall('POST', 'timegroups/update/', params);
			},

			deleteTimegroup: function(params) {
				return CoreApiService.makeApiCall('POST', 'timegroups/delete/', params);
			},

			getPeriodsList: function(params) {
				return CoreApiService.makeApiCall('POST', 'timegroups/periods/list/', params);
			},

			getPeriod: function(params) {
				return CoreApiService.makeApiCall('POST', 'timegroups/periods/get/', params);
			},

			createPeriod: function(params) {
				return CoreApiService.makeApiCall('POST', 'timegroups/periods/create/', params);
			},

			updatePeriod: function(params) {
				return CoreApiService.makeApiCall('POST', 'timegroups/periods/update/', params);
			},

			deletePeriod: function(params) {
				return CoreApiService.makeApiCall('POST', 'timegroups/periods/delete/', params);
			},

			downloadFiles: function(params) {
				return CoreApiService.makeApiCall('POST', 'timegroups/files/download/', params);
			},

			uploadFiles: function(params, data) {
				return CoreApiService.makeApiCall('POST', 'timegroups/files/upload/', params, data);
			},

			deleteFiles: function(params) {
				return CoreApiService.makeApiCall('POST', 'timegroups/files/delete/', params);
			},

			getTimegroupUsage: function(params) {
				return CoreApiService.makeApiCall('POST', 'timegroups/usage/', params);
			},

			defaultErrorHandler: CoreApiService.defaultErrorHandler,
		};
	});

'use strict';

angular
	.module('new-web')

	.factory('TicketsApiService', function(CoreApiService) {
		return {
			getTicketsList: function(params) {
				return CoreApiService.makeApiCall('POST', 'tickets/list/', params);
			},

			getTicket: function(params) {
				return CoreApiService.makeApiCall('POST', 'tickets/get/', params);
			},

			createTicket: function(params) {
				return CoreApiService.makeApiCall('POST', 'tickets/create/', params);
			},

			updateTicket: function(params) {
				return CoreApiService.makeApiCall('POST', 'tickets/update/', params);
			},

			defaultErrorHandler: CoreApiService.defaultErrorHandler,
		};
	});

'use strict';

angular
	.module('new-web')

	.factory('TaxesApiService', function(CoreApiService) {
		return {
			getTaxesList: function(params) {
				return CoreApiService.makeApiCall('POST', 'taxes/list/', params);
			},

			getTax: function(params) {
				return CoreApiService.makeApiCall('POST', 'taxes/get/', params);
			},

			createTax: function(params) {
				return CoreApiService.makeApiCall('POST', 'taxes/create/', params);
			},

			updateTax: function(params) {
				return CoreApiService.makeApiCall('POST', 'taxes/update/', params);
			},

			deleteTax: function(params) {
				return CoreApiService.makeApiCall('POST', 'taxes/delete/', params);
			},

			getLiable: function(params) {
				return CoreApiService.makeApiCall('POST', 'taxes/liable/get/', params);
			},

			setLiable: function(params) {
				return CoreApiService.makeApiCall('POST', 'taxes/liable/set/', params);
			},

			defaultErrorHandler: CoreApiService.defaultErrorHandler,
		};
	});

'use strict';

angular
	.module('new-web')

	.factory('SubscriptionsApiService', function(CoreApiService) {
		return {
			getSubscriptionsList: function(params) {
				return CoreApiService.makeApiCall('POST', 'subscriptions/list/', params);
			},

			createSubscription: function(params) {
				return CoreApiService.makeApiCall('POST', 'subscriptions/create/', params);
			},

			deleteSubscription: function(params) {
				return CoreApiService.makeApiCall('POST', 'subscriptions/delete/', params);
			},

			getSubscription: function(params) {
				return CoreApiService.makeApiCall('POST', 'subscriptions/get/', params);
			},

			defaultErrorHandler: CoreApiService.defaultErrorHandler,
		};
	});

'use strict';

angular
	.module('new-web')

	.factory('StarredApiService', function(CoreApiService) {
		return {
			getStarredList: function(params) {
				return CoreApiService.makeApiCall('POST', 'starred/list/', params);
			},

			getStarred: function(params) {
				return CoreApiService.makeApiCall('POST', 'starred/get/', params);
			},

			setStarred: function(params) {
				return CoreApiService.makeApiCall('POST', 'starred/set/', params);
			},

			unsetStarred: function(params) {
				return CoreApiService.makeApiCall('POST', 'starred/unset/', params);
			},

			defaultErrorHandler: CoreApiService.defaultErrorHandler,
		};
	});

'use strict';

angular
	.module('new-web')

	.factory('SpeeddialsApiService', function(CoreApiService) {
		return {
			getSpeeddialsList: function(params) {
				return CoreApiService.makeApiCall('POST', 'speeddials/list/', params);
			},

			createSpeeddial: function(params) {
				return CoreApiService.makeApiCall('POST', 'speeddials/create/', params);
			},

			deleteSpeeddial: function(params) {
				return CoreApiService.makeApiCall('POST', 'speeddials/delete/', params);
			},

			importSpeeddials: function(params, data) {
				return CoreApiService.makeApiCall('POST', 'speeddials/import/', params, data);
			},

			getSpeeddial: function(params) {
				return CoreApiService.makeApiCall('POST', 'speeddials/get/', params);
			},

			getNextUnusedSpeeddialNumber: function(params) {
				return CoreApiService.makeApiCall('POST', 'speeddials/unused/sdial/', params);
			},

			updateSpeeddial: function(params) {
				return CoreApiService.makeApiCall('POST', 'speeddials/update/', params);
			},

			defaultErrorHandler: CoreApiService.defaultErrorHandler,
		};
	});

'use strict';

angular
	.module('new-web')

	.factory('SoundsApiService', function(CoreApiService) {
		return {
			getSoundsList: function(params) {
				return CoreApiService.makeApiCall('POST', 'sounds/list/', params);
			},

			getSound: function(params) {
				return CoreApiService.makeApiCall('POST', 'sounds/get/', params);
			},

			createSound: function(params) {
				return CoreApiService.makeApiCall('POST', 'sounds/create/', params);
			},

			updateSound: function(params) {
				return CoreApiService.makeApiCall('POST', 'sounds/update/', params);
			},

			deleteSound: function(params) {
				return CoreApiService.makeApiCall('POST', 'sounds/delete/', params);
			},

			uploadFiles: function(params, data) {
				return CoreApiService.makeApiCall('POST', 'sounds/files/upload/', params, data);
			},

			downloadFiles: function(params) {
				return CoreApiService.makeApiCall('POST', 'sounds/files/download/', params);
			},

			defaultErrorHandler: CoreApiService.defaultErrorHandler,
		};
	});

'use strict';

angular
	.module('new-web')

	.factory('RoutesApiService', function(CoreApiService) {
		return {
			getRoutesList: function(params) {
				return CoreApiService.makeApiCall('POST', 'routes/list/', params);
			},

			createRoute: function(params) {
				return CoreApiService.makeApiCall('POST', 'routes/create/', params);
			},

			deleteRoute: function(params) {
				return CoreApiService.makeApiCall('POST', 'routes/delete/', params);
			},

			getRoute: function(params) {
				return CoreApiService.makeApiCall('POST', 'routes/get/', params);
			},

			updateRoute: function(params) {
				return CoreApiService.makeApiCall('POST', 'routes/update/', params);
			},

			importRoutes: function(params, data) {
				return CoreApiService.makeApiCall('POST', 'routes/import/', params, data);
			},

			defaultErrorHandler: CoreApiService.defaultErrorHandler,
		};
	});

'use strict';

angular
	.module('new-web')

	.factory('RolesApiService', function(CoreApiService, $rootScope, $timeout) {
		var cache_for_seconds = 60;

		var cachedValues = {};

		var deleteCachedValue = function(role, privilege) {
			if (role && privilege && cachedValues[privilege]) {
				delete cachedValues[privilege][role];
			}
		};

		var getCachedValue = function(role, privilege) {
			if (!role || !privilege) {
				return null;
			}

			if (cachedValues[privilege] && cachedValues[privilege][role]) {
				var now = new Date();
				if (now - (cachedValues[privilege][role].cached || 0) < cache_for_seconds * 1000) {
					return cachedValues[privilege][role];
				}
			}
			deleteCachedValue(role, privilege);
			return null;
		};

		var setCachedValue = function(role, privilege, value) {
			if (role && privilege) {
				cachedValues[privilege] = cachedValues[privilege] || {};
				value.cached = new Date();
				cachedValues[privilege][role] = value;
			}
		};

		var deleteAllCachedValues = function() {
			cachedValues = {};
		};

		$rootScope.$on('AuthSuccess', deleteAllCachedValues);

		return {
			getAccessForRole: function(params) {
				var cached;

				if ((cached = getCachedValue(params.role, params.privilege))) {
					return $timeout(function() {
						return cached;
					});
				}

				return CoreApiService.makeApiCall('POST', 'roles/access/get/', params).then(function(response) {
					setCachedValue(params.role, params.privilege, response);
					return response;
				});
			},

			setAccessForRole: function(params) {
				return CoreApiService.makeApiCall('POST', 'roles/access/set/', params).then(function(response) {
					deleteCachedValue(params.role, params.privilege);
					return response;
				});
			},

			getRolesList: function(params) {
				return CoreApiService.makeApiCall('POST', 'roles/list/', params);
			},

			getDefaultRole: function(params) {
				return CoreApiService.makeApiCall('POST', 'roles/default/get/', params);
			},

			createRole: function(params) {
				return CoreApiService.makeApiCall('POST', 'roles/create/', params);
			},

			deleteRole: function(params) {
				return CoreApiService.makeApiCall('POST', 'roles/delete/', params);
			},

			updateRole: function(params) {
				return CoreApiService.makeApiCall('POST', 'roles/update/', params);
			},

			getRole: function(params) {
				return CoreApiService.makeApiCall('POST', 'roles/get/', params);
			},

			defaultErrorHandler: CoreApiService.defaultErrorHandler,
		};
	});

'use strict';

angular
	.module('new-web')

	.factory('RequestsApiService', function(CoreApiService) {
		return {
			getRequestsList: function(params) {
				return CoreApiService.makeApiCall('POST', 'requests/list/', params);
			},

			getRequest: function(params) {
				return CoreApiService.makeApiCall('POST', 'requests/get/', params);
			},

			updateRequest: function(params) {
				return CoreApiService.makeApiCall('POST', 'requests/update/', params);
			},

			deleteRequest: function(params) {
				return CoreApiService.makeApiCall('POST', 'requests/delete/', params);
			},

			defaultErrorHandler: CoreApiService.defaultErrorHandler,
		};
	});

'use strict';

angular
	.module('new-web')

	.factory('RegionsApiService', function(CoreApiService) {
		return {
			getRegionsList: function(params) {
				return CoreApiService.makeApiCall('POST', 'regions/list/', params);
			},

			getRegion: function(params) {
				return CoreApiService.makeApiCall('POST', 'regions/get/', params);
			},

			createRegion: function(params) {
				return CoreApiService.makeApiCall('POST', 'regions/create/', params);
			},

			deleteRegion: function(params) {
				return CoreApiService.makeApiCall('POST', 'regions/delete/', params);
			},

			updateRegion: function(params) {
				return CoreApiService.makeApiCall('POST', 'regions/update/', params);
			},

			getMachinesList: function(params) {
				return CoreApiService.makeApiCall('POST', 'regions/machines/list/', params);
			},

			getMachine: function(params) {
				return CoreApiService.makeApiCall('POST', 'regions/machines/get/', params);
			},

			setMachine: function(params) {
				return CoreApiService.makeApiCall('POST', 'regions/machines/set/', params);
			},

			defaultErrorHandler: CoreApiService.defaultErrorHandler,
		};
	});

'use strict';

angular
	.module('new-web')

	.factory('RecordingApiService', function(CoreApiService) {
		return {
			getRecordGroupsList: function(params) {
				return CoreApiService.makeApiCall('POST', 'recording/groups/list/', params);
			},

			createRecordGroup: function(params) {
				return CoreApiService.makeApiCall('POST', 'recording/groups/create/', params);
			},

			deleteRecordGroup: function(params) {
				return CoreApiService.makeApiCall('POST', 'recording/groups/delete/', params);
			},

			getRecordGroup: function(params) {
				return CoreApiService.makeApiCall('POST', 'recording/groups/get/', params);
			},

			updateRecordGroup: function(params) {
				return CoreApiService.makeApiCall('POST', 'recording/groups/update/', params);
			},

			getRecordingsList: function(params) {
				return CoreApiService.makeApiCall('POST', 'recording/recordings/list/', params);
			},

			copyRecording: function(params) {
				return CoreApiService.makeApiCall('POST', 'recording/recordings/copy/', params);
			},

			deleteRecording: function(params) {
				return CoreApiService.makeApiCall('POST', 'recording/recordings/delete/', params);
			},

			getRecording: function(params) {
				return CoreApiService.makeApiCall('POST', 'recording/recordings/get/', params);
			},

			updateRecording: function(params) {
				return CoreApiService.makeApiCall('POST', 'recording/recordings/update/', params);
			},

			defaultErrorHandler: CoreApiService.defaultErrorHandler,
		};
	});

'use strict';

angular
	.module('new-web')

	.factory('QueuesApiService', function(CoreApiService) {
		return {
			getQueuesList: function(params) {
				return CoreApiService.makeApiCall('POST', 'queues/list/', params);
			},

			getQueue: function(params) {
				return CoreApiService.makeApiCall('POST', 'queues/get/', params);
			},

			createQueue: function(params) {
				return CoreApiService.makeApiCall('POST', 'queues/create/', params);
			},

			updateQueue: function(params) {
				return CoreApiService.makeApiCall('POST', 'queues/update/', params);
			},

			deleteQueue: function(params) {
				return CoreApiService.makeApiCall('POST', 'queues/delete/', params);
			},

			getActiveCalls: function(params) {
				return CoreApiService.makeApiCall('POST', 'queues/active/list/', params);
			},

			getStatistics: function(params) {
				return CoreApiService.makeApiCall('POST', 'queues/statistics/get/', params);
			},

			getDestinationsList: function(params) {
				return CoreApiService.makeApiCall('POST', 'queues/destinations/list/', params);
			},

			getDestination: function(params) {
				return CoreApiService.makeApiCall('POST', 'queues/destinations/get/', params);
			},

			createDestination: function(params) {
				return CoreApiService.makeApiCall('POST', 'queues/destinations/create/', params);
			},

			deleteDestination: function(params) {
				return CoreApiService.makeApiCall('POST', 'queues/destinations/delete/', params);
			},

			updateDestination: function(params) {
				return CoreApiService.makeApiCall('POST', 'queues/destinations/update/', params);
			},

			importDestinations: function(params, data) {
				return CoreApiService.makeApiCall('POST', 'queues/destinations/import/', params, data);
			},

			getDestinationStatistics: function(params) {
				return CoreApiService.makeApiCall('POST', 'queues/destinations/statistics/get/', params);
			},

			getEventsList: function(params) {
				return CoreApiService.makeApiCall('POST', 'queues/events/list/', params);
			},

			downloadFiles: function(params) {
				return CoreApiService.makeApiCall('POST', 'queues/files/download/', params);
			},

			uploadFiles: function(params, data) {
				return CoreApiService.makeApiCall('POST', 'queues/files/upload/', params, data);
			},

			deleteFiles: function(params) {
				return CoreApiService.makeApiCall('POST', 'queues/files/delete/', params);
			},

			defaultErrorHandler: CoreApiService.defaultErrorHandler,
		};
	});

'use strict';

angular
	.module('new-web')

	.factory('ProvisioningApiService', function(CoreApiService) {
		return {
			getProvisioningsList: function(params) {
				return CoreApiService.makeApiCall('POST', 'provisioning/list/', params);
			},

			getProvisioning: function(params) {
				return CoreApiService.makeApiCall('POST', 'provisioning/get/', params);
			},

			createProvisioning: function(params, data) {
				return CoreApiService.makeApiCall('POST', 'provisioning/create/', params, data);
			},

			updateProvisioning: function(params, data) {
				return CoreApiService.makeApiCall('POST', 'provisioning/update/', params, data);
			},

			deleteProvisioning: function(params) {
				return CoreApiService.makeApiCall('POST', 'provisioning/delete/', params);
			},

			getFile: function(params) {
				return CoreApiService.makeApiCall('POST', 'provisioning/files/get/', params);
			},

			updateFile: function(params) {
				return CoreApiService.makeApiCall('POST', 'provisioning/files/update/', params);
			},

			getProvisioning1Options: function(params) {
				return CoreApiService.makeApiCall('POST', 'provisioning/provision1/get/', params);
			},

			defaultErrorHandler: CoreApiService.defaultErrorHandler,
		};
	});

'use strict';

angular
	.module('new-web')

	.factory('ProductsApiService', function(CoreApiService) {
		return {
			createProduct: function(params) {
				return CoreApiService.makeApiCall('POST', 'products/create/', params);
			},

			deleteProduct: function(params) {
				return CoreApiService.makeApiCall('POST', 'products/delete/', params);
			},

			getProduct: function(params) {
				return CoreApiService.makeApiCall('POST', 'products/get/', params);
			},

			getProductsList: function(params) {
				return CoreApiService.makeApiCall('POST', 'products/list/', params);
			},

			purchaseProduct: function(params) {
				return CoreApiService.makeApiCall('POST', 'products/purchase/', params);
			},

			getProductTaxes: function(params) {
				return CoreApiService.makeApiCall('POST', 'products/taxes/list/', params);
			},

			updateProduct: function(params) {
				return CoreApiService.makeApiCall('POST', 'products/update/', params);
			},

			defaultErrorHandler: CoreApiService.defaultErrorHandler,
		};
	});

'use strict';

angular
	.module('new-web')

	.factory('PrefixesApiService', function(CoreApiService) {
		return {
			getPrefixesList: function(params) {
				return CoreApiService.makeApiCall('POST', 'prefixes/list/', params);
			},

			getPrefix: function(params) {
				return CoreApiService.makeApiCall('POST', 'prefixes/get/', params);
			},

			createPrefix: function(params) {
				return CoreApiService.makeApiCall('POST', 'prefixes/create/', params);
			},

			deletePrefix: function(params) {
				return CoreApiService.makeApiCall('POST', 'prefixes/delete/', params);
			},

			updatePrefix: function(params) {
				return CoreApiService.makeApiCall('POST', 'prefixes/update/', params);
			},

			defaultErrorHandler: CoreApiService.defaultErrorHandler,
		};
	});

'use strict';

angular
	.module('new-web')

	.factory('PreferencesApiService', function(CoreApiService) {
		return {
			getPreference: function(params) {
				return CoreApiService.makeApiCall('POST', 'preferences/get/', params);
			},

			setPreference: function(params) {
				return CoreApiService.makeApiCall('POST', 'preferences/set/', params);
			},

			getPreferencesList: function(params) {
				return CoreApiService.makeApiCall('POST', 'preferences/list/', params);
			},

			defaultErrorHandler: CoreApiService.defaultErrorHandler,
		};
	});

'use strict';

angular
	.module('new-web')

	.factory('PluginsApiService', function(CoreApiService) {
		return {
			getPluginsList: function(params) {
				return CoreApiService.makeApiCall('POST', 'plugins/list/', params);
			},

			getPlugin: function(params) {
				return CoreApiService.makeApiCall('POST', 'plugins/get/', params);
			},

			createPlugin: function(params) {
				return CoreApiService.makeApiCall('POST', 'plugins/create/', params);
			},

			deletePlugin: function(params) {
				return CoreApiService.makeApiCall('POST', 'plugins/delete/', params);
			},

			updatePlugin: function(params) {
				return CoreApiService.makeApiCall('POST', 'plugins/update/', params);
			},

			defaultErrorHandler: CoreApiService.defaultErrorHandler,
		};
	});

'use strict';

angular
	.module('new-web')

	.factory('PlansApiService', function(CoreApiService) {
		return {
			get: function(params) {
				return CoreApiService.makeApiCall('POST', 'plans/get/', params);
			},

			list: function(params) {
				return CoreApiService.makeApiCall('POST', 'plans/list/', params);
			},

			create: function(params) {
				return CoreApiService.makeApiCall('POST', 'plans/create/', params);
			},

			delete: function(params) {
				return CoreApiService.makeApiCall('POST', 'plans/delete/', params);
			},

			update: function(params) {
				return CoreApiService.makeApiCall('POST', 'plans/update/', params);
			},

			getFees: function(params) {
				return CoreApiService.makeApiCall('POST', 'plans/fees/get/', params);
			},

			setFees: function(params) {
				return CoreApiService.makeApiCall('POST', 'plans/fees/set/', params);
			},

			getFeaturesList: function(params) {
				return CoreApiService.makeApiCall('POST', 'plans/features/list/', params);
			},

			getFeatures: function(params) {
				return CoreApiService.makeApiCall('POST', 'plans/features/get/', params);
			},

			setFeatures: function(params) {
				return CoreApiService.makeApiCall('POST', 'plans/features/set/', params);
			},

			getMaximumFeatures: function(params) {
				return CoreApiService.makeApiCall('POST', 'plans/features/maximum/', params);
			},

			getClass: function(params) {
				return CoreApiService.makeApiCall('POST', 'plans/classes/get/', params);
			},

			getClassesList: function(params) {
				return CoreApiService.makeApiCall('POST', 'plans/classes/list/', params);
			},

			createClass: function(params) {
				return CoreApiService.makeApiCall('POST', 'plans/classes/create/', params);
			},

			deleteClass: function(params) {
				return CoreApiService.makeApiCall('POST', 'plans/classes/delete/', params);
			},

			updateClass: function(params) {
				return CoreApiService.makeApiCall('POST', 'plans/classes/update/', params);
			},

			getClassPrices: function(params) {
				return CoreApiService.makeApiCall('POST', 'plans/classes/prices/', params);
			},

			getIngroup: function(params) {
				return CoreApiService.makeApiCall('POST', 'plans/ingroups/get/', params);
			},

			getIngroupsList: function(params) {
				return CoreApiService.makeApiCall('POST', 'plans/ingroups/list/', params);
			},

			createIngroup: function(params) {
				return CoreApiService.makeApiCall('POST', 'plans/ingroups/create/', params);
			},

			deleteIngroup: function(params) {
				return CoreApiService.makeApiCall('POST', 'plans/ingroups/delete/', params);
			},

			updateIngroup: function(params) {
				return CoreApiService.makeApiCall('POST', 'plans/ingroups/update/', params);
			},

			importIngroups: function(params, data) {
				return CoreApiService.makeApiCall('POST', 'plans/ingroups/import/', params, data);
			},

			getOutgroup: function(params) {
				return CoreApiService.makeApiCall('POST', 'plans/outgroups/get/', params);
			},

			getOutgroupsList: function(params) {
				return CoreApiService.makeApiCall('POST', 'plans/outgroups/list/', params);
			},

			createOutgroup: function(params) {
				return CoreApiService.makeApiCall('POST', 'plans/outgroups/create/', params);
			},

			deleteOutgroup: function(params) {
				return CoreApiService.makeApiCall('POST', 'plans/outgroups/delete/', params);
			},

			updateOutgroup: function(params) {
				return CoreApiService.makeApiCall('POST', 'plans/outgroups/update/', params);
			},

			importOutgroups: function(params, data) {
				return CoreApiService.makeApiCall('POST', 'plans/outgroups/import/', params, data);
			},

			getProduct: function(params) {
				return CoreApiService.makeApiCall('POST', 'plans/products/get/', params);
			},

			getProductsList: function(params) {
				return CoreApiService.makeApiCall('POST', 'plans/products/list/', params);
			},

			createProduct: function(params) {
				return CoreApiService.makeApiCall('POST', 'plans/products/create/', params);
			},

			deleteProduct: function(params) {
				return CoreApiService.makeApiCall('POST', 'plans/products/delete/', params);
			},

			updateProduct: function(params) {
				return CoreApiService.makeApiCall('POST', 'plans/products/update/', params);
			},

			getRoute: function(params) {
				return CoreApiService.makeApiCall('POST', 'plans/routes/get/', params);
			},

			getRoutesList: function(params) {
				return CoreApiService.makeApiCall('POST', 'plans/routes/list/', params);
			},

			createRoute: function(params) {
				return CoreApiService.makeApiCall('POST', 'plans/routes/create/', params);
			},

			deleteRoute: function(params) {
				return CoreApiService.makeApiCall('POST', 'plans/routes/delete/', params);
			},

			updateRoute: function(params) {
				return CoreApiService.makeApiCall('POST', 'plans/routes/update/', params);
			},

			importRoutes: function(params, data) {
				return CoreApiService.makeApiCall('POST', 'plans/routes/import/', params, data);
			},

			defaultErrorHandler: CoreApiService.defaultErrorHandler,
		};
	});

'use strict';

angular
	.module('new-web')

	.factory('PickupgroupsApiService', function(CoreApiService) {
		return {
			getPickupgroupsList: function(params) {
				return CoreApiService.makeApiCall('POST', 'pickupgroups/list/', params);
			},

			getPickupgroup: function(params) {
				return CoreApiService.makeApiCall('POST', 'pickupgroups/get/', params);
			},

			createPickupgroup: function(params) {
				return CoreApiService.makeApiCall('POST', 'pickupgroups/create/', params);
			},

			updatePickupgroup: function(params) {
				return CoreApiService.makeApiCall('POST', 'pickupgroups/update/', params);
			},

			deletePickupgroup: function(params) {
				return CoreApiService.makeApiCall('POST', 'pickupgroups/delete/', params);
			},

			getPhonesList: function(params) {
				return CoreApiService.makeApiCall('POST', 'pickupgroups/phones/list/', params);
			},

			addPhone: function(params) {
				return CoreApiService.makeApiCall('POST', 'pickupgroups/phones/add/', params);
			},

			removePhone: function(params) {
				return CoreApiService.makeApiCall('POST', 'pickupgroups/phones/remove/', params);
			},

			defaultErrorHandler: CoreApiService.defaultErrorHandler,
		};
	});

'use strict';

angular
	.module('new-web')

	.factory('PhonesApiService', function(CoreApiService) {
		return {
			getPhonesList: function(params, panel) {
				var endpoint = 'phones/list/';
				if (typeof panel !== 'undefined' && panel) {
					endpoint += 'panel/';
				}

				return CoreApiService.makeApiCall('POST', endpoint, params);
			},

			getPhone: function(params) {
				return CoreApiService.makeApiCall('POST', 'phones/get/', params);
			},

			updatePhone: function(params, data) {
				return CoreApiService.makeApiCall('POST', 'phones/update/', params, data);
			},

			createPhone: function(params, data) {
				return CoreApiService.makeApiCall('POST', 'phones/create/', params, data);
			},

			deletePhone: function(params) {
				return CoreApiService.makeApiCall('POST', 'phones/delete/', params);
			},

			rebootPhone: function(params) {
				return CoreApiService.makeApiCall('POST', 'phones/reboot/', params);
			},

			unlockPhone: function(params) {
				return CoreApiService.makeApiCall('POST', 'phones/unlock/', params);
			},

			unregisterPhone: function(params) {
				return CoreApiService.makeApiCall('POST', 'phones/unregister/', params);
			},

			getEmergencyUrl: function(params) {
				return CoreApiService.makeApiCall('POST', 'phones/emergency/url/', params);
			},

			getNextUnusedPhone: function(params) {
				return CoreApiService.makeApiCall('POST', 'phones/unused/name/', params);
			},

			getHardwareCount: function(params) {
				return CoreApiService.makeApiCall('POST', 'phones/hardware/count/', params);
			},

			getRegistrationsList: function(params) {
				return CoreApiService.makeApiCall('POST', 'phones/registrations/list/', params);
			},

			getSystemPhonesList: function(params) {
				return CoreApiService.makeApiCall('POST', 'phones/system/list/', params);
			},

			defaultErrorHandler: CoreApiService.defaultErrorHandler,
		};
	});

'use strict';

angular
	.module('new-web')

	.factory('PeopleApiService', function(CoreApiService) {
		return {
			getPeopleList: function(params) {
				return CoreApiService.makeApiCall('POST', 'people/list/', params);
			},

			update: function(params) {
				return CoreApiService.makeApiCall('POST', 'people/update/', params);
			},

			get: function(params) {
				return CoreApiService.makeApiCall('POST', 'people/get/', params);
			},

			create: function(params) {
				return CoreApiService.makeApiCall('POST', 'people/create/', params);
			},

			delete: function(params) {
				return CoreApiService.makeApiCall('POST', 'people/delete/', params);
			},

			search: function(params) {
				return CoreApiService.makeApiCall('POST', 'people/search/list/', params);
			},

			unlock: function(params) {
				return CoreApiService.makeApiCall('POST', 'people/unlock/', params);
			},

			importPeople: function(params, data) {
				return CoreApiService.makeApiCall('POST', 'people/import/', params, data);
			},

			defaultErrorHandler: CoreApiService.defaultErrorHandler,
		};
	});

'use strict';

angular
	.module('new-web')

	.factory('PeersApiService', function(CoreApiService) {
		return {
			getPeersList: function(params) {
				return CoreApiService.makeApiCall('POST', 'peers/list/', params);
			},

			createPeer: function(params) {
				return CoreApiService.makeApiCall('POST', 'peers/create/', params);
			},

			deletePeer: function(params) {
				return CoreApiService.makeApiCall('POST', 'peers/delete/', params);
			},

			getPeer: function(params) {
				return CoreApiService.makeApiCall('POST', 'peers/get/', params);
			},

			updatePeer: function(params) {
				return CoreApiService.makeApiCall('POST', 'peers/update/', params);
			},

			defaultErrorHandler: CoreApiService.defaultErrorHandler,
		};
	});

'use strict';

angular
	.module('new-web')

	.factory('PeerCostsApiService', function(CoreApiService) {
		return {
			getCost: function(params) {
				return CoreApiService.makeApiCall('POST', 'peers/costs/get/', params);
			},

			getCostsList: function(params) {
				return CoreApiService.makeApiCall('POST', 'peers/costs/list/', params);
			},

			createCost: function(params) {
				return CoreApiService.makeApiCall('POST', 'peers/costs/create/', params);
			},

			deleteCost: function(params) {
				return CoreApiService.makeApiCall('POST', 'peers/costs/delete/', params);
			},

			updateCost: function(params) {
				return CoreApiService.makeApiCall('POST', 'peers/costs/update/', params);
			},

			importCosts: function(params, data) {
				return CoreApiService.makeApiCall('POST', 'peers/costs/import/', params, data);
			},

			defaultErrorHandler: CoreApiService.defaultErrorHandler,
		};
	});

'use strict';

angular
	.module('new-web')

	.factory('PatternmenusApiService', function(CoreApiService) {
		return {
			getPatternmenusList: function(params) {
				return CoreApiService.makeApiCall('POST', 'patternmenus/list/', params);
			},

			getPatternmenu: function(params) {
				return CoreApiService.makeApiCall('POST', 'patternmenus/get/', params);
			},

			createPatternmenu: function(params) {
				return CoreApiService.makeApiCall('POST', 'patternmenus/create/', params);
			},

			updatePatternmenu: function(params) {
				return CoreApiService.makeApiCall('POST', 'patternmenus/update/', params);
			},

			deletePatternmenu: function(params) {
				return CoreApiService.makeApiCall('POST', 'patternmenus/delete/', params);
			},

			getPatternsList: function(params) {
				return CoreApiService.makeApiCall('POST', 'patternmenus/patterns/list/', params);
			},

			getPattern: function(params) {
				return CoreApiService.makeApiCall('POST', 'patternmenus/patterns/get/', params);
			},

			createPattern: function(params) {
				return CoreApiService.makeApiCall('POST', 'patternmenus/patterns/create/', params);
			},

			updatePattern: function(params) {
				return CoreApiService.makeApiCall('POST', 'patternmenus/patterns/update/', params);
			},

			importPatterns: function(params, data) {
				return CoreApiService.makeApiCall('POST', 'patternmenus/patterns/import/', params, data);
			},

			deletePattern: function(params) {
				return CoreApiService.makeApiCall('POST', 'patternmenus/patterns/delete/', params);
			},

			uploadFiles: function(params, data) {
				return CoreApiService.makeApiCall('POST', 'patternmenus/files/upload/', params, data);
			},

			downloadFiles: function(params) {
				return CoreApiService.makeApiCall('POST', 'patternmenus/files/download/', params);
			},

			deleteFiles: function(params) {
				return CoreApiService.makeApiCall('POST', 'patternmenus/files/delete/', params);
			},

			defaultErrorHandler: CoreApiService.defaultErrorHandler,
		};
	});

'use strict';

angular
	.module('new-web')

	.factory('PagegroupsApiService', function(CoreApiService) {
		return {
			getPagegroupsList: function(params) {
				return CoreApiService.makeApiCall('POST', 'pagegroups/list/', params);
			},

			getPagegroup: function(params) {
				return CoreApiService.makeApiCall('POST', 'pagegroups/get/', params);
			},

			createPagegroup: function(params) {
				return CoreApiService.makeApiCall('POST', 'pagegroups/create/', params);
			},

			updatePagegroup: function(params) {
				return CoreApiService.makeApiCall('POST', 'pagegroups/update/', params);
			},

			deletePagegroup: function(params) {
				return CoreApiService.makeApiCall('POST', 'pagegroups/delete/', params);
			},

			getDestinationsList: function(params) {
				return CoreApiService.makeApiCall('POST', 'pagegroups/destinations/list/', params);
			},

			getDestination: function(params) {
				return CoreApiService.makeApiCall('POST', 'pagegroups/destinations/get/', params);
			},

			createDestination: function(params) {
				return CoreApiService.makeApiCall('POST', 'pagegroups/destinations/create/', params);
			},

			updateDestination: function(params) {
				return CoreApiService.makeApiCall('POST', 'pagegroups/destinations/update/', params);
			},

			importDestinations: function(params, data) {
				return CoreApiService.makeApiCall('POST', 'pagegroups/destinations/import/', params, data);
			},

			deleteDestination: function(params) {
				return CoreApiService.makeApiCall('POST', 'pagegroups/destinations/delete/', params);
			},

			defaultErrorHandler: CoreApiService.defaultErrorHandler,
		};
	});

'use strict';

angular
	.module('new-web')

	.factory('OutgroupsApiService', function(CoreApiService) {
		return {
			getOutgroupsList: function(params) {
				return CoreApiService.makeApiCall('POST', 'outgroups/list/', params);
			},

			getOutgroup: function(params) {
				return CoreApiService.makeApiCall('POST', 'outgroups/get/', params);
			},

			createOutgroup: function(params) {
				return CoreApiService.makeApiCall('POST', 'outgroups/create/', params);
			},

			updateOutgroup: function(params) {
				return CoreApiService.makeApiCall('POST', 'outgroups/update/', params);
			},

			deleteOutgroup: function(params) {
				return CoreApiService.makeApiCall('POST', 'outgroups/delete/', params);
			},

			importOutgroups: function(params, data) {
				return CoreApiService.makeApiCall('POST', 'outgroups/import/', params, data);
			},

			getTimesList: function(params) {
				return CoreApiService.makeApiCall('POST', 'outgroups/times/list/', params);
			},

			getTime: function(params) {
				return CoreApiService.makeApiCall('POST', 'outgroups/times/get/', params);
			},

			createTime: function(params) {
				return CoreApiService.makeApiCall('POST', 'outgroups/times/create/', params);
			},

			updateTime: function(params) {
				return CoreApiService.makeApiCall('POST', 'outgroups/times/update/', params);
			},

			deleteTime: function(params) {
				return CoreApiService.makeApiCall('POST', 'outgroups/times/delete/', params);
			},

			defaultErrorHandler: CoreApiService.defaultErrorHandler,
		};
	});

'use strict';

angular
	.module('new-web')

	.factory('OutcostsApiService', function(CoreApiService) {
		return {
			getOutcost: function(params) {
				return CoreApiService.makeApiCall('POST', 'outcosts/get/', params);
			},

			getOutcostsList: function(params) {
				return CoreApiService.makeApiCall('POST', 'outcosts/list/', params);
			},

			createOutcost: function(params) {
				return CoreApiService.makeApiCall('POST', 'outcosts/create/', params);
			},

			deleteOutcost: function(params) {
				return CoreApiService.makeApiCall('POST', 'outcosts/delete/', params);
			},

			updateOutcost: function(params) {
				return CoreApiService.makeApiCall('POST', 'outcosts/update/', params);
			},

			importOutcosts: function(params, data) {
				return CoreApiService.makeApiCall('POST', 'outcosts/import/', params, data);
			},

			getCustomerOutcostsList: function(params) {
				return CoreApiService.makeApiCall('POST', 'outcosts/customer/list/', params);
			},

			defaultErrorHandler: CoreApiService.defaultErrorHandler,
		};
	});

'use strict';

angular
	.module('new-web')

	.factory('NumbersApiService', function(CoreApiService) {
		return {
			getAvailableNumbersList: function(params) {
				return CoreApiService.makeApiCall('POST', 'numbers/available/list/', params);
			},

			getAvailableNumber: function(params) {
				return CoreApiService.makeApiCall('POST', 'numbers/available/get/', params);
			},

			getNumbersList: function(params) {
				return CoreApiService.makeApiCall('POST', 'numbers/list/', params);
			},

			purchaseNumber: function(params) {
				return CoreApiService.makeApiCall('POST', 'numbers/purchase/', params);
			},

			getNumber: function(params) {
				return CoreApiService.makeApiCall('POST', 'numbers/get/', params);
			},

			deleteNumber: function(params) {
				return CoreApiService.makeApiCall('POST', 'numbers/delete/', params);
			},

			updateNumber: function(params) {
				return CoreApiService.makeApiCall('POST', 'numbers/update/', params);
			},

			getCallersList: function(params) {
				return CoreApiService.makeApiCall('POST', 'numbers/callers/list/', params);
			},

			getCaller: function(params) {
				return CoreApiService.makeApiCall('POST', 'numbers/callers/get/', params);
			},

			createCaller: function(params) {
				return CoreApiService.makeApiCall('POST', 'numbers/callers/create/', params);
			},

			updateCaller: function(params) {
				return CoreApiService.makeApiCall('POST', 'numbers/callers/update/', params);
			},

			deleteCaller: function(params) {
				return CoreApiService.makeApiCall('POST', 'numbers/callers/delete/', params);
			},

			getTimesList: function(params) {
				return CoreApiService.makeApiCall('POST', 'numbers/times/list/', params);
			},

			getTime: function(params) {
				return CoreApiService.makeApiCall('POST', 'numbers/times/get/', params);
			},

			createTime: function(params) {
				return CoreApiService.makeApiCall('POST', 'numbers/times/create/', params);
			},

			updateTime: function(params) {
				return CoreApiService.makeApiCall('POST', 'numbers/times/update/', params);
			},

			deleteTime: function(params) {
				return CoreApiService.makeApiCall('POST', 'numbers/times/delete/', params);
			},

			getSystemsList: function(params) {
				return CoreApiService.makeApiCall('POST', 'numbers/system/list/', params);
			},

			getSystem: function(params) {
				return CoreApiService.makeApiCall('POST', 'numbers/system/get/', params);
			},

			createSystem: function(params) {
				return CoreApiService.makeApiCall('POST', 'numbers/system/create/', params);
			},

			updateSystem: function(params) {
				return CoreApiService.makeApiCall('POST', 'numbers/system/update/', params);
			},

			deleteSystem: function(params) {
				return CoreApiService.makeApiCall('POST', 'numbers/system/delete/', params);
			},

			uploadFiles: function(params, data) {
				return CoreApiService.makeApiCall('POST', 'numbers/files/upload/', params, data);
			},

			downloadFiles: function(params) {
				return CoreApiService.makeApiCall('POST', 'numbers/files/download/', params);
			},

			deleteFiles: function(params) {
				return CoreApiService.makeApiCall('POST', 'numbers/files/delete/', params);
			},

			defaultErrorHandler: CoreApiService.defaultErrorHandler,
		};
	});

'use strict';

angular
	.module('new-web')

	.factory('NotesApiService', function(CoreApiService) {
		return {
			getNotesList: function(params) {
				return CoreApiService.makeApiCall('POST', 'notes/list/', params);
			},

			createNote: function(params) {
				return CoreApiService.makeApiCall('POST', 'notes/create/', params);
			},

			deleteNote: function(params) {
				return CoreApiService.makeApiCall('POST', 'notes/delete/', params);
			},

			getNote: function(params) {
				return CoreApiService.makeApiCall('POST', 'notes/get/', params);
			},

			updateNote: function(params) {
				return CoreApiService.makeApiCall('POST', 'notes/update/', params);
			},

			defaultErrorHandler: CoreApiService.defaultErrorHandler,
		};
	});

'use strict';

angular
	.module('new-web')

	.factory('NVGroupsApiService', function(CoreApiService) {
		return {
			getNVGroupsList: function(params) {
				return CoreApiService.makeApiCall('POST', 'nvgroups/list/', params);
			},

			defaultErrorHandler: CoreApiService.defaultErrorHandler,
		};
	});

'use strict';

angular
	.module('new-web')

	.factory('MusicApiService', function(CoreApiService) {
		return {
			getMusicList: function(params) {
				return CoreApiService.makeApiCall('POST', 'music/list/', params);
			},

			createMusic: function(params) {
				return CoreApiService.makeApiCall('POST', 'music/create/', params);
			},

			deleteMusic: function(params) {
				return CoreApiService.makeApiCall('POST', 'music/delete/', params);
			},

			getMusic: function(params) {
				return CoreApiService.makeApiCall('POST', 'music/get/', params);
			},

			updateMusic: function(params) {
				return CoreApiService.makeApiCall('POST', 'music/update/', params);
			},

			uploadFiles: function(params, data) {
				return CoreApiService.makeApiCall('POST', 'music/files/upload/', params, data);
			},

			downloadFiles: function(params) {
				return CoreApiService.makeApiCall('POST', 'music/files/download/', params);
			},

			deleteFiles: function(params) {
				return CoreApiService.makeApiCall('POST', 'music/files/delete/', params);
			},

			defaultErrorHandler: CoreApiService.defaultErrorHandler,
		};
	});

'use strict';

angular
	.module('new-web')

	.factory('MessagesApiService', function(CoreApiService) {
		return {
			copyMessages: function(params) {
				return CoreApiService.makeApiCall('POST', 'messages/copy/', params);
			},

			deleteMessages: function(params) {
				return CoreApiService.makeApiCall('POST', 'messages/delete/', params);
			},

			deleteMessagesHash: function(params) {
				return CoreApiService.makeApiCall('POST', 'messages/delete/hash/', params);
			},

			getMessage: function(params) {
				return CoreApiService.makeApiCall('POST', 'messages/get/', params);
			},

			getMessagesList: function(params) {
				return CoreApiService.makeApiCall('POST', 'messages/list/', params);
			},

			listTextMessages: function(params) {
				return CoreApiService.makeApiCall('POST', 'messages/text/list/', params);
			},

			sendTextMessage: function(params) {
				return CoreApiService.makeApiCall('POST', 'messages/text/send/', params);
			},

			deleteTextMessage: function(params) {
				return CoreApiService.makeApiCall('POST', 'messages/text/delete/', params);
			},

			defaultErrorHandler: CoreApiService.defaultErrorHandler,
		};
	});

'use strict';

angular
	.module('new-web')

	.factory('MenusApiService', function(CoreApiService, $rootScope, $timeout) {
		var menusUpdated = {};
		var menusCache = {};

		var clearMenusCache = function() {
			menusUpdated = {};
			menusCache = {};
		};

		$rootScope.$on('AuthSuccess', clearMenusCache);
		$rootScope.$on('refreshMenu', clearMenusCache);

		return {
			getAvailableMenus: function(params) {
				if (new Date() - (menusUpdated[params.language || $rootScope.default_language || 'en'] || 0) < 60000) {
					return $timeout(function() {
						return menusCache[params.language || $rootScope.default_language || 'en'];
					});
				}

				return CoreApiService.makeApiCall('POST', 'menus/available/list/', params).then(function(response) {
					menusUpdated[params.language || $rootScope.default_language || 'en'] = new Date();
					menusCache[params.language || $rootScope.default_language || 'en'] = response;
					return response;
				});
			},

			createMenu: function(params) {
				clearMenusCache();
				return CoreApiService.makeApiCall('POST', 'menus/create/', params);
			},

			deleteMenu: function(params) {
				clearMenusCache();
				return CoreApiService.makeApiCall('POST', 'menus/delete/', params);
			},

			getMenu: function(params) {
				return CoreApiService.makeApiCall('POST', 'menus/get/', params);
			},

			getAllMenus: function(params) {
				return CoreApiService.makeApiCall('POST', 'menus/list/', params);
			},

			updateMenu: function(params) {
				return CoreApiService.makeApiCall('POST', 'menus/update/', params);
			},

			defaultErrorHandler: CoreApiService.defaultErrorHandler,
		};
	});

'use strict';

angular
	.module('new-web')

	.factory('MailboxesApiService', function(CoreApiService) {
		return {
			getMailboxesList: function(params) {
				return CoreApiService.makeApiCall('POST', 'mailboxes/list/', params);
			},

			getMailboxesStatistics: function(params) {
				return CoreApiService.makeApiCall('POST', 'mailboxes/statistics/get/', params);
			},

			createMailbox: function(params) {
				return CoreApiService.makeApiCall('POST', 'mailboxes/create/', params);
			},

			deleteMailbox: function(params) {
				return CoreApiService.makeApiCall('POST', 'mailboxes/delete/', params);
			},

			getDestinationsList: function(params) {
				return CoreApiService.makeApiCall('POST', 'mailboxes/destinations/list/', params);
			},

			setDestinations: function(params) {
				return CoreApiService.makeApiCall('POST', 'mailboxes/destinations/set/', params);
			},

			deleteFiles: function(params) {
				return CoreApiService.makeApiCall('POST', 'mailboxes/files/delete/', params);
			},

			downloadFiles: function(params) {
				return CoreApiService.makeApiCall('POST', 'mailboxes/files/download/', params);
			},

			uploadFiles: function(params, data) {
				return CoreApiService.makeApiCall('POST', 'mailboxes/files/upload/', params, data);
			},

			getMailbox: function(params) {
				return CoreApiService.makeApiCall('POST', 'mailboxes/get/', params);
			},

			updateMailbox: function(params) {
				return CoreApiService.makeApiCall('POST', 'mailboxes/update/', params);
			},

			defaultErrorHandler: CoreApiService.defaultErrorHandler,
		};
	});

'use strict';

angular
	.module('new-web')

	.factory('MachinesApiService', function(CoreApiService) {
		return {
			getMachinesList: function(params) {
				return CoreApiService.makeApiCall('POST', 'machines/list/', params);
			},

			getMachine: function(params) {
				return CoreApiService.makeApiCall('POST', 'machines/get/', params);
			},

			createMachine: function(params) {
				return CoreApiService.makeApiCall('POST', 'machines/create/', params);
			},

			updateMachine: function(params) {
				return CoreApiService.makeApiCall('POST', 'machines/update/', params);
			},

			deleteMachine: function(params) {
				return CoreApiService.makeApiCall('POST', 'machines/delete/', params);
			},

			getMachineStatistics: function(params) {
				return CoreApiService.makeApiCall('POST', 'machines/statistics/get/', params);
			},

			defaultErrorHandler: CoreApiService.defaultErrorHandler,
		};
	});

'use strict';

angular
	.module('new-web')

	.factory('IvrsApiService', function(CoreApiService) {
		return {
			getIvrsList: function(params) {
				return CoreApiService.makeApiCall('POST', 'ivrs/list/', params);
			},

			createIvr: function(params) {
				return CoreApiService.makeApiCall('POST', 'ivrs/create/', params);
			},

			deleteIvr: function(params) {
				return CoreApiService.makeApiCall('POST', 'ivrs/delete/', params);
			},

			getIvr: function(params) {
				return CoreApiService.makeApiCall('POST', 'ivrs/get/', params);
			},

			updateIvr: function(params) {
				return CoreApiService.makeApiCall('POST', 'ivrs/update/', params);
			},

			getDestination: function(params) {
				return CoreApiService.makeApiCall('POST', 'ivrs/destinations/get/', params);
			},

			setDestination: function(params) {
				return CoreApiService.makeApiCall('POST', 'ivrs/destinations/set/', params);
			},

			downloadFiles: function(params) {
				return CoreApiService.makeApiCall('POST', 'ivrs/files/download/', params);
			},

			uploadFiles: function(params, data) {
				return CoreApiService.makeApiCall('POST', 'ivrs/files/upload/', params, data);
			},

			deleteFiles: function(params) {
				return CoreApiService.makeApiCall('POST', 'ivrs/files/delete/', params);
			},

			defaultErrorHandler: CoreApiService.defaultErrorHandler,
		};
	});

'use strict';

angular
	.module('new-web')

	.factory('InvoicesApiService', function(CoreApiService) {
		return {
			getInvoiceList: function(params) {
				return CoreApiService.makeApiCall('POST', 'invoices/list/', params);
			},

			createInvoice: function(params) {
				return CoreApiService.makeApiCall('POST', 'invoices/create/', params);
			},

			deleteInvoice: function(params) {
				return CoreApiService.makeApiCall('POST', 'invoices/delete/', params);
			},

			getInvoice: function(params) {
				return CoreApiService.makeApiCall('POST', 'invoices/get/', params);
			},

			updateInvoice: function(params) {
				return CoreApiService.makeApiCall('POST', 'invoices/update/', params);
			},

			createSampleInvoice: function(params) {
				return CoreApiService.makeApiCall('POST', 'invoices/sample/', params);
			},

			sendInvoices: function(params) {
				return CoreApiService.makeApiCall('POST', 'invoices/send/', params);
			},

			downloadInvoices: function(params) {
				return CoreApiService.makeApiCall('POST', 'invoices/download/', params);
			},

			defaultErrorHandler: CoreApiService.defaultErrorHandler,
		};
	});

'use strict';

angular
	.module('new-web')

	.factory('IngroupsApiService', function(CoreApiService) {
		return {
			getIngroupsList: function(params) {
				return CoreApiService.makeApiCall('POST', 'ingroups/list/', params);
			},

			getIngroup: function(params) {
				return CoreApiService.makeApiCall('POST', 'ingroups/get/', params);
			},

			createIngroup: function(params) {
				return CoreApiService.makeApiCall('POST', 'ingroups/create/', params);
			},

			updateIngroup: function(params) {
				return CoreApiService.makeApiCall('POST', 'ingroups/update/', params);
			},

			deleteIngroup: function(params) {
				return CoreApiService.makeApiCall('POST', 'ingroups/delete/', params);
			},

			getTimesList: function(params) {
				return CoreApiService.makeApiCall('POST', 'ingroups/times/list/', params);
			},

			getTime: function(params) {
				return CoreApiService.makeApiCall('POST', 'ingroups/times/get/', params);
			},

			createTime: function(params) {
				return CoreApiService.makeApiCall('POST', 'ingroups/times/create/', params);
			},

			updateTime: function(params) {
				return CoreApiService.makeApiCall('POST', 'ingroups/times/update/', params);
			},

			deleteTime: function(params) {
				return CoreApiService.makeApiCall('POST', 'ingroups/times/delete/', params);
			},

			getNVGroupsList: function(params) {
				return CoreApiService.makeApiCall('POST', 'ingroups/nvgroups/list/', params);
			},

			getNVGroup: function(params) {
				return CoreApiService.makeApiCall('POST', 'ingroups/nvgroups/get/', params);
			},

			createNVGroup: function(params) {
				return CoreApiService.makeApiCall('POST', 'ingroups/nvgroups/create/', params);
			},

			updateNVGroup: function(params) {
				return CoreApiService.makeApiCall('POST', 'ingroups/nvgroups/update/', params);
			},

			deleteNVGroup: function(params) {
				return CoreApiService.makeApiCall('POST', 'ingroups/nvgroups/delete/', params);
			},

			defaultErrorHandler: CoreApiService.defaultErrorHandler,
		};
	});

'use strict';

angular
	.module('new-web')

	.factory('IncostsApiService', function(CoreApiService) {
		return {
			getIncost: function(params) {
				return CoreApiService.makeApiCall('POST', 'incosts/get/', params);
			},

			getIncostsList: function(params) {
				return CoreApiService.makeApiCall('POST', 'incosts/list/', params);
			},

			createIncost: function(params) {
				return CoreApiService.makeApiCall('POST', 'incosts/create/', params);
			},

			deleteIncost: function(params) {
				return CoreApiService.makeApiCall('POST', 'incosts/delete/', params);
			},

			updateIncost: function(params) {
				return CoreApiService.makeApiCall('POST', 'incosts/update/', params);
			},

			importIncosts: function(params, data) {
				return CoreApiService.makeApiCall('POST', 'incosts/import/', params, data);
			},

			getCustomerIncostsList: function(params) {
				return CoreApiService.makeApiCall('POST', 'incosts/customer/list/', params);
			},

			defaultErrorHandler: CoreApiService.defaultErrorHandler,
		};
	});

'use strict';

angular
	.module('new-web')

	.factory('HuntgroupsApiService', function(CoreApiService) {
		return {
			getHuntgroupsList: function(params) {
				return CoreApiService.makeApiCall('POST', 'huntgroups/list/', params);
			},

			getHuntgroup: function(params) {
				return CoreApiService.makeApiCall('POST', 'huntgroups/get/', params);
			},

			createHuntgroup: function(params) {
				return CoreApiService.makeApiCall('POST', 'huntgroups/create/', params);
			},

			updateHuntgroup: function(params) {
				return CoreApiService.makeApiCall('POST', 'huntgroups/update/', params);
			},

			deleteHuntgroup: function(params) {
				return CoreApiService.makeApiCall('POST', 'huntgroups/delete/', params);
			},

			getDestinationsList: function(params) {
				return CoreApiService.makeApiCall('POST', 'huntgroups/destinations/list/', params);
			},

			createDestination: function(params) {
				return CoreApiService.makeApiCall('POST', 'huntgroups/destinations/create/', params);
			},

			deleteDestination: function(params) {
				return CoreApiService.makeApiCall('POST', 'huntgroups/destinations/delete/', params);
			},

			getDestination: function(params) {
				return CoreApiService.makeApiCall('POST', 'huntgroups/destinations/get/', params);
			},

			importDestinations: function(params, data) {
				return CoreApiService.makeApiCall('POST', 'huntgroups/destinations/import/', params, data);
			},

			updateDestination: function(params) {
				return CoreApiService.makeApiCall('POST', 'huntgroups/destinations/update/', params);
			},

			getDestinationStatistics: function(params) {
				return CoreApiService.makeApiCall('POST', 'huntgroups/destinations/statistics/', params);
			},

			downloadFiles: function(params) {
				return CoreApiService.makeApiCall('POST', 'huntgroups/files/download/', params);
			},

			uploadFiles: function(params, data) {
				return CoreApiService.makeApiCall('POST', 'huntgroups/files/upload/', params, data);
			},

			deleteFiles: function(params) {
				return CoreApiService.makeApiCall('POST', 'huntgroups/files/delete/', params);
			},

			getLevel: function(params) {
				return CoreApiService.makeApiCall('POST', 'huntgroups/levels/get/', params);
			},

			setLevel: function(params) {
				return CoreApiService.makeApiCall('POST', 'huntgroups/levels/set/', params);
			},

			getStatistics: function(params) {
				return CoreApiService.makeApiCall('POST', 'huntgroups/statistics/get/', params);
			},

			defaultErrorHandler: CoreApiService.defaultErrorHandler,
		};
	});

'use strict';

angular
	.module('new-web')

	.factory('FilesApiService', function(CoreApiService) {
		return {
			getFilesList: function(params) {
				return CoreApiService.makeApiCall('POST', 'files/list/', params);
			},

			getFile: function(params) {
				return CoreApiService.makeApiCall('POST', 'files/get/', params);
			},

			createFile: function(params, data) {
				return CoreApiService.makeApiCall('POST', 'files/create/', params, data);
			},

			updateFile: function(params, data) {
				return CoreApiService.makeApiCall('POST', 'files/update/', params, data);
			},

			deleteFile: function(params) {
				return CoreApiService.makeApiCall('POST', 'files/delete/', params);
			},

			defaultErrorHandler: CoreApiService.defaultErrorHandler,
		};
	});

'use strict';

angular
	.module('new-web')

	.factory('FieldsApiService', function(CoreApiService) {
		return {
			getFieldsList: function(params) {
				return CoreApiService.makeApiCall('POST', 'fields/list/', params);
			},

			getField: function(params) {
				return CoreApiService.makeApiCall('POST', 'fields/get/', params);
			},

			createField: function(params) {
				return CoreApiService.makeApiCall('POST', 'fields/create/', params);
			},

			updateField: function(params) {
				return CoreApiService.makeApiCall('POST', 'fields/update/', params);
			},

			deleteField: function(params) {
				return CoreApiService.makeApiCall('POST', 'fields/delete/', params);
			},

			getValue: function(params) {
				return CoreApiService.makeApiCall('POST', 'fields/values/get/', params);
			},

			setValue: function(params) {
				return CoreApiService.makeApiCall('POST', 'fields/values/set/', params);
			},

			getAllowedValuesList: function(params) {
				return CoreApiService.makeApiCall('POST', 'fields/allowed/list/', params);
			},

			createAllowedValue: function(params) {
				return CoreApiService.makeApiCall('POST', 'fields/allowed/create/', params);
			},

			getAllowedValue: function(params) {
				return CoreApiService.makeApiCall('POST', 'fields/allowed/get/', params);
			},

			updateAllowedValue: function(params) {
				return CoreApiService.makeApiCall('POST', 'fields/allowed/update/', params);
			},

			deleteAllowedValue: function(params) {
				return CoreApiService.makeApiCall('POST', 'fields/allowed/delete/', params);
			},

			defaultErrorHandler: CoreApiService.defaultErrorHandler,
		};
	});

'use strict';

angular
	.module('new-web')

	.factory('FeaturesApiService', function(CoreApiService) {
		return {
			getFeature: function(params) {
				return CoreApiService.makeApiCall('POST', 'features/get/', params);
			},

			importFeature: function(params, data) {
				// DEPRECATED
				return CoreApiService.makeApiCall('POST', 'features/import/', params, data);
			},

			getFeatureName: function(params) {
				// DEPRECATED
				return CoreApiService.makeApiCall('POST', 'features/name/get/', params);
			},

			searchFeatures: function(params) {
				return CoreApiService.makeApiCall('POST', 'features/search/', params);
			},

			defaultErrorHandler: CoreApiService.defaultErrorHandler,
		};
	});

'use strict';

angular
	.module('new-web')

	.factory('FaxesApiService', function(CoreApiService) {
		return {
			sendFax: function(params, data) {
				return CoreApiService.makeApiCall('POST', 'faxes/send/', params, data);
			},

			defaultErrorHandler: CoreApiService.defaultErrorHandler,
		};
	});

'use strict';

angular
	.module('new-web')

	.factory('EventsApiService', function(CoreApiService) {
		return {
			getEventsList: function(params) {
				return CoreApiService.makeApiCall('POST', 'events/list/', params);
			},

			defaultErrorHandler: CoreApiService.defaultErrorHandler,
		};
	});

'use strict';

angular
	.module('new-web')

	.factory('EmailsApiService', function(CoreApiService) {
		return {
			sendEmail: function(params) {
				return CoreApiService.makeApiCall('POST', 'emails/send/', params);
			},

			defaultErrorHandler: CoreApiService.defaultErrorHandler,
		};
	});

'use strict';

angular
	.module('new-web')

	.factory('DomainsApiService', function(CoreApiService) {
		return {
			getDomainsList: function(params) {
				return CoreApiService.makeApiCall('POST', 'domains/list/', params);
			},

			getDomain: function(params) {
				return CoreApiService.makeApiCall('POST', 'domains/get/', params);
			},

			createDomain: function(params) {
				return CoreApiService.makeApiCall('POST', 'domains/create/', params);
			},

			getDomainsWebList: function(params) {
				return CoreApiService.makeApiCall('POST', 'domains/web/list/', params);
			},

			updateDomain: function(params) {
				return CoreApiService.makeApiCall('POST', 'domains/update/', params);
			},

			deleteDomain: function(params) {
				return CoreApiService.makeApiCall('POST', 'domains/delete/', params);
			},

			defaultErrorHandler: CoreApiService.defaultErrorHandler,
		};
	});

'use strict';

angular
	.module('new-web')

	.factory('CustomsApiService', function(CoreApiService, $timeout, $rootScope) {
		/*
		var cache_for_seconds = 60;

		var cachedValues = {};

		var getCachedValue = function(name) {
			if (cachedValues[name]) {
				var now = new Date();
				if (now - (cachedValues[name].cached || 0) < cache_for_seconds * 1000) {
					return cachedValues[name];
				}
			}
			deleteCachedValue(name);
			return null;
		};

		var setCachedValue = function(name, value) {
			value.cached = new Date();
			cachedValues[name] = value;
		};

		var deleteCachedValue = function(name) {
			delete cachedValues[name];
		};

		var deleteAllCachedValues = function() {
			cachedValues = {};
		};

		$rootScope.$on('AuthSuccess', deleteAllCachedValues);
		*/

		return {
			/*
			get: function(params) {

				var cached;

				if ((cached = getCachedValue(params.name))) {
					return $timeout(function() {
						return cached;
					});
				}

				return CoreApiService.makeApiCall('POST', 'customs/get/', params).then(function(response) {
					setCachedValue(params.name, response);
					return response;
				});
			},

			set: function(params, data) {
				return CoreApiService.makeApiCall('POST', 'customs/set/', params, data).then(function(response) {
					deleteCachedValue(params.name);
					//setCachedValue(name, {data: {value: params.value}});
					return response;
				});
			},
			*/

			get: function(params) {
				return CoreApiService.makeApiCall('POST', 'customs/get/', params);
			},

			set: function(params, data) {
				return CoreApiService.makeApiCall('POST', 'customs/set/', params, data);
			},

			list: function(params) {
				return CoreApiService.makeApiCall('POST', 'customs/list/', params);
			},

			unset: function(params) {
				return CoreApiService.makeApiCall('POST', 'customs/unset/', params);
			},

			defaultErrorHandler: CoreApiService.defaultErrorHandler,
		};
	});

'use strict';

angular
	.module('new-web')

	.factory('CustomersApiService', function(CoreApiService) {
		return {
			increaseCustomersBalance: function(params) {
				return CoreApiService.makeApiCall('POST', 'customers/balance/add/', params);
			},

			createCustomer: function(params) {
				return CoreApiService.makeApiCall('POST', 'customers/create/', params);
			},

			deleteCustomer: function(params) {
				return CoreApiService.makeApiCall('POST', 'customers/delete/', params);
			},

			getCustomer: function(params) {
				return CoreApiService.makeApiCall('POST', 'customers/get/', params);
			},

			getCustomersList: function(params) {
				return CoreApiService.makeApiCall('POST', 'customers/list/', params);
			},

			moveCustomer: function(params) {
				return CoreApiService.makeApiCall('POST', 'customers/move/', params);
			},

			purgeCustomer: function(params) {
				return CoreApiService.makeApiCall('POST', 'customers/purge/', params);
			},

			getCustomerStatistics: function(params) {
				return CoreApiService.makeApiCall('POST', 'customers/statistics/get/', params);
			},

			increaseCustomersTime: function(params) {
				return CoreApiService.makeApiCall('POST', 'customers/time/add/', params);
			},

			requestTopupForCustomer: function(params) {
				return CoreApiService.makeApiCall('POST', 'customers/topup/request/', params);
			},

			undeleteCustomer: function(params) {
				return CoreApiService.makeApiCall('POST', 'customers/undelete/', params);
			},

			getNextUnusedAccountNumber: function(params) {
				return CoreApiService.makeApiCall('POST', 'customers/unused/account/', params);
			},

			getNextUnusedPrefix: function(params) {
				return CoreApiService.makeApiCall('POST', 'customers/unused/prefix/', params);
			},

			updateCustomer: function(params) {
				return CoreApiService.makeApiCall('POST', 'customers/update/', params);
			},

			exportCustomers: function(params) {
				return CoreApiService.makeApiCall('POST', 'customers/export/', params);
			},

			importCustomers: function(params, data) {
				return CoreApiService.makeApiCall('POST', 'customers/import/', params, data);
			},

			defaultErrorHandler: CoreApiService.defaultErrorHandler,
		};
	});

'use strict';

angular
	.module('new-web')

	.factory('CosesApiService', function(CoreApiService) {
		return {
			getCosesList: function(params) {
				return CoreApiService.makeApiCall('POST', 'cos/list/', params);
			},

			getCos: function(params) {
				return CoreApiService.makeApiCall('POST', 'cos/get/', params);
			},

			createCos: function(params) {
				return CoreApiService.makeApiCall('POST', 'cos/create/', params);
			},

			deleteCos: function(params) {
				return CoreApiService.makeApiCall('POST', 'cos/delete/', params);
			},

			updateCos: function(params) {
				return CoreApiService.makeApiCall('POST', 'cos/update/', params);
			},

			createOutroute: function(params) {
				return CoreApiService.makeApiCall('POST', 'cos/outroutes/create/', params);
			},

			deleteOutroute: function(params) {
				return CoreApiService.makeApiCall('POST', 'cos/outroutes/delete/', params);
			},

			getOutroute: function(params) {
				return CoreApiService.makeApiCall('POST', 'cos/outroutes/get/', params);
			},

			getOutroutesList: function(params) {
				return CoreApiService.makeApiCall('POST', 'cos/outroutes/list/', params);
			},

			updateOutroute: function(params) {
				return CoreApiService.makeApiCall('POST', 'cos/outroutes/update/', params);
			},

			defaultErrorHandler: CoreApiService.defaultErrorHandler,
		};
	});

'use strict';

angular
	.module('new-web')

	.factory('ConfigsApiService', function(CoreApiService, $timeout, $rootScope) {
		var cache_for_seconds = 60;

		var cachedValues = {};

		var deleteCachedValue = function(name) {
			delete cachedValues[name];
		};

		var getCachedValue = function(name) {
			if (cachedValues[name]) {
				var now = new Date();
				if (now - (cachedValues[name].cached || 0) < cache_for_seconds * 1000) {
					return cachedValues[name];
				}
			}
			deleteCachedValue(name);
			return null;
		};

		var setCachedValue = function(name, value) {
			value.cached = new Date();
			cachedValues[name] = value;
		};

		var deleteAllCachedValues = function() {
			cachedValues = {};
		};

		$rootScope.$on('AuthSuccess', deleteAllCachedValues);

		return {
			getConfig: function(params, useCache) {
				var cached;
				var useCache = _.isUndefined(useCache) ? true : useCache;

				if ((cached = getCachedValue(params.name)) && useCache) {
					return $timeout(function() {
						return cached;
					});
				}

				return CoreApiService.makeApiCall('POST', 'configs/get/', params).then(function(response) {
					setCachedValue(params.name, response);
					return response;
				});
			},

			getConfigLanguages: function(params) {
				return CoreApiService.makeApiCall('POST', 'configs/languages/list/', params);
			},

			getConfigsList: function(params) {
				return CoreApiService.makeApiCall('POST', 'configs/list/', params);
			},

			updateConfig: function(params) {
				return CoreApiService.makeApiCall('POST', 'configs/update/', params).then(function(response) {
					deleteCachedValue(params.name);
					//setCachedValue(name, {data: {value: params.value}});
					return response;
				});
			},

			getEmergencyCodesList: function(params) {
				return CoreApiService.makeApiCall('POST', 'configs/emergency/codes/list/', params);
			},

			defaultErrorHandler: CoreApiService.defaultErrorHandler,
		};
	});

'use strict';

angular
	.module('new-web')

	.factory('ConferencesApiService', function(CoreApiService) {
		return {
			getConferencesList: function(params) {
				return CoreApiService.makeApiCall('POST', 'conferences/list/', params);
			},

			createConference: function(params) {
				return CoreApiService.makeApiCall('POST', 'conferences/create/', params);
			},

			deleteConference: function(params) {
				return CoreApiService.makeApiCall('POST', 'conferences/delete/', params);
			},

			getConference: function(params) {
				return CoreApiService.makeApiCall('POST', 'conferences/get/', params);
			},

			updateConference: function(params) {
				return CoreApiService.makeApiCall('POST', 'conferences/update/', params);
			},

			getNotificationsList: function(params) {
				return CoreApiService.makeApiCall('POST', 'conferences/notifications/list/', params);
			},

			createNotification: function(params) {
				return CoreApiService.makeApiCall('POST', 'conferences/notifications/create/', params);
			},

			resetNotifications: function(params) {
				return CoreApiService.makeApiCall('POST', 'conferences/notifications/reset/', params);
			},

			getUnusedCode: function(params) {
				return CoreApiService.makeApiCall('POST', 'conferences/unused/code/', params);
			},

			defaultErrorHandler: CoreApiService.defaultErrorHandler,
		};
	});

'use strict';

angular
	.module('new-web')

	.factory('CodesApiService', function(CoreApiService) {
		return {
			getCodesList: function(params) {
				return CoreApiService.makeApiCall('POST', 'codes/list/', params);
			},

			getCode: function(params) {
				return CoreApiService.makeApiCall('POST', 'codes/get/', params);
			},

			createCode: function(params) {
				return CoreApiService.makeApiCall('POST', 'codes/create/', params);
			},

			deleteCode: function(params) {
				return CoreApiService.makeApiCall('POST', 'codes/delete/', params);
			},

			updateCode: function(params) {
				return CoreApiService.makeApiCall('POST', 'codes/update/', params);
			},

			importCodes: function(params, data) {
				return CoreApiService.makeApiCall('POST', 'codes/import/', params, data);
			},

			getCallersList: function(params) {
				return CoreApiService.makeApiCall('POST', 'codes/callers/list/', params);
			},

			createCaller: function(params) {
				return CoreApiService.makeApiCall('POST', 'codes/callers/create/', params);
			},

			deleteCaller: function(params) {
				return CoreApiService.makeApiCall('POST', 'codes/callers/delete/', params);
			},

			getCaller: function(params) {
				return CoreApiService.makeApiCall('POST', 'codes/callers/get/', params);
			},

			updateCaller: function(params) {
				return CoreApiService.makeApiCall('POST', 'codes/callers/update/', params);
			},

			deleteFiles: function(params) {
				return CoreApiService.makeApiCall('POST', 'codes/files/delete/', params);
			},

			downloadFiles: function(params) {
				return CoreApiService.makeApiCall('POST', 'codes/files/download/', params);
			},

			uploadFiles: function(params, data) {
				return CoreApiService.makeApiCall('POST', 'codes/files/upload/', params, data);
			},

			getTimesList: function(params) {
				return CoreApiService.makeApiCall('POST', 'codes/times/list/', params);
			},

			createTime: function(params) {
				return CoreApiService.makeApiCall('POST', 'codes/times/create/', params);
			},

			deleteTime: function(params) {
				return CoreApiService.makeApiCall('POST', 'codes/times/delete/', params);
			},

			getTime: function(params) {
				return CoreApiService.makeApiCall('POST', 'codes/times/get/', params);
			},

			updateTime: function(params) {
				return CoreApiService.makeApiCall('POST', 'codes/times/update/', params);
			},

			defaultErrorHandler: CoreApiService.defaultErrorHandler,
		};
	});

'use strict';

angular
	.module('new-web')

	.factory('ClassesApiService', function(CoreApiService) {
		return {
			getClassesList: function(params) {
				return CoreApiService.makeApiCall('POST', 'classes/list/', params);
			},

			getClass: function(params) {
				return CoreApiService.makeApiCall('POST', 'classes/get/', params);
			},

			createClass: function(params) {
				return CoreApiService.makeApiCall('POST', 'classes/create/', params);
			},

			deleteClass: function(params) {
				return CoreApiService.makeApiCall('POST', 'classes/delete/', params);
			},

			updateClass: function(params) {
				return CoreApiService.makeApiCall('POST', 'classes/update/', params);
			},

			defaultErrorHandler: CoreApiService.defaultErrorHandler,
		};
	});

'use strict';

angular
	.module('new-web')

	.factory('ChargesApiService', function(CoreApiService) {
		return {
			getChargesList: function(params) {
				return CoreApiService.makeApiCall('POST', 'charges/list/', params);
			},

			createCharge: function(params) {
				return CoreApiService.makeApiCall('POST', 'charges/create/', params);
			},

			updateCharge: function(params) {
				return CoreApiService.makeApiCall('POST', 'charges/update/', params);
			},

			deleteCharge: function(params) {
				return CoreApiService.makeApiCall('POST', 'charges/delete/', params);
			},

			getCharge: function(params) {
				return CoreApiService.makeApiCall('POST', 'charges/get/', params);
			},

			charge: function(params) {
				return CoreApiService.makeApiCall('POST', 'charges/charge/', params);
			},

			defaultErrorHandler: CoreApiService.defaultErrorHandler,
		};
	});

'use strict';

angular
	.module('new-web')

	.factory('CdrsApiService', function(CoreApiService) {
		return {
			getCdrsList: function(params) {
				return CoreApiService.makeApiCall('POST', 'cdrs/list/', params);
			},

			getCdr: function(params) {
				return CoreApiService.makeApiCall('POST', 'cdrs/get/', params);
			},

			createCdr: function(params) {
				return CoreApiService.makeApiCall('POST', 'cdrs/create/', params);
			},

			updateCdr: function(params) {
				return CoreApiService.makeApiCall('POST', 'cdrs/update/', params);
			},

			rebillCdr: function(params) {
				return CoreApiService.makeApiCall('POST', 'cdrs/rebill/', params);
			},

			getStatistics: function(params) {
				return CoreApiService.makeApiCall('POST', 'cdrs/statistics/get/', params);
			},

			resetStatistics: function(params) {
				return CoreApiService.makeApiCall('POST', 'cdrs/statistics/reset/', params);
			},

			getTotalsList: function(params) {
				return CoreApiService.makeApiCall('POST', 'cdrs/totals/list/', params);
			},

			defaultErrorHandler: CoreApiService.defaultErrorHandler,
		};
	});

'use strict';

angular
	.module('new-web')

	.factory('CardsApiService', function(CoreApiService) {
		return {
			getCardsList: function(params) {
				return CoreApiService.makeApiCall('POST', 'cards/list/', params);
			},

			getCard: function(params) {
				return CoreApiService.makeApiCall('POST', 'cards/get/', params);
			},

			deleteCard: function(params) {
				return CoreApiService.makeApiCall('POST', 'cards/delete/', params);
			},

			updateCard: function(params) {
				return CoreApiService.makeApiCall('POST', 'cards/update/', params);
			},

			getBatchesList: function(params) {
				return CoreApiService.makeApiCall('POST', 'cards/batches/list/', params);
			},

			getBatch: function(params) {
				return CoreApiService.makeApiCall('POST', 'cards/batches/get/', params);
			},

			createBatch: function(params) {
				return CoreApiService.makeApiCall('POST', 'cards/batches/create/', params);
			},

			updateBatch: function(params) {
				return CoreApiService.makeApiCall('POST', 'cards/batches/update/', params);
			},

			deleteBatch: function(params) {
				return CoreApiService.makeApiCall('POST', 'cards/batches/delete/', params);
			},

			getCardgroupsList: function(params) {
				return CoreApiService.makeApiCall('POST', 'cards/groups/list/', params);
			},

			getCardgroup: function(params) {
				return CoreApiService.makeApiCall('POST', 'cards/groups/get/', params);
			},

			createCardgroup: function(params) {
				return CoreApiService.makeApiCall('POST', 'cards/groups/create/', params);
			},

			updateCardgroup: function(params) {
				return CoreApiService.makeApiCall('POST', 'cards/groups/update/', params);
			},

			deleteCardgroup: function(params) {
				return CoreApiService.makeApiCall('POST', 'cards/groups/delete/', params);
			},

			getStatistics: function(params) {
				return CoreApiService.makeApiCall('POST', 'cards/statistics/get/', params);
			},

			uploadFiles: function(params, data) {
				return CoreApiService.makeApiCall('POST', 'cards/files/upload/', params, data);
			},

			downloadFiles: function(params) {
				return CoreApiService.makeApiCall('POST', 'cards/files/download/', params);
			},

			deleteFiles: function(params) {
				return CoreApiService.makeApiCall('POST', 'cards/files/delete/', params);
			},

			defaultErrorHandler: CoreApiService.defaultErrorHandler,
		};
	});

'use strict';

angular
	.module('new-web')

	.factory('CallshopsApiService', function(CoreApiService) {
		return {
			createCallshop: function(params) {
				return CoreApiService.makeApiCall('POST', 'callshops/create/', params);
			},

			lockCallshop: function(params) {
				return CoreApiService.makeApiCall('POST', 'callshops/lock/', params);
			},

			resetCallshop: function(params) {
				return CoreApiService.makeApiCall('POST', 'callshops/reset/', params);
			},

			unlockCallshop: function(params) {
				return CoreApiService.makeApiCall('POST', 'callshops/unlock/', params);
			},

			getLastTransaction: function(params) {
				return CoreApiService.makeApiCall('POST', 'callshops/transaction/', params);
			},

			defaultErrorHandler: CoreApiService.defaultErrorHandler,
		};
	});

'use strict';

angular
	.module('new-web')

	.factory('CallsApiService', function($q, CoreApiService) {
		return {
			getActiveCalls: function(params, panel) {
				var endpoint = 'calls/active/list/';
				if (typeof panel !== 'undefined' && panel) {
					endpoint += 'panel/';
				}

				return CoreApiService.makeApiCall('POST', endpoint, params);
			},

			makeACall: function(params) {
				return CoreApiService.makeApiCall('POST', 'calls/make/', params);
			},

			hangupCall: function(params) {
				if (!params.uniqueid && !params.callid) {
					var defer = $q.defer();
					defer.reject();
					return defer.promise;
				}

				return CoreApiService.makeApiCall('POST', 'calls/hangup/', params);
			},

			redirectCall: function(params) {
				return CoreApiService.makeApiCall('POST', 'calls/redirect/', params);
			},

			getMissedCalls: function(params) {
				return CoreApiService.makeApiCall('POST', 'calls/missed/list/', params);
			},

			defaultErrorHandler: CoreApiService.defaultErrorHandler,
		};
	});

'use strict';

angular
	.module('new-web')

	.factory('BulkApiService', function(CoreApiService) {
		return {
			createCampaign: function(params) {
				return CoreApiService.makeApiCall('POST', 'bulk/campaigns/create/', params);
			},

			deleteCampaign: function(params) {
				return CoreApiService.makeApiCall('POST', 'bulk/campaigns/delete/', params);
			},

			getCampaign: function(params) {
				return CoreApiService.makeApiCall('POST', 'bulk/campaigns/get/', params);
			},

			getCampaignsList: function(params) {
				return CoreApiService.makeApiCall('POST', 'bulk/campaigns/list/', params);
			},

			updateCampaign: function(params) {
				return CoreApiService.makeApiCall('POST', 'bulk/campaigns/update/', params);
			},

			createDestinations: function(params, data) {
				return CoreApiService.makeApiCall('POST', 'bulk/destinations/create/', params, data);
			},

			deleteDestination: function(params) {
				return CoreApiService.makeApiCall('POST', 'bulk/destinations/delete/', params);
			},

			getDestination: function(params) {
				return CoreApiService.makeApiCall('POST', 'bulk/destinations/get/', params);
			},

			getDestinationsList: function(params) {
				return CoreApiService.makeApiCall('POST', 'bulk/destinations/list/', params);
			},

			updateDestination: function(params) {
				return CoreApiService.makeApiCall('POST', 'bulk/destinations/update/', params);
			},

			deleteFiles: function(params) {
				return CoreApiService.makeApiCall('POST', 'bulk/files/delete/', params);
			},

			downloadFiles: function(params) {
				return CoreApiService.makeApiCall('POST', 'bulk/files/download/', params);
			},

			uploadFiles: function(params, data) {
				return CoreApiService.makeApiCall('POST', 'bulk/files/upload/', params, data);
			},

			defaultErrorHandler: CoreApiService.defaultErrorHandler,
		};
	});

'use strict';

angular
	.module('new-web')

	.factory('AuditApiService', function(CoreApiService) {
		return {
			getAuditsList: function(params) {
				return CoreApiService.makeApiCall('POST', 'audit/list/', params);
			},

			defaultErrorHandler: CoreApiService.defaultErrorHandler,
		};
	});

'use strict';

angular
	.module('new-web')

	.factory('AlertsApiService', function(CoreApiService) {
		return {
			getAlertsList: function(params) {
				return CoreApiService.makeApiCall('POST', 'alerts/list/', params);
			},

			createAlert: function(params) {
				return CoreApiService.makeApiCall('POST', 'alerts/create/', params);
			},

			updateAlert: function(params) {
				return CoreApiService.makeApiCall('POST', 'alerts/update/', params);
			},

			deleteAlert: function(params) {
				return CoreApiService.makeApiCall('POST', 'alerts/delete/', params);
			},

			getAlert: function(params) {
				return CoreApiService.makeApiCall('POST', 'alerts/get/', params);
			},

			importAlerts: function(params, data) {
				return CoreApiService.makeApiCall('POST', 'alerts/import/', params, data);
			},

			defaultErrorHandler: CoreApiService.defaultErrorHandler,
		};
	});

'use strict';

angular
	.module('new-web')

	.factory('AddressesApiService', function(CoreApiService) {
		return {
			getAddressesList: function(params) {
				return CoreApiService.makeApiCall('POST', 'addresses/list/', params);
			},

			getAddress: function(params) {
				return CoreApiService.makeApiCall('POST', 'addresses/get/', params);
			},

			createAddress: function(params) {
				return CoreApiService.makeApiCall('POST', 'addresses/create/', params);
			},

			updateAddress: function(params) {
				return CoreApiService.makeApiCall('POST', 'addresses/update/', params);
			},

			deleteAddress: function(params) {
				return CoreApiService.makeApiCall('POST', 'addresses/delete/', params);
			},

			defaultErrorHandler: CoreApiService.defaultErrorHandler,
		};
	});

'use strict';

angular
	.module('new-web')

	.factory('AccessesApiService', function(CoreApiService) {
		return {
			getAccessesList: function(params) {
				return CoreApiService.makeApiCall('POST', 'access/list/', params);
			},

			getAccess: function(params) {
				return CoreApiService.makeApiCall('POST', 'access/get/', params);
			},

			createAccess: function(params) {
				return CoreApiService.makeApiCall('POST', 'access/create/', params);
			},

			updateAccess: function(params) {
				return CoreApiService.makeApiCall('POST', 'access/update/', params);
			},

			deleteAccess: function(params) {
				return CoreApiService.makeApiCall('POST', 'access/delete/', params);
			},

			getNextUnusedAccount: function(params) {
				return CoreApiService.makeApiCall('POST', 'access/unused/account/', params);
			},

			defaultErrorHandler: CoreApiService.defaultErrorHandler,
		};
	});

'use strict';

(function() {
	/** @ngInject */
	function modalTemplatesConfig($httpProvider) {
		var getCurrentLanguage = function() {
			return enswitchGlobals.currentLanguage || enswitchGlobals.default_language || 'en';
		};

		var getTemplatesFolder = function() {
			var currentLanguage = getCurrentLanguage();
			return (
				(enswitchGlobals.installedLanguages && enswitchGlobals.installedLanguages[currentLanguage]
					? enswitchGlobals.installedLanguages[currentLanguage].templates
					: currentLanguage) || currentLanguage
			);
		};

		var isLocalized = function(url) {
			if (!enswitchGlobals.templatesFolder) return false;
			var regex = new RegExp(
				(enswitchGlobals.templatesFolder || '/local/templates/').replace(/\//g, '\\/') + getTemplatesFolder() + '\\/'
			);

			return regex.test(url);
		};

		var getLocalizedUrl = function(url) {
			if (!enswitchGlobals.templatesFolder) return url;
			return url.replace(
				'app/components/',
				(enswitchGlobals.templatesFolder || '/local/templates/') + getTemplatesFolder() + '/'
			);
		};

		var getOriginalUrl = function(url) {
			if (!enswitchGlobals.templatesFolder) return url;
			var regex = new RegExp(
				(enswitchGlobals.templatesFolder || '/local/templates/').replace(/\//g, '\\/') + getTemplatesFolder() + '\\/'
			);
			return url.replace(regex, 'app/components/');
		};

		var shouldLookForLocalizedTemplate = function(request) {
			if (!enswitchGlobals.templatesFolder) return false;
			return (
				request.method == 'GET' &&
				(!request.config || !request.config.data || !request.config.data.checkedForLocalizedTemplate) &&
				/\.html$/.test(request.url) &&
				/app\/components\//.test(request.url) &&
				// !/app\/components\/common\//.test(request.url) &&
				!isLocalized(request.url)
			);
		};

		/** @ngInject */
		$httpProvider.interceptors.push(function($q, $injector) {
			return {
				request: function(request) {
					if (request.method == 'GET' && /(app|assets)\//.test(request.url)) {
						request.url += '?v=' + String(enswitchGlobals.versionTimestamp || 0);
					}
					if (!enswitchGlobals.templatesFolder) return request;
					if (shouldLookForLocalizedTemplate(request)) {
						request.url = getLocalizedUrl(request.url);

						request.config = request.config || {};
						request.config.data = request.config.data || {};
						request.config.data.checkedForLocalizedTemplate = 1;
						request.config.timeout = 10000;
					}

					return request;
				},

				responseError: function(rejection) {
					// console.log('template error: ', rejection); // @TODO: remove this, it's here temporarily for live debugging
					if (rejection.status === 404 && isLocalized(rejection.config.url)) {
						var request = rejection.config;

						request.url = getOriginalUrl(request.url);

						request.config = request.config || {};
						request.config.data = request.config.data || {};
						request.config.data.checkedForLocalizedTemplate = 1;

						return $injector.get('$http')(request);
					}

					return $q.reject(rejection);
				},
			};
		});
	}

	angular.module('new-web').config(modalTemplatesConfig);
})();

/**
 * INSPINIA - Responsive Admin Theme
 * 2.5
 *
 * Custom scripts
 */

'use strict';

(function(window, angular) {
	setTimeout(function() {
		angular.element(document).ready(function($timeout) {
			// Full height of sidebar
			function fix_height() {
				var heightWithoutNavbar = angular.element('body > #wrapper').height() - 61;
				angular.element('.sidebard-panel').css('min-height', heightWithoutNavbar + 'px');

				var navbarHeigh = angular.element('nav.navbar-default').height();
				var wrapperHeigh = angular.element('#page-wrapper').height();

				if (navbarHeigh > wrapperHeigh) {
					angular.element('#page-wrapper').css('min-height', navbarHeigh + 'px');
				}

				if (navbarHeigh < wrapperHeigh) {
					angular.element('#page-wrapper').css('min-height', angular.element(window).height() + 'px');
				}

				if (angular.element('body').hasClass('fixed-nav')) {
					if (navbarHeigh > wrapperHeigh) {
						angular.element('#page-wrapper').css('min-height', navbarHeigh - 60 + 'px');
					} else {
						angular.element('#page-wrapper').css('min-height', angular.element(window).height() - 60 + 'px');
					}
				}
			}

			angular.element(window).bind('load resize scroll', function() {
				if (!angular.element('body').hasClass('body-small')) {
					fix_height();
				}
			});

			// Move right sidebar top after scroll
			angular.element(window).scroll(function() {
				if (angular.element(window).scrollTop() > 0 && !angular.element('body').hasClass('fixed-nav')) {
					angular.element('#right-sidebar').addClass('sidebar-top');
				} else {
					angular.element('#right-sidebar').removeClass('sidebar-top');
				}
			});

			$timeout(function() {
				fix_height();
			});

			// Minimalize menu when screen is less than 768px
			angular.element(window).bind('load resize', function() {
				if (angular.element(document).width() < 769) {
					angular.element('body').addClass('body-small');
				} else {
					angular.element('body').removeClass('body-small');
				}
			});
		});
	});
})(window, window.angular);

'use strict';

(function(window, document, angular, undefined) {
	/** @ngInject */
	function runBlock($log, $rootScope, RunService, variables, $sce) {
		RunService.run();

		// ng-stats inititalize - causes tests to fail!
		//(function() {var a = document.createElement("script");a.src = "https://rawgit.com/kentcdodds/ng-stats/master/dist/ng-stats.js";a.onload=function(){window.showAngularStats({position: 'bottomLeft'})};document.head.appendChild(a)})();

		// Define regexes for form validation

		$rootScope.trustSrc = function(src) {
			return $sce.trustAsResourceUrl(src);
		};

		$rootScope.currency_regex = /^[0-9]+([,.][0-9]+)?$/;
		$rootScope.currency_regex_negative = /^\-{0,1}[0-9]+([,.][0-9]+)?$/;
		$rootScope.url_regex = new RegExp( // Diego Perini
			'^' +
			// protocol identifier
			'(?:(?:https?|ftp)://)?' + // edited, addded '?' so the protocol is required!
				// user:pass authentication
				'(?:\\S+(?::\\S*)?@)?' +
				'(?:' +
				// IP address exclusion
				// private & local networks
				'(?!(?:10|127)(?:\\.\\d{1,3}){3})' +
				'(?!(?:169\\.254|192\\.168)(?:\\.\\d{1,3}){2})' +
				'(?!172\\.(?:1[6-9]|2\\d|3[0-1])(?:\\.\\d{1,3}){2})' +
				// IP address dotted notation octets
				// excludes loopback network 0.0.0.0
				// excludes reserved space >= 224.0.0.0
				// excludes network & broacast addresses
				// (first & last IP address of each class)
				'(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])' +
				'(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}' +
				'(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))' +
				'|' +
				// host name
				'(?:(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)' +
				// domain name
				'(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*' +
				// TLD identifier
				'(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))' +
				// TLD may end with dot
				'\\.?' +
				')' +
				// port number
				'(?::\\d{2,5})?' +
				// resource path
				'(?:[/?#]\\S*)?' +
				'$',
			'i'
		);

		$rootScope.ipaddr_regex = /^(http[s]?:\/\/)?(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])(:[0-9]{2,5})?$/;
		//$rootScope.hostname_regex = /^(http[s]?:\/\/)?(([a-zA-Z]|[a-zA-Z][a-zA-Z0-9\-]*[a-zA-Z0-9])\.)*([A-Za-z]|[A-Za-z][A-Za-z0-9\-]*[A-Za-z0-9])(:[0-9]{2,5})?$/; // not needed?
		$rootScope.url_ip_regex = /(^(?:(?:https?|ftp):\/\/)?(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,}))\.?)(?::\d{2,5})?(?:[\/?#]\S*)?$)|(^(http[s]?:\/\/)?(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])(:[0-9]{2,5})?$)|(^(http[s]?:\/\/)?(localhost)(:[0-9]{2,5})?$)/;

		$rootScope.check_patterns = variables.check_patterns;

		// $log.debug('runBlock end');
	}

	angular.module('new-web').run(runBlock);
})(window, document, window.angular);

'use strict';

(function() {
	/** @ngInject */
	function routerConfig($stateProvider, $urlRouterProvider, $anchorScrollProvider) {
		$anchorScrollProvider.disableAutoScrolling();

		var requiresAuth = function(stateName) {
			return /^(index\.)/.test(stateName);
		};

		var shouldEnableModal = function(stateName) {
			return (
				!/(-list|index\.customerselect|index\.calls\.panel|index\.home)$/.test(stateName) &&
				!_.includes(stateName, 'index.plugin_')
			);
		};

		var getControllerPath = function(state) {
			return (state.templateUrl || state.data.originalTemplate).replace(/\/\w+?\.html/, '/' + state.controller + '.js');
		};

		$stateProvider.localizedTemplateState = function(stateName, stateConfig) {
			// dynamic template url's based on current language
			stateConfig.data = stateConfig.data || {};

			if (stateConfig.templateUrl) {
				var original = stateConfig.templateUrl;

				delete stateConfig.templateUrl;
				stateConfig.data.originalTemplate = original;

				stateConfig.templateProvider = [
					'$rootScope',
					'$http',
					'$state',
					'$templateCache',
					function($rootScope, $http, $state, $templateCache) {
						var baseUrl = 'app/components/';

						var cIndex = original.indexOf('app/components');

						if (cIndex < 0 || cIndex > 1) {
							// for plugins
							baseUrl = 'local/';
						}

						var currentLanguage = $rootScope.currentLanguage || $rootScope.default_language || 'en';

						var templatesFolder =
							($rootScope.installedLanguages && $rootScope.installedLanguages[currentLanguage]
								? $rootScope.installedLanguages[currentLanguage].templates
								: currentLanguage) || currentLanguage;

						// Always look for localized first, even if "en" - can be overriden if put in "local" folder!
						var templateUrl = /*(currentLanguage == 'en') ? original : */ $rootScope.templatesFolder
							? original.replace(baseUrl, $rootScope.templatesFolder + templatesFolder + '/')
							: original;

						return (
							$templateCache.get(templateUrl) ||
							$http
								.get(templateUrl, {
									data: {
										checkedForLocalizedTemplate: 1,
									},
								})
								.then(
									function(tpl) {
										if (tpl && tpl.data) {
											$templateCache.put(templateUrl, tpl.data); // in timeout?
											return tpl.data;
										} else {
											// if no localized template fall back to default
											return (
												$templateCache.get(original) ||
												$http
													.get(original, {
														data: {
															checkedForLocalizedTemplate: 1,
														},
													})
													.then(
														function(tpl) {
															$templateCache.put(original, tpl.data); // in timeout?
															return tpl.data;
														},
														function() {
															if (stateName != 'index.error-page') {
																$state.go('index.error-page');
															} else if (stateName != 'index.home') {
																$state.go('index.home');
															}
														}
													)
											);
										}
									},
									function(error) {
										if (!$rootScope.templatesFolder || error.status !== 404) {
											if (stateName != 'index.error-page') {
												$state.go('index.error-page');
											} else if (stateName != 'index.home') {
												$state.go('index.home');
											}
											return;
										}
										return (
											$templateCache.get(original) ||
											$http
												.get(original, {
													data: {
														checkedForLocalizedTemplate: 1,
													},
												})
												.then(
													function(tpl) {
														$templateCache.put(original, tpl.data); // in timeout?
														return tpl.data;
													},
													function() {
														if (stateName != 'index.error-page') {
															$state.go('index.error-page');
														} else if (stateName != 'index.home') {
															$state.go('index.home');
														}
													}
												)
										);
									}
								)
						);
					},
				];
			}

			if (!stateConfig.abstract) {
				stateConfig.resolve = stateConfig.resolve || {};
				stateConfig.resolve.customCSSLoaded = [
					'$rootScope',
					'$q',
					function($rootScope, $q) {
						return $rootScope.customCSSPromise ? $rootScope.customCSSPromise.promise : $q.resolve();
					},
				];
			}

			stateConfig.data.requiresAuth = requiresAuth(stateName);

			if (shouldEnableModal(stateName)) {
				stateConfig.params = stateConfig.params || {};

				stateConfig.params.preselect = stateConfig.params.preselect || '';

				if (stateConfig.url && !/(\?|\&)preselect(\=.*)?$/.test(stateConfig.url)) {
					stateConfig.url += (/\?/.test(stateConfig.url) ? '&' : '?') + 'preselect';
				}

				stateConfig.params.modal = stateConfig.params.modal || '';

				if (stateConfig.url && !/(\?|\&)modal(\=.*)?$/.test(stateConfig.url)) {
					stateConfig.url += (/\?/.test(stateConfig.url) ? '&' : '?') + 'modal';
				}

				/*
				stateConfig.params.modalOptions = stateConfig.params.modalOptions || {
					type: 'json',
					value: {
						'hideHeader': false,
						'hideHeaderIcon': true,
						'updating': false,
					},
					isOptional: true,
					squash: true,
				};

				if (stateConfig.url && !/(\?|\&)modalOptions(\=.*)?$/.test(stateConfig.url)) {
					stateConfig.url += (/\?/.test(stateConfig.url) ? '&' : '?') + 'modalOptions:json';
				}
				*/
			}

			return this.state(stateName, stateConfig);
		};

		$stateProvider.lazyLoadedState = function(stateName, stateConfig) {
			if (!stateConfig.abstract && stateConfig.controller) {
				stateConfig.resolve = stateConfig.resolve || {};

				stateConfig.resolve.loadController = [
					'UtilsService',
					function(UtilsService) {
						return UtilsService.loadScript(getControllerPath(stateConfig));
					},
				];
			}

			return this.localizedTemplateState(stateName, stateConfig);
		};

		$stateProvider

			/** Authentication */

			.lazyLoadedState('login', {
				url: '/login/?timeout&redirect&redirectParams',
				params: {
					username: '',
					password: '',
					timeout: '',
					redirect: '',
					redirectParams: '',
				},
				templateUrl: 'app/components/login/login.html',
				data: {
					pageTitle: 'Login',
				},
				title: 'Login',
				controller: 'LoginCtrl',
				controllerAs: 'login',
			})
			.lazyLoadedState('lostpassword', {
				url: '/lost-password/',
				templateUrl: 'app/components/login/lostPasswordView.html',
				data: {
					pageTitle: 'Lost password',
				},
				title: 'Lost password',
				controller: 'LostPasswordController',
				controllerAs: 'lostPassword',
			})
			.lazyLoadedState('resetpassword', {
				url: '/reset-password/?username&reset',
				params: {
					username: '',
					reset: '',
				},
				templateUrl: 'app/components/login/resetPasswordView.html',
				data: {
					pageTitle: 'Reset password',
				},
				title: 'Reset password',
				controller: 'ResetPasswordController',
				controllerAs: 'resetPassword',
			})

			.lazyLoadedState('signup', {
				url: '/signup',
				templateUrl: 'app/components/signup/mainSignupView.html',
				data: {
					pageTitle: 'Sign up',
				},
				title: 'Sign up',
				resolve: {
					resourcesLoaded: [
						'$rootScope',
						'$timeout',
						function($rootScope, $timeout) {
							// add timeout (outside)?
							return $rootScope.resourcesLoaded.then(function() {
								return $timeout(function() {
									//console.log('resourcesLoaded test: ', $rootScope.languageString('error_no_file_selected')); // seems to work
									return true;
								});
							});
						},
					],
				},
				controller: 'MainSignupController',
				controllerAs: 'signupMain',
			})
			.lazyLoadedState('signup.signup', {
				url: '/signup/',
				templateUrl: 'app/components/signup/signupView.html',
				data: {
					pageTitle: 'Sign up',
				},
				title: 'Sign up',
			})
			.lazyLoadedState('signup.plan', {
				url: '/plan/',
				templateUrl: 'app/components/signup/planView.html',
				data: {
					pageTitle: 'Rate plan',
				},
				title: 'Rate plan',
			})
			.lazyLoadedState('signup.ingroup', {
				url: '/ingroup/',
				templateUrl: 'app/components/signup/ingroupView.html',
				data: {
					pageTitle: 'Number',
				},
				title: 'Number',
			})
			.lazyLoadedState('signup.number', {
				url: '/number/',
				templateUrl: 'app/components/signup/numberView.html',
				data: {
					pageTitle: 'Choose number',
				},
				title: 'Choose number',
			})
			.lazyLoadedState('signup.customer', {
				url: '/customer/',
				templateUrl: 'app/components/signup/customerView.html',
				data: {
					pageTitle: 'Billing details',
				},
				title: 'Billing details',
			})
			.lazyLoadedState('signup.person', {
				url: '/person/',
				templateUrl: 'app/components/signup/personView.html',
				data: {
					pageTitle: 'Yourself',
				},
				title: 'Yourself',
			})
			.lazyLoadedState('signup.payment', {
				url: '/payment/',
				templateUrl: 'app/components/signup/paymentView.html',
				data: {
					pageTitle: 'Payment',
				},
				title: 'Payment',
			})
			.lazyLoadedState('signup.confirm', {
				url: '/confirm/',
				templateUrl: 'app/components/signup/confirmView.html',
				data: {
					pageTitle: 'Confirm details',
				},
				title: 'Confirm details',
			})
			.lazyLoadedState('signup.create', {
				url: '/create/',
				templateUrl: 'app/components/signup/createView.html',
				data: {
					pageTitle: 'Account created',
				},
				title: 'Account created',
			})
			.lazyLoadedState('voicemail-delete', {
				url: '/messages/delete/?message',
				params: {
					message: '',
				},
				templateUrl: 'app/components/calls/messages/deleteVoicemailView.html',
				data: {
					pageTitle: 'Delete voicemail',
				},
				resolve: {
					resourcesLoaded: [
						'$rootScope',
						'$timeout',
						function($rootScope, $timeout) {
							return $rootScope.resourcesLoaded.then(function() {
								return $timeout(function() {
									return true;
								});
							});
						},
					],
				},
				controller: 'DeleteVoicemailController',
				controllerAs: 'deleteVoicemail',
			})

			/** Root state for authenticated users */

			.localizedTemplateState('index', {
				abstract: true,

				templateUrl: 'app/components/common/content.html',

				resolve: {
					resourcesLoaded: [
						'$rootScope',
						'$timeout',
						function($rootScope, $timeout) {
							// add timeout (outside)?
							return $rootScope.resourcesLoaded.then(function() {
								return $timeout(function() {
									// $timeout not needed?
									return true;
								});
							});
						},
					],
				},
			})

			/** Dashboard */

			.lazyLoadedState('index.home', {
				url: '/?switched',
				params: {
					switched: '',
				},
				templateUrl: 'app/components/home/homeView.html',
				data: {
					pageTitle: 'Dashboard',
				},
				controller: 'HomeController',
				controllerAs: 'home',
			})
			.lazyLoadedState('index.customerselect', {
				url: '/customerselect/?name&offset&sort&descending',
				params: {
					name: '',
					offset: '',
					sort: '',
					descending: '',
				},
				templateUrl: 'app/components/customerselect/customerselectView.html',
				data: {
					pageTitle: 'Choose customer',
				},
				controller: 'CustomerSelectController',
				controllerAs: 'customerSelect',
			})

			/** Global */

			.lazyLoadedState('index.global', {
				abstract: true,
				template: '<div ui-view></div>',
				data: {
					pageTitle: 'Global',
				},
			})

			.lazyLoadedState('index.global.config-list', {
				url: '/global/config/list/',
				templateUrl: 'app/components/global/config/configListView.html',
				data: {
					pageTitle: 'Configuration',
				},
				controller: 'ConfigListController',
				controllerAs: 'configList',
			})
			.lazyLoadedState('index.global.config-edit', {
				url: '/global/config/edit/?name',
				templateUrl: 'app/components/global/config/editConfigView.html',
				data: {
					pageTitle: 'Edit configuration setting',
				},
				controller: 'EditConfigController',
				controllerAs: 'editConfig',
			})
			.lazyLoadedState('index.global.config-help', {
				url: '/global/config/help/?name',
				params: {
					name: 'help_config_body',
				},
				templateUrl: 'app/components/help/documentation/helpDocumentationViewView.html',
				data: {
					pageTitle: 'Help for Configuration',
				},
				controller: 'HelpDocumentationViewController',
				controllerAs: 'helpView',
			})

			.lazyLoadedState('index.global.fields-list', {
				url: '/global/fields/list/',
				templateUrl: 'app/components/global/fields/fieldListView.html',
				data: {
					pageTitle: 'Custom fields',
				},
				controller: 'FieldListController',
				controllerAs: 'fieldList',
			})
			.lazyLoadedState('index.global.fields-edit', {
				url: '/global/fields/edit/?id',
				templateUrl: 'app/components/global/fields/editFieldView.html',
				data: {
					pageTitle: 'Edit custom field',
				},
				controller: 'EditFieldController',
				controllerAs: 'editField',
			})
			.lazyLoadedState('index.global.fields-new', {
				url: '/global/fields/new/',
				params: {
					id: '',
				},
				templateUrl: 'app/components/global/fields/editFieldView.html',
				data: {
					pageTitle: 'New custom field',
				},
				controller: 'EditFieldController',
				controllerAs: 'editField',
			})
			.lazyLoadedState('index.global.fields-help', {
				url: '/global/fields/help/?name',
				params: {
					name: 'help_fields_body',
				},
				templateUrl: 'app/components/help/documentation/helpDocumentationViewView.html',
				data: {
					pageTitle: 'Help for Custom fields',
				},
				controller: 'HelpDocumentationViewController',
				controllerAs: 'helpView',
			})
			.lazyLoadedState('index.global.fields-notes', {
				url: '/global/fields/notes/list/?snumber',
				params: {
					stype: 'field',
				},
				templateUrl: 'app/components/utils/notesListView.html',
				data: {
					pageTitle: 'Notes',
				},
				controller: 'NotesListController',
				controllerAs: 'notesList',
			})

			.lazyLoadedState('index.global.domains-list', {
				url: '/global/domains/list/',
				templateUrl: 'app/components/global/domains/domainListView.html',
				data: {
					pageTitle: 'Domains',
				},
				controller: 'DomainListController',
				controllerAs: 'domainList',
			})
			.lazyLoadedState('index.global.domains-edit', {
				url: '/global/domains/edit/?id',
				templateUrl: 'app/components/global/domains/editDomainView.html',
				data: {
					pageTitle: 'Edit domain',
				},
				controller: 'EditDomainController',
				controllerAs: 'editDomain',
			})
			.lazyLoadedState('index.global.domains-new', {
				url: '/global/domains/new/',
				params: {
					id: '0',
				},
				templateUrl: 'app/components/global/domains/editDomainView.html',
				data: {
					pageTitle: 'New domain',
				},
				controller: 'EditDomainController',
				controllerAs: 'editDomain',
			})
			.lazyLoadedState('index.global.domains-help', {
				url: '/global/domains/help/?name',
				params: {
					name: 'help_domains_body',
				},
				templateUrl: 'app/components/help/documentation/helpDocumentationViewView.html',
				data: {
					pageTitle: 'Help for Domains',
				},
				controller: 'HelpDocumentationViewController',
				controllerAs: 'helpView',
			})

			.lazyLoadedState('index.global.ingroups-list', {
				url: '/global/ingroups/list/?offset&sort&descending',
				params: {
					offset: '',
					sort: '',
					descending: '',
				},
				templateUrl: 'app/components/global/ingroups/ingroupListView.html',
				data: {
					pageTitle: 'Inbound groups',
				},
				controller: 'SysIngroupListController',
				controllerAs: 'sysIngroupList',
			})
			.lazyLoadedState('index.global.ingroups-edit', {
				url: '/global/ingroups/edit/?id',
				templateUrl: 'app/components/global/ingroups/editSysIngroupView.html',
				data: {
					pageTitle: 'Edit inbound group',
				},
				controller: 'EditSysIngroupController',
				controllerAs: 'editSysIngroup',
			})
			.lazyLoadedState('index.global.ingroups-new', {
				url: '/global/ingroups/new/',
				params: {
					id: '0',
				},
				templateUrl: 'app/components/global/ingroups/editSysIngroupView.html',
				data: {
					pageTitle: 'New inbound group',
				},
				controller: 'EditSysIngroupController',
				controllerAs: 'editSysIngroup',
			})
			.lazyLoadedState('index.global.ingroups-bulk-edit', {
				url: '/global/ingroups/bulk/edit/?ingroup',
				params: {
					ingroup: '0',
				},
				templateUrl: 'app/components/global/ingroups/bulk/bulkChangeRegionsView.html',
				data: {
					pageTitle: 'Bulk change number regions',
				},
				controller: 'BulkChangeRegionsController',
				controllerAs: 'bulkChangeRegions',
			})
			.lazyLoadedState('index.global.ingroups-incosts-list', {
				url: '/global/ingroups/incosts/list/?ingroup&offset&sort&descending',
				params: {
					ingroup: '',
					offset: '',
					sort: '',
					descending: '',
				},
				templateUrl: 'app/components/global/ingroups/incosts/ingroupIncostListView.html',
				data: {
					pageTitle: 'Inbound call costs',
				},
				controller: 'IngroupIncostListController',
				controllerAs: 'ingroupIncostList',
			})
			.lazyLoadedState('index.global.ingroups-incosts-edit', {
				url: '/global/ingroups/incosts/edit/?ingroup?id',
				templateUrl: 'app/components/global/ingroups/incosts/editIngroupIncostView.html',
				data: {
					pageTitle: 'Edit inbound cost',
				},
				controller: 'EditIngroupIncostController',
				controllerAs: 'editIngroupIncost',
			})
			.lazyLoadedState('index.global.ingroups-incosts-new', {
				url: '/global/ingroups/incosts/new/?ingroup',
				params: {
					id: '0',
				},
				templateUrl: 'app/components/global/ingroups/incosts/editIngroupIncostView.html',
				data: {
					pageTitle: 'New inbound cost',
				},
				controller: 'EditIngroupIncostController',
				controllerAs: 'editIngroupIncost',
			})
			.lazyLoadedState('index.global.ingroups-times-edit', {
				url: '/global/ingroups/times/edit/?ingroup?id',
				templateUrl: 'app/components/global/ingroups/times/editIngroupTimeView.html',
				data: {
					pageTitle: 'Edit time',
				},
				controller: 'EditIngroupTimeController',
				controllerAs: 'editIngroupTime',
			})
			.lazyLoadedState('index.global.ingroups-times-new', {
				url: '/global/ingroups/times/new/?ingroup',
				params: {
					id: '0',
				},
				templateUrl: 'app/components/global/ingroups/times/editIngroupTimeView.html',
				data: {
					pageTitle: 'New time',
				},
				controller: 'EditIngroupTimeController',
				controllerAs: 'editIngroupTime',
			})
			.lazyLoadedState('index.global.ingroups-numbers-list', {
				url: '/global/ingroups/numbers/list/?ingroup&search&offset&descending',
				params: {
					search: '',
					offset: '',
					descending: '',
				},
				templateUrl: 'app/components/global/ingroups/numbers/ingroupNumbersView.html',
				data: {
					pageTitle: 'Numbers',
				},
				controller: 'IngroupNumbersController',
				controllerAs: 'ingroupNumbers',
			})
			.lazyLoadedState('index.global.ingroups-numbers-edit', {
				url: '/global/ingroups/numbers/edit/?number',
				params: {
					number: '',
				},
				templateUrl: 'app/components/global/ingroups/numbers/editIngroupNumberView.html',
				data: {
					pageTitle: 'Edit number',
				},
				controller: 'EditIngroupNumberController',
				controllerAs: 'editIngroupNumber',
			})
			.lazyLoadedState('index.global.ingroups-numbers-new', {
				url: '/global/ingroups/numbers/new/?ingroup',
				templateUrl: 'app/components/global/ingroups/numbers/addNumbersView.html',
				data: {
					pageTitle: 'New number range',
				},
				controller: 'AddNumbersController',
				controllerAs: 'addIngroupNumbers',
			})
			.lazyLoadedState('index.global.ingroups-nvgroups-list', {
				url: '/global/ingroups/nvgroups/list/?ingroup',
				templateUrl: 'app/components/global/ingroups/nvgroups/NVGroupListView.html',
				data: {
					pageTitle: 'Number vendors',
				},
				controller: 'NVGroupListController',
				controllerAs: 'nvgroupList',
			})
			.lazyLoadedState('index.global.ingroups-nvgroups-edit', {
				url: '/global/ingroups/nvgroups/edit/?id',
				templateUrl: 'app/components/global/ingroups/nvgroups/editNVGroupView.html',
				data: {
					pageTitle: 'Edit number vendor',
				},
				controller: 'EditNVGroupController',
				controllerAs: 'editNVGroup',
			})
			.lazyLoadedState('index.global.ingroups-nvgroups-new', {
				url: '/global/ingroups/nvgroups/new/?ingroup',
				templateUrl: 'app/components/global/ingroups/nvgroups/editNVGroupView.html',
				data: {
					pageTitle: 'New number vendor',
				},
				controller: 'EditNVGroupController',
				controllerAs: 'editNVGroup',
			})
			.lazyLoadedState('index.global.ingroups-help', {
				url: '/global/ingroups/help/?name',
				params: {
					name: 'help_ingroups_body',
				},
				templateUrl: 'app/components/help/documentation/helpDocumentationViewView.html',
				data: {
					pageTitle: 'Help for Inbound groups',
				},
				controller: 'HelpDocumentationViewController',
				controllerAs: 'helpView',
			})

			.lazyLoadedState('index.global.machines-list', {
				url: '/global/machines/list/',
				templateUrl: 'app/components/global/machines/machineListView.html',
				data: {
					pageTitle: 'Machines',
				},
				controller: 'MachineListController',
				controllerAs: 'machineList',
			})
			.lazyLoadedState('index.global.machines-edit', {
				url: '/global/machines/edit/?id',
				templateUrl: 'app/components/global/machines/editMachineView.html',
				data: {
					pageTitle: 'Edit machine',
				},
				controller: 'EditMachineController',
				controllerAs: 'editMachine',
			})
			.lazyLoadedState('index.global.machines-new', {
				url: '/global/machines/new/',
				params: {
					id: '0',
				},
				templateUrl: 'app/components/global/machines/editMachineView.html',
				data: {
					pageTitle: 'New machine',
				},
				controller: 'EditMachineController',
				controllerAs: 'editMachine',
			})
			.lazyLoadedState('index.global.machines-help', {
				url: '/global/machines/help/?name',
				params: {
					name: 'help_machines_body',
				},
				templateUrl: 'app/components/help/documentation/helpDocumentationViewView.html',
				data: {
					pageTitle: 'Help for Machines',
				},
				controller: 'HelpDocumentationViewController',
				controllerAs: 'helpView',
			})

			.lazyLoadedState('index.global.menus-list', {
				url: '/global/menus/list/',
				templateUrl: 'app/components/global/menus/menuListView.html',
				data: {
					pageTitle: 'Menus',
				},
				controller: 'MenuListController',
				controllerAs: 'menuList',
			})
			.lazyLoadedState('index.global.menus-edit', {
				url: '/global/menus/edit/?id',
				templateUrl: 'app/components/global/menus/editMenuView.html',
				data: {
					pageTitle: 'Edit menu',
				},
				controller: 'EditMenuController',
				controllerAs: 'editMenu',
			})
			.lazyLoadedState('index.global.menus-new', {
				url: '/global/menus/new/',
				params: {
					id: '0',
				},
				templateUrl: 'app/components/global/menus/editMenuView.html',
				data: {
					pageTitle: 'New menu',
				},
				controller: 'EditMenuController',
				controllerAs: 'editMenu',
			})
			.lazyLoadedState('index.global.menus-help', {
				url: '/global/menus/help/?name',
				params: {
					name: 'help_menus_body',
				},
				templateUrl: 'app/components/help/documentation/helpDocumentationViewView.html',
				data: {
					pageTitle: 'Help for Menus',
				},
				controller: 'HelpDocumentationViewController',
				controllerAs: 'helpView',
			})

			.lazyLoadedState('index.global.plugins-list', {
				url: '/global/plugins/list/',
				templateUrl: 'app/components/global/plugins/pluginListView.html',
				data: {
					pageTitle: 'Plugins',
				},
				controller: 'PluginListController',
				controllerAs: 'pluginList',
			})
			.lazyLoadedState('index.global.plugins-edit', {
				url: '/global/plugins/edit/?id',
				templateUrl: 'app/components/global/plugins/editPluginView.html',
				data: {
					pageTitle: 'Edit plugin',
				},
				controller: 'EditPluginController',
				controllerAs: 'editPlugin',
			})
			.lazyLoadedState('index.global.plugins-new', {
				url: '/global/plugins/new/',
				params: {
					id: '0',
				},
				templateUrl: 'app/components/global/plugins/editPluginView.html',
				data: {
					pageTitle: 'New plugin',
				},
				controller: 'EditPluginController',
				controllerAs: 'editPlugin',
			})
			.lazyLoadedState('index.global.plugins-help', {
				url: '/global/plugins/help/?name',
				params: {
					name: 'help_plugins_body',
				},
				templateUrl: 'app/components/help/documentation/helpDocumentationViewView.html',
				data: {
					pageTitle: 'Help for Plugins',
				},
				controller: 'HelpDocumentationViewController',
				controllerAs: 'helpView',
			})

			.lazyLoadedState('index.global.roles-list', {
				url: '/global/roles/list/',
				templateUrl: 'app/components/global/roles/roleListView.html',
				data: {
					pageTitle: 'Roles',
				},
				controller: 'RoleListController',
				controllerAs: 'roleList',
			})
			.lazyLoadedState('index.global.roles-edit', {
				url: '/global/roles/edit/?id',
				templateUrl: 'app/components/global/roles/editRoleView.html',
				data: {
					pageTitle: 'Edit role',
				},
				controller: 'EditRoleController',
				controllerAs: 'editRole',
			})
			.lazyLoadedState('index.global.roles-new', {
				url: '/global/roles/new/',
				params: {
					id: '0',
				},
				templateUrl: 'app/components/global/roles/editRoleView.html',
				data: {
					pageTitle: 'New role',
				},
				controller: 'EditRoleController',
				controllerAs: 'editRole',
			})
			.lazyLoadedState('index.global.roles-help', {
				url: '/global/roles/help/?name',
				params: {
					name: 'help_roles_body',
				},
				templateUrl: 'app/components/help/documentation/helpDocumentationViewView.html',
				data: {
					pageTitle: 'Help for Roles',
				},
				controller: 'HelpDocumentationViewController',
				controllerAs: 'helpView',
			})

			.lazyLoadedState('index.global.classes-list', {
				url: '/global/classes/list/',
				templateUrl: 'app/components/global/classes/numberClassListView.html',
				data: {
					pageTitle: 'Number classes',
				},
				controller: 'NumberClassListController',
				controllerAs: 'numberClasses',
			})
			.lazyLoadedState('index.global.classes-edit', {
				url: '/global/classes/edit/?id',
				templateUrl: 'app/components/global/classes/editNumberClassView.html',
				data: {
					pageTitle: 'Edit number class',
				},
				controller: 'EditNumberClassController',
				controllerAs: 'editNumberClass',
			})
			.lazyLoadedState('index.global.classes-new', {
				url: '/global/classes/new/',
				params: {
					id: '0',
				},
				templateUrl: 'app/components/global/classes/editNumberClassView.html',
				data: {
					pageTitle: 'New number class',
				},
				controller: 'EditNumberClassController',
				controllerAs: 'editNumberClass',
			})
			.lazyLoadedState('index.global.classes-bulk-edit', {
				url: '/global/classes/bulk/edit/?class',
				params: {
					class: '0',
				},
				templateUrl: 'app/components/global/classes/bulk/bulkNumberRegionsView.html',
				data: {
					pageTitle: 'Bulk change number regions',
				},
				controller: 'BulkNumberRegionsController',
				controllerAs: 'bulkNumberRegions',
			})
			.lazyLoadedState('index.global.classes-help', {
				url: '/global/classes/help/?name',
				params: {
					name: 'help_classes_body',
				},
				templateUrl: 'app/components/help/documentation/helpDocumentationViewView.html',
				data: {
					pageTitle: 'Help for Number classes',
				},
				controller: 'HelpDocumentationViewController',
				controllerAs: 'helpView',
			})

			.lazyLoadedState('index.global.outgroups-list', {
				url: '/global/outgroups/list/?name&offset',
				params: {
					name: '',
					offset: '',
				},
				templateUrl: 'app/components/global/outgroups/sysOutgroupListView.html',
				data: {
					pageTitle: 'Outbound groups',
				},
				controller: 'SysOutgroupListController',
				controllerAs: 'sysOutgroupList',
			})
			.lazyLoadedState('index.global.outgroups-edit', {
				url: '/global/outgroups/edit/?id',
				templateUrl: 'app/components/global/outgroups/editSysOutgroupView.html',
				data: {
					pageTitle: 'Edit outbound group',
				},
				controller: 'EditSysOutgroupController',
				controllerAs: 'editSysOutgroup',
			})
			.lazyLoadedState('index.global.outgroups-new', {
				url: '/global/outgroups/new/',
				params: {
					id: '0',
				},
				templateUrl: 'app/components/global/outgroups/editSysOutgroupView.html',
				data: {
					pageTitle: 'New outbound group',
				},
				controller: 'EditSysOutgroupController',
				controllerAs: 'editSysOutgroup',
			})
			.lazyLoadedState('index.global.outgroups-bulk-edit', {
				url: '/global/outgroups/bulk/edit/?outgroup',
				params: {
					outgroup: '0',
				},
				templateUrl: 'app/components/global/outgroups/bulk/bulkChangeRoutesView.html',
				data: {
					pageTitle: 'Bulk change routes',
				},
				controller: 'BulkChangeRoutesController',
				controllerAs: 'bulkChangeRoutes',
			})
			.lazyLoadedState('index.global.outgroups-times-edit', {
				url: '/global/outgroups/times/edit/?outgroup?id',
				templateUrl: 'app/components/global/outgroups/times/editOutgroupTimeView.html',
				data: {
					pageTitle: 'Edit time',
				},
				controller: 'EditOutgroupTimeController',
				controllerAs: 'editOutgroupTime',
			})
			.lazyLoadedState('index.global.outgroups-times-new', {
				url: '/global/outgroups/times/new/?outgroup',
				params: {
					id: '0',
				},
				templateUrl: 'app/components/global/outgroups/times/editOutgroupTimeView.html',
				data: {
					pageTitle: 'New time',
				},
				controller: 'EditOutgroupTimeController',
				controllerAs: 'editOutgroupTime',
			})
			.lazyLoadedState('index.global.outgroups-help', {
				url: '/global/outgroups/help/?name',
				params: {
					name: 'help_outgroups_body',
				},
				templateUrl: 'app/components/help/documentation/helpDocumentationViewView.html',
				data: {
					pageTitle: 'Help for Outbound groups',
				},
				controller: 'HelpDocumentationViewController',
				controllerAs: 'helpView',
			})

			.lazyLoadedState('index.global.peers-list', {
				url: '/global/peers/list/',
				templateUrl: 'app/components/global/peers/peerListView.html',
				data: {
					pageTitle: 'Peers',
				},
				controller: 'PeerListController',
				controllerAs: 'peerList',
			})
			.lazyLoadedState('index.global.peers-edit', {
				url: '/global/peers/edit/?id',
				templateUrl: 'app/components/global/peers/editPeerView.html',
				data: {
					pageTitle: 'Edit peer',
				},
				controller: 'EditPeerController',
				controllerAs: 'editPeer',
			})
			.lazyLoadedState('index.global.peers-new', {
				url: '/global/peers/new/',
				params: {
					id: '0',
				},
				templateUrl: 'app/components/global/peers/editPeerView.html',
				data: {
					pageTitle: 'New peer',
				},
				controller: 'EditPeerController',
				controllerAs: 'editPeer',
			})
			.lazyLoadedState('index.global.peers-bulk-edit', {
				url: '/global/peers/bulk/edit/?peer',
				templateUrl: 'app/components/global/peers/bulk/bulkPeerRoutesView.html',
				data: {
					pageTitle: 'Bulk change routes',
				},
				controller: 'BulkPeerRoutesController',
				controllerAs: 'bulkPeerRoutes',
			})
			.lazyLoadedState('index.global.peers-costs-list', {
				url: '/global/peers/costs/list/?peer?offset',
				params: {
					peer: '0',
					offset: '',
				},
				templateUrl: 'app/components/global/peers/costs/peerCostListView.html',
				data: {
					pageTitle: 'Outbound call costs',
				},
				controller: 'PeerCostListController',
				controllerAs: 'peerCostList',
			})
			.lazyLoadedState('index.global.peers-costs-edit', {
				url: '/global/peers/costs/edit/?peer?id',
				params: {
					peer: '0',
				},
				templateUrl: 'app/components/global/peers/costs/editPeerCostView.html',
				data: {
					pageTitle: 'Edit outbound cost',
				},
				controller: 'EditPeerCostController',
				controllerAs: 'editPeerCost',
			})
			.lazyLoadedState('index.global.peers-costs-new', {
				url: '/global/peers/costs/new/?peer',
				params: {
					id: '0',
				},
				templateUrl: 'app/components/global/peers/costs/editPeerCostView.html',
				data: {
					pageTitle: 'New outbound cost',
				},
				controller: 'EditPeerCostController',
				controllerAs: 'editPeerCost',
			})
			.lazyLoadedState('index.global.peers-outcosts-list', {
				url: '/global/peers/outcosts/list/?peer?offset',
				params: {
					peer: '0',
					offset: '',
				},
				templateUrl: 'app/components/global/peers/outcosts/peerOutcostListView.html',
				data: {
					pageTitle: 'Outbound call costs',
				},
				controller: 'PeerOutcostListController',
				controllerAs: 'peerOutcostList',
			})
			.lazyLoadedState('index.global.peers-outcosts-edit', {
				url: '/global/peers/outcosts/edit/?peer?id',
				params: {
					peer: '0',
				},
				templateUrl: 'app/components/global/peers/outcosts/editPeerOutcostView.html',
				data: {
					pageTitle: 'Edit outbound cost',
				},
				controller: 'EditPeerOutcostController',
				controllerAs: 'editPeerOutcost',
			})
			.lazyLoadedState('index.global.peers-outcosts-new', {
				url: '/global/peers/outcosts/new/?peer',
				params: {
					id: '0',
				},
				templateUrl: 'app/components/global/peers/outcosts/editPeerOutcostView.html',
				data: {
					pageTitle: 'New outbound cost',
				},
				controller: 'EditPeerOutcostController',
				controllerAs: 'editPeerOutcost',
			})
			.lazyLoadedState('index.global.peers-help', {
				url: '/global/peers/help/?name',
				params: {
					name: 'help_peers_body',
				},
				templateUrl: 'app/components/help/documentation/helpDocumentationViewView.html',
				data: {
					pageTitle: 'Help for Peers',
				},
				controller: 'HelpDocumentationViewController',
				controllerAs: 'helpView',
			})

			.lazyLoadedState('index.global.regions-list', {
				url: '/global/regions/list/',
				templateUrl: 'app/components/global/regions/regionListView.html',
				data: {
					pageTitle: 'Regions',
				},
				controller: 'RegionListController',
				controllerAs: 'regionList',
			})
			.lazyLoadedState('index.global.regions-edit', {
				url: '/global/regions/edit/?id',
				templateUrl: 'app/components/global/regions/editRegionView.html',
				data: {
					pageTitle: 'Edit region',
				},
				controller: 'EditRegionController',
				controllerAs: 'editRegion',
			})
			.lazyLoadedState('index.global.regions-new', {
				url: '/global/regions/new/',
				params: {
					id: '0',
				},
				templateUrl: 'app/components/global/regions/editRegionView.html',
				data: {
					pageTitle: 'New region',
				},
				controller: 'EditRegionController',
				controllerAs: 'editRegion',
			})
			.lazyLoadedState('index.global.regions-machines-list', {
				url: '/global/regions/machines/list/?region',
				templateUrl: 'app/components/global/regions/machines/regionMachineListView.html',
				data: {
					pageTitle: 'Machines',
				},
				controller: 'RegionMachineListController',
				controllerAs: 'regionMachineList',
			})
			.lazyLoadedState('index.global.regions-machines-edit', {
				url: '/global/regions/machines/edit/?region&machine',
				templateUrl: 'app/components/global/regions/machines/editRegionMachineView.html',
				data: {
					pageTitle: 'Edit machines',
				},
				controller: 'EditRegionMachineController',
				controllerAs: 'editRegionMachine',
			})
			.lazyLoadedState('index.global.regions-all-edit', {
				url: '/global/regions/all/edit/',
				templateUrl: 'app/components/global/regions/all/editAllRegionsView.html',
				data: {
					pageTitle: 'Edit all regions',
				},
				controller: 'EditAllRegionsController',
				controllerAs: 'editAllRegions',
			})
			.lazyLoadedState('index.global.regions-help', {
				url: '/global/regions/help/?name',
				params: {
					name: 'help_regions_body',
				},
				templateUrl: 'app/components/help/documentation/helpDocumentationViewView.html',
				data: {
					pageTitle: 'Help for Regions',
				},
				controller: 'HelpDocumentationViewController',
				controllerAs: 'helpView',
			})

			.lazyLoadedState('index.global.outroutes-list', {
				url: '/global/outroutes/list/?search_called&offset',
				params: {
					search_called: '',
					offset: '',
					isSearched: '',
				},
				templateUrl: 'app/components/global/outroutes/outrouteListView.html',
				data: {
					pageTitle: 'Routes',
				},
				controller: 'OutrouteListController',
				controllerAs: 'outrouteList',
			})
			.lazyLoadedState('index.global.outroutes-edit', {
				url: '/global/outroutes/edit/?id',
				templateUrl: 'app/components/global/outroutes/editOutrouteView.html',
				data: {
					pageTitle: 'Edit route',
				},
				controller: 'EditOutrouteController',
				controllerAs: 'editOutroute',
			})
			.lazyLoadedState('index.global.outroutes-new', {
				url: '/global/outroutes/new/',
				params: {
					id: '0',
				},
				templateUrl: 'app/components/global/outroutes/editOutrouteView.html',
				data: {
					pageTitle: 'New route',
				},
				controller: 'EditOutrouteController',
				controllerAs: 'editOutroute',
			})
			.lazyLoadedState('index.global.outroutes-bulk-edit', {
				url: '/global/outroutes/bulk/edit/',
				templateUrl: 'app/components/global/outroutes/bulk/bulkChangeOutroutesView.html',
				data: {
					pageTitle: 'Bulk change routes',
				},
				controller: 'BulkChangeOutroutesController',
				controllerAs: 'bulkOutroutes',
			})
			.lazyLoadedState('index.global.outroutes-help', {
				url: '/global/outroutes/help/?name',
				params: {
					name: 'help_outroutes_body',
				},
				templateUrl: 'app/components/help/documentation/helpDocumentationViewView.html',
				data: {
					pageTitle: 'Help for Routes',
				},
				controller: 'HelpDocumentationViewController',
				controllerAs: 'helpView',
			})

			/** Users */

			.lazyLoadedState('index.users', {
				abstract: true,
				template: '<div ui-view></div>',
				data: {
					pageTitle: 'Accounts and users',
				},
			})

			.lazyLoadedState('index.users.add', {
				url: '/users/add/',
				templateUrl: 'app/components/users/add/addUserView.html',
				data: {
					pageTitle: 'Create user',
				},
				controller: 'AddUserController',
				controllerAs: 'addUser',
			})
			.lazyLoadedState('index.users.add-help', {
				url: '/users/add/help/?name',
				params: {
					name: 'help_add_body',
				},
				templateUrl: 'app/components/help/documentation/helpDocumentationViewView.html',
				data: {
					pageTitle: 'Help for Add user with features',
				},
				controller: 'HelpDocumentationViewController',
				controllerAs: 'helpView',
			})

			.lazyLoadedState('index.users.import', {
				url: '/users/import/',
				templateUrl: 'app/components/users/import/importUsersView.html',
				data: {
					pageTitle: 'Import users and features',
				},
				controller: 'ImportUsersController',
				controllerAs: 'importUsers',
			})
			.lazyLoadedState('index.users.import-help', {
				url: '/users/import/help/?name',
				params: {
					name: 'help_import_body',
				},
				templateUrl: 'app/components/help/documentation/helpDocumentationViewView.html',
				data: {
					pageTitle: 'Help for Import users',
				},
				controller: 'HelpDocumentationViewController',
				controllerAs: 'helpView',
			})

			.lazyLoadedState('index.users.user-switch', {
				url: '/user/switch/?username',
				templateUrl: 'app/components/users/switch/userSwitchView.html',
				controller: 'UserSwitchController',
				controllerAs: 'userSwitch',
			})

			.lazyLoadedState('index.users.users-list', {
				url: '/users/users/list/?customer&offset&sort&descending',
				params: {
					customer: '',
					offset: '',
					sort: '',
					descending: '',
				},
				templateUrl: 'app/components/users/users/peopleListView.html',
				data: {
					pageTitle: 'Users',
				},
				controller: 'PeopleListController',
				controllerAs: 'peopleList',
			})
			.lazyLoadedState('index.users.users-edit', {
				url: '/users/users/edit/?id&username',
				params: {
					username: '',
				},
				templateUrl: 'app/components/users/users/editPeopleView.html',
				data: {
					pageTitle: 'Edit user',
				},
				controller: 'EditPeopleController',
				controllerAs: 'editPeople',
			})
			.lazyLoadedState('index.users.users-new', {
				url: '/users/users/new/?customer',
				params: {
					id: '',
					username: '',
					customer: '',
				},
				templateUrl: 'app/components/users/users/editPeopleView.html',
				data: {
					pageTitle: 'New user',
				},
				controller: 'EditPeopleController',
				controllerAs: 'editPeople',
			})
			.lazyLoadedState('index.users.users-help', {
				url: '/users/users/help/?name',
				params: {
					name: 'help_users_body',
				},
				templateUrl: 'app/components/help/documentation/helpDocumentationViewView.html',
				data: {
					pageTitle: 'Help for Users',
				},
				controller: 'HelpDocumentationViewController',
				controllerAs: 'helpView',
			})
			.lazyLoadedState('index.users.users-notes', {
				url: '/users/users/notes/list/?snumber',
				params: {
					stype: 'people',
				},
				templateUrl: 'app/components/utils/notesListView.html',
				data: {
					pageTitle: 'Notes',
				},
				controller: 'NotesListController',
				controllerAs: 'notesList',
			})

			.lazyLoadedState('index.users.commerce', {
				url: '/users/commerce/',
				templateUrl: 'app/components/users/commerce/commerceSettingsView.html',
				data: {
					pageTitle: 'Commerce settings',
				},
				controller: 'CommerceSettingsController',
				controllerAs: 'commerceSettings',
			})
			.lazyLoadedState('index.users.commerce-help', {
				url: '/users/commerce/help/?name',
				params: {
					name: 'help_users_commerce_body',
				},
				templateUrl: 'app/components/help/documentation/helpDocumentationViewView.html',
				data: {
					pageTitle: 'Help for User commerce settings',
				},
				controller: 'HelpDocumentationViewController',
				controllerAs: 'helpView',
			})
			.lazyLoadedState('index.users.customer', {
				url: '/users/customer/',
				templateUrl: 'app/components/users/customer/customerSettingsView.html',
				data: {
					pageTitle: 'Customer settings',
				},
				controller: 'CustomerSettingsController',
				controllerAs: 'customerSettings',
			})
			.lazyLoadedState('index.users.customer-help', {
				url: '/users/customer/help/?name',
				params: {
					name: 'help_users_customer_body',
				},
				templateUrl: 'app/components/help/documentation/helpDocumentationViewView.html',
				data: {
					pageTitle: 'Help for User customer settings',
				},
				controller: 'HelpDocumentationViewController',
				controllerAs: 'helpView',
			})
			.lazyLoadedState('index.users.payment', {
				url: '/users/payment/',
				templateUrl: 'app/components/users/payment/paymentSettingsView.html',
				data: {
					pageTitle: 'Payment settings',
				},
				controller: 'PaymentSettingsController',
				controllerAs: 'paymentSettings',
			})
			.lazyLoadedState('index.users.payment-topup', {
				url: '/users/payment/topup/',
				templateUrl: 'app/components/users/payment/topup/editTopupView.html',
				data: {
					pageTitle: 'Top up account',
				},
				controller: 'EditTopupController',
				controllerAs: 'editTopup',
			})
			.lazyLoadedState('index.users.payment-topup-creditcard', {
				url: '/users/payment/topup/confirm/creditcard/?amount&amount_ex_tax&invoice',
				params: {
					method: 'creditcard',
					invoice: '',
					amount: '0.00',
					amount_ex_tax: '0.00',
				},
				templateUrl: 'app/components/users/payment/topup/confirm/confirmCreditcardView.html',
				data: {
					pageTitle: 'Confirm payment',
				},
				controller: 'ConfirmPaymentController',
				controllerAs: 'confirmCreditcard',
			})
			.lazyLoadedState('index.users.payment-topup-paypal', {
				url: '/users/payment/topup/confirm/paypal/?amount&amount_ex_tax',
				params: {
					method: 'paypal',
					amount: '0.00',
					amount_ex_tax: '0.00',
				},
				templateUrl: 'app/components/users/payment/topup/confirm/confirmPaypalView.html',
				data: {
					pageTitle: 'Confirm payment',
				},
				controller: 'ConfirmPaymentController',
				controllerAs: 'confirmPaypal',
			})
			.lazyLoadedState('index.users.payment-topup-google_checkout', {
				url: '/users/payment/topup/confirm/google_checkout/?amount&amount_ex_tax',
				params: {
					method: 'google_checkout',
					amount: '0.00',
					amount_ex_tax: '0.00',
				},
				templateUrl: 'app/components/users/payment/topup/confirm/confirmGoogleCheckoutView.html',
				data: {
					pageTitle: 'Confirm payment',
				},
				controller: 'ConfirmPaymentController',
				controllerAs: 'confirmGoogleCheckout',
			})
			.lazyLoadedState('index.users.payment-voucher', {
				url: '/users/payment/voucher/',
				templateUrl: 'app/components/users/payment/topup/voucher/voucherTopupView.html',
				data: {
					pageTitle: 'Top up using voucher',
				},
				controller: 'VoucherTopupController',
				controllerAs: 'voucherTopup',
			})
			.lazyLoadedState('index.users.payment-help', {
				url: '/users/payment/help/?name',
				params: {
					name: 'help_users_payment_body',
				},
				templateUrl: 'app/components/help/documentation/helpDocumentationViewView.html',
				data: {
					pageTitle: 'Help for Users payment settings',
				},
				controller: 'HelpDocumentationViewController',
				controllerAs: 'helpView',
			})
			.lazyLoadedState('index.users.passwords', {
				url: '/users/passwords/',
				templateUrl: 'app/components/users/password/passwordSettingsView.html',
				data: {
					pageTitle: 'Password',
				},
				controller: 'PasswordSettingsController',
				controllerAs: 'passwordSettings',
			})

			/** Customers */

			.lazyLoadedState('index.customers', {
				abstract: true,
				template: '<div ui-view></div>',
				data: {
					pageTitle: 'Customers',
				},
			})

			.lazyLoadedState('index.customers.callshop-list', {
				url: '/customers/callshop/list/',
				templateUrl: 'app/components/customers/callshop/callshopListView.html',
				data: {
					pageTitle: 'Call shop telephones',
				},
				controller: 'CallshopListController',
				controllerAs: 'callshopList',
			})
			.lazyLoadedState('index.customers.callshop-edit', {
				url: '/customers/callshop/edit/?id',
				templateUrl: 'app/components/customers/callshop/editCallshopView.html',
				data: {
					pageTitle: 'Edit call shop telephone',
				},
				controller: 'EditCallshopController',
				controllerAs: 'editCallshop',
			})
			.lazyLoadedState('index.customers.callshop-new', {
				url: '/customers/callshop/new/',
				templateUrl: 'app/components/customers/callshop/newCallshopView.html',
				data: {
					pageTitle: 'New call shop telephones',
				},
				controller: 'NewCallshopController',
				controllerAs: 'callshop',
			})
			.lazyLoadedState('index.customers.callshop-help', {
				url: '/customers/callshop/help/?name',
				params: {
					name: 'help_callshop_body',
				},
				templateUrl: 'app/components/help/documentation/helpDocumentationViewView.html',
				data: {
					pageTitle: 'Help for Call shop',
				},
				controller: 'HelpDocumentationViewController',
				controllerAs: 'helpView',
			})

			.lazyLoadedState('index.customers.cards-list', {
				url: '/customers/cards/list/?cardgroup?batch?offset',
				params: {
					cardgroup: '',
					batch: '',
					offset: '',
					sort: '',
					descending: '',
				},
				templateUrl: 'app/components/customers/cards/cardListView.html',
				data: {
					pageTitle: 'Cards listing',
				},
				controller: 'CardListController',
				controllerAs: 'cardList',
			})
			.lazyLoadedState('index.customers.cards-edit', {
				url: '/customers/cards/edit/?card',
				templateUrl: 'app/components/customers/cards/editCardView.html',
				data: {
					pageTitle: 'Edit calling card',
				},
				controller: 'EditCardController',
				controllerAs: 'editCard',
			})
			.lazyLoadedState('index.customers.cards-usage', {
				url: '/customers/cards/usage/?cardgroup&batch',
				params: {
					cardgroup: '',
					batch: '',
				},
				templateUrl: 'app/components/customers/cards/usage/cardUsageView.html',
				data: {
					pageTitle: 'Card usage statistics',
				},
				controller: 'CardUsageController',
				controllerAs: 'cardUsage',
			})
			// @TODO: fix breadcrumb
			.lazyLoadedState('index.customers.cards-batches-list', {
				url: '/customers/cards/batches/list/?cardgroup',
				templateUrl: 'app/components/customers/cards/batches/batchListView.html',
				data: {
					pageTitle: 'Calling card batches',
				},
				controller: 'BatchListController',
				controllerAs: 'batchList',
			})
			.lazyLoadedState('index.customers.cards-batches-edit', {
				url: '/customers/cards/batches/edit/?id&cardgroup',
				params: {
					cardgroup: '0',
				},
				templateUrl: 'app/components/customers/cards/batches/editBatchView.html',
				data: {
					pageTitle: 'Edit calling card batch',
				},
				controller: 'EditBatchController',
				controllerAs: 'editBatch',
			})
			.lazyLoadedState('index.customers.cards-batches-new', {
				url: '/customers/cards/batches/new/?cardgroup',
				templateUrl: 'app/components/customers/cards/batches/newBatchView.html',
				data: {
					pageTitle: 'New calling card batch',
				},
				controller: 'NewBatchController',
				controllerAs: 'newBatch',
			})
			.lazyLoadedState('index.customers.cards-groups-list', {
				url: '/customers/cards/groups/list/',
				templateUrl: 'app/components/customers/cards/groups/cardgroupListView.html',
				data: {
					pageTitle: 'Calling cards',
				},
				controller: 'CardgroupListController',
				controllerAs: 'cardgroupList',
			})
			.lazyLoadedState('index.customers.cards-groups-edit', {
				url: '/customers/cards/groups/edit/?id',
				templateUrl: 'app/components/customers/cards/groups/editCardgroupView.html',
				data: {
					pageTitle: 'Edit calling card group',
				},
				controller: 'EditCardgroupController',
				controllerAs: 'editCardgroup',
			})
			.lazyLoadedState('index.customers.cards-groups-new', {
				url: '/customers/cards/groups/new/',
				params: {
					id: 0,
				},
				templateUrl: 'app/components/customers/cards/groups/editCardgroupView.html',
				data: {
					pageTitle: 'New calling card group',
				},
				controller: 'EditCardgroupController',
				controllerAs: 'editCardgroup',
			})
			.lazyLoadedState('index.customers.cards-groups-notes', {
				url: '/customers/cards/groups/notes/list/?snumber',
				params: {
					stype: 'cardgroup',
				},
				templateUrl: 'app/components/utils/notesListView.html',
				data: {
					pageTitle: 'Notes',
				},
				controller: 'NotesListController',
				controllerAs: 'notesList',
			})
			.lazyLoadedState('index.customers.cards-help', {
				url: '/customers/cards/help/?name',
				params: {
					name: 'help_cards_groups_body',
				},
				templateUrl: 'app/components/help/documentation/helpDocumentationViewView.html',
				data: {
					pageTitle: 'Help for Calling cards',
				},
				controller: 'HelpDocumentationViewController',
				controllerAs: 'helpView',
			})

			.lazyLoadedState('index.customers.customers-list', {
				url: '/customers/customers/list/?offset&name&sort&descending',
				params: {
					offset: '',
					name: '',
					deleted: null,
					own: '1',
					sort: '',
					descending: '',
				},
				templateUrl: 'app/components/customers/customers/customersView.html',
				data: {
					pageTitle: 'Customers',
				},
				controller: 'CustomersController',
				controllerAs: 'customers',
			})
			.lazyLoadedState('index.customers.customers-edit', {
				url: '/customers/customers/edit/?id&interface&number&port&class&classnumber&ingroup',
				params: {
					interface: '',
					number: '',
					port: '',
					class: '',
					classnumber: '',
					ingroup: '',
				},
				templateUrl: 'app/components/customers/customers/editCustomerView.html',
				data: {
					pageTitle: 'Edit customer',
				},
				controller: 'EditCustomerController',
				controllerAs: 'editCustomer',
			})
			.lazyLoadedState('index.customers.customers-new', {
				url: '/customers/customers/new/',
				templateUrl: 'app/components/customers/customers/new/newCustomerView.html',
				data: {
					pageTitle: 'New customer',
				},
				controller: 'NewCustomerController',
				controllerAs: 'newCustomer',
			})
			.lazyLoadedState('index.customers.customers-ingroup', {
				url: '/customers/customers/ingroup/',
				templateUrl: 'app/components/customers/customers/ingroup/customerNumberTypeView.html',
				data: {
					pageTitle: 'Choose type of number',
				},
				controller: 'CustomerNumberTypeController',
				controllerAs: 'custNumType',
			})
			.lazyLoadedState('index.customers.customers-choose', {
				url: '/customers/customers/choose/?ingroup&code',
				params: {
					ingroup: '0',
					code: '0',
				},
				templateUrl: 'app/components/customers/customers/choose/chooseCustomerNumberView.html',
				data: {
					pageTitle: 'Choose number',
				},
				controller: 'ChooseCustomerNumberController',
				controllerAs: 'customerNumber',
			})
			.lazyLoadedState('index.customers.customers-lines-new', {
				url: '/customers/customers/lines/new/?customer',
				templateUrl: 'app/components/customers/customers/lines/new/lineNumberTypeView.html',
				data: {
					pageTitle: 'Choose type of number',
				},
				controller: 'LineNumberTypeController',
				controllerAs: 'lineNumType',
			})
			.lazyLoadedState('index.customers.customers-lines-choose', {
				url: '/customers/customers/lines/choose/?customer&ingroup&code',
				params: {
					customer: '0',
					ingroup: '0',
					code: '0',
				},
				templateUrl: 'app/components/customers/customers/lines/choose/chooseLineNumberView.html',
				data: {
					pageTitle: 'Choose number',
				},
				controller: 'ChooseLineNumberController',
				controllerAs: 'lineNumber',
			})
			.lazyLoadedState('index.customers.customers-balance', {
				url: '/customers/customers/balance/?id',
				params: {
					id: '0',
				},
				templateUrl: 'app/components/customers/customers/balance/addBalanceView.html',
				data: {
					pageTitle: "Add to customer's balance",
				},
				controller: 'AddBalanceController',
				controllerAs: 'addBalance',
			})
			.lazyLoadedState('index.customers.customers-charges-list', {
				url: '/customers/customers/charges/list/?customer',
				params: {
					customer: '0',
				},
				templateUrl: 'app/components/customers/customers/charges/chargeListView.html',
				data: {
					pageTitle: 'Customer charges',
				},
				controller: 'ChargeListController',
				controllerAs: 'chargeList',
			})
			.lazyLoadedState('index.customers.customers-charges-edit', {
				url: '/customers/customers/charges/edit/?id',
				params: {
					customer: '0',
				},
				templateUrl: 'app/components/customers/customers/charges/editChargeView.html',
				data: {
					pageTitle: 'Edit charge',
				},
				controller: 'EditChargeController',
				controllerAs: 'editCharge',
			})
			.lazyLoadedState('index.customers.customers-charges-new', {
				url: '/customers/customers/charges/new/?customer',
				params: {
					id: '0',
				},
				templateUrl: 'app/components/customers/customers/charges/editChargeView.html',
				data: {
					pageTitle: 'New charge',
				},
				controller: 'EditChargeController',
				controllerAs: 'editCharge',
			})
			.lazyLoadedState('index.customers.customers-invoice-edit', {
				url: '/customers/customers/invoice/edit/?id',
				templateUrl: 'app/components/customers/customers/invoice/createInvoiceView.html',
				data: {
					pageTitle: 'Create invoice',
				},
				controller: 'CreateInvoiceController',
				controllerAs: 'createInvoice',
			})
			.lazyLoadedState('index.customers.customers-payment-view', {
				url: '/customers/customers/payment/view/?id',
				templateUrl: 'app/components/customers/customers/payment/viewPaymentView.html',
				data: {
					pageTitle: 'Payment details',
				},
				controller: 'ViewPaymentController',
				controllerAs: 'viewPayment',
			})
			.lazyLoadedState('index.customers.customers-time-edit', {
				url: '/customers/customers/time/edit/?id',
				templateUrl: 'app/components/customers/customers/time/addTimeView.html',
				data: {
					pageTitle: "Add to customer's call time",
				},
				controller: 'AddTimeController',
				controllerAs: 'addTime',
			})
			.lazyLoadedState('index.customers.customers-help', {
				url: '/customers/customers/help/?name',
				params: {
					name: 'help_customers_body',
				},
				templateUrl: 'app/components/help/documentation/helpDocumentationViewView.html',
				data: {
					pageTitle: 'Help for Customers',
				},
				controller: 'HelpDocumentationViewController',
				controllerAs: 'helpView',
			})
			.lazyLoadedState('index.customers.customers-notes', {
				url: '/customers/customers/notes/list/?snumber',
				params: {
					stype: 'customer',
				},
				templateUrl: 'app/components/utils/notesListView.html',
				data: {
					pageTitle: 'Notes',
				},
				controller: 'NotesListController',
				controllerAs: 'notesList',
			})
			.lazyLoadedState('index.customers.customers-export-edit', {
				url: '/customers/customers/export/edit/',
				templateUrl: 'app/components/customers/customers/time/addTimeView.html',
				data: {
					pageTitle: "Add to customer's call time",
				},
				controller: 'AddTimeController',
				controllerAs: 'addTime',
			})

			.lazyLoadedState('index.customers.plans-list', {
				url: '/customers/plans/list/?offset&name&sort&descending',
				params: {
					offset: '',
					name: '',
					sort: '',
					descending: '',
				},
				templateUrl: 'app/components/customers/plans/planListView.html',
				data: {
					pageTitle: 'Rate plans',
				},
				controller: 'PlanListController',
				controllerAs: 'planList',
			})
			.lazyLoadedState('index.customers.plans-edit', {
				url: '/customers/plans/edit/?id',
				params: {
					id: '0',
				},
				templateUrl: 'app/components/customers/plans/editPlanView.html',
				data: {
					pageTitle: 'Edit rate plan',
				},
				controller: 'EditPlanController',
				controllerAs: 'editPlan',
			})
			.lazyLoadedState('index.customers.plans-new', {
				url: '/customers/plans/new/',
				params: {
					id: '0',
				},
				templateUrl: 'app/components/customers/plans/editPlanView.html',
				data: {
					pageTitle: 'New rate plan',
				},
				controller: 'EditPlanController',
				controllerAs: 'editPlan',
			})
			.lazyLoadedState('index.customers.plans-charges-list', {
				url: '/customers/plans/charges/list/?plan',
				params: {
					plan: '0',
				},
				templateUrl: 'app/components/customers/plans/charges/planChargesView.html',
				data: {
					pageTitle: 'Customer charges',
				},
				controller: 'PlanChargesController',
				controllerAs: 'planCharges',
			})
			.lazyLoadedState('index.customers.plans-charges-edit', {
				url: '/customers/plans/charges/edit/?id',
				params: {
					plan: '0',
				},
				templateUrl: 'app/components/customers/plans/charges/editPlanChargeView.html',
				data: {
					pageTitle: 'Edit charge',
				},
				controller: 'EditPlanChargeController',
				controllerAs: 'editPlanCharge',
			})
			.lazyLoadedState('index.customers.plans-charges-new', {
				url: '/customers/plans/charges/new/?plan',
				params: {
					id: '0',
				},
				templateUrl: 'app/components/customers/plans/charges/editPlanChargeView.html',
				data: {
					pageTitle: 'New charge',
				},
				controller: 'EditPlanChargeController',
				controllerAs: 'editPlanCharge',
			})
			.lazyLoadedState('index.customers.plans-classes-list', {
				url: '/customers/plans/classes/list/?plan',
				params: {
					plan: '0',
				},
				templateUrl: 'app/components/customers/plans/classes/classListView.html',
				data: {
					pageTitle: 'Number classes',
				},
				controller: 'ClassListController',
				controllerAs: 'classList',
			})
			.lazyLoadedState('index.customers.plans-classes-edit', {
				url: '/customers/plans/classes/edit/?id',
				params: {
					plan: '0',
				},
				templateUrl: 'app/components/customers/plans/classes/editPlanClassView.html',
				data: {
					pageTitle: 'Edit number class',
				},
				controller: 'EditPlanClassController',
				controllerAs: 'editPlanClass',
			})
			.lazyLoadedState('index.customers.plans-classes-new', {
				url: '/customers/plans/classes/new/?plan',
				params: {
					id: '0',
				},
				templateUrl: 'app/components/customers/plans/classes/editPlanClassView.html',
				data: {
					pageTitle: 'New number class',
				},
				controller: 'EditPlanClassController',
				controllerAs: 'editPlanClass',
			})
			.lazyLoadedState('index.customers.plans-customs-list', {
				url: '/customers/plans/customs/list/?plan',
				params: {
					plan: '0',
				},
				templateUrl: 'app/components/customers/plans/customs/ratePlanCustomsView.html',
				data: {
					pageTitle: 'Custom settings',
				},
				controller: 'RatePlanCustomsController',
				controllerAs: 'customs',
			})
			.lazyLoadedState('index.customers.plans-customs-edit', {
				url: '/customers/plans/customs/edit/?plan?name?language?min_level?max_level?new',
				params: {
					plan: '0',
					new: '0',
				},
				templateUrl: 'app/components/customers/plans/customs/editCustomView.html',
				data: {
					pageTitle: 'Edit custom setting',
				},
				controller: 'EditCustomController',
				controllerAs: 'editCustom',
			})
			.lazyLoadedState('index.customers.plans-features-edit', {
				url: '/customers/plans/features/edit/?plan',
				params: {
					plan: '0',
				},
				templateUrl: 'app/components/customers/plans/features/planFeaturesView.html',
				data: {
					pageTitle: 'Edit features',
				},
				controller: 'PlanFeaturesController',
				controllerAs: 'planFeatures',
			})
			.lazyLoadedState('index.customers.plans-fees-edit', {
				url: '/customers/plans/fees/edit/?plan',
				params: {
					plan: '0',
				},
				templateUrl: 'app/components/customers/plans/fees/planFeesView.html',
				data: {
					pageTitle: 'Edit fees',
				},
				controller: 'PlanFeesController',
				controllerAs: 'planFees',
			})
			.lazyLoadedState('index.customers.plans-incosts-list', {
				url: '/customers/plans/incosts/list/?plan&offset&sort&descending',
				params: {
					plan: '0',
					offset: '',
					sort: '',
					descending: '',
				},
				templateUrl: 'app/components/customers/plans/incosts/incostListView.html',
				data: {
					pageTitle: 'Inbound call costs exceptions',
				},
				controller: 'IncostListController',
				controllerAs: 'incostList',
			})
			.lazyLoadedState('index.customers.plans-incosts-edit', {
				url: '/customers/plans/incosts/edit/?plan?id',
				params: {
					plan: '0',
				},
				templateUrl: 'app/components/customers/plans/incosts/editIncostView.html',
				data: {
					pageTitle: 'Edit inbound exception',
				},
				controller: 'EditIncostController',
				controllerAs: 'editIncost',
			})
			.lazyLoadedState('index.customers.plans-incosts-new', {
				url: '/customers/plans/incosts/new/?plan',
				params: {
					id: '0',
				},
				templateUrl: 'app/components/customers/plans/incosts/editIncostView.html',
				data: {
					pageTitle: 'New inbound exception',
				},
				controller: 'EditIncostController',
				controllerAs: 'editIncost',
			})
			.lazyLoadedState('index.customers.plans-ingroups-list', {
				url: '/customers/plans/ingroups/list/?plan',
				params: {
					plan: '0',
				},
				templateUrl: 'app/components/customers/plans/ingroups/ingroupListView.html',
				data: {
					pageTitle: 'Inbound included call time exceptions',
				},
				controller: 'IngroupListController',
				controllerAs: 'ingroupList',
			})
			.lazyLoadedState('index.customers.plans-ingroups-edit', {
				url: '/customers/plans/ingroups/edit/?plan?ingroup',
				params: {
					plan: '0',
				},
				templateUrl: 'app/components/customers/plans/ingroups/editIngroupView.html',
				data: {
					pageTitle: 'Edit exception',
				},
				controller: 'EditIngroupController',
				controllerAs: 'editIngroup',
			})
			.lazyLoadedState('index.customers.plans-ingroups-new', {
				url: '/customers/plans/ingroups/new/?plan',
				params: {
					ingroup: '0',
				},
				templateUrl: 'app/components/customers/plans/ingroups/editIngroupView.html',
				data: {
					pageTitle: 'New exception',
				},
				controller: 'EditIngroupController',
				controllerAs: 'editIngroup',
			})
			.lazyLoadedState('index.customers.plans-outcosts-list', {
				url: '/customers/plans/outcosts/list/?plan&offset&sort&descending',
				params: {
					plan: '0',
					offset: '',
					sort: '',
					descending: '',
				},
				templateUrl: 'app/components/customers/plans/outcosts/outcostListView.html',
				data: {
					pageTitle: 'Outbound call costs exceptions',
				},
				controller: 'OutcostListController',
				controllerAs: 'outcostList',
			})
			.lazyLoadedState('index.customers.plans-outcosts-edit', {
				url: '/customers/plans/outcosts/edit/?plan&id',
				params: {
					plan: '0',
					id: '0',
				},
				templateUrl: 'app/components/customers/plans/outcosts/editOutcostView.html',
				data: {
					pageTitle: 'Edit outbound exception',
				},
				controller: 'EditOutcostController',
				controllerAs: 'editOutcost',
			})
			.lazyLoadedState('index.customers.plans-outcosts-new', {
				url: '/customers/plans/outcosts/new/?plan',
				params: {
					id: '0',
				},
				templateUrl: 'app/components/customers/plans/outcosts/editOutcostView.html',
				data: {
					pageTitle: 'New outbound exception',
				},
				controller: 'EditOutcostController',
				controllerAs: 'editOutcost',
			})
			.lazyLoadedState('index.customers.plans-outgroups-list', {
				url: '/customers/plans/outgroups/list/?plan',
				params: {
					plan: '0',
				},
				templateUrl: 'app/components/customers/plans/outgroups/outgroupListView.html',
				data: {
					pageTitle: 'Outbound included call time exceptions',
				},
				controller: 'OutgroupListController',
				controllerAs: 'outgroupList',
			})
			.lazyLoadedState('index.customers.plans-outgroups-edit', {
				url: '/customers/plans/outgroups/edit/?plan?outgroup',
				params: {
					plan: '0',
				},
				templateUrl: 'app/components/customers/plans/outgroups/editOutgroupView.html',
				data: {
					pageTitle: 'Edit exception',
				},
				controller: 'EditOutgroupController',
				controllerAs: 'editOutgroup',
			})
			.lazyLoadedState('index.customers.plans-outgroups-new', {
				url: '/customers/plans/outgroups/new/?plan',
				params: {
					outgroup: '0',
				},
				templateUrl: 'app/components/customers/plans/outgroups/editOutgroupView.html',
				data: {
					pageTitle: 'New exception',
				},
				controller: 'EditOutgroupController',
				controllerAs: 'editOutgroup',
			})
			.lazyLoadedState('index.customers.plans-products-list', {
				url: '/customers/plans/products/list/?plan',
				params: {
					plan: '0',
				},
				templateUrl: 'app/components/customers/plans/products/planProductListView.html',
				data: {
					pageTitle: 'Product cost exceptions',
				},
				controller: 'PlanProductListController',
				controllerAs: 'planProducts',
			})
			.lazyLoadedState('index.customers.plans-products-edit', {
				url: '/customers/plans/products/edit/?plan?product',
				params: {
					plan: '0',
				},
				templateUrl: 'app/components/customers/plans/products/editPlanProductView.html',
				data: {
					pageTitle: 'Edit product cost exception',
				},
				controller: 'EditPlanProductController',
				controllerAs: 'editPlanProduct',
			})
			.lazyLoadedState('index.customers.plans-products-new', {
				url: '/customers/plans/products/new/?plan',
				params: {
					product: '0',
				},
				templateUrl: 'app/components/customers/plans/products/editPlanProductView.html',
				data: {
					pageTitle: 'New product cost exception',
				},
				controller: 'EditPlanProductController',
				controllerAs: 'editPlanProduct',
			})
			.lazyLoadedState('index.customers.plans-routes-list', {
				url: '/customers/plans/routes/list/?plan&offset&sort&descending',
				params: {
					plan: '0',
					offset: '',
					sort: '',
					descending: '',
				},
				templateUrl: 'app/components/customers/plans/routes/planRouteListView.html',
				data: {
					pageTitle: 'Routes',
				},
				controller: 'PlanRouteListController',
				controllerAs: 'planRoutes',
			})
			.lazyLoadedState('index.customers.plans-routes-edit', {
				url: '/customers/plans/routes/edit/?plan?prefix?media',
				params: {
					plan: '0',
				},
				templateUrl: 'app/components/customers/plans/routes/editPlanRouteView.html',
				data: {
					pageTitle: 'Edit route',
				},
				controller: 'EditPlanRouteController',
				controllerAs: 'editPlanRoute',
			})
			.lazyLoadedState('index.customers.plans-routes-new', {
				url: '/customers/plans/routes/new/?plan',
				params: {
					prefix: '',
					media: '',
				},
				templateUrl: 'app/components/customers/plans/routes/editPlanRouteView.html',
				data: {
					pageTitle: 'New route',
				},
				controller: 'EditPlanRouteController',
				controllerAs: 'editPlanRoute',
			})
			.lazyLoadedState('index.customers.plans-routes-bulk-edit', {
				url: '/customers/plans/routes/bulk/edit/?plan',
				params: {
					plan: '0',
				},
				templateUrl: 'app/components/customers/plans/routes/bulk/bulkPlanRoutesView.html',
				data: {
					pageTitle: 'Bulk change routes',
				},
				controller: 'BulkPlanRoutesController',
				controllerAs: 'bulkPlanRoutes',
			})
			.lazyLoadedState('index.customers.plans-help', {
				url: '/customers/plans/help/?name',
				params: {
					name: 'help_plans_body',
				},
				templateUrl: 'app/components/help/documentation/helpDocumentationViewView.html',
				data: {
					pageTitle: 'Help for Rate plans',
				},
				controller: 'HelpDocumentationViewController',
				controllerAs: 'helpView',
			})
			.lazyLoadedState('index.customers.plans-notes', {
				url: '/customers/plans/notes/list/?snumber',
				params: {
					stype: 'plan',
				},
				templateUrl: 'app/components/utils/notesListView.html',
				data: {
					pageTitle: 'Notes',
				},
				controller: 'NotesListController',
				controllerAs: 'notesList',
			})

			.lazyLoadedState('index.customers.requests-list', {
				url: '/customers/requests/list/',
				templateUrl: 'app/components/customers/requests/requestListView.html',
				data: {
					pageTitle: 'Requests',
				},
				controller: 'RequestListController',
				controllerAs: 'requestList',
			})
			.lazyLoadedState('index.customers.requests-edit', {
				url: '/customers/requests/edit/?id',
				templateUrl: 'app/components/customers/requests/editRequestView.html',
				data: {
					pageTitle: 'Edit request',
				},
				controller: 'EditRequestController',
				controllerAs: 'editRequest',
			})
			.lazyLoadedState('index.customers.requests-help', {
				url: '/customers/requests/help/?name',
				params: {
					name: 'help_requests_body',
				},
				templateUrl: 'app/components/help/documentation/helpDocumentationViewView.html',
				data: {
					pageTitle: 'Help for Requests',
				},
				controller: 'HelpDocumentationViewController',
				controllerAs: 'helpView',
			})

			.lazyLoadedState('index.customers.search-list', {
				url: '/customers/search/list/?search&match&name&role',
				params: {
					search: '',
					match: '',
					role: '',
					name: '',
				},
				templateUrl: 'app/components/customers/search/searchListView.html',
				data: {
					pageTitle: 'Search',
				},
				controller: 'SearchListController',
				controllerAs: 'searchList',
			})
			.lazyLoadedState('index.customers.search-help', {
				url: '/customers/search/help/?name',
				params: {
					name: 'help_customers_search_body',
				},
				templateUrl: 'app/components/help/documentation/helpDocumentationViewView.html',
				data: {
					pageTitle: 'Help for Customers search',
				},
				controller: 'HelpDocumentationViewController',
				controllerAs: 'helpView',
			})

			.lazyLoadedState('index.customers.support-list', {
				url: '/customers/support/list/?customer&status&search&sort&descending&offset',
				params: {
					customer: '',
					status: '',
					search: '',
					sort: '',
					descending: '',
					offset: '',
				},
				templateUrl: 'app/components/customers/support/commerceSupportView.html',
				data: {
					pageTitle: 'Support',
				},
				controller: 'CommerceSupportController',
				controllerAs: 'commerceSupport',
			})
			.lazyLoadedState('index.customers.support-ticket', {
				url: '/customers/support/ticket/?id',
				params: {
					id: '',
				},
				templateUrl: 'app/components/customers/support/commerceTicketView.html',
				data: {
					pageTitle: 'View ticket',
				},
				controller: 'CommerceTicketController',
				controllerAs: 'commerceTicket',
			})
			.lazyLoadedState('index.customers.support-help', {
				url: '/customers/support/help/?name',
				params: {
					name: 'help_support_body',
				},
				templateUrl: 'app/components/help/documentation/helpDocumentationViewView.html',
				data: {
					pageTitle: 'Help for Support',
				},
				controller: 'HelpDocumentationViewController',
				controllerAs: 'helpView',
			})

			.lazyLoadedState('index.customers.taxes-list', {
				url: '/customers/taxes/list/',
				templateUrl: 'app/components/customers/taxes/taxListView.html',
				data: {
					pageTitle: 'Taxes',
				},
				controller: 'TaxListController',
				controllerAs: 'taxList',
			})
			.lazyLoadedState('index.customers.taxes-edit', {
				url: '/customers/taxes/edit/?id',
				params: {
					id: '0',
				},
				templateUrl: 'app/components/customers/taxes/editTaxView.html',
				data: {
					pageTitle: 'Edit tax',
				},
				controller: 'EditTaxController',
				controllerAs: 'editTax',
			})
			.lazyLoadedState('index.customers.taxes-new', {
				url: '/customers/taxes/new/',
				params: {
					id: '0',
				},
				templateUrl: 'app/components/customers/taxes/editTaxView.html',
				data: {
					pageTitle: 'New tax',
				},
				controller: 'EditTaxController',
				controllerAs: 'editTax',
			})
			.lazyLoadedState('index.customers.taxes-help', {
				url: '/customers/taxes/help/?name',
				params: {
					name: 'help_taxes_body',
				},
				templateUrl: 'app/components/help/documentation/helpDocumentationViewView.html',
				data: {
					pageTitle: 'Help for Taxes',
				},
				controller: 'HelpDocumentationViewController',
				controllerAs: 'helpView',
			})

			.lazyLoadedState('index.customers.unlimited-list', {
				url: '/customers/unlimited/list/',
				templateUrl: 'app/components/customers/unlimited/unlimitedListView.html',
				data: {
					pageTitle: 'Unlimited access numbers',
				},
				controller: 'UnlimitedListController',
				controllerAs: 'unlimitedList',
			})
			.lazyLoadedState('index.customers.unlimited-edit', {
				url: '/customers/unlimited/edit/?id',
				params: {
					id: '0',
				},
				templateUrl: 'app/components/customers/unlimited/editUnlimitedView.html',
				data: {
					pageTitle: 'Edit unlimited access number',
				},
				controller: 'EditUnlimitedController',
				controllerAs: 'editUnlimited',
			})
			.lazyLoadedState('index.customers.unlimited-new', {
				url: '/customers/unlimited/new/',
				params: {
					id: '0',
				},
				templateUrl: 'app/components/customers/unlimited/editUnlimitedView.html',
				data: {
					pageTitle: 'New unlimited access number',
				},
				controller: 'EditUnlimitedController',
				controllerAs: 'editUnlimited',
			})
			.lazyLoadedState('index.customers.unlimited-help', {
				url: '/customers/unlimited/help/?name',
				params: {
					name: 'help_unlimited_body',
				},
				templateUrl: 'app/components/help/documentation/helpDocumentationViewView.html',
				data: {
					pageTitle: 'Help for Unlimited access numbers',
				},
				controller: 'HelpDocumentationViewController',
				controllerAs: 'helpView',
			})
			.lazyLoadedState('index.customers.unlimited-notes', {
				url: '/customers/unlimited/notes/list/?snumber',
				params: {
					stype: 'unlimited',
				},
				templateUrl: 'app/components/utils/notesListView.html',
				data: {
					pageTitle: 'Notes',
				},
				controller: 'NotesListController',
				controllerAs: 'notesList',
			})

			.lazyLoadedState('index.customers.vouchers-batches-list', {
				url: '/customers/vouchers/batches/list/',
				templateUrl: 'app/components/customers/vouchers/batches/voucherBatchListView.html',
				data: {
					pageTitle: 'Vouchers',
				},
				controller: 'VoucherBatchListController',
				controllerAs: 'voucherBatchList',
			})
			.lazyLoadedState('index.customers.vouchers-batches-edit', {
				url: '/customers/vouchers/batches/edit/?id',
				params: {
					id: '0',
				},
				templateUrl: 'app/components/customers/vouchers/batches/editVoucherBatchView.html',
				data: {
					pageTitle: 'Edit batch',
				},
				controller: 'EditVoucherBatchController',
				controllerAs: 'editVoucherBatch',
			})
			.lazyLoadedState('index.customers.vouchers-batches-new', {
				url: '/customers/vouchers/batches/new/',
				templateUrl: 'app/components/customers/vouchers/batches/newVoucherBatchView.html',
				data: {
					pageTitle: 'New batch',
				},
				controller: 'NewVoucherBatchController',
				controllerAs: 'newVoucherBatch',
			})
			.lazyLoadedState('index.customers.vouchers-list', {
				url: '/customers/vouchers/list/?batch',
				templateUrl: 'app/components/customers/vouchers/voucherListView.html',
				data: {
					pageTitle: 'Vouchers listing',
				},
				controller: 'VoucherListController',
				controllerAs: 'voucherList',
			})
			.lazyLoadedState('index.customers.vouchers-edit', {
				url: '/customers/vouchers/edit/?serial',
				templateUrl: 'app/components/customers/vouchers/editVoucherView.html',
				data: {
					pageTitle: 'Edit voucher',
				},
				controller: 'EditVoucherController',
				controllerAs: 'editVoucher',
			})
			.lazyLoadedState('index.customers.vouchers-help', {
				url: '/customers/vouchers/help/?name',
				params: {
					name: 'help_vouchers_batches_body',
				},
				templateUrl: 'app/components/help/documentation/helpDocumentationViewView.html',
				data: {
					pageTitle: 'Help for Vouchers',
				},
				controller: 'HelpDocumentationViewController',
				controllerAs: 'helpView',
			})

			/** Calls and messages */

			.lazyLoadedState('index.calls', {
				abstract: true,
				template: '<div ui-view></div>',
				data: {
					pageTitle: 'Calls and messages',
				},
			})

			.lazyLoadedState('index.calls.active-list', {
				url: '/calls/active/list/?customer&direction&refresh',
				params: {
					customer: '',
					direction: '',
					refresh: '',
				},
				templateUrl: 'app/components/calls/active/activeCallsView.html',
				data: {
					pageTitle: 'Active calls',
				},
				controller: 'ActiveCallsController',
				controllerAs: 'activeCalls',
			})
			.lazyLoadedState('index.calls.active-help', {
				url: '/calls/active/help/?name',
				params: {
					name: 'help_calls_active_body',
				},
				templateUrl: 'app/components/help/documentation/helpDocumentationViewView.html',
				data: {
					pageTitle: 'Help for Active calls',
				},
				controller: 'HelpDocumentationViewController',
				controllerAs: 'helpView',
			})

			.lazyLoadedState('index.calls.cdrs-list', {
				url:
					'/calls/cdrs/list/?customer&stype&start&end&sort&descending&group&cost_customer&status&caller_match&callername_match&called_match&direction&recurse&archive&include_tax&caller_number&callername_number&called_number&phone&talktime_minimum&talktime_maximum&cost_min&cost_max',
				params: {
					customer: '',
					stype: '',
					start: '',
					end: '',
					sort: '',
					descending: '',
					group: '',
					cost_customer: '',
					status: '',
					caller_match: '',
					callername_match: '',
					called_match: '',
					direction: '',
					recurse: '',
					archive: '',
					include_tax: '',
					caller_number: '',
					callername_number: '',
					called_number: '',
					phone: '',
					talktime_minimum: '',
					talktime_maximum: '',
					cost_min: '',
					cost_max: '',
				},
				templateUrl: 'app/components/calls/cdrs/callHistoryView.html',
				data: {
					pageTitle: 'Call history',
				},
				controller: 'CallHistoryController',
				controllerAs: 'callHistory',
			})
			.lazyLoadedState('index.calls.cdrs-edit', {
				url: '/calls/cdrs/edit/?callid&customer&cost_customer&include_tax&archive&sort&descending&recurse&status',
				params: {
					callid: '',
					customer: '',
					cost_customer: '',
					include_tax: '',
					archive: '',
					sort: '',
					descending: '',
					recurse: '',
					status: '',
				},
				templateUrl: 'app/components/calls/cdrs/callDetailsView.html',
				data: {
					pageTitle: 'Call details',
				},
				controller: 'CallDetailsController',
				controllerAs: 'callDetails',
			})
			.lazyLoadedState('index.calls.cdrs-concurrent-edit', {
				url:
					'/calls/cdrs/concurrent/edit/?customer&start&end&recurse&status&direction&caller_match&caller_number&callername_match&callername_number&called_match&called_number&phone&talktime_minimum&talktime_maximum&cost_minimum&cost_maximum&cost_customer&include_tax&group&sort&descending&simple&stype',
				params: {
					start: '',
					end: '',
					customer: '',
					recurse: '',
					status: '',
					direction: '',
					caller_match: '',
					caller_number: '',
					callername_match: '',
					callername_number: '',
					called_match: '',
					called_number: '',
					phone: '',
					talktime_minimum: '',
					talktime_maximum: '',
					cost_minimum: '',
					cost_maximum: '',
					cost_customer: '',
					include_tax: '',
					group: '',
					sort: '',
					descending: '',
					simple: '',
					stype: '',
				},
				templateUrl: 'app/components/calls/cdrs/concurrent/concurrentCallsView.html',
				data: {
					pageTitle: 'Calculate concurrent calls',
				},
				controller: 'ConcurrentCallsController',
				controllerAs: 'concurrentCalls',
			})
			.lazyLoadedState('index.calls.cdrs-recalculate-edit', {
				url:
					'/calls/cdrs/recalculate/edit/?customer&start&end&recurse&status&direction&caller_match&caller_number&callername_match&callername_number&called_match&called_number&phone&talktime_minimum&talktime_maximum&cost_minimum&cost_maximum&cost_customer&include_tax&group&sort&descending&simple&stype',
				params: {
					start: '',
					end: '',
					customer: '',
					recurse: '',
					status: '',
					direction: '',
					caller_match: '',
					caller_number: '',
					callername_match: '',
					callername_number: '',
					called_match: '',
					called_number: '',
					phone: '',
					talktime_minimum: '',
					talktime_maximum: '',
					cost_minimum: '',
					cost_maximum: '',
					cost_customer: '',
					include_tax: '',
					group: '',
					sort: '',
					descending: '',
					simple: '',
					stype: '',
				},
				templateUrl: 'app/components/calls/cdrs/recalculate/recalculateCostsView.html',
				data: {
					pageTitle: 'Recalculate call costs',
				},
				controller: 'RecalculateCostsController',
				controllerAs: 'recalculateCosts',
			})
			.lazyLoadedState('index.calls.cdrs-help', {
				url: '/calls/cdrs/help/?name',
				params: {
					name: 'help_calls_cdrs_body',
				},
				templateUrl: 'app/components/help/documentation/helpDocumentationViewView.html',
				data: {
					pageTitle: 'Help for Call history',
				},
				controller: 'HelpDocumentationViewController',
				controllerAs: 'helpView',
			})
			.lazyLoadedState('index.calls.cdrs-notes', {
				url: '/calls/cdrs/notes/list/?snumber&return',
				params: {
					stype: 'cdr',
					return: '',
				},
				templateUrl: 'app/components/utils/notesListView.html',
				data: {
					pageTitle: 'Notes',
				},
				controller: 'NotesListController',
				controllerAs: 'notesList',
			})

			.lazyLoadedState('index.calls.call', {
				url: '/calls/call/',
				templateUrl: 'app/components/calls/call/callView.html',
				data: {
					pageTitle: 'Make a call',
				},
				controller: 'makeACallController',
				controllerAs: 'makeACall',
			})
			.lazyLoadedState('index.calls.call-help', {
				url: '/calls/call/help/?name',
				params: {
					name: 'help_make_call_body',
				},
				templateUrl: 'app/components/help/documentation/helpDocumentationViewView.html',
				data: {
					pageTitle: 'Help for Make a call',
				},
				controller: 'HelpDocumentationViewController',
				controllerAs: 'helpView',
			})

			.lazyLoadedState('index.calls.panel', {
				url: '/calls/panel/?sort&menu&readonly',
				params: {
					sort: '',
					menu: '',
					readonly: '',
				},
				templateUrl: 'app/components/calls/panel/controlPanelView.html',
				data: {
					pageTitle: 'Control panel',
				},
				controller: 'controlPanelController',
				controllerAs: 'controlPanel',
			})
			.lazyLoadedState('index.calls.panel-help', {
				url: '/calls/panel/help/?name',
				params: {
					name: 'help_control_panel_body',
				},
				templateUrl: 'app/components/help/documentation/helpDocumentationViewView.html',
				data: {
					pageTitle: 'Help for Control panel',
				},
				controller: 'HelpDocumentationViewController',
				controllerAs: 'helpView',
			})

			.lazyLoadedState('index.calls.mailboxes', {
				url: '/calls/mailboxes/',
				templateUrl: 'app/components/calls/messages/mailboxesView.html',
				data: {
					pageTitle: 'All mailboxes',
				},
				controller: 'MailboxesController',
				controllerAs: 'mailboxes',
			})
			.lazyLoadedState('index.calls.messages-list', {
				url: '/calls/messages/list/?mailbox',
				params: {
					type: 'all',
					mailbox: '',
				},
				templateUrl: 'app/components/calls/messages/messagesView.html',
				data: {
					pageTitle: 'All messages',
				},
				controller: 'MessagesController',
				controllerAs: 'messages',
			})
			.lazyLoadedState('index.calls.faxes', {
				url: '/calls/messages/faxes/',
				templateUrl: 'app/components/calls/messages/mailboxesView.html',
				data: {
					pageTitle: 'Faxes',
				},
				controller: 'MailboxesController',
				controllerAs: 'mailboxes',
			})
			.lazyLoadedState('index.calls.faxes-list', {
				url: '/calls/messages/faxes/list/?mailbox',
				params: {
					type: 'fax',
					mailbox: '',
				},
				templateUrl: 'app/components/calls/messages/messagesView.html',
				data: {
					pageTitle: 'Faxes',
				},
				controller: 'MessagesController',
				controllerAs: 'messages',
			})
			.lazyLoadedState('index.calls.voicemail', {
				url: '/calls/messages/voicemail/',
				templateUrl: 'app/components/calls/messages/mailboxesView.html',
				data: {
					pageTitle: 'Voicemail',
				},
				controller: 'MailboxesController',
				controllerAs: 'mailboxes',
			})
			.lazyLoadedState('index.calls.voicemail-list', {
				url: '/calls/messages/voicemail/list/?mailbox',
				params: {
					type: 'voicemail',
					mailbox: '',
				},
				templateUrl: 'app/components/calls/messages/messagesView.html',
				data: {
					pageTitle: 'Voicemail',
				},
				controller: 'MessagesController',
				controllerAs: 'messages',
			})
			.lazyLoadedState('index.calls.text', {
				url: '/calls/messages/text/',
				params: {
					type: 'text',
					mailbox: '',
				},
				templateUrl: 'app/components/calls/messages/messagesView.html',
				data: {
					pageTitle: 'Text messages',
				},
				controller: 'MessagesController',
				controllerAs: 'messages',
			})
			.lazyLoadedState('index.calls.text-help', {
				url: '/calls/messages/text/help/?name',
				params: {
					name: 'help_messages_text_body',
				},
				templateUrl: 'app/components/help/documentation/helpDocumentationViewView.html',
				data: {
					pageTitle: 'Help for Text messages',
				},
				controller: 'HelpDocumentationViewController',
				controllerAs: 'helpView',
			})

			.lazyLoadedState('index.calls.emails', {
				url: '/calls/emails/',
				templateUrl: 'app/components/calls/emails/emailsView.html',
				data: {
					pageTitle: 'Send emails',
				},
				controller: 'sendEmailsController',
				controllerAs: 'sendEmails',
			})
			.lazyLoadedState('index.calls.emails-help', {
				url: '/calls/emails/help/?name',
				params: {
					name: 'help_calls_emails_body',
				},
				templateUrl: 'app/components/help/documentation/helpDocumentationViewView.html',
				data: {
					pageTitle: 'Help for Send emails',
				},
				controller: 'HelpDocumentationViewController',
				controllerAs: 'helpView',
			})
			.lazyLoadedState('index.calls.message', {
				url: '/calls/message/',
				templateUrl: 'app/components/calls/message/messageView.html',
				data: {
					pageTitle: 'Send a message',
				},
				controller: 'SendMessageController',
				controllerAs: 'sendMessage',
			})
			.lazyLoadedState('index.calls.message-help', {
				url: '/calls/message/help/?name',
				params: {
					name: 'help_calls_message_body',
				},
				templateUrl: 'app/components/help/documentation/helpDocumentationViewView.html',
				data: {
					pageTitle: 'Help for Send a message',
				},
				controller: 'HelpDocumentationViewController',
				controllerAs: 'helpView',
			})
			.lazyLoadedState('index.calls.fax', {
				url: '/calls/fax/',
				templateUrl: 'app/components/calls/fax/sendFaxView.html',
				data: {
					pageTitle: 'Send a fax',
				},
				controller: 'SendFaxController',
				controllerAs: 'sendFax',
			})
			.lazyLoadedState('index.calls.fax-help', {
				url: '/calls/fax/help/?name',
				params: {
					name: 'help_calls_fax_body',
				},
				templateUrl: 'app/components/help/documentation/helpDocumentationViewView.html',
				data: {
					pageTitle: 'Help for Send a fax',
				},
				controller: 'HelpDocumentationViewController',
				controllerAs: 'helpView',
			})

			.lazyLoadedState('index.calls.mailboxes-help', {
				url: '/calls/mailboxes/help/?name',
				params: {
					name: 'help_messages_mailboxes_body',
				},
				templateUrl: 'app/components/help/documentation/helpDocumentationViewView.html',
				data: {
					pageTitle: 'Help for Mailboxes messages',
				},
				controller: 'HelpDocumentationViewController',
				controllerAs: 'helpView',
			})
			.lazyLoadedState('index.calls.faxes-help', {
				url: '/calls/messages/faxes/help/?name',
				params: {
					name: 'help_messages_mailboxes_body',
				},
				templateUrl: 'app/components/help/documentation/helpDocumentationViewView.html',
				data: {
					pageTitle: 'Help for Mailboxes messages (faxes)',
				},
				controller: 'HelpDocumentationViewController',
				controllerAs: 'helpView',
			})
			.lazyLoadedState('index.calls.voicemail-help', {
				url: '/calls/messages/voicemail/help/?name',
				params: {
					name: 'help_messages_mailboxes_body',
				},
				templateUrl: 'app/components/help/documentation/helpDocumentationViewView.html',
				data: {
					pageTitle: 'Help for Mailboxes messages (voicemail)',
				},
				controller: 'HelpDocumentationViewController',
				controllerAs: 'helpView',
			})

			/** Tools and features */

			.lazyLoadedState('index.features', {
				abstract: true,
				template: '<div ui-view></div>',
				data: {
					pageTitle: 'Tools and features',
				},
			})

			.lazyLoadedState('index.features.alerts-list', {
				url: '/features/alerts/list/',
				templateUrl: 'app/components/features/alerts/alertListView.html',
				data: {
					pageTitle: 'Alerts',
				},
				controller: 'AlertListController',
				controllerAs: 'alertList',
			})
			.lazyLoadedState('index.features.alerts-edit', {
				url: '/features/alerts/edit/?id',
				templateUrl: 'app/components/features/alerts/editAlertView.html',
				data: {
					pageTitle: 'Edit alert',
				},
				controller: 'EditAlertController',
				controllerAs: 'editAlert',
			})
			.lazyLoadedState('index.features.alerts-new', {
				url: '/features/alerts/new/',
				params: {
					id: '',
				},
				templateUrl: 'app/components/features/alerts/editAlertView.html',
				data: {
					pageTitle: 'New alert',
				},
				controller: 'EditAlertController',
				controllerAs: 'editAlert',
			})
			.lazyLoadedState('index.features.alerts-help', {
				url: '/features/alerts/help/?name',
				params: {
					name: 'help_alerts_body',
				},
				templateUrl: 'app/components/help/documentation/helpDocumentationViewView.html',
				data: {
					pageTitle: 'Help for Alerts',
				},
				controller: 'HelpDocumentationViewController',
				controllerAs: 'helpView',
			})
			.lazyLoadedState('index.features.alerts-notes', {
				url: '/features/alerts/notes/list/?snumber',
				params: {
					stype: 'alert',
				},
				templateUrl: 'app/components/utils/notesListView.html',
				data: {
					pageTitle: 'Notes',
				},
				controller: 'NotesListController',
				controllerAs: 'notesList',
			})
			.lazyLoadedState('index.features.alerts-events', {
				url: '/features/alerts/events/?id',
				templateUrl: 'app/components/features/alerts/events/alertEventsView.html',
				data: {
					pageTitle: 'Alerts stored',
				},
				controller: 'AlertEventsController',
				controllerAs: 'events',
			})

			.lazyLoadedState('index.features.bulk-list', {
				url: '/features/bulk/list/',
				templateUrl: 'app/components/features/bulk/bulkListView.html',
				data: {
					pageTitle: 'Bulk campaigns',
				},
				controller: 'BulkListController',
				controllerAs: 'bulkList',
			})
			.lazyLoadedState('index.features.bulk-edit', {
				url: '/features/bulk/edit/?id',
				templateUrl: 'app/components/features/bulk/editBulkView.html',
				data: {
					pageTitle: 'Edit campaign',
				},
				controller: 'EditBulkController',
				controllerAs: 'editBulk',
			})
			.lazyLoadedState('index.features.bulk-new', {
				url: '/features/bulk/new/',
				params: {
					id: '0',
				},
				templateUrl: 'app/components/features/bulk/editBulkView.html',
				data: {
					pageTitle: 'New campaign',
				},
				controller: 'EditBulkController',
				controllerAs: 'editBulk',
			})
			.lazyLoadedState('index.features.bulk-help', {
				url: '/features/bulk/help/?name',
				params: {
					name: 'help_bulk_body',
				},
				templateUrl: 'app/components/help/documentation/helpDocumentationViewView.html',
				data: {
					pageTitle: 'Help for Bulk dialer',
				},
				controller: 'HelpDocumentationViewController',
				controllerAs: 'helpView',
			})
			.lazyLoadedState('index.features.bulk-notes', {
				url: '/features/bulk/notes/list/?snumber',
				params: {
					stype: 'bulk_campaign',
				},
				templateUrl: 'app/components/utils/notesListView.html',
				data: {
					pageTitle: 'Notes',
				},
				controller: 'NotesListController',
				controllerAs: 'notesList',
			})
			.lazyLoadedState('index.features.bulk-destinations', {
				url: '/features/bulk/destinations/?id&offset&sort&descending',
				params: {
					id: '0',
					offset: '',
					sort: '',
					descending: '',
				},
				templateUrl: 'app/components/features/bulk/destinations/destinationListView.html',
				data: {
					pageTitle: 'Destinations',
				},
				controller: 'DestinationListController',
				controllerAs: 'destinationList',
			})

			.lazyLoadedState('index.features.recordings-groups-list', {
				url: '/features/recordings/groups/list/',
				templateUrl: 'app/components/features/recordings/recordgroupListView.html',
				data: {
					pageTitle: 'Call recording',
				},
				controller: 'RecordgroupListController',
				controllerAs: 'recordgroupList',
			})
			.lazyLoadedState('index.features.recordings-groups-edit', {
				url: '/features/recordings/groups/edit/?id',
				templateUrl: 'app/components/features/recordings/editRecordgroupView.html',
				data: {
					pageTitle: 'Edit record group',
				},
				controller: 'EditRecordgroupController',
				controllerAs: 'editRecordgroup',
			})
			.lazyLoadedState('index.features.recordings-groups-new', {
				url: '/features/recordings/groups/new/',
				params: {
					id: 0,
				},
				templateUrl: 'app/components/features/recordings/editRecordgroupView.html',
				data: {
					pageTitle: 'New record group',
				},
				controller: 'EditRecordgroupController',
				controllerAs: 'editRecordgroup',
			})
			.lazyLoadedState('index.features.recordings-groups-features', {
				url: '/features/recordings/groups/features/?id',
				params: {
					id: '',
				},
				templateUrl: 'app/components/features/recordings/recordgroupFeaturesView.html',
				data: {
					pageTitle: 'Features',
				},
				controller: 'RecordgroupFeaturesController',
				controllerAs: 'recordgroupFeatures',
			})
			.lazyLoadedState('index.features.recordings-groups-help', {
				url: '/features/recordings/groups/help/?name',
				params: {
					name: 'help_recordings_groups_body',
				},
				templateUrl: 'app/components/help/documentation/helpDocumentationViewView.html',
				data: {
					pageTitle: 'Help for Record groups',
				},
				controller: 'HelpDocumentationViewController',
				controllerAs: 'helpView',
			})
			.lazyLoadedState('index.features.recordings-groups-notes', {
				url: '/features/recordings/groups/notes/list/?snumber',
				params: {
					stype: 'recordgroup',
				},
				templateUrl: 'app/components/utils/notesListView.html',
				data: {
					pageTitle: 'Notes',
				},
				controller: 'NotesListController',
				controllerAs: 'notesList',
			})
			.lazyLoadedState('index.features.recordings-list', {
				url: '/features/recordings/list/?recordgroup',
				templateUrl: 'app/components/features/recordings/recordingListView.html',
				data: {
					pageTitle: 'Listing recordings',
				},
				controller: 'RecordingListController',
				controllerAs: 'recordingList',
			})

			.lazyLoadedState('index.features.cos-list', {
				url: '/features/cos/list/',
				templateUrl: 'app/components/features/cos/cosListView.html',
				data: {
					pageTitle: 'Classes of service',
				},
				controller: 'CosListController',
				controllerAs: 'cosList',
			})
			.lazyLoadedState('index.features.cos-edit', {
				url: '/features/cos/edit/?id',
				templateUrl: 'app/components/features/cos/editCosView.html',
				data: {
					pageTitle: 'Edit class of service',
				},
				controller: 'EditCosController',
				controllerAs: 'editCos',
			})
			.lazyLoadedState('index.features.cos-new', {
				url: '/features/cos/new/',
				params: {
					id: 0,
				},
				templateUrl: 'app/components/features/cos/editCosView.html',
				data: {
					pageTitle: 'New class of service',
				},
				controller: 'EditCosController',
				controllerAs: 'editCos',
			})
			.lazyLoadedState('index.features.cos-help', {
				url: '/features/cos/help/?name',
				params: {
					name: 'help_cos_body',
				},
				templateUrl: 'app/components/help/documentation/helpDocumentationViewView.html',
				data: {
					pageTitle: 'Help for Classes of service',
				},
				controller: 'HelpDocumentationViewController',
				controllerAs: 'helpView',
			})
			.lazyLoadedState('index.features.cos-notes', {
				url: '/features/cos/notes/list/?snumber',
				params: {
					stype: 'cos',
				},
				templateUrl: 'app/components/utils/notesListView.html',
				data: {
					pageTitle: 'Notes',
				},
				controller: 'NotesListController',
				controllerAs: 'notesList',
			})

			.lazyLoadedState('index.features.files-list', {
				url: '/features/files/list/',
				templateUrl: 'app/components/features/files/fileListView.html',
				data: {
					pageTitle: 'Files',
				},
				controller: 'FileListController',
				controllerAs: 'fileList',
			})
			.lazyLoadedState('index.features.files-edit', {
				url: '/features/files/edit/?id',
				templateUrl: 'app/components/features/files/editFileView.html',
				data: {
					pageTitle: 'Edit file',
				},
				controller: 'EditFileController',
				controllerAs: 'editFile',
			})
			.lazyLoadedState('index.features.files-new', {
				url: '/features/files/new/',
				params: {
					id: '',
				},
				templateUrl: 'app/components/features/files/editFileView.html',
				data: {
					pageTitle: 'New file',
				},
				controller: 'EditFileController',
				controllerAs: 'editFile',
			})
			.lazyLoadedState('index.features.files-help', {
				url: '/features/files/help/?name',
				params: {
					name: 'help_files_body',
				},
				templateUrl: 'app/components/help/documentation/helpDocumentationViewView.html',
				data: {
					pageTitle: 'Help for Files',
				},
				controller: 'HelpDocumentationViewController',
				controllerAs: 'helpView',
			})
			.lazyLoadedState('index.features.files-notes', {
				url: '/features/files/notes/list/?snumber',
				params: {
					stype: 'file',
				},
				templateUrl: 'app/components/utils/notesListView.html',
				data: {
					pageTitle: 'Notes',
				},
				controller: 'NotesListController',
				controllerAs: 'notesList',
			})

			.lazyLoadedState('index.features.conferences-list', {
				url: '/features/conferences/list/',
				templateUrl: 'app/components/features/conferences/conferenceListView.html',
				data: {
					pageTitle: 'Conferences',
				},
				controller: 'ConferenceListController',
				controllerAs: 'conferenceList',
			})
			.lazyLoadedState('index.features.conferences-edit', {
				url: '/features/conferences/edit/?id',
				templateUrl: 'app/components/features/conferences/editConferenceView.html',
				data: {
					pageTitle: 'Edit conference',
				},
				controller: 'EditConferenceController',
				controllerAs: 'editConference',
			})
			.lazyLoadedState('index.features.conferences-new', {
				url: '/features/conferences/new/',
				params: {
					id: '',
				},
				templateUrl: 'app/components/features/conferences/editConferenceView.html',
				data: {
					pageTitle: 'New conference',
				},
				controller: 'EditConferenceController',
				controllerAs: 'editConference',
			})
			.lazyLoadedState('index.features.conferences-help', {
				url: '/features/conferences/help/?name',
				params: {
					name: 'help_conferences_body',
				},
				templateUrl: 'app/components/help/documentation/helpDocumentationViewView.html',
				data: {
					pageTitle: 'Help for Conferences',
				},
				controller: 'HelpDocumentationViewController',
				controllerAs: 'helpView',
			})
			.lazyLoadedState('index.features.conferences-notes', {
				url: '/features/conferences/notes/list/?snumber',
				params: {
					stype: 'conference',
				},
				templateUrl: 'app/components/utils/notesListView.html',
				data: {
					pageTitle: 'Notes',
				},
				controller: 'NotesListController',
				controllerAs: 'notesList',
			})

			.lazyLoadedState('index.features.huntgroups-list', {
				url: '/features/huntgroups/list/',
				templateUrl: 'app/components/features/huntgroups/huntgroupListView.html',
				data: {
					pageTitle: 'Hunt groups',
				},
				controller: 'HuntgroupListController',
				controllerAs: 'huntgroupList',
			})
			.lazyLoadedState('index.features.huntgroups-edit', {
				url: '/features/huntgroups/edit/?id',
				templateUrl: 'app/components/features/huntgroups/editHuntgroupView.html',
				data: {
					pageTitle: 'Edit hunt group',
				},
				controller: 'EditHuntgroupController',
				controllerAs: 'editHuntgroup',
			})
			.lazyLoadedState('index.features.huntgroups-new', {
				url: '/features/huntgroups/new/',
				params: {
					id: '',
				},
				templateUrl: 'app/components/features/huntgroups/editHuntgroupView.html',
				data: {
					pageTitle: 'New hunt group',
				},
				controller: 'EditHuntgroupController',
				controllerAs: 'editHuntgroup',
			})
			.lazyLoadedState('index.features.huntgroups-deststats', {
				url: '/features/huntgroups/destinations/statistics/?id',
				params: {
					id: '',
				},
				templateUrl: 'app/components/features/huntgroups/destinations/huntgroupDestinationStatisticsView.html',
				data: {
					pageTitle: 'Destination statistics',
				},
				controller: 'HuntgroupDestinationStatisticsController',
				controllerAs: 'huntDestStats',
			})
			.lazyLoadedState('index.features.huntgroups-statistics', {
				url: '/features/huntgroups/statistics/?id',
				params: {
					id: '',
				},
				templateUrl: 'app/components/features/huntgroups/huntgroupStatisticsView.html',
				data: {
					pageTitle: 'Statistics',
				},
				controller: 'HuntgroupStatisticsController',
				controllerAs: 'huntStats',
			})
			/*
			.lazyLoadedState('index.features.huntgroups-destdefault', {
				url: '/features/huntgroups/destinations/edit/?huntgroup?id', // default?
				params: {id: '-1'},
				templateUrl: "app/components/features/huntgroups/destinations/editHuntgroupDestinationView.html",
				data: { pageTitle: 'Edit default destination' },
				controller: 'EditHuntgroupDestinationController',
				controllerAs: 'editHuntDest'
			})
			*/
			.lazyLoadedState('index.features.huntgroups-destedit', {
				url: '/features/huntgroups/destinations/edit/?huntgroup?id',
				params: {
					id: '0',
				},
				templateUrl: 'app/components/features/huntgroups/destinations/editHuntgroupDestinationView.html',
				data: {
					pageTitle: 'Edit destination',
				},
				controller: 'EditHuntgroupDestinationController',
				controllerAs: 'editHuntDest',
			})
			.lazyLoadedState('index.features.huntgroups-destnew', {
				url: '/features/huntgroups/destinations/new/?huntgroup',
				params: {
					id: '0',
				},
				templateUrl: 'app/components/features/huntgroups/destinations/editHuntgroupDestinationView.html',
				data: {
					pageTitle: 'New destination',
				},
				controller: 'EditHuntgroupDestinationController',
				controllerAs: 'editHuntDest',
			})
			.lazyLoadedState('index.features.huntgroups-level', {
				url: '/features/huntgroups/levels/edit/?huntgroup?level',
				templateUrl: 'app/components/features/huntgroups/levels/editHuntgroupLevelView.html',
				data: {
					pageTitle: 'Edit level',
				},
				controller: 'EditHuntgroupLevelController',
				controllerAs: 'editHuntLevel',
			})
			.lazyLoadedState('index.features.huntgroups-help', {
				url: '/features/huntgroups/help/?name',
				params: {
					name: 'help_huntgroups_body',
				},
				templateUrl: 'app/components/help/documentation/helpDocumentationViewView.html',
				data: {
					pageTitle: 'Help for Hunt groups',
				},
				controller: 'HelpDocumentationViewController',
				controllerAs: 'helpView',
			})
			.lazyLoadedState('index.features.huntgroups-notes', {
				url: '/features/huntgroups/notes/list/?snumber',
				params: {
					stype: 'huntgroup',
				},
				templateUrl: 'app/components/utils/notesListView.html',
				data: {
					pageTitle: 'Notes',
				},
				controller: 'NotesListController',
				controllerAs: 'notesList',
			})

			.lazyLoadedState('index.features.pagegroups-list', {
				url: '/features/pagegroups/list/',
				templateUrl: 'app/components/features/pagegroups/pagegroupListView.html',
				data: {
					pageTitle: 'Page groups',
				},
				controller: 'PagegroupListController',
				controllerAs: 'pagegroupList',
			})
			.lazyLoadedState('index.features.pagegroups-edit', {
				url: '/features/pagegroups/edit/?id',
				templateUrl: 'app/components/features/pagegroups/editPagegroupView.html',
				data: {
					pageTitle: 'Edit page group',
				},
				controller: 'EditPagegroupController',
				controllerAs: 'editPagegroup',
			})
			.lazyLoadedState('index.features.pagegroups-new', {
				url: '/features/pagegroups/new/',
				params: {
					id: '',
				},
				templateUrl: 'app/components/features/pagegroups/editPagegroupView.html',
				data: {
					pageTitle: 'New page group',
				},
				controller: 'EditPagegroupController',
				controllerAs: 'editPagegroup',
			})
			.lazyLoadedState('index.features.pagegroups-help', {
				url: '/features/pagegroups/help/?name',
				params: {
					name: 'help_pagegroups_body',
				},
				templateUrl: 'app/components/help/documentation/helpDocumentationViewView.html',
				data: {
					pageTitle: 'Help for Page groups',
				},
				controller: 'HelpDocumentationViewController',
				controllerAs: 'helpView',
			})
			.lazyLoadedState('index.features.pagegroups-notes', {
				url: '/features/pagegroups/notes/list/?snumber',
				params: {
					stype: 'pagegroup',
				},
				templateUrl: 'app/components/utils/notesListView.html',
				data: {
					pageTitle: 'Notes',
				},
				controller: 'NotesListController',
				controllerAs: 'notesList',
			})

			.lazyLoadedState('index.features.queues-list', {
				url: '/features/queues/list/',
				templateUrl: 'app/components/features/queues/queueListView.html',
				data: {
					pageTitle: 'Queues',
				},
				controller: 'QueueListController',
				controllerAs: 'queueList',
			})
			.lazyLoadedState('index.features.queues-edit', {
				url: '/features/queues/edit/?id',
				templateUrl: 'app/components/features/queues/editQueueView.html',
				data: {
					pageTitle: 'Edit queue',
				},
				controller: 'EditQueueController',
				controllerAs: 'editQueue',
			})
			.lazyLoadedState('index.features.queues-new', {
				url: '/features/queues/new/',
				params: {
					id: '',
				},
				templateUrl: 'app/components/features/queues/editQueueView.html',
				data: {
					pageTitle: 'New queue',
				},
				controller: 'EditQueueController',
				controllerAs: 'editQueue',
			})
			.lazyLoadedState('index.features.queues-deststats', {
				url: '/features/queues/destinations/statistics/?id&start&end',
				params: {
					id: '',
					start: '',
					end: '',
				},
				templateUrl: 'app/components/features/queues/destinations/queueDestinationStatisticsView.html',
				data: {
					pageTitle: 'Destination statistics',
				},
				controller: 'QueueDestinationStatisticsController',
				controllerAs: 'queueDestStats',
			})
			.lazyLoadedState('index.features.queues-statistics', {
				url: '/features/queues/statistics/?id',
				params: {
					id: '',
				},
				templateUrl: 'app/components/features/queues/queueStatisticsView.html',
				data: {
					pageTitle: 'Statistics',
				},
				controller: 'QueueStatisticsController',
				controllerAs: 'queueStats',
			})
			.lazyLoadedState('index.features.queues-holding', {
				url: '/features/queues/holding/?id',
				params: {
					id: '',
				},
				templateUrl: 'app/components/features/queues/queueCallsHoldingView.html',
				data: {
					pageTitle: 'Holding calls',
				},
				controller: 'QueueCallsHoldingController',
				controllerAs: 'queueHolding',
			})
			.lazyLoadedState('index.features.queues-help', {
				url: '/features/queues/help/?name',
				params: {
					name: 'help_queues_body',
				},
				templateUrl: 'app/components/help/documentation/helpDocumentationViewView.html',
				data: {
					pageTitle: 'Help for Queues',
				},
				controller: 'HelpDocumentationViewController',
				controllerAs: 'helpView',
			})
			.lazyLoadedState('index.features.queues-notes', {
				url: '/features/queues/notes/list/?snumber',
				params: {
					stype: 'queue',
				},
				templateUrl: 'app/components/utils/notesListView.html',
				data: {
					pageTitle: 'Notes',
				},
				controller: 'NotesListController',
				controllerAs: 'notesList',
			})

			.lazyLoadedState('index.features.ivrs-list', {
				url: '/features/ivrs/list/',
				templateUrl: 'app/components/features/ivrs/ivrListView.html',
				data: {
					pageTitle: 'IVR menus',
				},
				controller: 'IvrListController',
				controllerAs: 'ivrList',
			})
			.lazyLoadedState('index.features.ivrs-edit', {
				url: '/features/ivrs/edit/?id',
				templateUrl: 'app/components/features/ivrs/editIvrView.html',
				data: {
					pageTitle: 'Edit IVR menu',
				},
				controller: 'EditIvrController',
				controllerAs: 'editIvr',
			})
			.lazyLoadedState('index.features.ivrs-new', {
				url: '/features/ivrs/new/',
				params: {
					id: '',
				},
				templateUrl: 'app/components/features/ivrs/editIvrView.html',
				data: {
					pageTitle: 'New IVR menu',
				},
				controller: 'EditIvrController',
				controllerAs: 'editIvr',
			})
			.lazyLoadedState('index.features.ivrs-help', {
				url: '/features/ivrs/help/?name',
				params: {
					name: 'help_ivrs_body',
				},
				templateUrl: 'app/components/help/documentation/helpDocumentationViewView.html',
				data: {
					pageTitle: 'Help for IVR menus',
				},
				controller: 'HelpDocumentationViewController',
				controllerAs: 'helpView',
			})
			.lazyLoadedState('index.features.ivrs-notes', {
				url: '/features/ivrs/notes/list/?snumber',
				params: {
					stype: 'ivr',
				},
				templateUrl: 'app/components/utils/notesListView.html',
				data: {
					pageTitle: 'Notes',
				},
				controller: 'NotesListController',
				controllerAs: 'notesList',
			})

			.lazyLoadedState('index.features.mailboxes-list', {
				url: '/features/mailboxes/list/',
				templateUrl: 'app/components/features/mailboxes/mailboxesFeatureView.html',
				data: {
					pageTitle: 'Mailboxes',
				},
				controller: 'MailboxesFeatureController',
				controllerAs: 'fmailboxes',
			})
			.lazyLoadedState('index.features.mailboxes-edit', {
				url: '/features/mailboxes/edit/?mailbox',
				templateUrl: 'app/components/features/mailboxes/editMailboxView.html',
				data: {
					pageTitle: 'Edit mailbox',
				},
				controller: 'EditMailboxController',
				controllerAs: 'editMailbox',
			})
			.lazyLoadedState('index.features.mailboxes-new', {
				url: '/features/mailboxes/new/',
				params: {
					mailbox: '',
				},
				templateUrl: 'app/components/features/mailboxes/editMailboxView.html',
				data: {
					pageTitle: 'New mailbox',
				},
				controller: 'EditMailboxController',
				controllerAs: 'editMailbox',
			})
			.lazyLoadedState('index.features.mailboxes-statistics', {
				url: '/features/mailboxes/statistics/',
				templateUrl: 'app/components/features/mailboxes/mailboxStatisticsView.html',
				data: {
					pageTitle: 'Mailbox statistics',
				},
				controller: 'MailboxStatisticsController',
				controllerAs: 'mailboxStats',
			})
			.lazyLoadedState('index.features.mailboxes-help', {
				url: '/features/mailboxes/help/?name',
				params: {
					name: 'help_mailboxes_body',
				},
				templateUrl: 'app/components/help/documentation/helpDocumentationViewView.html',
				data: {
					pageTitle: 'Help for Mailboxes',
				},
				controller: 'HelpDocumentationViewController',
				controllerAs: 'helpView',
			})
			.lazyLoadedState('index.features.mailboxes-notes', {
				url: '/features/mailboxes/notes/list/?snumber',
				params: {
					stype: 'mailbox',
				},
				templateUrl: 'app/components/utils/notesListView.html',
				data: {
					pageTitle: 'Notes',
				},
				controller: 'NotesListController',
				controllerAs: 'notesList',
			})

			.lazyLoadedState('index.features.music-list', {
				url: '/features/music/list/',
				templateUrl: 'app/components/features/music/musicListView.html',
				data: {
					pageTitle: 'Music',
				},
				controller: 'MusicListController',
				controllerAs: 'musicList',
			})
			.lazyLoadedState('index.features.music-edit', {
				url: '/features/music/edit/?id',
				templateUrl: 'app/components/features/music/editMusicView.html',
				data: {
					pageTitle: 'Edit music',
				},
				controller: 'EditMusicController',
				controllerAs: 'editMusic',
			})
			.lazyLoadedState('index.features.music-new', {
				url: '/features/music/new/',
				params: {
					id: '',
				},
				templateUrl: 'app/components/features/music/newMusicView.html',
				data: {
					pageTitle: 'New music',
				},
				controller: 'NewMusicController',
				controllerAs: 'newMusic',
			})
			.lazyLoadedState('index.features.music-help', {
				url: '/features/music/help/?name',
				params: {
					name: 'help_music_body',
				},
				templateUrl: 'app/components/help/documentation/helpDocumentationViewView.html',
				data: {
					pageTitle: 'Help for Music',
				},
				controller: 'HelpDocumentationViewController',
				controllerAs: 'helpView',
			})
			.lazyLoadedState('index.features.music-notes', {
				url: '/features/music/notes/list/?snumber',
				params: {
					stype: 'music',
				},
				templateUrl: 'app/components/utils/notesListView.html',
				data: {
					pageTitle: 'Notes',
				},
				controller: 'NotesListController',
				controllerAs: 'notesList',
			})

			.lazyLoadedState('index.features.patternmenus-list', {
				url: '/features/patternmenus/list/',
				templateUrl: 'app/components/features/patternmenus/patternmenuListView.html',
				data: {
					pageTitle: 'Pattern menus',
				},
				controller: 'PatternmenuListController',
				controllerAs: 'patternmenuList',
			})
			.lazyLoadedState('index.features.patternmenus-edit', {
				url: '/features/patternmenus/edit/?id',
				templateUrl: 'app/components/features/patternmenus/editPatternmenuView.html',
				data: {
					pageTitle: 'Edit pattern menu',
				},
				controller: 'EditPatternmenuController',
				controllerAs: 'editPatternmenu',
			})
			.lazyLoadedState('index.features.patternmenus-new', {
				url: '/features/patternmenus/new/',
				params: {
					id: '',
				},
				templateUrl: 'app/components/features/patternmenus/editPatternmenuView.html',
				data: {
					pageTitle: 'New pattern menu',
				},
				controller: 'EditPatternmenuController',
				controllerAs: 'editPatternmenu',
			})
			.lazyLoadedState('index.features.patternmenus-help', {
				url: '/features/patternmenus/help/?name',
				params: {
					name: 'help_patternmenus_body',
				},
				templateUrl: 'app/components/help/documentation/helpDocumentationViewView.html',
				data: {
					pageTitle: 'Help for Pattern menus',
				},
				controller: 'HelpDocumentationViewController',
				controllerAs: 'helpView',
			})
			.lazyLoadedState('index.features.patternmenus-notes', {
				url: '/features/patternmenus/notes/list/?snumber',
				params: {
					stype: 'patternmenu',
				},
				templateUrl: 'app/components/utils/notesListView.html',
				data: {
					pageTitle: 'Notes',
				},
				controller: 'NotesListController',
				controllerAs: 'notesList',
			})

			.lazyLoadedState('index.features.pickupgroups-list', {
				url: '/features/pickupgroups/list/',
				templateUrl: 'app/components/features/pickupgroups/pickupgroupListView.html',
				data: {
					pageTitle: 'Pickup groups',
				},
				controller: 'PickupgroupListController',
				controllerAs: 'pickupgroupList',
			})
			.lazyLoadedState('index.features.pickupgroups-edit', {
				url: '/features/pickupgroups/edit/?id',
				templateUrl: 'app/components/features/pickupgroups/editPickupgroupView.html',
				data: {
					pageTitle: 'Edit pickup group',
				},
				controller: 'EditPickupgroupController',
				controllerAs: 'editPickupgroup',
			})
			.lazyLoadedState('index.features.pickupgroups-new', {
				url: '/features/pickupgroups/new/',
				params: {
					id: '',
				},
				templateUrl: 'app/components/features/pickupgroups/editPickupgroupView.html',
				data: {
					pageTitle: 'New pickup group',
				},
				controller: 'EditPickupgroupController',
				controllerAs: 'editPickupgroup',
			})
			.lazyLoadedState('index.features.pickupgroups-help', {
				url: '/features/pickupgroups/help/?name',
				params: {
					name: 'help_pickupgroups_body',
				},
				templateUrl: 'app/components/help/documentation/helpDocumentationViewView.html',
				data: {
					pageTitle: 'Help for Pickup groups',
				},
				controller: 'HelpDocumentationViewController',
				controllerAs: 'helpView',
			})
			.lazyLoadedState('index.features.pickupgroups-notes', {
				url: '/features/pickupgroups/notes/list/?snumber',
				params: {
					stype: 'pickupgroup',
				},
				templateUrl: 'app/components/utils/notesListView.html',
				data: {
					pageTitle: 'Notes',
				},
				controller: 'NotesListController',
				controllerAs: 'notesList',
			})

			.lazyLoadedState('index.features.products-list', {
				url: '/features/products/list/',
				templateUrl: 'app/components/features/products/productListView.html',
				data: {
					pageTitle: 'Products',
				},
				controller: 'ProductListController',
				controllerAs: 'productList',
			})
			.lazyLoadedState('index.features.products-edit', {
				url: '/features/products/edit/?id',
				templateUrl: 'app/components/features/products/editProductView.html',
				data: {
					pageTitle: 'Edit product',
				},
				controller: 'EditProductController',
				controllerAs: 'editProduct',
			})
			.lazyLoadedState('index.features.products-new', {
				url: '/features/products/new/',
				params: {
					id: '0',
				},
				templateUrl: 'app/components/features/products/editProductView.html',
				data: {
					pageTitle: 'New product',
				},
				controller: 'EditProductController',
				controllerAs: 'editProduct',
			})
			.lazyLoadedState('index.features.products-help', {
				url: '/features/products/help/?name',
				params: {
					name: 'help_products_body',
				},
				templateUrl: 'app/components/help/documentation/helpDocumentationViewView.html',
				data: {
					pageTitle: 'Help for Products',
				},
				controller: 'HelpDocumentationViewController',
				controllerAs: 'helpView',
			})
			.lazyLoadedState('index.features.products-notes', {
				url: '/features/products/notes/list/?snumber',
				params: {
					stype: 'product',
				},
				templateUrl: 'app/components/utils/notesListView.html',
				data: {
					pageTitle: 'Notes',
				},
				controller: 'NotesListController',
				controllerAs: 'notesList',
			})

			.lazyLoadedState('index.features.purchase', {
				url: '/features/purchase/',
				templateUrl: 'app/components/features/purchase/makePurchaseView.html',
				data: {
					pageTitle: 'Make a purchase',
				},
				controller: 'MakePurchaseController',
				controllerAs: 'makePurchase',
			})
			.lazyLoadedState('index.features.purchase-help', {
				url: '/features/purchase/help/?name',
				params: {
					name: 'help_purchase_body',
				},
				templateUrl: 'app/components/help/documentation/helpDocumentationViewView.html',
				data: {
					pageTitle: 'Help for Purchase',
				},
				controller: 'HelpDocumentationViewController',
				controllerAs: 'helpView',
			})

			.lazyLoadedState('index.features.sounds-list', {
				url: '/features/sounds/list/',
				templateUrl: 'app/components/features/sounds/soundListView.html',
				data: {
					pageTitle: 'Sounds',
				},
				controller: 'SoundListController',
				controllerAs: 'soundList',
			})
			.lazyLoadedState('index.features.sounds-edit', {
				url: '/features/sounds/edit/?id',
				templateUrl: 'app/components/features/sounds/editSoundView.html',
				data: {
					pageTitle: 'Edit sound',
				},
				controller: 'EditSoundController',
				controllerAs: 'editSound',
			})
			.lazyLoadedState('index.features.sounds-new', {
				url: '/features/sounds/new/',
				params: {
					id: '',
				},
				templateUrl: 'app/components/features/sounds/editSoundView.html',
				data: {
					pageTitle: 'New sound',
				},
				controller: 'EditSoundController',
				controllerAs: 'editSound',
			})
			.lazyLoadedState('index.features.sounds-help', {
				url: '/features/sounds/help/?name',
				params: {
					name: 'help_sounds_body',
				},
				templateUrl: 'app/components/help/documentation/helpDocumentationViewView.html',
				data: {
					pageTitle: 'Help for Sounds',
				},
				controller: 'HelpDocumentationViewController',
				controllerAs: 'helpView',
			})
			.lazyLoadedState('index.features.sounds-notes', {
				url: '/features/sounds/notes/list/?snumber',
				params: {
					stype: 'sound',
				},
				templateUrl: 'app/components/utils/notesListView.html',
				data: {
					pageTitle: 'Notes',
				},
				controller: 'NotesListController',
				controllerAs: 'notesList',
			})

			.lazyLoadedState('index.features.urls-list', {
				url: '/features/urls/list/',
				templateUrl: 'app/components/features/urls/urlListView.html',
				data: {
					pageTitle: 'Web URLs',
				},
				controller: 'UrlListController',
				controllerAs: 'urlList',
			})
			.lazyLoadedState('index.features.urls-edit', {
				url: '/features/urls/edit/?id',
				templateUrl: 'app/components/features/urls/editUrlView.html',
				data: {
					pageTitle: 'Edit web URL',
				},
				controller: 'EditUrlController',
				controllerAs: 'editUrl',
			})
			.lazyLoadedState('index.features.urls-new', {
				url: '/features/urls/new/',
				params: {
					id: '',
				},
				templateUrl: 'app/components/features/urls/editUrlView.html',
				data: {
					pageTitle: 'New web URL',
				},
				controller: 'EditUrlController',
				controllerAs: 'editUrl',
			})
			.lazyLoadedState('index.features.urls-help', {
				url: '/features/urls/help/?name',
				params: {
					name: 'help_urls_body',
				},
				templateUrl: 'app/components/help/documentation/helpDocumentationViewView.html',
				data: {
					pageTitle: 'Help for Web URLs',
				},
				controller: 'HelpDocumentationViewController',
				controllerAs: 'helpView',
			})
			.lazyLoadedState('index.features.urls-notes', {
				url: '/features/urls/notes/list/?snumber',
				params: {
					stype: 'url',
				},
				templateUrl: 'app/components/utils/notesListView.html',
				data: {
					pageTitle: 'Notes',
				},
				controller: 'NotesListController',
				controllerAs: 'notesList',
			})

			.lazyLoadedState('index.features.times-groups-list', {
				url: '/features/times/groups/list/',
				templateUrl: 'app/components/features/times/timegroupListView.html',
				data: {
					pageTitle: 'Times and dates',
				},
				controller: 'TimegroupListController',
				controllerAs: 'timegroupList',
			})
			.lazyLoadedState('index.features.times-groups-edit', {
				url: '/features/times/groups/edit/?id',
				templateUrl: 'app/components/features/times/editTimegroupView.html',
				data: {
					pageTitle: 'Edit time group',
				},
				controller: 'EditTimegroupController',
				controllerAs: 'editTimegroup',
			})
			.lazyLoadedState('index.features.times-groups-new', {
				url: '/features/times/groups/new/',
				params: {
					id: '',
				},
				templateUrl: 'app/components/features/times/editTimegroupView.html',
				data: {
					pageTitle: 'New time group',
				},
				controller: 'EditTimegroupController',
				controllerAs: 'editTimegroup',
			})
			.lazyLoadedState('index.features.times-groups-usage', {
				url: '/features/times/groups/usage/?id',
				templateUrl: 'app/components/features/times/timegroupUsageView.html',
				data: {
					pageTitle: 'Time group usage',
				},
				controller: 'TimegroupUsageController',
				controllerAs: 'timegroupUsage',
			})
			.lazyLoadedState('index.features.times-periods-edit', {
				url: '/features/times/periods/edit/?id&timegroup',
				params: {
					timegroup: '',
				},
				templateUrl: 'app/components/features/times/editPeriodView.html',
				data: {
					pageTitle: 'Edit time period',
				},
				controller: 'EditPeriodController',
				controllerAs: 'editPeriod',
			})
			.lazyLoadedState('index.features.times-periods-new', {
				url: '/features/times/periods/new/?timegroup',
				params: {
					id: '',
				},
				templateUrl: 'app/components/features/times/editPeriodView.html',
				data: {
					pageTitle: 'New time period',
				},
				controller: 'EditPeriodController',
				controllerAs: 'editPeriod',
			})
			.lazyLoadedState('index.features.times-help', {
				// url: '/features/times/groups/help/?name',
				url: '/features/times/help/?name',
				params: {
					name: 'help_times_body',
				},
				templateUrl: 'app/components/help/documentation/helpDocumentationViewView.html',
				data: {
					pageTitle: 'Help for Times and dates',
				},
				controller: 'HelpDocumentationViewController',
				controllerAs: 'helpView',
			})
			.lazyLoadedState('index.features.times-groups-notes', {
				url: '/features/times/groups/notes/list/?snumber',
				params: {
					stype: 'timegroup',
				},
				templateUrl: 'app/components/utils/notesListView.html',
				data: {
					pageTitle: 'Notes',
				},
				controller: 'NotesListController',
				controllerAs: 'notesList',
			})

			/** Devices and numbers */

			.lazyLoadedState('index.devices', {
				abstract: true,
				template: '<div ui-view></div>',
				data: {
					pageTitle: 'Devices and numbers',
				},
			})

			.lazyLoadedState('index.devices.speeddials-list', {
				url: '/devices/speeddials/list/',
				templateUrl: 'app/components/devices/speeddials/speeddialsListView.html',
				data: {
					pageTitle: 'Speed dials',
				},
				controller: 'FSpeeddialsListController',
				controllerAs: 'fSpeeddialsList',
			})
			.lazyLoadedState('index.devices.speeddials-edit', {
				url: '/devices/speeddials/edit/?id',
				templateUrl: 'app/components/devices/speeddials/editSpeeddialView.html',
				data: {
					pageTitle: 'Edit speed dial',
				},
				controller: 'EditSpeeddialController',
				controllerAs: 'editSpeeddial',
			})
			.lazyLoadedState('index.devices.speeddials-new', {
				url: '/devices/speeddials/new/',
				params: {
					id: '',
				},
				templateUrl: 'app/components/devices/speeddials/editSpeeddialView.html',
				data: {
					pageTitle: 'New speed dials',
				},
				controller: 'EditSpeeddialController',
				controllerAs: 'editSpeeddial',
			})
			.lazyLoadedState('index.devices.speeddials-help', {
				url: '/devices/speeddials/help/?name',
				params: {
					name: 'help_speeddials_body',
				},
				templateUrl: 'app/components/help/documentation/helpDocumentationViewView.html',
				data: {
					pageTitle: 'Help for Speed dials',
				},
				controller: 'HelpDocumentationViewController',
				controllerAs: 'helpView',
			})
			.lazyLoadedState('index.devices.speeddials-notes', {
				url: '/devices/speeddials/notes/list/?snumber',
				params: {
					stype: 'speeddial',
				},
				templateUrl: 'app/components/utils/notesListView.html',
				data: {
					pageTitle: 'Notes',
				},
				controller: 'NotesListController',
				controllerAs: 'notesList',
			})

			.lazyLoadedState('index.devices.lines-list', {
				url: '/devices/lines/list/',
				templateUrl: 'app/components/devices/lines/linesListView.html',
				data: {
					pageTitle: 'Lines',
				},
				controller: 'LinesListController',
				controllerAs: 'linesList',
			})
			.lazyLoadedState('index.devices.lines', {
				url: '/devices/lines/edit/?line',
				params: {
					line: '',
				},
				templateUrl: 'app/components/devices/lines/linesSettingsView.html',
				data: {
					pageTitle: 'Line settings',
				},
				controller: 'LinesSettingsController',
				controllerAs: 'linesSettings',
			})
			.lazyLoadedState('index.devices.lines-speeddials', {
				url: '/devices/lines/speeddials/?line',
				params: {
					line: '',
				},
				templateUrl: 'app/components/devices/lines/speeddials/speeddialsListView.html',
				data: {
					pageTitle: 'Speed dials',
				},
				controller: 'SpeeddialsListController',
				controllerAs: 'speeddialsList',
			})
			.lazyLoadedState('index.devices.lines-emergency', {
				url: '/devices/lines/emergency/?line',
				params: {
					line: '',
				},
				templateUrl: 'app/components/devices/lines/emergency/emergencySettingsView.html',
				data: {
					pageTitle: 'Emergency address',
				},
				controller: 'EmergencySettingsController',
				controllerAs: 'emergencySettings',
			})

			.lazyLoadedState('index.devices.codes-list', {
				url: '/devices/codes/list/?offset&sort&descending',
				params: {
					offset: '',
					sort: '',
					descending: '',
				},
				templateUrl: 'app/components/devices/codes/codeListView.html',
				data: {
					pageTitle: 'Codes',
				},
				controller: 'CodeListController',
				controllerAs: 'codeList',
			})
			.lazyLoadedState('index.devices.codes-edit', {
				url: '/devices/codes/edit/?code',
				templateUrl: 'app/components/devices/codes/editCodeView.html',
				data: {
					pageTitle: 'Edit code',
				},
				controller: 'EditCodeController',
				controllerAs: 'editCode',
			})
			.lazyLoadedState('index.devices.codes-new', {
				url: '/devices/codes/new/',
				params: {
					code: '',
				},
				templateUrl: 'app/components/devices/codes/editCodeView.html',
				data: {
					pageTitle: 'New feature code',
				},
				controller: 'EditCodeController',
				controllerAs: 'editCode',
			})
			.lazyLoadedState('index.devices.codes-flow', {
				url: '/devices/codes/flow/?dnumber',
				templateUrl: 'app/components/utils/flow/callFlowsView.html',
				params: {
					dtype: 'code',
					dnumber: '',
				},
				data: {
					pageTitle: 'Call flow',
				},
				controller: 'CallFlowsController',
				controllerAs: 'callFlows',
			})
			.lazyLoadedState('index.devices.codes-help', {
				url: '/devices/codes/help/?name',
				params: {
					name: 'help_codes_body',
				},
				templateUrl: 'app/components/help/documentation/helpDocumentationViewView.html',
				data: {
					pageTitle: 'Help for Feature codes',
				},
				controller: 'HelpDocumentationViewController',
				controllerAs: 'helpView',
			})
			.lazyLoadedState('index.devices.codes-notes', {
				url: '/devices/codes/notes/list/?snumber',
				params: {
					stype: 'code',
				},
				templateUrl: 'app/components/utils/notesListView.html',
				data: {
					pageTitle: 'Notes',
				},
				controller: 'NotesListController',
				controllerAs: 'notesList',
			})

			.lazyLoadedState('index.devices.prefixes-list', {
				url: '/devices/prefixes/list/',
				templateUrl: 'app/components/devices/prefixes/prefixListView.html',
				data: {
					pageTitle: 'Feature prefixes',
				},
				controller: 'PrefixListController',
				controllerAs: 'prefixList',
			})
			.lazyLoadedState('index.devices.prefixes-edit', {
				url: '/devices/prefixes/edit/?id',
				templateUrl: 'app/components/devices/prefixes/editPrefixView.html',
				data: {
					pageTitle: 'Edit prefix',
				},
				controller: 'EditPrefixController',
				controllerAs: 'editPrefix',
			})
			.lazyLoadedState('index.devices.prefixes-new', {
				url: '/devices/prefixes/new/',
				params: {
					id: '',
				},
				templateUrl: 'app/components/devices/prefixes/editPrefixView.html',
				data: {
					pageTitle: 'New prefix',
				},
				controller: 'EditPrefixController',
				controllerAs: 'editPrefix',
			})
			.lazyLoadedState('index.devices.prefixes-help', {
				url: '/devices/prefixes/help/?name',
				params: {
					name: 'help_prefixes_body',
				},
				templateUrl: 'app/components/help/documentation/helpDocumentationViewView.html',
				data: {
					pageTitle: 'Help for Feature prefixes',
				},
				controller: 'HelpDocumentationViewController',
				controllerAs: 'helpView',
			})
			.lazyLoadedState('index.devices.prefixes-notes', {
				url: '/devices/prefixes/notes/list/?snumber',
				params: {
					stype: 'prefix',
				},
				templateUrl: 'app/components/utils/notesListView.html',
				data: {
					pageTitle: 'Notes',
				},
				controller: 'NotesListController',
				controllerAs: 'notesList',
			})

			.lazyLoadedState('index.devices.numbers-list', {
				url: '/devices/numbers/list/?offset&sort&descending',
				params: {
					offset: '',
					sort: '',
					descending: '',
				},
				templateUrl: 'app/components/devices/numbers/numberListView.html',
				data: {
					pageTitle: 'Numbers',
				},
				controller: 'NumberListController',
				controllerAs: 'numberList',
			})
			.lazyLoadedState('index.devices.numbers-edit', {
				url: '/devices/numbers/edit/?number',
				params: {
					new: '',
					port: '',
					class: '',
					classnumber: '',
					ingroup: '',
				},
				templateUrl: 'app/components/devices/numbers/editNumberView.html',
				data: {
					pageTitle: 'Edit number',
				},
				controller: 'EditNumberController',
				controllerAs: 'editNumber',
			})
			.lazyLoadedState('index.devices.numbers-new', {
				url: '/devices/numbers/new/',
				params: {
					copy: '',
				},
				templateUrl: 'app/components/devices/numbers/newNumberView.html',
				data: {
					pageTitle: 'New number',
				},
				controller: 'NewNumberController',
				controllerAs: 'newNumber',
			})
			.lazyLoadedState('index.devices.numbers-copy', {
				url: '/devices/numbers/copy/?copy',
				params: {
					copy: '',
				},
				templateUrl: 'app/components/devices/numbers/newNumberView.html',
				data: {
					pageTitle: 'Copy number',
				},
				controller: 'NewNumberController',
				controllerAs: 'newNumber',
			})
			.lazyLoadedState('index.devices.numbers-choose', {
				url: '/devices/numbers/choose/?copy&ingroup&code',
				params: {
					copy: '',
					ingroup: '0',
					code: '0',
				},
				templateUrl: 'app/components/devices/numbers/chooseNumberView.html',
				data: {
					pageTitle: 'Choose number',
				},
				controller: 'ChooseNumberController',
				controllerAs: 'chooseNumber',
			})
			.lazyLoadedState('index.devices.numbers-bulk', {
				url: '/devices/numbers/bulk/',
				templateUrl: 'app/components/devices/numbers/bulkChangeNumbersView.html',
				data: {
					pageTitle: 'Bulk change',
				},
				controller: 'BulkChangeNumbersController',
				controllerAs: 'bulkChangeNum',
			})
			.lazyLoadedState('index.devices.numbers-flow', {
				url: '/devices/numbers/flow/?dnumber',
				templateUrl: 'app/components/utils/flow/callFlowsView.html',
				params: {
					dtype: 'number',
					dnumber: '',
				},
				data: {
					pageTitle: 'Call flow',
				},
				controller: 'CallFlowsController',
				controllerAs: 'callFlows',
			})
			.lazyLoadedState('index.devices.numbers-help', {
				url: '/devices/numbers/help/?name',
				params: {
					name: 'help_numbers_body',
				},
				templateUrl: 'app/components/help/documentation/helpDocumentationViewView.html',
				data: {
					pageTitle: 'Help for Numbers',
				},
				controller: 'HelpDocumentationViewController',
				controllerAs: 'helpView',
			})
			.lazyLoadedState('index.devices.numbers-notes', {
				url: '/devices/numbers/notes/list/?snumber',
				params: {
					stype: 'number',
				},
				templateUrl: 'app/components/utils/notesListView.html',
				data: {
					pageTitle: 'Notes',
				},
				controller: 'NotesListController',
				controllerAs: 'notesList',
			})

			.lazyLoadedState('index.devices.provisioning-list', {
				url: '/devices/provisioning/list/',
				templateUrl: 'app/components/devices/provisioning/provisioningListView.html',
				data: {
					pageTitle: 'Provisioning templates',
				},
				controller: 'ProvisioningListController',
				controllerAs: 'provisioningList',
			})
			.lazyLoadedState('index.devices.provisioning-edit', {
				url: '/devices/provisioning/edit/?id',
				templateUrl: 'app/components/devices/provisioning/editProvisioningView.html',
				data: {
					pageTitle: 'Edit provisioning template',
				},
				controller: 'EditProvisioningController',
				controllerAs: 'editProvisioning',
			})
			.lazyLoadedState('index.devices.provisioning-new', {
				url: '/devices/provisioning/new/',
				params: {
					id: '',
				},
				templateUrl: 'app/components/devices/provisioning/editProvisioningView.html',
				data: {
					pageTitle: 'New provisioning template',
				},
				controller: 'EditProvisioningController',
				controllerAs: 'editProvisioning',
			})
			.lazyLoadedState('index.devices.provisioning-help', {
				url: '/devices/provisioning/help/?name',
				params: {
					name: 'help_provisioning_body',
				},
				templateUrl: 'app/components/help/documentation/helpDocumentationViewView.html',
				data: {
					pageTitle: 'Help for Provisioning',
				},
				controller: 'HelpDocumentationViewController',
				controllerAs: 'helpView',
			})
			.lazyLoadedState('index.devices.provisioning-notes', {
				url: '/devices/provisioning/notes/list/?snumber',
				params: {
					stype: 'provisioning',
				},
				templateUrl: 'app/components/utils/notesListView.html',
				data: {
					pageTitle: 'Notes',
				},
				controller: 'NotesListController',
				controllerAs: 'notesList',
			})

			.lazyLoadedState('index.devices.access-list', {
				url: '/devices/access/list/',
				templateUrl: 'app/components/devices/access/accessListView.html',
				data: {
					pageTitle: 'Remote access accounts',
				},
				controller: 'AccessListController',
				controllerAs: 'accessList',
			})
			.lazyLoadedState('index.devices.access-edit', {
				url: '/devices/access/edit/?id',
				templateUrl: 'app/components/devices/access/editAccessView.html',
				data: {
					pageTitle: 'Edit remote access account',
				},
				controller: 'EditAccessController',
				controllerAs: 'editAccess',
			})
			.lazyLoadedState('index.devices.access-new', {
				url: '/devices/access/new/',
				params: {
					id: 0,
				},
				templateUrl: 'app/components/devices/access/editAccessView.html',
				data: {
					pageTitle: 'New remote access account',
				},
				controller: 'EditAccessController',
				controllerAs: 'editAccess',
			})
			.lazyLoadedState('index.devices.access-help', {
				url: '/devices/access/help/?name',
				params: {
					name: 'help_access_body',
				},
				templateUrl: 'app/components/help/documentation/helpDocumentationViewView.html',
				data: {
					pageTitle: 'Help for Remote access',
				},
				controller: 'HelpDocumentationViewController',
				controllerAs: 'helpView',
			})
			.lazyLoadedState('index.devices.access-notes', {
				url: '/devices/access/notes/list/?snumber',
				params: {
					stype: 'access',
				},
				templateUrl: 'app/components/utils/notesListView.html',
				data: {
					pageTitle: 'Notes',
				},
				controller: 'NotesListController',
				controllerAs: 'notesList',
			})

			.lazyLoadedState('index.devices.addresses-list', {
				url: '/devices/addresses/list/',
				templateUrl: 'app/components/devices/addresses/addressListView.html',
				data: {
					pageTitle: 'SIP addresses',
				},
				controller: 'AddressListController',
				controllerAs: 'addressList',
			})
			.lazyLoadedState('index.devices.addresses-edit', {
				url: '/devices/addresses/edit/?id',
				templateUrl: 'app/components/devices/addresses/editAddressView.html',
				data: {
					pageTitle: 'Edit SIP address',
				},
				controller: 'EditAddressController',
				controllerAs: 'editAddress',
			})
			.lazyLoadedState('index.devices.addresses-new', {
				url: '/devices/addresses/new/',
				params: {
					id: 0,
				},
				templateUrl: 'app/components/devices/addresses/editAddressView.html',
				data: {
					pageTitle: 'New SIP address',
				},
				controller: 'EditAddressController',
				controllerAs: 'editAddress',
			})
			.lazyLoadedState('index.devices.addresses-help', {
				url: '/devices/addresses/help/?name',
				params: {
					name: 'help_addresses_body',
				},
				templateUrl: 'app/components/help/documentation/helpDocumentationViewView.html',
				data: {
					pageTitle: 'Help for SIP addresses',
				},
				controller: 'HelpDocumentationViewController',
				controllerAs: 'helpView',
			})
			.lazyLoadedState('index.devices.addresses-notes', {
				url: '/devices/addresses/notes/list/?snumber',
				params: {
					stype: 'address',
				},
				templateUrl: 'app/components/utils/notesListView.html',
				data: {
					pageTitle: 'Notes',
				},
				controller: 'NotesListController',
				controllerAs: 'notesList',
			})

			.lazyLoadedState('index.devices.phones-list', {
				url: '/devices/phones/list/?offset&sort&descending',
				params: {
					offset: '',
					sort: '',
					descending: '',
				},
				templateUrl: 'app/components/devices/phones/phoneListView.html',
				data: {
					pageTitle: 'Telephone lines',
				},
				controller: 'PhoneListController',
				controllerAs: 'phoneList',
			})
			.lazyLoadedState('index.devices.phones-edit', {
				url: '/devices/phones/edit/?name',
				templateUrl: 'app/components/devices/phones/editPhoneView.html',
				data: {
					pageTitle: 'Edit telephone line',
				},
				controller: 'EditPhoneController',
				controllerAs: 'editPhone',
			})
			.lazyLoadedState('index.devices.phones-new', {
				url: '/devices/phones/new/',
				params: {
					name: '',
				},
				templateUrl: 'app/components/devices/phones/editPhoneView.html',
				data: {
					pageTitle: 'New telephone line',
				},
				controller: 'EditPhoneController',
				controllerAs: 'editPhone',
			})
			.lazyLoadedState('index.devices.phones-speeddials', {
				url: '/devices/phones/speeddials/?name',
				params: {
					name: '',
				},
				templateUrl: 'app/components/devices/phones/speeddials/speeddialsListView.html',
				data: {
					pageTitle: 'Speed dials',
				},
				controller: 'PSpeeddialsListController',
				controllerAs: 'pSpeeddialsList',
			})
			.lazyLoadedState('index.devices.phones-emergency', {
				url: '/devices/phones/emergency/?line',
				params: {
					line: '',
				},
				templateUrl: 'app/components/devices/phones/emergency/emergencySettingsView.html',
				data: {
					pageTitle: 'Emergency address',
				},
				controller: 'PEmergencySettingsController',
				controllerAs: 'emergencyAddress',
			})
			.lazyLoadedState('index.devices.phones-missedcalls', {
				url: '/devices/phones/missedcalls/?line',
				params: {
					line: '',
				},
				templateUrl: 'app/components/devices/phones/missedcalls/missedCallsView.html',
				data: {
					pageTitle: 'Missed calls',
				},
				controller: 'MissedCallsController',
				controllerAs: 'missedCalls',
			})
			.lazyLoadedState('index.devices.phones-huntgroups', {
				url: '/devices/phones/huntgroups/?line',
				params: {
					line: '',
				},
				templateUrl: 'app/components/devices/phones/huntgroups/phoneHuntgroupsView.html',
				data: {
					pageTitle: 'Telephone line hunt groups',
				},
				controller: 'PhoneHuntgroupsController',
				controllerAs: 'phoneHuntgroups',
			})
			.lazyLoadedState('index.devices.phones-queues', {
				url: '/devices/phones/queues/?line',
				params: {
					line: '',
				},
				templateUrl: 'app/components/devices/phones/queues/phoneQueuesView.html',
				data: {
					pageTitle: 'Telephone line queues',
				},
				controller: 'PhoneQueuesController',
				controllerAs: 'phoneQueues',
			})
			.lazyLoadedState('index.devices.phones-lamps', {
				url: '/devices/phones/lamps/?line',
				params: {
					line: '',
				},
				templateUrl: 'app/components/devices/phones/lamps/busyLampsView.html',
				data: {
					pageTitle: 'Busy lamps',
				},
				controller: 'BusyLampsController',
				controllerAs: 'busyLamps',
			})
			.lazyLoadedState('index.devices.phones-events', {
				url: '/devices/phones/events/?line&start&end&archive',
				params: {
					line: '',
					start: '',
					end: '',
					archive: '',
				},
				templateUrl: 'app/components/devices/phones/events/registrationEventsView.html',
				data: {
					pageTitle: 'Registration history',
				},
				controller: 'RegistrationEventsController',
				controllerAs: 'regEvents',
			})
			.lazyLoadedState('index.devices.phones-bulk', {
				url: '/devices/phones/bulk/?line',
				params: {
					line: '',
				},
				templateUrl: 'app/components/devices/phones/bulk/bulkEditPhoneView.html',
				data: {
					pageTitle: 'Bulk change',
				},
				controller: 'BulkEditPhoneController',
				controllerAs: 'bulkPhone',
			})
			.lazyLoadedState('index.devices.phones-bulk-add', {
				url: '/devices/phones/bulk/add/',
				templateUrl: 'app/components/devices/phones/bulkAddPhonesView.html',
				data: {
					pageTitle: 'Bulk add telephone lines',
				},
				controller: 'BulkAddPhonesController',
				controllerAs: 'bulkAddPhones',
			})
			.lazyLoadedState('index.devices.phones-help', {
				url: '/devices/phones/help/?name',
				params: {
					name: 'help_phones_body',
				},
				templateUrl: 'app/components/help/documentation/helpDocumentationViewView.html',
				data: {
					pageTitle: 'Help for Telephone lines',
				},
				controller: 'HelpDocumentationViewController',
				controllerAs: 'helpView',
			})
			.lazyLoadedState('index.devices.phones-notes', {
				url: '/devices/phones/notes/list/?snumber',
				params: {
					stype: 'phone',
				},
				templateUrl: 'app/components/utils/notesListView.html',
				data: {
					pageTitle: 'Notes',
				},
				controller: 'NotesListController',
				controllerAs: 'notesList',
			})

			/** Billing and analysis */

			.lazyLoadedState('index.reports', {
				abstract: true,
				template: '<div ui-view></div>',
				data: {
					pageTitle: 'Reports',
				},
			})

			.lazyLoadedState('index.reports.audit-list', {
				url: '/reports/audit/list/?customer&start&end&column&match&value&archive',
				params: {
					customer: '',
					start: '',
					end: '',
					column: '',
					match: '',
					value: '',
					archive: '',
				},
				templateUrl: 'app/components/reports/audit/auditLogView.html',
				data: {
					pageTitle: 'Audit log',
				},
				controller: 'AuditLogController',
				controllerAs: 'auditLog',
			})
			.lazyLoadedState('index.reports.audit-help', {
				url: '/reports/audit/help/?name',
				params: {
					name: 'help_audit_body',
				},
				templateUrl: 'app/components/help/documentation/helpDocumentationViewView.html',
				data: {
					pageTitle: 'Help for Audit log',
				},
				controller: 'HelpDocumentationViewController',
				controllerAs: 'helpView',
			})

			.lazyLoadedState('index.reports.commerce-list', {
				url: '/reports/commerce/list/?start&end',
				templateUrl: 'app/components/reports/commerce/commerceStatisticsView.html',
				params: {
					start: '',
					end: '',
				},
				data: {
					pageTitle: 'Commercial reports',
				},
				controller: 'CommerceStatisticsController',
				controllerAs: 'commerceStats',
			})
			.lazyLoadedState('index.reports.commerce-help', {
				url: '/reports/commerce/help/?name',
				params: {
					name: 'help_commerce_report_body',
				},
				templateUrl: 'app/components/help/documentation/helpDocumentationViewView.html',
				data: {
					pageTitle: 'Help for Commercial reports',
				},
				controller: 'HelpDocumentationViewController',
				controllerAs: 'helpView',
			})

			.lazyLoadedState('index.reports.customers-list', {
				url: '/reports/customers/list/?customer&search&number&sort&descending',
				templateUrl: 'app/components/reports/customers/customerReportsView.html',
				params: {
					customer: '',
					search: '',
					number: '',
					sort: '',
					descending: '',
				},
				data: {
					pageTitle: 'Customer reports',
				},
				controller: 'CustomerReportsController',
				controllerAs: 'customerReports',
			})
			.lazyLoadedState('index.reports.customers-help', {
				url: '/reports/customers/help/?name',
				params: {
					name: 'help_customers_report_body',
				},
				templateUrl: 'app/components/help/documentation/helpDocumentationViewView.html',
				data: {
					pageTitle: 'Help for Customer reports',
				},
				controller: 'HelpDocumentationViewController',
				controllerAs: 'helpView',
			})

			.lazyLoadedState('index.reports.invoices-list', {
				url: '/reports/invoices/list/?customer&start&end&status&sort&descending',
				params: {
					customer: '',
					start: '',
					end: '',
					status: '',
					sort: '',
					descending: '',
				},
				templateUrl: 'app/components/reports/invoices/invoicesListView.html',
				data: {
					pageTitle: 'Invoices',
				},
				controller: 'InvoicesListController',
				controllerAs: 'invoicesList',
			})
			.lazyLoadedState('index.reports.invoices-help', {
				url: '/reports/invoices/help/?name',
				params: {
					name: 'help_invoices_body',
				},
				templateUrl: 'app/components/help/documentation/helpDocumentationViewView.html',
				data: {
					pageTitle: 'Help for Invoices',
				},
				controller: 'HelpDocumentationViewController',
				controllerAs: 'helpView',
			})
			.lazyLoadedState('index.reports.invoices-edit', {
				url: '/reports/invoices/edit/?id&status&customer&start&end&sort&descending',
				params: {
					id: '',
					status: '',
					customer: '0',
					start: '',
					end: '',
					sort: 'number',
					descending: '',
				},
				templateUrl: 'app/components/reports/invoices/editInvoiceView.html',
				data: {
					pageTitle: 'Edit invoice',
				},
				controller: 'EditInvoiceController',
				controllerAs: 'editInvoice',
			})
			.lazyLoadedState('index.reports.invoices-transactions-list', {
				url: '/reports/invoices/transactions/list/?invoice&status&customer&start&end&sort&descending',
				params: {
					invoice: '',
					status: '',
					customer: '0',
					start: '',
					end: '',
					sort: 'number',
					descending: '',
				},
				templateUrl: 'app/components/reports/invoices/transactions/transactionListView.html',
				data: {
					pageTitle: 'Transactions',
				},
				controller: 'TransactionListController',
				controllerAs: 'transactionList',
			})
			.lazyLoadedState('index.reports.invoices-transactions-edit', {
				url:
					'/reports/invoices/transactions/edit/?id&invoice_customer&invoice&status&customer&start&end&sort&descending',
				params: {
					id: '',
					invoice_customer: '',
					invoice: '',
					status: '',
					customer: '0',
					start: '',
					end: '',
					sort: 'number',
					descending: '',
				},
				templateUrl: 'app/components/reports/invoices/transactions/editTransactionView.html',
				data: {
					pageTitle: 'Edit transaction',
				},
				controller: 'EditTransactionController',
				controllerAs: 'editTransaction',
			})
			.lazyLoadedState('index.reports.invoices-transactions-bulk', {
				url:
					'/reports/invoices/transactions/bulk/?id&invoice_customer&invoice&status&customer&start&end&sort&descending',
				params: {
					id: '',
					invoice_customer: '',
					invoice: '',
					status: '',
					customer: '0',
					start: '',
					end: '',
					sort: 'number',
					descending: '',
				},
				templateUrl: 'app/components/reports/invoices/transactions/bulkChangeTransactionView.html',
				data: {
					pageTitle: 'Bulk change',
				},
				controller: 'BulkChangeTransactionController',
				controllerAs: 'bulkChangeTransaction',
			})
			.lazyLoadedState('index.reports.invoices-transactions-new', {
				url: '/reports/invoices/transactions/new/?invoice&invoice_customer&status&customer&start&end&sort&descending',
				params: {
					id: '',
					invoice_customer: '',
					invoice: '',
					status: '',
					customer: '0',
					start: '',
					end: '',
					sort: 'number',
					descending: '',
				},
				templateUrl: 'app/components/reports/invoices/transactions/editTransactionView.html',
				data: {
					pageTitle: 'New transaction',
				},
				controller: 'EditTransactionController',
				controllerAs: 'editTransaction',
			})
			.lazyLoadedState('index.reports.invoices-cdrs-list', {
				url: '/reports/invoices/cdrs/list/?invoice&status&customer&start&end&sort&descending',
				params: {
					invoice: '',
					status: '',
					customer: '0',
					start: '',
					end: '',
					sort: 'number',
					descending: '',
				},
				templateUrl: 'app/components/reports/invoices/cdrs/cdrListView.html',
				data: {
					pageTitle: 'Calls',
				},
				controller: 'CdrListController',
				controllerAs: 'cdrList',
			})
			.lazyLoadedState('index.reports.invoices-cdrs-edit', {
				url: '/reports/invoices/cdrs/edit/?uniqueid&invoice_customer&invoice&status&customer&start&end&sort&descending',
				params: {
					uniqueid: '',
					invoice_customer: '',
					invoice: '',
					status: '',
					customer: '0',
					start: '',
					end: '',
					sort: 'number',
					descending: '',
				},
				templateUrl: 'app/components/reports/invoices/cdrs/editCdrView.html',
				data: {
					pageTitle: 'Edit call',
				},
				controller: 'EditCdrController',
				controllerAs: 'editCdr',
			})
			.lazyLoadedState('index.reports.invoices-email-edit', {
				url: '/reports/invoices/email/edit/',
				templateUrl: 'app/components/reports/invoices/email/emailInvoicesView.html',
				data: {
					pageTitle: 'Email invoices',
				},
				controller: 'EmailInvoicesController',
				controllerAs: 'emailInvoices',
			})

			.lazyLoadedState('index.reports.users-list', {
				url: '/reports/users/list/?role',
				params: {
					role: '',
				},
				templateUrl: 'app/components/reports/users/peopleReportsView.html',
				data: {
					pageTitle: 'User reports',
				},
				controller: 'PeopleReportsController',
				controllerAs: 'peopleReports',
			})
			.lazyLoadedState('index.reports.users-help', {
				url: '/reports/users/help/?name',
				params: {
					name: 'help_users_report_body',
				},
				templateUrl: 'app/components/help/documentation/helpDocumentationViewView.html',
				data: {
					pageTitle: 'Help for User reports',
				},
				controller: 'HelpDocumentationViewController',
				controllerAs: 'helpView',
			})

			.lazyLoadedState('index.reports.statistics-list', {
				url: '/reports/statistics/list/?machine&name&start&end',
				params: {
					machine: '',
					name: '',
					start: '',
					end: '',
				},
				templateUrl: 'app/components/reports/statistics/machineStatisticsView.html',
				data: {
					pageTitle: 'System usage',
				},
				controller: 'MachineStatisticsController',
				controllerAs: 'machineStatistics',
			})
			.lazyLoadedState('index.reports.statistics-help', {
				url: '/reports/statistics/help/?name',
				params: {
					name: 'help_statistics_body',
				},
				templateUrl: 'app/components/help/documentation/helpDocumentationViewView.html',
				data: {
					pageTitle: 'Help for System usage',
				},
				controller: 'HelpDocumentationViewController',
				controllerAs: 'helpView',
			})

			.lazyLoadedState('index.reports.phones-list', {
				url: '/reports/phones/list/?registered',
				params: {
					registered: '',
				},
				templateUrl: 'app/components/reports/phones/telephoneLinesView.html',
				data: {
					pageTitle: 'Telephone lines',
				},
				controller: 'TelephoneLinesController',
				controllerAs: 'telephoneLines',
			})
			.lazyLoadedState('index.reports.phones-help', {
				url: '/reports/phones/help/?name',
				params: {
					name: 'help_phones_report_body',
				},
				templateUrl: 'app/components/help/documentation/helpDocumentationViewView.html',
				data: {
					pageTitle: 'Help for Telephone reports',
				},
				controller: 'HelpDocumentationViewController',
				controllerAs: 'helpView',
			})

			.lazyLoadedState('index.reports.top-list', {
				url: '/reports/top/list/?list&start&end&direction&maximum',
				params: {
					list: '',
					start: '',
					end: '',
					direction: '',
					maximum: '',
				},
				templateUrl: 'app/components/reports/top/topListsView.html',
				data: {
					pageTitle: 'Top lists',
				},
				controller: 'TopListsController',
				controllerAs: 'topLists',
			})
			.lazyLoadedState('index.reports.top-help', {
				url: '/reports/top/help/?name',
				params: {
					name: 'help_top_lists_body',
				},
				templateUrl: 'app/components/help/documentation/helpDocumentationViewView.html',
				data: {
					pageTitle: 'Help for Top lists',
				},
				controller: 'HelpDocumentationViewController',
				controllerAs: 'helpView',
			})

			.lazyLoadedState('index.reports.traces-list', {
				url: '/reports/traces/list/',
				templateUrl: 'app/components/reports/traces/tracesListView.html',
				data: {
					pageTitle: 'Traces',
				},
				controller: 'TracesListController',
				controllerAs: 'traceList',
			})
			.lazyLoadedState('index.reports.traces-new', {
				url: '/reports/traces/new/',
				templateUrl: 'app/components/reports/traces/editTraceView.html',
				data: {
					pageTitle: 'New trace',
				},
				controller: 'EditTraceController',
				controllerAs: 'editTraces',
			})
			.lazyLoadedState('index.reports.traces-start', {
				url: '/reports/traces/start/?started',
				params: {
					started: '',
				},
				templateUrl: 'app/components/reports/traces/editTraceView.html',
				data: {
					pageTitle: 'Trace running',
				},
				controller: 'EditTraceController',
				controllerAs: 'editTraces',
			})
			.lazyLoadedState('index.reports.traces-view-list', {
				url: '/reports/traces/view/list/?timestamp&machine',
				params: {
					timestamp: '0',
					machine: '',
				},
				templateUrl: 'app/components/reports/traces/view/traceCallsView.html',
				data: {
					pageTitle: 'Calls for trace',
				},
				controller: 'TraceCallsController',
				controllerAs: 'traceCalls',
			})
			.lazyLoadedState('index.reports.traces-view-call', {
				url: '/reports/traces/view/call/?timestamp&machine&callid',
				params: {
					timestamp: '0',
					machine: '',
					callid: '',
				},
				templateUrl: 'app/components/reports/traces/view/traceCallView.html',
				data: {
					pageTitle: 'Call',
				},
				controller: 'TraceCallController',
				controllerAs: 'traceCall',
			})
			.lazyLoadedState('index.reports.traces-help', {
				url: '/reports/traces/help/?name',
				params: {
					name: 'help_traces_body',
				},
				templateUrl: 'app/components/help/documentation/helpDocumentationViewView.html',
				data: {
					pageTitle: 'Help for Traces',
				},
				controller: 'HelpDocumentationViewController',
				controllerAs: 'helpView',
			})

			.lazyLoadedState('index.reports.transactions-list', {
				url: '/reports/transactions/list/?customer&start&end&amount_minimum&amount_maximum&include_tax&archive',
				params: {
					customer: '',
					start: '',
					end: '',
					amount_minimum: '',
					amount_maximum: '',
					include_tax: '',
					archive: '',
				},
				templateUrl: 'app/components/reports/transactions/transactionReportView.html',
				data: {
					pageTitle: 'Transactions',
				},
				controller: 'TransactionReportController',
				controllerAs: 'transactionReport',
			})
			.lazyLoadedState('index.reports.transactions-edit', {
				url: '/reports/transactions/edit/?id&customer&start&end&amount_minimum&amount_maximum&sort&descending',
				params: {
					id: '',
					customer: '0',
					amount_minimum: '',
					amount_maximum: '',
					start: '',
					end: '',
					sort: 'number',
					descending: '',
				},
				templateUrl: 'app/components/reports/transactions/editReportTransactionView.html',
				data: {
					pageTitle: 'Edit transaction',
				},
				controller: 'EditReportTransactionController',
				controllerAs: 'editReportTransaction',
			})
			.lazyLoadedState('index.reports.transactions-bulk', {
				url: '/reports/transactions/bulk/?customer&start&end&amount_min&amount_max&sort&descending&archive',
				params: {
					customer: '0',
					amount_min: '',
					amount_max: '',
					start: '',
					end: '',
					sort: 'time',
					descending: '',
					archive: '',
				},
				templateUrl: 'app/components/reports/transactions/bulkChangeReportTransactionsView.html',
				data: {
					pageTitle: 'Bulk change',
				},
				controller: 'BulkChangeReportTransactionsController',
				controllerAs: 'bulkChangeReportTransactions',
			})
			.lazyLoadedState('index.reports.transactions-help', {
				url: '/reports/transactions/help/?name',
				params: {
					name: 'help_transactions_body',
				},
				templateUrl: 'app/components/help/documentation/helpDocumentationViewView.html',
				data: {
					pageTitle: 'Help for Transactions',
				},
				controller: 'HelpDocumentationViewController',
				controllerAs: 'helpView',
			})

			.lazyLoadedState('index.reports.plans', {
				url: '/reports/plans/',
				templateUrl: 'app/components/reports/plans/plansReportView.html',
				data: {
					pageTitle: 'Rate plan',
				},
				controller: 'PlansReportController',
				controllerAs: 'plansReport',
			})
			.lazyLoadedState('index.reports.plans-fees', {
				url: '/reports/plans/fees/?plan&taxes',
				params: {
					plan: '',
					taxes: '',
				},
				templateUrl: 'app/components/reports/plans/fees/planFeesReportView.html',
				data: {
					pageTitle: 'Rate plan fees',
				},
				controller: 'PlanFeesReportController',
				controllerAs: 'planFeesReport',
			})
			.lazyLoadedState('index.reports.plans-incosts', {
				url: '/reports/plans/incosts/?plan&taxes&offset',
				params: {
					plan: '',
					taxes: '',
					offset: '',
				},
				templateUrl: 'app/components/reports/plans/incosts/planIncostsReportView.html',
				data: {
					pageTitle: 'Rate plan inbound costs',
				},
				controller: 'PlanIncostsReportController',
				controllerAs: 'planIncostsReport',
			})
			.lazyLoadedState('index.reports.plans-outcosts', {
				url: '/reports/plans/outcosts/?plan&search&taxes&offset',
				params: {
					plan: '',
					search: '',
					taxes: '',
					offset: '',
				},
				templateUrl: 'app/components/reports/plans/outcosts/planOutcostsReportView.html',
				data: {
					pageTitle: 'Rate plan outbound costs',
				},
				controller: 'PlanOutcostsReportController',
				controllerAs: 'planOutcostsReport',
			})
			.lazyLoadedState('index.reports.plans-destination', {
				url: '/reports/plans/destination/?plan&destination&taxes&offset',
				params: {
					plan: '',
					destination: '',
					taxes: '',
					offset: '',
				},
				templateUrl: 'app/components/reports/plans/destination/planDestinationReportView.html',
				data: {
					pageTitle: 'Cost to destination number',
				},
				controller: 'PlanDestinationReportController',
				controllerAs: 'planDestinationReport',
			})
			.lazyLoadedState('index.reports.plans-help', {
				url: '/reports/plans/help/?name',
				params: {
					name: 'help_plans_report_body',
				},
				templateUrl: 'app/components/help/documentation/helpDocumentationViewView.html',
				data: {
					pageTitle: 'Help for View rate plan',
				},
				controller: 'HelpDocumentationViewController',
				controllerAs: 'helpView',
			})

			/** Help */

			.lazyLoadedState('index.help', {
				abstract: true,
				template: '<div ui-view></div>',
				data: {
					pageTitle: 'Help',
				},
			})
			.lazyLoadedState('index.help.support-list', {
				url: '/help/support/list/?status&search&sort&descending&offset',
				params: {
					status: '',
					search: '',
					sort: '',
					descending: '',
					offset: '',
				},
				templateUrl: 'app/components/help/support/helpSupportView.html',
				data: {
					pageTitle: 'Support',
				},
				controller: 'HelpSupportController',
				controllerAs: 'helpSupport',
			})
			.lazyLoadedState('index.help.support-ticket', {
				url: '/help/support/ticket/?id',
				params: {
					id: '',
				},
				templateUrl: 'app/components/help/support/helpTicketView.html',
				data: {
					pageTitle: 'View ticket',
				},
				controller: 'HelpTicketController',
				controllerAs: 'helpTicket',
			})
			.lazyLoadedState('index.help.support-new', {
				url: '/help/support/new/',
				templateUrl: 'app/components/help/support/newTicketView.html',
				data: {
					pageTitle: 'New ticket',
				},
				controller: 'NewTicketController',
				controllerAs: 'newTicket',
			})
			.lazyLoadedState('index.help.support-help', {
				url: '/help/support/help/?name',
				params: {
					name: 'help_requiring_support_body',
				},
				templateUrl: 'app/components/help/documentation/helpDocumentationViewView.html',
				data: {
					pageTitle: 'Help for Support',
				},
				controller: 'HelpDocumentationViewController',
				controllerAs: 'helpView',
			})
			.lazyLoadedState('index.help.howto', {
				url: '/help/howto/',
				templateUrl: 'app/components/help/howto/howToView.html',
				data: {
					pageTitle: 'How-to Guides',
				},
				controller: 'HowToController',
				controllerAs: 'howTo',
			})
			.lazyLoadedState('index.help.howto-help', {
				url: '/help/howto/help/?name',
				params: {
					name: 'help_howto_body',
				},
				templateUrl: 'app/components/help/documentation/helpDocumentationViewView.html',
				data: {
					pageTitle: 'Help for how-to guides',
				},
				controller: 'HelpDocumentationViewController',
				controllerAs: 'helpView',
			})
			// .lazyLoadedState('index.help.documentation-list', {
			// 	url: '/help/documentation/list/',
			// 	templateUrl: 'app/components/help/documentation/helpDocumentationListView.html',
			// 	data: {
			// 		pageTitle: 'Documentation',
			// 	},
			// 	controller: 'HelpDocumentationListController',
			// 	controllerAs: 'helpDocumentation',
			// })
			// .lazyLoadedState('index.help.documentation-view', {
			// 	url: '/help/documentation/view/?name&language',
			// 	params: {
			// 		name: '',
			// 		language: '',
			// 	},
			// 	templateUrl: 'app/components/help/documentation/helpDocumentationViewView.html',
			// 	data: {
			// 		pageTitle: 'View topic',
			// 	},
			// 	controller: 'HelpDocumentationViewController',
			// 	controllerAs: 'helpView',
			// })

			/*
			.lazyLoadedState('index.notes-list', {
			  url: "/utils/notes/list/?stype/?snumber",
			  templateUrl: "app/components/utils/notesListView.html",
			  data: { pageTitle: 'Notes' },
			  controller: 'NotesListController',
			  controllerAs: 'notesList'
			});
			*/

			/** 404 page */

			.localizedTemplateState('index.error-page', {
				url: '/404/',
				templateUrl: 'app/components/common/404.html',
				data: {
					pageTitle: 'Page not found',
				},
			});

		/** automatically append '/' if needed */

		$urlRouterProvider.rule(function($injector, $location) {
			var path = $location.path() || '';
			if (/^\/?local\//.test(path)) {
				path = path.replace('local/', '');
				return $location.path(path);
			} else if (path && !/\/$/.test(path) && path.indexOf('?') < 0) {
				return path + '/';
			}
		});

		$urlRouterProvider.when('', '/');

		/** State not recognized from path - check if custom redirect, otherwise redirect to 404 */

		$urlRouterProvider.otherwise(function($injector, $location) {
			var $rootScope = $injector.get('$rootScope');
			var path = ($location.path() || '').replace(/^\//, '').replace(/\/$/, '');
			if (
				path.replace(/^local\//, '') !=
					($rootScope.login_redirect_url || '')
						.replace(/^\//, '')
						.replace(/^local\//, '')
						.replace(/\?.*?$/, '')
						.replace(/\/$/, '') &&
				path.replace(/^local\//, '') !=
					($rootScope.switch_redirect_url || '')
						.replace(/^\//, '')
						.replace(/^local\//, '')
						.replace(/\?.*?$/, '')
						.replace(/\/$/, '')
			) {
				return $location.replace().path('/404/');
			}
			$rootScope = null;
		});
	}

	/*
	for dynamic states:
	http://stackoverflow.com/a/25872852/1630623
	http://stackoverflow.com/a/28323471/1630623
	*/

	angular.module('new-web').config(routerConfig);
})();

'use strict';

(function() {
	/** @ngInject */
	function httpRequestConfig($httpProvider, $cookiesProvider) {
		var now = new Date();
		var n = Number(now) + 30 * 24 * 60 * 60 * 1000;
		var nextMonth = new Date(n);
		$cookiesProvider.defaults.expires = nextMonth.toString();

		//console.log($httpProvider.defaults);
		$httpProvider.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=utf-8';

		/**
		 * The workhorse; converts an object to x-www-form-urlencoded serialization.
		 * @param {Object} obj
		 * @return {String}
		 */
		var param = function(obj) {
			var query = '',
				name,
				value,
				fullSubName,
				subName,
				subValue,
				innerObj,
				i;

			for (name in obj) {
				value = obj[name];

				if (value instanceof Array) {
					for (i = 0; i < value.length; ++i) {
						subValue = value[i];
						fullSubName = name + '[' + i + ']';
						innerObj = {};
						innerObj[fullSubName] = subValue;
						query += param(innerObj) + '&';
					}
				} else if (value instanceof Object) {
					for (subName in value) {
						subValue = value[subName];
						fullSubName = name + '[' + subName + ']';
						innerObj = {};
						innerObj[fullSubName] = subValue;
						query += param(innerObj) + '&';
					}
				} else if (value !== undefined && value !== null)
					query += encodeURIComponent(name) + '=' + encodeURIComponent(value) + '&';
			}

			return query.length ? query.substr(0, query.length - 1) : query;
		};

		var configFileRegex = /\.(conf|ini)(\?v=\d+)?$/;
		var localFileRegex = /^\/?local\//;
		var localizedTemplatesRegex = /^\/?local\/templates\//;

		var shouldCache = function(request) {
			var url = request.url;
			return request.method == 'GET' && !configFileRegex.test(url)
				&& (!localFileRegex.test(url) || localizedTemplatesRegex.test(request.url));
		};

		var disableCacheIfNeeded = function(request) {
			if (request.method !== 'GET') {
				return request;
			}
			request.headers = request.headers || {};
			request.headers['Cache-Control'] = 'no-cache';
			request.cache = false;
			return request;
		};

		$httpProvider.interceptors.unshift(
			/*@ngInject*/ function($q, $injector, $rootScope) {
				return {
					request: function(request) {
						return shouldCache(request) ? request : disableCacheIfNeeded(request);
					},

					requestError: function(rejection) {
						return $q.reject(rejection);
					},

					response: function(response) {
						return response;
					},

					responseError: function(rejection) {
						return $q.reject(rejection);
					},
				};
			}
		);

		// Override $http service's default transformRequest
		$httpProvider.defaults.transformRequest = [
			function(data) {
				return angular.isObject(data) && String(data) !== '[object File]' ? param(data) : data;
			},
		];
	}

	angular.module('new-web').config(httpRequestConfig);
})();

'use strict';

(function(window, document, angular, undefined) {
	/** @ngInject */
	function runBlock() {
		// enable disabling columns and rows for filtering
		enswitchGlobals.waitForResource('footable').then(function() {
			var options = window.footable.options;

			options.filter.filterFunction = function(index) {
				var $t = $(this);

				if ($t.hasClass('footable-ignore-filter')) {
					// disable row
					return true;
				}

				var $table = $t.parents('table:first'),
					filter = $table.data('current-filter').toLowerCase(),
					//text = $t.find('td:not([data-value])').text(); // replace with data-value instaad of append! can be used to disable filtering by some columns
					text = '';

				var columns = $table.find('thead > tr:last-child > th');

				if (!$table.data('filter-text-only')) {
					$t.find('td').each(function(index) {
						// [data-value]
						var columnData = columns[index].dataset || {};
						if (!columnData.filterIgnore && columnData.type !== 'numeric') {
							// don't filter numeric values by default!
							var $this = $(this);
							text += $this.data('value') === undefined ? $this.text() : $this.data('value');
						}
					});
				}

				return text.toLowerCase().indexOf(filter) >= 0;
			};

			//options.classes.sort.sortable = ''; // for mouse over!
			/* // custom icons
			options.classes.sort.sorted = 'fa-sort-asc';
			options.classes.sort.descending = 'fa-sort-desc';
			options.classes.sort.indicator = 'fa-sort';
			*/

			options.classes.sort.sorted = 'footable-sorted-desc'; // inverted by default for some reason!
			options.classes.sort.descending = 'footable-sorted';
		});
	}

	angular.module('new-web').run(runBlock);
})(window, document, window.angular);

'use strict';

(function(window, angular) {
	if (!Array.from) {
		// Array.from polyfill (for IE)
		Array.from = (function() {
			var toStr = Object.prototype.toString;
			var isCallable = function(fn) {
				return typeof fn === 'function' || toStr.call(fn) === '[object Function]';
			};
			var toInteger = function(value) {
				var number = Number(value);
				if (isNaN(number)) {
					return 0;
				}
				if (number === 0 || !isFinite(number)) {
					return number;
				}
				return (number > 0 ? 1 : -1) * Math.floor(Math.abs(number));
			};
			var maxSafeInteger = Math.pow(2, 53) - 1;
			var toLength = function(value) {
				var len = toInteger(value);
				return Math.min(Math.max(len, 0), maxSafeInteger);
			};

			// The length property of the from method is 1.
			return function from(arrayLike /*, mapFn, thisArg */) {
				// 1. Let C be the this value.
				var C = this;

				// 2. Let items be ToObject(arrayLike).
				var items = Object(arrayLike);

				// 3. ReturnIfAbrupt(items).
				if (arrayLike == null) {
					throw new TypeError('Array.from requires an array-like object - not null or undefined');
				}

				// 4. If mapfn is undefined, then let mapping be false.
				var mapFn = arguments.length > 1 ? arguments[1] : void undefined;
				var T;
				if (typeof mapFn !== 'undefined') {
					// 5. else
					// 5. a If IsCallable(mapfn) is false, throw a TypeError exception.
					if (!isCallable(mapFn)) {
						throw new TypeError('Array.from: when provided, the second argument must be a function');
					}

					// 5. b. If thisArg was supplied, let T be thisArg; else let T be undefined.
					if (arguments.length > 2) {
						T = arguments[2];
					}
				}

				// 10. Let lenValue be Get(items, "length").
				// 11. Let len be ToLength(lenValue).
				var len = toLength(items.length);

				// 13. If IsConstructor(C) is true, then
				// 13. a. Let A be the result of calling the [[Construct]] internal method
				// of C with an argument list containing the single item len.
				// 14. a. Else, Let A be ArrayCreate(len).
				var A = isCallable(C) ? Object(new C(len)) : new Array(len);

				// 16. Let k be 0.
				var k = 0;
				// 17. Repeat, while k < len… (also steps a - h)
				var kValue;
				while (k < len) {
					kValue = items[k];
					if (mapFn) {
						A[k] = typeof T === 'undefined' ? mapFn(kValue, k) : mapFn.call(T, kValue, k);
					} else {
						A[k] = kValue;
					}
					k += 1;
				}
				// 18. Let putStatus be Put(A, "length", len, true).
				A.length = len;
				// 20. Return A.
				return A;
			};
		})();
	}

	/** @ngInject */
	function setRouterReference($stateProvider, $urlRouterProvider, $controllerProvider, $provide) {
		window.enswitchGlobals = window.enswitchGlobals || {};

		window.enswitchGlobals.stateProvider = $stateProvider;
		window.enswitchGlobals.urlRouterProvider = $urlRouterProvider;
		window.enswitchGlobals.registerController = $controllerProvider.register;
		window.enswitchGlobals.registerService = $provide.service;
		window.enswitchGlobals.registerFactory = $provide.factory;

		$urlRouterProvider.deferIntercept();
	}

	angular.module('new-web').config(setRouterReference);
})(window, window.angular);

'use strict';

var inputDirective = [
	'$timeout',
	'$compile',
	'$log',
	'UtilsService',
	'$rootScope',
	'$interpolate',
	function($timeout, $compile, $log, UtilsService, $rootScope, $interpolate) {
		var touchDevice = 'ontouchstart' in document.documentElement;

		return {
			restrict: 'E',

			require: '^?form',
			scope: false,

			link: function(scope, element, attrs, ngFormController) {
				if (attrs['uibDatepickerPopup'] || attrs['validationInitialized']) {
					return;
				}

				$timeout(function() {
					var formName = '';

					if (ngFormController) {
						formName = ngFormController.$name;
					}

					var el = angular.element(element);

					var inputName = attrs.name;
					var isDate = false;

					var input = el[0];

					el.attr('validation-initialized', 'true');

					if (
						input.type == 'hidden' ||
						el.attr('type') == 'hidden' ||
						input.type == 'range' ||
						el.attr('type') == 'range'
					) {
						return;
					}

					element.parent().is('div') &&
						!element.parent().is('.timepicker-group') &&
						element.parent().addClass('form-row-input');

					if ((input.type == 'checkbox' || el.attr('type') == 'checkbox') && !el.parent().hasClass('switch')) {
						// custom checkbox + handle table row selection
						el.wrap('<div class="checkbox"></div>');
						$timeout(function() {
							el.parent().append(angular.element('<label>' + (attrs.label || '') + '</label>'));
						});
						if (el.parents('tr').length) {
							var handleCheckboxChange = function(newValue) {
								el.parents('tr')
									.last()
									.toggleClass('table-activeBg', newValue || false);
							};
							scope.$watch(attrs.ngModel, handleCheckboxChange);
						}
					}

					if (!el.attr('autocomplete')) {
						if (inputName) {
							el.attr(
								'autocomplete',
								inputName.replace('first_name', 'given-name').replace('last_name', 'family-name')
							);
						} else {
							el.attr('autocomplete', '');
						}

						scope.$watch(
							function() {
								return attrs.name;
							},
							function(newValue) {
								if (newValue) {
									el.attr(
										'autocomplete',
										newValue.replace('first_name', 'given-name').replace('last_name', 'family-name')
									);
								} else {
									el.attr('autocomplete', '');
								}
							}
						);
					}

					if (!touchDevice && (isDate = input.type == 'date' || el.attr('type') == 'date')) {
						// FF doesn't support type="date"
						var isOpen = 'is_open_' + (inputName.replace(/-/g, '_') || UtilsService.randomString('alphanumeric', 8));

						var mockInput = angular.element(angular.copy(el));

						mockInput.attr('type', 'text');

						mockInput.attr('uib-datepicker-popup', 'dd/MM/yyyy');

						scope.initDate = scope.initDate || UtilsService.newDate();
						mockInput.attr('datepicker-options', '{initDate: initDate}');

						mockInput.attr('close-text', $rootScope.languageString('close'));
						mockInput.attr('current-text', $rootScope.languageString('today'));
						mockInput.attr('clear-text', $rootScope.languageString('clear'));
						mockInput.attr('datepicker-append-to-body', 'true');
						mockInput.attr('show-button-bar', 'true');
						mockInput.attr('is-open', isOpen);
						mockInput.attr('should-convert', 'false');

						mockInput.css({
							visibility: 'hidden',
							position: 'absolute',
							left: '15px',
							top: '0px',
						}); // use translate() instead?

						// add ng-min/ng-max checks on the picker input, otherwise they get overriden by the picker ngModel
						// bindings are passed via date-picker-min and date-picker-max attributes on the original input[type=date] element
						if (el.attr('date-picker-min')) {
							mockInput.attr('ng-min', el.attr('date-picker-min'));
							mockInput.attr('datepicker-options', `{minDate: ${el.attr('date-picker-min')}, initDate: initDate}`);
						}
						if (el.attr('date-picker-max')) {
							mockInput.attr('ng-max', el.attr('date-picker-max'));
							mockInput.attr('datepicker-options', `{maxDate: ${el.attr('date-picker-max')}, initDate: initDate}`);
						}

						$compile(mockInput)(scope);
						el.after(mockInput);

						var btn = angular.element('<i class="glyphicon glyphicon-calendar" ng-click="' + isOpen + '=true"></i>');
						// calculate margin-top according to height if needed?
						// TODO: style when media (?)
						// TODO: remove blue border when active on chrome
						$compile(btn)(scope);
						el.after(btn);

						// @TODO: class text-info is on current date, remove it and add it to the current date in user's time zone;
						// $('.uib-datepicker').find('.text-info').removeClass('.text-info'); // on open!

						scope.$on('$destroy', function() {
							btn.remove();
							btn = null;
							mockInput.remove();
							mockInput = null;
						});

						el.bind('keydown', function(event) {
							if (event.keyIdentifier == 'Down' || event.keyIdentifier == 'Up') {
								event.preventDefault();
								return false;
							}

							return true;
						});
					}

					if (
						formName &&
						inputName &&
						(input.type == 'email' ||
							input.required ||
							input.pattern ||
							'ngRequired' in attrs ||
							'ngPattern' in attrs ||
							'ngMin' in attrs ||
							'ngMax' in attrs ||
							'ngMinlength' in attrs ||
							'ngMaxlength' in attrs ||
							'minlength' in attrs ||
							'maxlength' in attrs ||
							'apiValidation' in attrs ||
							'maxSize' in attrs ||
							'validateRegex' in attrs ||
							'patternEach' in attrs)
					) {
						// min, max, (not ngMin, ngMax - autocorrected), different <p>'s for every error type?
						scope.options = scope.options || {};
						scope.options[inputName] = {};
						var __scope = scope.options[inputName];

						var rowDiv = el;
						while ((rowDiv = rowDiv.parent()).length && !rowDiv.hasClass('row'));

						if (rowDiv) {
							rowDiv.addClass('form-group');
							rowDiv
								.find('span')
								.first()
								.addClass('control-label');

							scope.$watch(formName + '[\'' + inputName + '\'].$valid', function(isValid) {
								$timeout(function() {
									rowDiv && rowDiv[isValid || scope[formName].$pristine ? 'removeClass' : 'addClass']('has-error');
								});
							});
						}

						scope.$on('$destroy', function() {
							rowDiv = null;
							__scope = null;
						});

						var message;

						scope.refresh = function(fieldName) {
							$timeout(function() {
								scope.$broadcast('$$rebind::' + fieldName);
								scope.$broadcast('$$rebind::' + formName);
							});
						};

						var inputValueChanged = function() {
							scope.refresh(el.attr('name'));
						};

						el.bind('change keyup paste mouseup', inputValueChanged); // "input propertychange" instead of "change keyup paste mouseup" (or just "input")?

						scope.$on('$destroy', function() {
							el.unbind('change keyup paste mouseup', inputValueChanged);
						});

						var ngModelCtrl = ngFormController[inputName];

						switch (el.attr('type')) {
							case 'email': {
								message =
									$rootScope.languageString('please_enter_valid') +
									' ' +
									$rootScope.languageString('email_address') +
									'.';
								break;
							}

							case 'file': {
								if (
									(el.attr('ng-required') !== undefined || el.attr('required') !== undefined || 'maxSize' in attrs) &&
									el.attr('ng-model') === undefined
								) {
									el.attr('ng-model', 'dummy_' + inputName.replace(/-/g, '_') + '_model');
									scope['dummy_' + inputName.replace(/-/g, '_') + '_model'] = null;
									//el.attr('ng-required', 'false');
									$compile(element)(scope); //
								}

								ngModelCtrl = ngModelCtrl || ngFormController[inputName];

								if ('maxSize' in attrs && ngModelCtrl) {
									// ng-model is required for this!
									__scope.maxSize = Number($rootScope.maximum_upload_size || 0);

									scope.$watch(
										function() {
											return attrs.maxSize;
										},
										function(newValue) {
											var _newValue = Number(newValue);
											if (
												newValue &&
												_newValue &&
												isFinite(_newValue) &&
												!isNaN(_newValue) &&
												_newValue != __scope.maxSize
											) {
												$timeout(function() {
													__scope.maxSize = _newValue;
													inputValueChanged();
												});
											}
										}
									);

									var choseFile = function(e) {
										if (el[0].files.length > 0) {
											ngModelCtrl.$setValidity(
												'maxSize',
												__scope.maxSize <= 0 || el[0].files[0].size <= __scope.maxSize
											);
											ngModelCtrl.$setValidity('required', true);
											var fileName = el[0].files[0].name || '';
											$timeout(function() {
												scope['dummy_' + inputName.replace(/-/g, '_') + '_model'] = fileName;
												inputValueChanged();
											});
										} else {
											ngModelCtrl.$setValidity('maxSize', true);
											ngModelCtrl.$setValidity('required', !attrs.required);
											$timeout(function() {
												scope['dummy_' + inputName.replace(/-/g, '_') + '_model'] = null;
												inputValueChanged();
											});
										}
										return e;
									};

									ngModelCtrl.$parsers.push(choseFile);
									ngModelCtrl.$formatters.push(choseFile);

									el.bind('change', choseFile);

									scope.$on('$destroy', function() {
										el.unbind('change', choseFile);
									});

									message =
										'<span ng-show=":' +
										formName +
										':' +
										inputName +
										':' +
										formName +
										'[\'' +
										inputName +
										'\'].$error.maxSize">' +
										$rootScope.languageString('config_maximum_upload_size_title') +
										': {{(options[\'' +
										inputName +
										'\'].maxSize||maximum_upload_size)|bytes}}</span> ';
								} else {
									message = '';
								}

								message +=
									'<span ng-show=":' +
									formName +
									':' +
									inputName +
									':' +
									formName +
									'[\'' +
									inputName +
									'\'].$error.required">' +
									$rootScope.languageString('please_choose_file') +
									'</span>';
								break;
							}

							case 'date': {
								message = $rootScope.languageString('enter_valid_date'); // format?
								break;
							}

							default: {
								// @TODO: emptyString, invalidString, minMaxString

								var displayName = /*$rootScope.languageString(*/ (el.attr('caption') || inputName).replace(/^(\S+-)+/, '').split('_').join(' ');
								var updateMessage = function() {
									$timeout(function() {
										// console.log('patternErrorMessage: ', attrs.patternErrorMessage);s
										'patternErrorMessage' in attrs &&
											(__scope.patternErrorMessage = $interpolate(attrs.patternErrorMessage)(scope));
										__scope.displayName = displayName = /*$rootScope.languageString(*/ (
											attrs.caption ||
											attrs.name ||
											inputName
										)
											.replace(/^(\S+-)+/, '')
											.split('_')
											.join(' ');
										scope.$broadcast('$$rebind::' + inputName);
									});
								};
								'patternErrorMessage' in attrs && scope.$watch($interpolate(attrs.patternErrorMessage), updateMessage);
								//scope.$watch(attrs.name, updateMessage);
								var requiredErrorMessage =
									'requiredErrorMessage' in attrs && attrs.requiredErrorMessage
										? attrs.requiredErrorMessage
										: $rootScope.capitalize(displayName) + ' ' + $rootScope.languageString('is_required') + ' ';
								var patternErrorMessage =
									'patternErrorMessage' in attrs
										? '{{options[\'' + inputName + '\'].patternErrorMessage}}'
										: input.pattern || 'ngPattern' in attrs || 'validateRegex' in attrs || 'patternEach' in attrs
										? $rootScope.languageString('please_enter_valid') + ' ' + displayName + '. '
										: input.required || el.attr('ng-required')
										? requiredErrorMessage
										: '';
								message = `<span ng-show=":${formName}:${inputName}:(!!(${formName}[\'${inputName}\'].$error.required||${formName}[\'${inputName}\'].$error.regex||${formName}[\'${inputName}\'].$error.each||${formName}[\'${inputName}\'].$error.pattern))">${patternErrorMessage}</span>`;

								if ('ngMinlength' in attrs || 'ngMaxlength' in attrs || 'minlength' in attrs || 'maxlength' in attrs) {
									/*
									ngFormController[inputName].$options = ngFormController[inputName].$options || {};
									ngFormController[inputName].$options.allowInvalid = true;
									el.attr('ng-model-options', '{allowInvalid: true}');
									*/

									__scope.minlength = attrs.minlength || '';
									__scope.maxlength = attrs.maxlength || '';

									if ('ngMinlength' in attrs) {
										scope.$watch(
											function() {
												return attrs.minlength;
											},
											function(newValue) {
												if (newValue != __scope.minlength) {
													$timeout(function() {
														__scope.minlength = newValue;
													});
												}
											}
										);
									}

									if ('ngMaxlength' in attrs) {
										scope.$watch(
											function() {
												return attrs.maxlength;
											},
											function(newValue) {
												if (newValue != __scope.maxlength) {
													$timeout(function() {
														__scope.maxlength = newValue;
													});
												}
											}
										);
									}

									if ('ngMinlength' in attrs || 'minlength' in attrs) {
										if (!ngModelCtrl.$validators.minlength) {
											var minLengthValidator = function(ngModelValue) {
												ngModelCtrl.$setValidity(
													'minlength',
													!String(ngModelValue || '').length ||
														String(ngModelValue || '').length >= Number(attrs.minlength || 0)
												);
												return ngModelValue;
											};

											ngModelCtrl.$parsers.push(minLengthValidator);
											ngModelCtrl.$formatters.push(minLengthValidator);
										}
									}

									if ('ngMaxlength' in attrs || 'maxlength' in attrs) {
										if (!ngModelCtrl.$validators.maxlength) {
											var maxLengthValidator = function(ngModelValue) {
												var _maxlength = Math.max(Number(attrs.maxlength) || 0, 0);
												if (!_maxlength) {
													ngModelCtrl.$setValidity('maxlength', true);
													return ngModelValue;
												}
												ngModelCtrl.$setValidity('maxlength', String(ngModelValue || '').length <= _maxlength);
												return ngModelValue;
											};

											ngModelCtrl.$parsers.push(maxLengthValidator);
											ngModelCtrl.$formatters.push(maxLengthValidator);
										}
									}

									if (
										('ngMinlength' in attrs || 'minlength' in attrs) &&
										('ngMaxlength' in attrs || 'maxlength' in attrs)
									) {
										message +=
											' <span ng-show=":' +
											formName +
											':' +
											inputName +
											':(!!(' +
											formName +
											'[\'' +
											inputName +
											'\'].$error.minlength||' +
											formName +
											'[\'' +
											inputName +
											'\'].$error.maxlength))">' +
											$rootScope.capitalize(displayName) +
											' ' +
											$rootScope.languageString('must_be_between') +
											' {{options[\'' +
											inputName +
											'\'].minlength}} ' +
											$rootScope.languageString('and') +
											' {{options[\'' +
											inputName +
											'\'].maxlength}} ' +
											$rootScope.languageString('characters_end') +
											'</span>';
									} else {
										var min = 'ngMinlength' in attrs || 'minlength' in attrs;
										var l = min ? 'minlength' : 'maxlength';
										var s = min ? $rootScope.languageString('at_least') : $rootScope.languageString('maximum');
										message +=
											' <span ng-show=":' +
											formName +
											':' +
											inputName +
											':(!!' +
											formName +
											'[\'' +
											inputName +
											'\'].$error.' +
											(min ? 'minlength' : 'maxlength') +
											')">' +
											$rootScope.capitalize(displayName) +
											' ' +
											$rootScope.languageString('must_be') +
											' ' +
											s +
											' {{options[\'' +
											inputName +
											'\'].' +
											l +
											'}} ' +
											$rootScope.languageString('characters_end') +
											'</span>';
									}
								}

								if ('ngMin' in attrs || 'ngMax' in attrs) {
									__scope.min = attrs.ngMin || '';
									__scope.max = attrs.ngMax || '';

									if ('ngMin' in attrs) {
										scope.$watch(
											function() {
												return attrs.ngMin;
											},
											function(newValue) {
												if (newValue != __scope.min) {
													$timeout(function() {
														__scope.min = newValue;
													});
												}
											}
										);
									}

									if ('ngMax' in attrs) {
										scope.$watch(
											function() {
												return attrs.ngMax;
											},
											function(newValue) {
												if (newValue != __scope.max) {
													$timeout(function() {
														__scope.max = newValue;
													});
												}
											}
										);
									}

									var isCurrency = 'isCurrency' in attrs && String(attrs.isCurrency) !== 'false';

									if ('ngMin' in attrs && 'ngMax' in attrs) {
										message +=
											' <span ng-show=":' +
											formName +
											':' +
											inputName +
											':(!!(' +
											formName +
											'[\'' +
											inputName +
											'\'].$error.ngMin||' +
											formName +
											'[\'' +
											inputName +
											'\'].$error.ngMax))">' +
											$rootScope.capitalize(displayName) +
											' ' +
											$rootScope.languageString('must_be_between') +
											' {{options[\'' +
											inputName +
											'\'].min' +
											(isCurrency ? '|currencyFormat' : '') +
											'}} ' +
											$rootScope.languageString('and') +
											' {{options[\'' +
											inputName +
											'\'].max' +
											(isCurrency ? '|currencyFormat' : '') +
											'}}</span>';
									} else {
										var min = 'ngMin' in attrs;
										var l = min ? 'min' : 'max';
										var s = min ? $rootScope.languageString('at_least') : $rootScope.languageString('maximum');
										message +=
											' <span ng-show=":' +
											formName +
											':' +
											inputName +
											':(!!' +
											formName +
											'[\'' +
											inputName +
											'\'].$error.' +
											(min ? 'ngMin' : 'ngMax') +
											')">' +
											$rootScope.capitalize(displayName) +
											' ' +
											$rootScope.languageString('must_be') +
											' ' +
											s +
											' {{options[\'' +
											inputName +
											'\'].' +
											l +
											(isCurrency ? '|currencyFormat' : '') +
											'}}</span>';
									}
								}

								if ('validateRegex' in attrs) {
									var regexValidator = function(modelValue, viewValue) {
										if (String(attrs.validateRegex) === 'false') return true;
										var pattern = modelValue || viewValue;
										try {
											return UtilsService.regexFromString(pattern);
										} catch (e) {
											return false;
										}
									};
									ngModelCtrl.$validators.regex = regexValidator;
								}

								if ('patternEach' in attrs) {
									var eachValueValidator = function(modelValue, viewValue) {
										if (!attrs.patternEach) return true;
										const inputValue = modelValue || viewValue;
										if (!inputValue) {
											return true;
										}
										try {
											const pattern = UtilsService.regexFromString(attrs.patternEach);
											const inputArray = inputValue.split(' ');
											return inputArray.reduce((previousValue, currentValue) => {
												return previousValue && pattern.test(currentValue);
											}, true);
										} catch (error) {
											return true;
										}
									};
									ngModelCtrl.$validators.each = eachValueValidator;
								}

								break;
							}
						}

						if ('apiValidation' in attrs) {
							message += '<br/>';
						}

						var p = angular.element(
							'<p ng-show=":' +
								formName +
								':' +
								inputName +
								':(!!(' +
								formName +
								'[\'' +
								inputName +
								'\'].$invalid && !' +
								formName +
								'[\'' +
								inputName +
								'\'].$error.apivalidate && (!' +
								formName +
								'[\'' +
								inputName +
								'\'].$pristine' +
								' || ' +
								formName +
								'.$submitted)))" class="help-block" style="min-height: 18px; height: auto; min-width:180px; width:auto; max-width: 100%;">' +
								message +
								'</p>'
						);
						//console.log('message: ', message);
						$compile(p)(scope);
						if (input.type == 'checkbox') {
							$timeout(function() {
								p[0].style.marginLeft = '20px';
								el.parent().after(p);
							});
						} else {
							(input.type == 'file' ? el.parent() : isDate ? el.next() : el).after(p);
						}

						ngModelCtrl &&
							UtilsService.getPreselectOptions().some(function(item) {
								if (item.name === attrs.name) {
									var preselectWatch = scope.$watch(attrs.ngModel, function(newValue, oldValue) {
										// console.log('watch; ', newValue, oldValue);
										if (oldValue === undefined && (newValue || newValue === '')) {
											$timeout(function() {
												preselectWatch();
												ngModelCtrl.$setViewValue(item.value);
												ngModelCtrl.$commitViewValue();
											});
										}
									});
									return true;
								}
								return false;
							});

						scope.$on('$destroy', function() {
							p.remove();
							p = null;
							el = null;
						});
					}
				});
			},
		};
	},
];

angular
	.module('new-web')

	/**
	 * iboxTools - Directive for iBox tools elements in right corner of ibox
	 * edited!
	 */
	.controller('iboxToolsController', [
		'$scope',
		'$element',
		'$rootScope',
		'$timeout',
		function($scope, $element, $rootScope, $timeout) {
			var ibox = $element.closest('div.ibox');
			var icon = $element.find('i:first');

			var expandText = $scope.expandText || $rootScope.languageString('expand');
			var collapseText = $scope.collapseText || $rootScope.languageString('collapse');

			var collapsed = ibox.hasClass('collapsed');

			$scope.expand_collapse = collapsed ? expandText : collapseText;

			var content = collapsed ? ibox.find('div.ibox-content') : ibox.find('div.ibox-content').first();
			var _collapsed = collapsed;

			if (_collapsed) {
				// additional content
				ibox
					.find('div.ibox-content')
					.first()
					.next()
					.slideToggle(250 * $rootScope.animationDurationMultiplier);
			}

			$scope.showhide = function() {
				if (_collapsed) {
					content = ibox.find('div.ibox-content').first();
					_collapsed = false;
				}

				content.slideToggle(250 * $rootScope.animationDurationMultiplier);
				icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
				ibox.toggleClass('').toggleClass('border-bottom');

				collapsed = !collapsed;

				$timeout(function() {
					ibox.resize();
					ibox.find('[id^=map-]').resize();
					$scope.expand_collapse = collapsed ? expandText : collapseText;
				}, 50);
			};

			$scope.closebox = function() {
				var ibox = $element.closest('div.ibox');
				ibox.remove();
				ibox = null;
			};

			$scope.$on('$destroy', function() {
				content = null;
				ibox = null;
				icon = null;
			});
		},
	])
	.directive('iboxTools', [
		'$timeout',
		'$rootScope',
		function iboxTools($timeout, $rootScope) {
			return {
				restrict: 'A',

				scope: {
					expandText: '=expandText',
					collapseText: '=collapseText',
					toggleLeft: '=toggleLeft',
				},

				templateUrl: 'app/components/common/ibox_tools.html',

				controller: 'iboxToolsController',

				link: function(scope, element) {
					if (scope.toggleLeft) {
						element.addClass('pull-left');
						element.find('a').css({
							color: '#727577',
							'font-size': '14px',
							'font-weight': '600',
						});
					} else {
						element.addClass('pull-right');
					}
				},
			};
		},
	])

	.directive('customSidebar', [
		'$rootScope',
		function($rootScope) {
			return {
				restrict: 'E',
				template:
					`<div class="custom-sidebar">
						<a href="" ng-click="minimalize()"><img src="assets/images/panel/hamburger.svg" class="fa"/></a>
					</div>`,
				controller: function($scope) {
					$scope.minimalize = function() {
						$rootScope.hide_menu = false;
					};
				},
			};
		},
	])
	
	//Directives used to set metisMenu and minimalize button
	.directive('sideNavigation', [
		'$rootScope',
		'$timeout',
		function($rootScope, $timeout) {
			return {
				restrict: 'A',
				link: function(scope, element) {
					// Call metsi to build when user signup
					/*
				scope.$watch('authentication.user', function() {
					$timeout(function() {
						element.metisMenu();
					});
				});
				*/

					var setupMenu;

					var removeEventListeners = function() {
						element
							.find('li')
							.has('ul')
							.children('a')
							.off('click.metisMenu');
						element.off('mmTransitionEnd');
					};

					(setupMenu = function() {
						$timeout(function() {
							element.metisMenu();
						}, 50);
					})();

					scope.$on('$$rebind::navigation', setupMenu);
					scope.$on('WillLogOut', removeEventListeners);
					$rootScope.$on('$destroy', removeEventListeners);
				},
			};
		},
	])

	.directive('minimalizaSidebar', [
		'$rootScope',
		'$timeout',
		function($rootScope, $timeout) {
			return {
				restrict: 'A',
				template:
					'<a class="navbar-minimalize minimalize-styl-2 btn btn-primary" href="" ng-click="minimalize()"><img src="assets/images/panel/hamburger.svg" class="fa"/></a>',
				controller: function($scope) {
					$scope.minimalize = function() {
						angular.element('body').toggleClass('mini-navbar');
						if (!angular.element('body').hasClass('mini-navbar') || angular.element('body').hasClass('body-small')) {
							// Hide menu in order to smoothly turn on when maximize menu
							angular.element('#side-menu').hide();
							// For smoothly turn on menu
							$timeout(function() {
								angular.element('#side-menu').fadeIn(400 * $rootScope.animationDurationMultiplier);
							}, 200);
						} else {
							// Remove all inline style from jquery fadeIn function to reset menu state
							angular.element('#side-menu').removeAttr('style');
						}
					};
				},
			};
		},
	])

	.directive('svgImage', [
		'$compile',
		'$http',
		'$log',
		'$timeout',
		function($compile, $http, $log, $timeout) {
			return {
				//http://stackoverflow.com/a/28167145/1630623

				restrict: 'A',
				//priority: 1001,
				link: function(scope, element, attrs) {
					/*
				var setDescription = function(el, _desc) {

					var $el = $(el);
					var desc = $el.find('desc');
					if (!desc.length) {
						desc = $('<desc></desc>');
						$el.prepend(desc);
					}
					desc.html(_desc);
				};
				*/

					element.hide();

					var setTitle = function(el, _title) {
						if (String(attrs['hideTitle']) === 'true') return;
						var $el = angular.element(el);
						var $title = $el.find('title');
						if (!$title.length) {
							$title = $('<title></title>');
							$el.prepend($title);
							scope.$on('$destroy', function() {
								$title && $title.remove();
								$title = null;
							});
						}
						$title.html(_title);
						$el = null;
					};

					$timeout(function() {
						var imgURL = element.attr('src') || element.attr('ng-src') || element.attr('ng-include');

						var $img = $(element);

						var attributes = $img.prop('attributes');

						$http({
							method: 'GET',
							url: imgURL,
							headers: {
								Accept: 'text/html',
							},
						}).then(function(response) {
							// Get the SVG tag
							var $svg = $(response.data); //.find('svg');

							$.each(attributes, function() {
								this.name != 'svg-image' && this.name != 'ng-src' && $svg.attr(this.name, this.value);

								/*
							if (this.name == 'alt') {

								var _desc = this.value;

								//setDescription($svg, _desc);

								$svg.find('path, rect', 'g').each(function(i, el) {
									setDescription(el, _desc);
									//$log.debug("adding description: ", $svg, desc, this.value);
								});
							}
							*/

								if (this.name == 'title') {
									//var _title = this.value;
									//setTitle($svg, _title);
									/*
								$svg.find('path, rect', 'g').each(function(i, el) {
									setTitle(el, _title);
									//$log.debug("adding title: ", $svg, title, this.value);
								});
								*/
									//setTitle($svg.find('path, rect', 'g').first(), _title);
								}
							});

							// Replace IMG with SVG
							$img.replaceWith($svg);
							$img = null;

							$svg.show();

							scope.$on('$destroy', function() {
								$svg.remove();
								$svg = null;
							});
						}, element.show);
					});
				},
				/*
			compile: function(element) {
				element.removeAttr('svg-image');
				var fn = $compile(element);
				return function(scope){
					fn(scope);
				};
			}
			*/
			};
		},
	])
	//
	// .directive('hideEmpty', ['$timeout', function($timeout) {
	// 	return {
	// 		restrict: 'A',
	//
	// 		link: {
	// 			post: function(scope, elem, attrs) {
	// 				$timeout(function() {
	// 					if (!elem.html()) {
	// 						elem.hide();
	// 					}
	// 				});
	// 			},
	// 		},
	// 	};
	// }, ])

	.directive('breadcrumbs', [
		'$state',
		'$timeout',
		'$rootScope',
		function($state, $timeout, $rootScope) {
			return {
				restrict: 'E',
				scope: {
					statesList: '@',
					params: '=',
					editTitle: '=',
				},
				controller: function($scope) {
					var statesList = [];

					if (typeof $scope.statesList == 'string') {
						statesList = JSON.parse($scope.statesList);
					}

					if (statesList instanceof Array && statesList.length) {
						$scope.$watch('statesList', function(newValue) {
							$timeout(function() {
								statesList = JSON.parse($scope.statesList);

								$scope.states = [angular.copy($state.get('index.home'))]
									.concat(
										(statesList || []).map(function(s, i) {
											return angular.copy($state.get(s));
										})
									)
									.concat([angular.copy($state.current)]);

								if ($scope.editTitle) {
									var state = $scope.states[Math.max($scope.states.length - 2, 0)];
									state.title = $scope.editTitle;

									$scope.$on('$destroy', function() {
										state = null;
									});
								}

								$scope.states[0].data.pageTitle = 'Home'; // @TODO: translation
							});
						});

						$scope.$watch('editTitle', function(newValue) {
							if (!newValue) {
								return;
							}

							if (!$scope.states) {
								return;
							}

							var state = $scope.states[Math.max($scope.states.length - 2, 0)];

							$timeout(function() {
								state.title = $scope.editTitle;
							});

							$scope.$on('$destroy', function() {
								state = null;
							});
						});

						/*
					$scope.$watch('params', function(newValue) {
						if (!newValue) {
							return;
						}
						var state = $scope.states[Math.max($scope.states.length - 2, 0)];
						$timeout(function() {
							var strParams = JSON.stringify($scope.params);
							var s = strParams.substr(1, strParams.length - 2);
							if (!s) {
								return;
							}
							state.name += '(' + s + ')';
							//console.log(state.name);
						});
					});
					*/
					} else {
						var name = $state.current.name;
						if (name == 'index.features.recordings-list') {
							name = 'index.features.recordings-groups-recordings';
						}

						var legs = name.split('.');

						if ($state.current.name == 'index.home') {
							legs.splice(-1);
						}

						$scope.states = [];
						var temp = [];

						legs.forEach(function(leg, index) {
							var l = leg;

							if (l == 'recordings-groups-recordings') {
								l = 'recordings-list';
							}

							temp.push(l);
							var current = angular.copy($state.get(temp.join('.')));

							if (current) {
								if (current.name == 'index') {
									current = angular.copy(current);
									current.data = {
										pageTitle: 'Home', // @TODO: translation
									};
									current.name = 'index.home';
								}

								if (index < legs.length - 1 || (index == 1 && legs.length == 1)) {
									$scope.states.push(current);
								} else {
									var _temp = leg.split('-');

									var cnt = 0;
									var prefix = '';

									temp.splice(-1);

									_temp.forEach(function(_leg, index) {
										var s = prefix + (prefix ? '-' : '') + _leg;

										prefix = s; //(prefix || _leg) + (index ? s : '');

										temp.push(s);
										var _current = angular.copy($state.get(temp.join('.')));

										if (_current && _current.name) {
											$scope.states.push(_current);
											cnt++;
										} else if (_leg != 'fax' && leg.indexOf('-list') < 0 && index == _temp.length - 2) {
											_current = angular.copy($state.get(temp.join('.') + '-list'));

											if (_current && current.name) {
												$scope.states.push(_current);
												cnt++;
											}
										}

										temp.splice(-1);

										if (index == _temp.length - 1 && (!cnt || l == 'recordings-list')) {
											$scope.states.push(current);
										}

										$scope.$on('$destroy', function() {
											_current = null;
										});
									});

									if (/index\.features\.times-(periods-.+|help)/.test(name)) {
										$scope.states.splice(2, 0, angular.copy($state.get('index.features.times-groups-list')));
									} else if (name == 'index.customers.callshop-new') {
										$scope.states.splice(2, 1);
									} else if (name == 'index.customers.callshop-help') {
										var u = $scope.$watch('$root.menuItems', function(items) {
											if (items && items.length) {
												u();
												var found = false;
												items.some(function(item) {
													item.children &&
														item.children.length &&
														item.children.some(function(child) {
															return (found = child.state == 'index.customers.callshop-list');
														});
													return (found = found || item.state == 'index.customers.callshop-list');
												});
												if (!found) {
													$scope.states[2] = angular.copy($state.get('index.customers.callshop-new'));
												}
											}
										});
									} else if (name == 'index.customers.vouchers-help') {
										$scope.states[2] = angular.copy($state.get('index.customers.vouchers-batches-list'));
									} else if (name == 'index.customers.cards-help') {
										$scope.states[2] = angular.copy($state.get('index.customers.cards-groups-list'));
									} else if (name == 'index.calls.messages-list') {
										$scope.states.splice(2, 0, angular.copy($state.get('index.calls.mailboxes')));
									}
								}
							}

							$scope.$on('$destroy', function() {
								current = null;
							});
						});
					}

					var updateCurrentTitle = function(newValue, oldValue) {
						newValue !== oldValue &&
							$timeout(function() {
								if ($scope.states && $scope.states.length) {
									var data = ($scope.states[$scope.states.length - 1].data =
										$scope.states[$scope.states.length - 1].data || {});
									data.pageTitle = newValue || $state.get($scope.states[$scope.states.length - 1].name).data.pageTitle;
									$scope.$on('$destroy', function() {
										data = null;
									});
								}
							});
					};
					updateCurrentTitle($rootScope.currentPageTitle, '');

					$scope.$watch('$root.currentPageTitle', updateCurrentTitle);

					$scope.$on('$destroy', function() {
						$scope.states = null;
						temp = null;
						statesList = null;
					});
				},

				template:
					'<ol class="breadcrumb"><li ng-repeat="state in states track by $index" ng-class="{active: $index==states.length-1}"><a ui-sref="{{state.name}}($index==states.length-2?params:{})" ng-if="(($index!=states.length-1)&&(states.length>1)&&!state.abstract)||state.name==\'index.home\'">{{state.title||(state.data.pageTitle?state.data.pageTitle:state.name)}}</a><span ng-if="($index==states.length-1)||(state.abstract&&(state.name!=\'index.home\'))">{{(states.length<2)?\'Home\':state.data.pageTitle?state.data.pageTitle:state.name}}</span></li></ol>',
			};
		},
	])

	.directive('onReadFile', [
		'$parse',
		'$timeout',
		function($parse, $timeout) {
			return {
				restrict: 'A',
				scope: false,

				link: function(scope, element, attrs) {
					var fn = $parse(attrs.onReadFile);
					var base64encode = 'base64encode' in attrs;

					var handleChange = function(onChangeEvent) {
						var reader = new FileReader();
						var fileInfo = (onChangeEvent.srcElement || onChangeEvent.target).files[0];

						reader.onload = function(onLoadEvent) {
							scope.$apply(function() {
								fn(scope, {
									$fileInfo: fileInfo,
									$fileContent: onLoadEvent.target.result.substring(
										base64encode ? onLoadEvent.target.result.indexOf(',') + 1 : 0
									),
									$rows: base64encode
										? []
										: onLoadEvent.target.result.split(/\r\n|\r|\n/g).filter(function(row) {
												return !!row;
										  }),
								});
							});
						};

						if (fileInfo) {
							if (base64encode) {
								reader.readAsDataURL(fileInfo);
							} else {
								reader.readAsText(fileInfo);
							}
						}

						$timeout(function() {
							// allow same file to be uploaded again
							element.val('');
						}, 100);
					};

					element.on('change', handleChange);

					scope.$on('$destroy', function() {
						element.off('change', handleChange);
					});
				},
			};
		},
	])

	.directive('hideOnError', [
		'$rootScope',
		'$timeout',
		function($rootScope, $timeout) {
			var _path = window.location.pathname.split('/')[1] || '';
			var baseHref = '/' + (_path.length ? _path + '/' : '');

			return {
				scope: {
					placeholderImage: '@',
					ngSrc: '@',
				},

				restrict: 'A',

				link: function(scope, el, attr) {
					if (el.attr('errorHandlerSet')) {
						return;
					} else {
						el.attr('errorHandlerSet', 'true');
					}

					var versionTimestamp = String($rootScope.versionTimestamp || 0);
					var tries = 0;

					var watch, bWatch;

					var isImage = el[0].tagName.toLowerCase() == 'img';

					var addTimestampIfNeeded = function(_src) {
						return /\?v=\d+$/.test(_src) || /^https?:\/\//.test(_src) ? _src : _src + '?v=' + versionTimestamp;
					};

					var testImage = function(_src) {
						var src = addTimestampIfNeeded(_src);

						el.attr('src', src);

						$('<img/>')
							.attr('src', src)
							.on('load', function() {
								$(this).remove();
								el.css({
									'background-image': 'url("' + src + '")',
								});
							})
							.on('error', handleError);
					};

					var handleError = function() {
						if (isImage) {
							watch =
								watch ||
								scope.$watch('ngSrc', function() {
									tries = 0;
									el.attr('src', scope.ngSrc);
								});
						} else {
							$(this).remove();
						}

						if (
							scope.placeholderImage &&
							scope.placeholderImage != el.attr('src') &&
							location.protocol + '//' + location.host + (baseHref + scope.placeholderImage).replace('//', '/') !=
								el.attr('src')
						) {
							if (el.attr('defaultExtension') && /\.svg(\?v=\d+)?$/.test(el.attr('src'))) {
								// if extension has been replaced with .svg
								tries = 0;

								if (isImage) {
									el.attr('src', el.attr('src').replace(/\.svg(\?v=\d+)?$/, '.' + el.attr('defaultExtension') + '$1'));
								} else {
									testImage(el.attr('src').replace(/\.svg(\?v=\d+)?$/, '.' + el.attr('defaultExtension')));
								}
							} else if (++tries < 3) {
								// just in case, to prevent infinite loop
								if (isImage) {
									el.show();
									el.attr('src', addTimestampIfNeeded(scope.placeholderImage));
								} else {
									testImage(scope.placeholderImage);
								}
							} else {
								if (isImage) {
									el.hide(); // placeholderImage also invalid
								} else {
									el.css({
										'background-image': '',
									});
								}
							}
						} else {
							if (isImage) {
								el.hide();
							} else {
								el.css({
									'background-image': '',
								});
							}
						}
					};

					if (isImage) {
						el.on('error', handleError);
					} else {
						bWatch =
							bWatch ||
							scope.$watch('ngSrc', function() {
								if (scope.ngSrc) {
									tries = 0;

									var src = scope.ngSrc;

									if (!/^https?:\/\//.test(src)) {
										src = location.protocol + '//' + location.host + (baseHref + src).replace('//', '/');
									}

									testImage(src);
								}
							});
					}

					scope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams, options) {
						if (fromState) {
							tries = 0;
						}
					});

					scope.$on('$destroy', function() {
						if (isImage) {
							el.off('error', handleError);
						}
					});
				},
			};
		},
	])

	.directive('autoActive', [
		'$rootScope',
		'$state',
		'$timeout',
		'$log',
		function($rootScope, $state, $timeout, $log) {
			var firstTime = true;

			var handleSubitemHighlighting = function(li, element) {
				var parentItemId = angular.element(li).attr('parent-item-id');
				// console.log('parentItemId: ', parentItemId);
				if (parentItemId && Number(parentItemId)) {
					var parentLi = angular.element($('#side-menu > li.has-children[menu-item-id="' + parentItemId + '"]'));
					// console.log('parentLi: ', parentLi);
					parentLi.addClass('mm-active');
					parentLi
						.find('ul')
						.first()
						.addClass('mm-show');
					$timeout(function() {
						// scroll to be visible
						var offset = angular.element(li).offset().top;
						if (element && element[0] && element[0].offsetParent) {
							// prevent error when switching customer
							var offsetHeight = element[0].offsetParent.offsetHeight;
							var scrollTop = element[0].offsetParent.scrollTop;
							if (offset + li.offsetHeight > offsetHeight + scrollTop) {
								element
									.parent()
									.parent()
									.animate(
										{
											scrollTop: offset - offsetHeight + li.offsetHeight,
										},
										{
											duration: 500 * $rootScope.animationDurationMultiplier,
										}
									);
							} else if (offset < scrollTop) {
								// probably will never happen?
								element
									.parent()
									.parent()
									.animate(
										{
											scrollTop: offset,
										},
										{
											duration: 500 * $rootScope.animationDurationMultiplier,
										}
									);
							}
						}
					}, 500);
					parentLi = null;
				}

				if (!angular.element(li).hasClass('mm-active')) {
					angular.element(li).addClass('mm-active');
				}
			};

			return {
				restrict: 'A',
				scope: false,

				link: {
					post: function(scope, element) {
						var setActive = function(event, toState, toParams, fromState, fromParams) {
							if (
								toState &&
								toState.name &&
								(toState.name.split('.').length > 2 || /^index\.plugin_/.test(toState.name))
							) {
								$timeout(function() {
									var opened = $('#side-menu > li.has-children.mm-active');
									if (opened.length) {
										opened
											.removeClass('mm-active')
											.find('ul')
											.first()
											.removeClass('mm-show');
									}
									opened = null;

									var found = false;

									var subitems = element.find('li:not(.has-children)');

									angular.forEach(subitems, function(li) {
										if (found) {
											return;
										}

										var anchor = li.querySelector('a');
										if (!anchor) {
											// is subsection
											return;
										}

										var _state = anchor.attributes['ui-sref'];

										if (typeof _state == 'undefined' || !_state) {
											return;
										}

										var state = _state.value || '';

										if (!state) {
											return;
										}

										var s1 = toState.name + '-';
										s1 = s1.substring(0, s1.indexOf('-'));

										var s2 = state.replace(/\(.*?$/, '') + '-';
										s2 = s2.substring(0, s2.indexOf('-'));

										if (
											(s1 == s2 && !/plugin_/.test(s2)) ||
											(s1 == 'index.calls.messages' && s2 == 'index.calls.mailboxes')
										) {
											found = true;
											handleSubitemHighlighting(li, element);
										}
									});

									if (!found) {
										// plugin that is subpage of existing page
										angular.forEach(subitems, function(li) {
											if (found) {
												return;
											}

											var anchor = li.querySelector('a');
											if (!anchor) {
												// is subsection
												return;
											}

											var _path = anchor.attributes['href'];

											if (typeof _path == 'undefined' || !_path) {
												return;
											}

											var path = _path.value || '';

											if (!path) {
												return;
											}

											var url = toState.url.pattern || toState.url;
											var s1 = /^\/?(.+?(\/.+?)?)\//.exec(url.replace(/\?.*?$/, ''))[1];
											var s2 = /^#?\/?(.+?(\/.+?)?)\//.exec(path.replace(/\?.*?$/, ''))[1];
											if (s2 == s1) {
												found = true;
												if (angular.element(li).hasClass('ng-hide')) {
													// plugin subpages
													var _li = li;
													var s3 = /^\/?(.+?)(\/.+?)?\//.exec(url.replace(/\?.*?$/, ''))[1];
													while (_li.previousElementSibling) {
														_li = _li.previousElementSibling;
														if (angular.element(_li).hasClass('ng-hide')) continue;
														var a = li.querySelector('a');
														if (!a) break;
														var p = anchor.attributes['href'];
														if (!p) continue;
														var h = p.value || '';
														if (!h) continue;
														var s4 = /^#?\/?(.+?)(\/.+?)?\//.exec(h.replace(/\?.*?$/, ''))[1];
														if (s3 == s4) {
															handleSubitemHighlighting(_li, element);
															break;
														}
													}
													_li = null;
												} else {
													handleSubitemHighlighting(li, element);
												}
											}
										});
									}

									subitems = null;
								});
							} else {
								var opened = $('#side-menu > li.has-children.mm-active');
								if (opened.length) {
									opened
										.removeClass('mm-active')
										.find('ul')
										.first()
										.removeClass('mm-show');
								}
								opened = null;
							}

							if (!firstTime && angular.element('body').hasClass('body-small')) {
								$timeout(function() {
									$('.btn.navbar-minimalize').click();
								});
							}

							firstTime = false;
						};

						scope.$on('$stateChangeSuccess', setActive);
						scope.$on('UpdateMenuHighlighting', function() {
							$timeout(function() {
								setActive(null, $state.current);
							});
						});

						$timeout(function() {
							setActive(null, $state.current);
						}, 200);
					},
				},
			};
		},
	])

	.directive('autoRecompile', [
		'$compile',
		'$rootScope',
		'$timeout',
		'$state',
		function($compile, $rootScope, $timeout, $state) {
			return {
				restrict: 'A',
				scope: false,

				link: function(scope, element, attrs) {
					var checkActive = function() {
						var _state = scope.item.state;

						if (_state == 'index.') {
							_state = 'index.home';
						}

						if (!scope.item.children || !scope.item.children.length) {
							//scope.item.active = $state.current.name == _state;
							$(element)
								.parent()
								.toggleClass('mm-active', $state.current.name == _state);
						} else {
							//scope.item.active = false;
							$(element)
								.parent()
								.toggleClass('mm-active', false)
								.find('ul')
								.first()
								.toggleClass('mm-show', false);
						}
					};

					var unsubscribe = $rootScope.$on('$stateChangeSuccess', function(
						event,
						toState,
						toParams,
						fromState,
						fromParams
					) {
						$timeout(function() {
							//$compile(element.contents())(scope);
							$rootScope.$broadcast('$$rebind::navigation');
							checkActive();
						});
						//unsubscribe();
					});

					scope.$on('$destroy', function() {
						(unsubscribe || angular.noop)();
					});

					$timeout(checkActive);
				},
			};
		},
	])

	.directive('whenOnline', [
		'$parse',
		'$rootScope',
		function($parse, $rootScope) {
			return {
				restrict: 'A',
				scope: false,
				priority: 10000,

				link: function(scope, element, attrs) {
					var fn = $parse(attrs.whenOnline);

					if (!$rootScope.offline) {
						fn(scope, {});
					}

					var everyTime = attrs.whenOnlineAlways && $parse(attrs.whenOnlineAlways);

					if ($rootScope.offline || everyTime) {
						var unsubscribe = scope.$on('navigator-online', function() {
							fn(scope, {});

							if (!everyTime) {
								unsubscribe();
							}
						});

						scope.$on('$destroy', function() {
							(unsubscribe || angular.noop)();
						});
					}
				},
			};
		},
	])

	.directive('permissionsNeeded', [
		'$q',
		'$animate',
		'$compile',
		'SessionService',
		'RolesApiService',
		'ConfigsApiService',
		function($q, $animate, $compile, SessionService, RolesApiService, ConfigsApiService) {
			return {
				restrict: 'E',
				transclude: 'element',
				scope: {
					privilegeNeeded: '=',
					configNeeded: '=',
				},
				priority: 1,

				link: function(scope, element, attrs, ctrl, transclude) {
					const currentSession = SessionService.getSession();
					const privilegeNames = scope.privilegeNeeded || [];
					const configNames = scope.configNeeded || [];

					const hasPrivilegesPermission = $q
						.all(
							privilegeNames.map((privilege) => {
								return RolesApiService.getAccessForRole({
									privilege: privilege,
									role: currentSession.effective_role || currentSession.role,
								});
							})
						)
						.then((responses) => {
							return responses.some((response) => !!Number(response.data));
						});

					const hasConfigsPermission = $q
						.all(
							configNames.map((config) => {
								return ConfigsApiService.getConfig({
									name: config,
									default: 0,
								});
							})
						)
						.then((responses) => {
							return responses.some((response) => !!Number(response.data.value));
						});

					$q.all([hasPrivilegesPermission, hasConfigsPermission]).then((responses) => {
						const hasPrivileges = responses.some((response) => response);
						var childScope;
						if (hasPrivileges) {
							if (!childScope) {
								transclude(function(clone, newScope) {
									childScope = newScope;
									// clone[clone.length++] = $compile.$$createComment('end permissionsNeeded', element.context.data);
									$animate.enter(clone, element.parent(), element);
								});
							}
						}
					});
				},
			};
		},
	])

	.directive('confirmClick', [
		'$rootScope',
		'SwalService',
		function($rootScope, SwalService) {
			return {
				priority: -1,
				restrict: 'A',
				scope: {
					confirmFunction: '&confirmClick',
					ignoreIf: '&',
					onCancel: '&',
				},

				link: function(scope, element, attrs) {
					var hasCheck = 'ignoreIf' in attrs;

					var lang = $rootScope.languageString;
					var capitalize = $rootScope.capitalize;

					var handleClick = function(e) {
						if (hasCheck && scope.ignoreIf()) {
							return;
						}

						var message = attrs.confirmMessage
							? attrs.confirmMessage
							: $rootScope.languageString('default_prompt_question');

						var params = {
							title: message,
							type: attrs.confirmType || 'warning',
							showCancelButton: true,
							confirmButtonColor: '#1c84c6',
							confirmButtonText: capitalize(lang('yes')),
							cancelButtonText: capitalize(lang('cancel')),
							//closeOnConfirm: true
						};

						if (attrs.smallText) {
							params.text = attrs.smallText;
						}

						SwalService.popup(params).then(
							function() {
								scope.confirmFunction();
							},
							function(dismiss) {
								(scope.onCancel || angular.noop)();
							}
						);
					};

					element.bind('click', handleClick);

					scope.$on('$destroy', function() {
						element.unbind('click', handleClick);
					});
				},
			};
		},
	])

	.directive('disableClick', [
		'$timeout',
		function($timeout) {
			return {
				restrict: 'A',
				scope: {
					disableClick: '&',
				},

				link: function(scope, element, attrs) {
					var enabled = true;

					var lb = {
						start: angular.noop,
						stop: angular.noop,
					};

					if (attrs.id) {
						$timeout(function() {
							lb = Ladda.create(document.querySelector('#' + attrs.id));
							element.addClass('ladda-button');
							//console.log(lb);
						});
					}

					var enableClick = function() {
						element.removeClass('loading');
						enabled = true;
						lb.stop();
					};

					var handleClick = function(e) {
						if (enabled) {
							enabled = false;
							var p = scope.disableClick() || {};

							if (typeof p.then == 'function') {
								element.addClass('loading');
								lb.start();
								p.then(enableClick, enableClick);
							} else {
								$timeout(enableClick, 500); // prevent double click from triggering click twice
							}
						}

						e.preventDefault();
					};

					element.bind('click', handleClick);

					scope.$on('$destroy', function() {
						element.unbind('click', handleClick);
					});
				},
			};
		},
	])

	.directive('addRemoveList', [
		'$timeout',
		'$log',
		'$rootScope',
		'UtilsService',
		function($timeout, $log, $rootScope, UtilsService) {
			return {
				restrict: 'E',

				require: '^?form',

				scope: {
					left: '=left',
					right: '=right',
					display: '@',
					value: '@',
					note: '@',
				},

				controller: function($scope, $element, $attrs) {
					var compare = function(a, b) {
						if (String(a[$scope.display]) < String(b[$scope.display])) return -1;
						if (String(a[$scope.display]) > String(b[$scope.display])) return 1;
						return 0;
					};

					var addList = $element.find('ul.add-items');
					var removeList = $element.find('ul.remove-items');

					var lastSelectedAddItem = -1;
					var lastSelectedRemoveItem = -1;

					var stringifyItem = function(item) {
						return item || item === 0 ? String(item) : '';
					};

					$scope.addSelected = function() {
						$timeout(function() {
							lastSelectedAddItem = -1;

							$scope.left = $scope.left.concat(
								$scope.right.filter(function(item) {
									return $scope.data.itemsToAdd.map(stringifyItem).indexOf(stringifyItem(item[$scope.value])) > -1;
								})
							);

							$scope.right = $scope.right.filter(function(item) {
								return $scope.data.itemsToAdd.map(stringifyItem).indexOf(stringifyItem(item[$scope.value])) < 0;
							});

							$scope.data.itemsToAdd = [];

							$scope.left.sort(compare);

							$scope.$broadcast('$$rebind::addRemoveList');
							$attrs.name && $rootScope.$broadcast('$$rebind::' + $attrs.name);
						});
					};

					$scope.removeSelected = function() {
						$timeout(function() {
							lastSelectedRemoveItem = -1;

							$scope.right = $scope.right.concat(
								$scope.left.filter(function(item) {
									return $scope.data.itemsToRemove.map(stringifyItem).indexOf(stringifyItem(item[$scope.value])) > -1;
								})
							);

							$scope.left = $scope.left.filter(function(item) {
								return $scope.data.itemsToRemove.map(stringifyItem).indexOf(stringifyItem(item[$scope.value])) < 0;
							});

							$scope.data.itemsToRemove = [];

							$scope.right.sort(compare);

							$scope.$broadcast('$$rebind::addRemoveList');
							$attrs.name && $rootScope.$broadcast('$$rebind::' + $attrs.name);
						});
					};

					$scope.sortLists = function() {
						$scope.left && $scope.left.sort(compare);
						$scope.right && $scope.right.sort(compare);
					};

					$scope.addItemToAdd = function(item, index, event) {
						if (!event.shiftKey || lastSelectedAddItem < 0) {
							addList.find('li[data-index="' + String(index) + '"]').addClass('selected');
							$scope.data.itemsToAdd.push(item[$scope.value]);
						} else {
							var indices = UtilsService.numArray(
								Math.min(index, lastSelectedAddItem),
								Math.max(index, lastSelectedAddItem)
							);
							for (var i in indices) {
								var _index = Number(i) + Number(indices[0]);
								var val = $scope.right[_index][$scope.value];
								if ($scope.data.itemsToAdd.map(stringifyItem).indexOf(stringifyItem(val)) < 0) {
									addList.find('li[data-index="' + String(_index) + '"]').addClass('selected');
									$scope.data.itemsToAdd.push(val);
								}
							}
						}
						lastSelectedAddItem = index;
					};

					$scope.addItemToRemove = function(item, index, event) {
						if (!event.shiftKey || lastSelectedRemoveItem < 0) {
							removeList.find('li[data-index="' + String(index) + '"]').addClass('selected');
							$scope.data.itemsToRemove.push(item[$scope.value]);
						} else {
							var indices = UtilsService.numArray(
								Math.min(index, lastSelectedRemoveItem),
								Math.max(index, lastSelectedRemoveItem)
							);
							for (var i in indices) {
								var _index = Number(i) + Number(indices[0]);
								//console.log('_index: ', _index);
								var val = $scope.left[_index][$scope.value];
								if ($scope.data.itemsToRemove.map(stringifyItem).indexOf(stringifyItem(val)) < 0) {
									removeList.find('li[data-index="' + String(_index) + '"]').addClass('selected');
									$scope.data.itemsToRemove.push(val);
								}
							}
						}
						lastSelectedRemoveItem = index;
					};

					$scope.removeItemToAdd = function(item, index) {
						$timeout(function() {
							$scope.data.itemsToAdd = $scope.data.itemsToAdd.filter(function(_item) {
								var remove = _item === item[$scope.value];
								remove && addList.find('li[data-index="' + String(index) + '"]').removeClass('selected');
								return !remove;
							});
							if (lastSelectedAddItem == index) {
								lastSelectedAddItem = -1;
							}
						});
					};

					$scope.removeItemToRemove = function(item, index) {
						$timeout(function() {
							//console.log('removeItemToRemove: ', item);
							$scope.data.itemsToRemove = $scope.data.itemsToRemove.filter(function(_item) {
								var remove = _item === item[$scope.value];
								remove && removeList.find('li[data-index="' + String(index) + '"]').removeClass('selected');
								return !remove;
							});
							if (lastSelectedRemoveItem == index) {
								lastSelectedRemoveItem = -1;
							}
						});
					};

					$scope.clickedAddItem = function(item, index, event) {
						if (!(event.ctrlKey || event.metaKey) && !event.shiftKey) {
							$timeout(function() {
								addList.find('li').removeClass('selected');
								var val = item[$scope.value];
								var shouldAdd = $scope.data.itemsToAdd.map(stringifyItem).indexOf(stringifyItem(val)) < 0;
								$scope.data.itemsToAdd = [];
								if (shouldAdd) {
									$scope.data.itemsToAdd.push(val);
									addList.find('li[data-index="' + String(index) + '"]').addClass('selected');
									lastSelectedAddItem = index;
								} else {
									lastSelectedAddItem = -1;
								}
							});
							return;
						}
						(addList.find('li[data-index="' + String(index) + '"]').hasClass('selected')
							? $scope.removeItemToAdd
							: $scope.addItemToAdd)(item, index, event);
					};

					$scope.clickedRemoveItem = function(item, index, event) {
						if (!(event.ctrlKey || event.metaKey) && !event.shiftKey) {
							$timeout(function() {
								removeList.find('li').removeClass('selected');
								var val = item[$scope.value];
								var shouldAdd = $scope.data.itemsToRemove.map(stringifyItem).indexOf(stringifyItem(val)) < 0;
								$scope.data.itemsToRemove = [];
								if (shouldAdd) {
									$scope.data.itemsToRemove.push(val);
									removeList.find('li[data-index="' + String(index) + '"]').addClass('selected');
									lastSelectedRemoveItem = index;
								} else {
									lastSelectedRemoveItem = -1;
								}
							});
							return;
						}
						(removeList.find('li[data-index="' + String(index) + '"]').hasClass('selected')
							? $scope.removeItemToRemove
							: $scope.addItemToRemove)(item, index, event);
					};

					$scope.dblClickedRemoveItem = function(item) {
						$timeout(function() {
							$scope.data.itemsToRemove = [item[$scope.value]];
							$scope.removeSelected();
							removeList.find('li').removeClass('selected');
						});
					};

					$scope.dblClickedAddItem = function(item) {
						$timeout(function() {
							$scope.data.itemsToAdd = [item[$scope.value]];
							$scope.addSelected();
							addList.find('li').removeClass('selected');
						});
					};

					var handleAddArrowKey = function(direction, item, index, event) {
						var newIndex = index + direction;
						if (newIndex > -1 && newIndex < $scope.right.length) {
							event.preventDefault();
							$scope.clickedAddItem($scope.right[newIndex], newIndex, event);
							return false;
						}
						return true;
					};

					var handleRemoveArrowKey = function(direction, item, index, event) {
						var newIndex = index + direction;
						if (newIndex > -1 && newIndex < $scope.left.length) {
							event.preventDefault();
							$scope.clickedRemoveItem($scope.left[newIndex], newIndex, event);
							return false;
						}
						return true;
					};

					var scrollToIndexIfNeeded = function(list, index) {
						var scrollHeight = list[0].scrollHeight;
						var offsetHeight = list[0].offsetHeight;
						var itemHeight = scrollHeight / list.find('li').length;
						var scrollTop = list[0].scrollTop;
						if (scrollTop < itemHeight * (index + 2) - offsetHeight) {
							list.scrollTop(Math.min(scrollHeight - offsetHeight, itemHeight * (index + 2) - offsetHeight));
						} else if (scrollTop > itemHeight * (index - 1)) {
							list.scrollTop(Math.max(0, itemHeight * (index - 1)));
						}
					};

					$scope.keydown = function(action, item, index, event) {
						if ([38, 40].indexOf(event.which) !== -1) {
							var isAdd = action == 'add';
							var _index = isAdd ? lastSelectedAddItem : lastSelectedRemoveItem;
							if (_index < 0) _index = index;
							scrollToIndexIfNeeded(isAdd ? addList : removeList, _index);
							return (isAdd ? handleAddArrowKey : handleRemoveArrowKey)(
								event.which == 38 ? -1 : 1,
								item,
								_index,
								event
							);
						}
						return true;
					};

					$timeout(function() {
						$scope.sortLists();
						$scope.$broadcast('$$rebind::addRemoveList');
					});

					$scope.addString = $rootScope.languageString('add_selected');
					$scope.removeString = $rootScope.languageString('remove_selected');

					$scope.$on('$destroy', function() {
						addList = null;
						removeList = null;
					});
				},

				link: function(scope, element, attrs, ngFormController) {
					if (scope.left && !(scope.left instanceof Array)) {
						scope.left = [];
					}

					if (scope.right && !(scope.right instanceof Array)) {
						scope.right = [];
					}

					scope.left = scope.left || [];
					scope.right = scope.right || [];
					scope.display = scope.display || 'display';
					scope.value = scope.value || 'value';

					scope.data = {
						itemsToAdd: [],
						itemsToRemove: [],
					};

					var initialised = false;

					scope.$watchGroup(['left', 'right'], function(newValues, oldValues, scope) {
						var nonArrayFound = false;

						if (newValues[0] && newValues[0].length && !(newValues[0] instanceof Array)) {
							nonArrayFound = true;
						}

						if (!nonArrayFound && newValues[1] && newValues[1].length && !(newValues[1] instanceof Array)) {
							nonArrayFound = true;
						}

						if (!nonArrayFound) {
							scope.$broadcast('$$rebind::addRemoveList');
							if (newValues[0] && newValues[1] && (newValues[0].length || newValues[1].length)) {
								// v(); // remove?
								if (!initialised) {
									initialised = true;
								} else if (ngFormController) {
									ngFormController.$dirty || ngFormController.$setDirty() || element.find('ul').addClass('ng-dirty');
								}
								$timeout(function() {
									if (scope.sortLists) {
										scope.sortLists();
										scope.$broadcast('$$rebind::addRemoveList');
									}
								});
							}
						}
					});
				},

				template:
					'<div class="add-remove">' +
					'<ul class="remove-items"><li ng-repeat="(index, option) in :addRemoveList:left track by $index" ng-attr-title="{{:addRemoveList:option[display]}}" data-index="{{index}}" tabindex="{{index}}" ng-click="clickedRemoveItem(option, index, $event)" ng-dblclick="dblClickedRemoveItem(option)" ng-keydown="keydown(\'remove\', option, index, $event)" data-after="{{:addRemoveList:(note?option[note]:\'\')}}">{{:addRemoveList:option[display]}}</li></ul>' +
					'<div><button type="button" class="btn btn-default blue" ng-click="addSelected()">{{addString}}</button><button type="button" class="btn btn-default red" ng-click="removeSelected()">{{removeString}}</button></div>' +
					'<ul class="add-items"><li ng-repeat="(index, option) in :addRemoveList:right track by $index" ng-attr-title="{{:addRemoveList:option[display]}}" data-index="{{index}}" tabindex="{{index}}" ng-click="clickedAddItem(option, index, $event)" ng-dblclick="dblClickedAddItem(option)" ng-keydown="keydown(\'add\', option, index, $event)" data-after="{{:addRemoveList:(note?option[note]:\'\')}}">{{:addRemoveList:option[display]}}</li></ul>' +
					'</div>',
			};
		},
	])

	.directive('destinationSelect', [
		'CoreApiService',
		'SessionService',
		'UtilsService',
		'$rootScope',
		'$q',
		'$timeout',
		'variables',
		'$log',
		function(ApiService, SessionService, UtilsService, $rootScope, $q, $timeout, variables, $log) {
			var cache = null;

			var clearCache = function() {
				cache = null;
			};

			$rootScope.$on('AuthSuccess', clearCache);
			$rootScope.$on('WillLogOut', clearCache);

			var isLoading = false;
			var waitForResponse;

			return {
				restrict: 'E',
				replace: true,

				require: '?^form',

				priority: 1,

				scope: {
					field: '@',
					stype: '@',
					snumber: '@',
					dtype: '@',
					dnumber: '@',
					special: '@',
					selecteditem: '=',
					selectedsubitem: '=',
				},

				controller: function($scope, $element) {
					var me = SessionService.getSession();

					if (!me) {
						return;
					} // reload on AuthSucces

					var _dests_type = function(type, label, ref, key, stype, snumber) {
						if (typeof key == 'undefined') {
							key = 'id';
						}

						if (typeof stype == 'undefined') {
							stype = '';
						}

						if (typeof snumber == 'undefined') {
							snumber = '';
						}

						if (!ref || !ref.length) {
							return null;
						}

						if (key && ref.length == 1 && stype == type) {
							var d = ref[0];

							if (snumber == d[key]) {
								return null;
							}
						}

						var r = {
							role: 'menuitem',
							field: $scope.field,
							type: type,
							key: key,
						};

						if (label) {
							r.value = type;
							r.display = label;

							return r;
						}

						r.value = type;
						r.display = $rootScope.languageString('dtype_' + type);

						return r;
					};

					var _dests_select = function(field, type, ref, key, display, url, stype, snumber, dtype, dnumber) {
						if (!ref || !ref.length) {
							return null;
						}
						display = display || 'display';

						var options = [];

						ref.forEach(function(item) {
							if (stype && stype == type && snumber == item[key]) {
								return;
							}

							options.push({
								type: type,
								//stype: stype,
								//key: key,
								conferenceId: _.startsWith(type, 'conference') ? item['id'] : '',
								value: _.startsWith(type, 'conference') ? item['code'] : item[key],
								display: item[display],
								role: 'menuitem',
								url: url,
								owner: item.owner,
								display_key: display,
								link: UtilsService.getLink(field + '_' + type, url, item[key]),
							});
						});

						if (options.length) {
							//
						}

						return options;
					};

					var all_subitems = {};

					$scope.options = {};

					$scope.options.show_input = {
						callback: false,
						faxtoemail: false,
						forward: false,
						peer: false,
						redirect_message: false,
						sipuri: false,
					};

					$scope.inputs = {};

					var sortByKey = function(key) {
						return function(a, b) {
							return (a[key] || '').localeCompare(b[key] || '');
						};
					};

					this.add_subitem = function(item) {
						return $scope.selecteditem
							? $timeout(function() {
									var u = ($scope.selectedsubitem || {}).url || '';
									var t = $scope.selecteditem.type || '';
									var value = item[$scope.selecteditem.key] || '';
									item.link = u + value;
									var display_key = ($scope.selectedsubitem || {}).display_key || 'display';
									item.display = item[display_key];
									item.display_key = display_key;
									item.value = (t == 'update_routing_timegroup' ? 'timegroup_' : '') + value;
									var subitems = all_subitems[t + '_select'];
									if (subitems) {
										subitems.push(item);
										subitems.sort(sortByKey('display'));
										clearCache();
										$scope.$broadcast('$$rebind::destination_subitems');
									}
									// console.log('adding subitem: ', item, t, subitems);
									subitems = null;
									return item;
							  })
							: $q.resolve(item);
					};

					this.select_subitem = $scope.select_subitem = function(subitem) {
						return $timeout(function() {
							if ($scope.selecteditem.value == 'peer') {
								var _selectedsubitem = '';

								if ($scope.selectedsubitem && $scope.selectedsubitem instanceof Object) {
									_selectedsubitem = $scope.selectedsubitem.value;
								}

								if (!$scope.selectedsubitem) {
									_selectedsubitem = '@';
									if (subitem && subitem instanceof Object) {
										_selectedsubitem += subitem.value || '';
									} else {
										_selectedsubitem = (subitem || '') + $scope.selectedsubitem;
									}
								} else {
									if (subitem && subitem instanceof Object) {
										_selectedsubitem = ($scope.inputs.peer || '') + '@' + (subitem.value || '');
									} else {
										var atIndex = ($scope.selectedsubitem.value || _selectedsubitem).indexOf('@');
										if (atIndex < 0) {
											_selectedsubitem = (subitem || '') + '@';
										} else {
											_selectedsubitem =
												(subitem || '') + ($scope.selectedsubitem.value || _selectedsubitem).slice(atIndex);
										}
									}
								}

								if (!(subitem instanceof Object)) {
									$scope.selectedsubitem = {
										value: _selectedsubitem,
										display: ($scope.selectedsubitem || {}).display || '',
										link: '',
									};
								} else {
									$scope.selectedsubitem = $scope.selectedsubitem || {};
									if (!($scope.selectedsubitem instanceof Object)) {
										$scope.selectedsubitem = {};
									}
									$scope.selectedsubitem.value = _selectedsubitem;
									$scope.selectedsubitem.display = subitem.display || '';
									$scope.selectedsubitem.link = '';
								}

								//$log.debug('numbet at peer: ', $scope.selectedsubitem);
							} else {
								$scope.selectedsubitem = angular.copy(subitem);

								if (
									$scope.selecteditem.value == 'update_routing_timegroup' ||
									$scope.selecteditem.value == 'update_routing'
								) {
									// ?
									$scope.selecteditem.value = 'update_routing';
									$scope.selectedsubitem.value = 'timegroup_' + $scope.selectedsubitem.value;
								}
							}

							$scope.show_url_warning =
								$scope.dtype.value == 'url' && !($scope.dnumber.value.match(/^\d+$./) || []).length;

							return subitem;
						});
					};

					this.getType = function() {
						return ($scope.selecteditem || { value: '' }).value || '';
					};

					this.getSelectedSubitem = function() {
						return $scope.selectedsubitem || { link: '' };
					};

					this.getLink = function() {
						// console.log('$scope.selectedsubitem: ', $scope.selectedsubitem);
						return this.getSelectedSubitem().link || '';
					};

					$scope.select_item = function(item, subitem) {
						if (typeof subitem == 'undefined') {
							subitem = null;
						}

						$timeout(function() {
							//$log.debug('select_item: ', item, subitem);

							$scope.selecteditem = angular.copy(item);
							$scope.editKey = ($scope.selecteditem || {}).key || 'id';
							// console.log('eeeeee', $scope.selecteditem, $scope.editKey);

							switch (item.value) {
								case 'callback':
								case 'faxtoemail':
								case 'forward':
								case 'peer':
								case 'redirect_message':
								case 'sipuri': {
									$scope.subitems = [];

									$scope.inputs[item.value] = $scope.inputs[item.value] || all_subitems[item.value] || '';
									$scope.selectedsubitem = angular.copy(subitem || $scope.inputs[item.value]);

									for (var key in $scope.options.show_input) {
										$scope.options.show_input[key] = key == item.value;
									}

									if (item.value != 'peer') {
										break;
									}
								}

								default: {
									for (var key in $scope.options.show_input) {
										$scope.options.show_input[key] = false;
									}
									if (item.value == 'peer') {
										$scope.options.show_input.peer = true;
									}

									$scope.subitems = all_subitems[item.value + '_select'] || [];

									if ($scope.subitems && $scope.subitems.length) {
										$scope.select_subitem(subitem || $scope.subitems[0]);
									} else {
										$scope.selectedsubitem = null;
									}

									if (
										/^update_routing_/.test($scope.selecteditem.value) &&
										$scope.selecteditem.value != 'update_routing_timegroup'
									) {
										$scope.selectedsubitem =
											'update_routing_default' == $scope.selecteditem.value ? 'default' : 'normal';
										$scope.selecteditem.value = 'update_routing';
									}

									break;
								}
							}

							//console.log('subitems, show_input', $scope.subitems, $scope.options.show_input);

							$scope.show_url_warning =
								$scope.dtype.value == 'url' && !($scope.dnumber.value.match(/^\d+$./) || []).length;
						}).then(function() {
							$timeout(function() {
								$scope.$broadcast('$$rebind::destination_subitems');
							});
						});
					};

					var errors = [];

					var pushError = function(e) {
						errors.push(e);
						return e || {};
					};

					var loadApiData = function(method, endpoint, params, data) {
						return ApiService.makeApiCall(method, endpoint, params, data).then(angular.identity, pushError);
					};

					$scope.loadData = function() {
						if ($scope.loaded) {
							return;
						}

						errors = [];

						//console.log('Debug: $scope.dtype = ' + String($scope.dtype) + ' (' + typeof($scope.dtype) + ')');

						if (!$scope.dtype) {
							// prevent multiple loading
							//console.log('not ready to initialize yet!');
							return;
						}

						$scope.loaded = !!$scope.dtype;

						// init
						//$scope.dtype = $scope.dtype || 'hangup'; // not needed!

						$scope.peer_number = '';

						if ($scope.dtype == 'peer') {
							var found = $scope.dnumber.match(/^([\s\S]*)\@(\d+)$/);

							if (found && found.length > 2) {
								$scope.peer_number = found[1];
								$scope.dnumber = found[2];
							}

							$scope.inputs.peer = $scope.peer_number || '';
							//console.log('$scope.inputs.peer', $scope.inputs.peer);
						} else if ($scope.dtype == 'update_routing') {
							var found = $scope.dnumber.match(/^timegroup_(\d+)$/);

							//console.log('update_routing_timegroup: ', $scope.dtype, $scope.dnumber, found);
							if (found && found.length > 1) {
								$scope.dtype = 'update_routing_timegroup';
								$scope.dnumber = found[1];
							} else if ($scope.dnumber.match(/^\d+$/)) {
								$scope.dtype += '_timegroup';
							} else {
								$scope.dtype += '_' + ($scope.dnumber || 'default');
								$scope.dnumber = '';
							}
						}
						// /init

						$scope.selecteditem = $scope.dtype;
						$scope.selectedsubitem = $scope.dnumber;

						var _cache;

						(function() {
							_cache = cache; //angular.copy(cache);

							if (_cache) {
								//$log.debug('Found cached values!');
								return $timeout(function() {
									return _cache;
								});
							}

							if (isLoading) {
								//$log.debug('Waiting for response!');
								return waitForResponse;
							}

							isLoading = true;

							return (waitForResponse = $q
								.all({
									wholesale: loadApiData('POST', 'roles/access/get/', {
										role: me.effective_role || me.role,
										privilege: 'wholesale',
									}),
									enable_fax: loadApiData('POST', 'configs/get/', {
										name: 'enable_fax',
										default: '0',
									}),
									enable_park: loadApiData('POST', 'configs/get/', {
										name: 'enable_park',
										default: '0',
									}),
									asterisk_version: loadApiData('POST', 'configs/get/', {
										name: 'asterisk_version',
										default: '11',
									}),
									codes: loadApiData('POST', 'codes/list/', {}),
									conferences: loadApiData('POST', 'conferences/list/', {}),
									huntgroups: loadApiData('POST', 'huntgroups/list/', {}),
									ivrs: loadApiData('POST', 'ivrs/list/', {}),
									mailboxes: loadApiData('POST', 'mailboxes/list/', {}),
									pagegroups: loadApiData('POST', 'pagegroups/list/', {}),
									patternmenus: loadApiData('POST', 'patternmenus/list/', {}),
									peers: loadApiData('POST', 'peers/list/', {
										destination: 1,
									}),
									phones: loadApiData('POST', 'phones/list/', {
										owner: '-1',
									}),
									plugins: loadApiData('POST', 'plugins/list/', {
										available: 1,
									}),
									queues: loadApiData('POST', 'queues/list/', {}),
									timegroups: loadApiData('POST', 'timegroups/list/', {
										available: 1,
									}),
									unlimited_accesses: loadApiData('POST', 'unlimited/list/', {}),
									urls: loadApiData('POST', 'urls/list/', {}),
									max_callbacks: loadApiData('POST', 'plans/features/maximum/', {
										feature: 'callback',
									}),
									max_faxtoemails: loadApiData('POST', 'plans/features/maximum/', {
										feature: 'faxtoemails',
									}),
									max_sipuris: loadApiData('POST', 'plans/features/maximum/', {
										feature: 'sipuris',
									}),
									max_faxboxes: loadApiData('POST', 'plans/features/maximum/', {
										feature: 'faxboxes',
									}),
									max_features: loadApiData('POST', 'plans/features/maximum/', {
										feature: 'features',
									}),
									max_sounds: loadApiData('POST', 'plans/features/maximum/', {
										feature: 'sounds',
									}),
								})
								.then(
									function(responses) {
										//$log.debug('Finished loading from api!');
										//_cache = responses;
										//cache = responses;
										isLoading = false;
										return responses;
									},
									function(error) {
										isLoading = false;
										ApiService.defaultErrorHandler(error);
										return null;
									}
								));
						})().then(function(_responses) {
							if (!_cache && !cache) {
								//$log.debug('Loaded from api!');
								setTimeout(clearCache, 60000);

								cache = _responses;
								_cache = _responses;
							} else {
								if (!_cache) {
									_cache = cache; //angular.copy(cache);
									//$log.debug('Copied cache!');
								}

								//$log.debug('Used value from cache: ', _cache);
							}

							var responses = _cache;

							for (var key in responses) {
								switch (key) {
									case 'max_callbacks':
									case 'max_faxtoemails':
									case 'max_sipuris':
									case 'max_faxboxes':
									case 'max_features':
									case 'max_sounds': {
										$scope[key] = Number(responses[key].data.maximum);
										break;
									}

									case 'enable_fax':
									case 'enable_park': {
										$scope[key] = Number(responses[key].data.value);
										break;
									}
									case 'asterisk_version': {
										$scope[key] = responses[key].data.value;
										break;
									}

									default: {
										$scope[key] = responses[key].data;
										break;
									}
								}
							}

							$scope.show_fax =
								$scope.special != 'terminal' &&
								$scope.special != 'queue' &&
								!Number($scope.wholesale) &&
								Number($scope.enable_fax);

							var items = [];

							items.push({
								display: $rootScope.languageString('external_destinations'),
								role: 'section',
							});

							var external_destination1 =
								$scope.special != 'terminal' &&
								$scope.special != 'queue' &&
								!Number($scope.wholesale) &&
								$scope.max_callbacks
									? {
											value: 'callback',
											display: $rootScope.languageString('dtype_callback'),
											role: 'menuitem',
									  }
									: null;
							if (external_destination1) {
								items.push(external_destination1);
							}

							var external_destination2 =
								$scope.show_fax && $scope.max_faxtoemails
									? {
											value: 'faxtoemail',
											display: $rootScope.languageString('dtype_faxtoemail'),
											role: 'menuitem',
									  }
									: null;
							if (external_destination2) {
								items.push(external_destination2);
							}

							items.push({
								value: 'forward',
								display: $rootScope.languageString('dtype_forward'),
								role: 'menuitem',
							});

							var external_destination3 = _dests_type('peer', '', $scope.peers);
							if (external_destination3) {
								items.push(external_destination3);
							}

							var external_destination4 =
								$scope.special != 'queue' && $scope.max_sipuris
									? {
											value: 'sipuri',
											display: $rootScope.languageString('dtype_sipuri'),
											role: 'menuitem',
									  }
									: null;
							if (external_destination4) {
								items.push(external_destination4);
							}

							if ($scope.special == 'terminal' || $scope.special == 'queue') {
								if ($scope.phones.length) {
									items.push({
										display: $rootScope.languageString('my_features'),
										role: 'section',
									});
									items.push(_dests_type('phone', '', $scope.phones, 'name'));
								}
							} else {
								items.push({
									display: $rootScope.languageString('my_features'),
									role: 'section',
								});

								items.push(_dests_type('code', '', $scope.codes, 'code'));
								items.push(_dests_type('conference', '', $scope.conferences, 'code'));
								items.push(_dests_type('conference_admin', '', $scope.conferences, 'code'));
								items.push(_dests_type('conference_talk', '', $scope.conferences, 'code'));
								items.push(_dests_type('conference_listen', '', $scope.conferences, 'code'));
								if ($scope.show_fax && $scope.max_faxboxes) {
									items.push(_dests_type('faxbox', '', $scope.mailboxes, 'mailbox'));
								}
								items.push(_dests_type('huntgroup', '', $scope.huntgroups, 'id', $scope.stype, $scope.snumber));
								items.push(_dests_type('ivr', '', $scope.ivrs));
								items.push(_dests_type('mailbox', '', $scope.mailboxes, 'mailbox'));
								items.push(_dests_type('pagegroup', '', $scope.pagegroups, 'id', $scope.stype, $scope.snumber));
								items.push(_dests_type('patternmenu', '', $scope.patternmenus));
								items.push(_dests_type('plugin', '', $scope.plugins));
								items.push(
									_dests_type(
										'phone',
										$rootScope.languageString(Number($scope.wholesale) ? 'dtype_trunk' : 'dtype_phone'),
										$scope.phones,
										'name',
										$scope.stype,
										$scope.snumber
									)
								);
								items.push(_dests_type('queue', '', $scope.queues, 'id', $scope.stype, $scope.snumber));
								items.push(_dests_type('unlimited_access', '', $scope.unlimited_accesses));
								items.push(_dests_type('url', '', $scope.urls));
								items.push(_dests_type('voicemailbox', '', $scope.mailboxes, 'mailbox'));
								items.push(_dests_type('voicemailboxpin', '', $scope.mailboxes, 'mailbox'));

								if ($scope.special == 'ivr') {
									var ivrFeatures = [];

									variables.features_ivr.forEach(function(feature) {
										var name = $rootScope.languageString('dtype_' + feature);

										if (name) {
											ivrFeatures.push({
												value: feature,
												display: name,
												role: 'menuitem',
											});
										}
									});

									if (ivrFeatures.length) {
										items.push({
											display: $rootScope.languageString('ivr_features'),
											role: 'section',
										});
										items = items.concat(ivrFeatures);
									}
								}

								if (!Number($scope.wholesale) && $scope.max_features) {
									var features = [];

									var _features = variables.features;

									if ($scope.special == 'code') {
										_features = _features.concat(variables.features_code);
									}

									_features.forEach(function(feature) {
										if (feature == 'holding' && $scope.asterisk_version == '11') {
											return;
										}

										if ((feature == 'park' || feature == 'parking') && !$scope.enable_park) {
											return;
										}

										if (feature == 'record_sound' && !$scope.max_sounds) {
											return;
										}

										var name = $rootScope.languageString('dtype_' + feature);

										if (name) {
											features.push({
												value: feature,
												display: name,
												role: 'menuitem',
											});
										}
									});

									if (features.length) {
										items.push({
											display: $rootScope.languageString('predefined_features'),
											role: 'section',
										});
										items = items.concat(features);
									}
								} else {
									items.push({
										display: $rootScope.languageString('predefined_features'),
										role: 'section',
									});
									items.push({
										value: 'hangup',
										display: $rootScope.languageString('dtype_hangup'),
										role: 'menuitem',
									});
								}

								items.push({
									display: $rootScope.languageString('update_routing'),
									role: 'section',
								});
								items.push({
									value: 'update_routing_normal',
									display: $rootScope.languageString('update_routing_normal'),
									role: 'menuitem',
								});
								items.push({
									value: 'update_routing_default',
									display: $rootScope.languageString('update_routing_default'),
									role: 'menuitem',
								});

								if ($scope.timegroups.length) {
									items.push(
										_dests_type(
											'update_routing_timegroup',
											$rootScope.languageString('update_routing_timegroup'),
											$scope.timegroups
										)
									);
								}
							}

							all_subitems.callback = $scope.dtype == 'callback' ? $scope.dnumber : '';
							all_subitems.code_select = _dests_select(
								$scope.field,
								'code',
								$scope.codes,
								'code',
								'display',
								'/devices/codes/edit/?code=',
								$scope.stype,
								$scope.snumber,
								$scope.dtype,
								$scope.dnumber
							);
							all_subitems.conference_select = _dests_select(
								$scope.field,
								'conference',
								$scope.conferences,
								'id',
								'display',
								'/features/conferences/edit/?id=',
								'',
								'',
								$scope.dtype,
								$scope.dnumber
							);
							all_subitems.conference_admin_select = _dests_select(
								$scope.field,
								'conference_admin',
								$scope.conferences,
								'id',
								'display',
								'/features/conferences/edit/?id=',
								'',
								'',
								$scope.dtype,
								$scope.dnumber
							);
							all_subitems.conference_listen_select = _dests_select(
								$scope.field,
								'conference_listen',
								$scope.conferences,
								'id',
								'display',
								'/features/conferences/edit/?id=',
								'',
								'',
								$scope.dtype,
								$scope.dnumber
							);
							all_subitems.conference_talk_select = _dests_select(
								$scope.field,
								'conference_talk',
								$scope.conferences,
								'id',
								'display',
								'/features/conferences/edit/?id=',
								'',
								'',
								$scope.dtype,
								$scope.dnumber
							);
							all_subitems.faxbox_select = _dests_select(
								$scope.field,
								'faxbox',
								$scope.mailboxes,
								'mailbox',
								'display',
								'/features/mailboxes/edit/?mailbox=',
								'',
								'',
								$scope.dtype,
								$scope.dnumber
							);
							all_subitems.faxtoemail = $scope.dtype == 'faxtoemail' ? $scope.dnumber : '';
							all_subitems.forward = $scope.dtype == 'forward' ? $scope.dnumber : '';
							all_subitems.huntgroup_select = _dests_select(
								$scope.field,
								'huntgroup',
								$scope.huntgroups,
								'id',
								'name',
								'/features/huntgroups/edit/?id=',
								$scope.stype,
								$scope.snumber,
								$scope.dtype,
								$scope.dnumber
							);
							all_subitems.ivr_select = _dests_select(
								$scope.field,
								'ivr',
								$scope.ivrs,
								'id',
								'name',
								'/features/ivrs/edit/?id=',
								'',
								'',
								$scope.dtype,
								$scope.dnumber
							);
							all_subitems.mailbox_select = _dests_select(
								$scope.field,
								'mailbox',
								$scope.mailboxes,
								'mailbox',
								'display',
								'/features/mailboxes/edit/?mailbox=',
								'',
								'',
								$scope.dtype,
								$scope.dnumber
							);
							all_subitems.pagegroup_select = _dests_select(
								$scope.field,
								'pagegroup',
								$scope.pagegroups,
								'id',
								'name',
								'/features/pagegroups/edit/?id=',
								'',
								'',
								$scope.dtype,
								$scope.dnumber
							);
							all_subitems.patternmenu_select = _dests_select(
								$scope.field,
								'patternmenu',
								$scope.patternmenus,
								'id',
								'name',
								'/features/patternmenus/edit/?id=',
								'',
								'',
								$scope.dtype,
								$scope.dnumber
							);
							all_subitems.peer_number = $scope.peer_number;
							all_subitems.peer_select = _dests_select(
								$scope.field,
								'peer',
								$scope.peers,
								'id',
								'name',
								'',
								'',
								'',
								$scope.dtype,
								$scope.dnumber
							);
							all_subitems.phone_select = _dests_select(
								$scope.field,
								'phone',
								$scope.phones,
								'name',
								'display',
								'/devices/phones/edit/?name=',
								$scope.stype,
								$scope.snumber,
								$scope.dtype,
								$scope.dnumber
							);
							all_subitems.plugin_select = _dests_select(
								$scope.field,
								'plugin',
								$scope.plugins,
								'id',
								'name',
								'',
								'',
								'',
								$scope.dtype,
								$scope.dnumber
							);
							all_subitems.queue_select = _dests_select(
								$scope.field,
								'queue',
								$scope.queues,
								'id',
								'name',
								'/features/queues/edit/?id=',
								$scope.stype,
								$scope.snumber,
								$scope.dtype,
								$scope.dnumber
							);
							all_subitems.redirect_message = $scope.dtype == 'redirect_message' ? $scope.dnumber : '';
							all_subitems.sipuri = $scope.dtype == 'sipuri' ? $scope.dnumber : '';
							all_subitems.unlimited_access_select = _dests_select(
								$scope.field,
								'unlimited_access',
								$scope.unlimited_accesses,
								'id',
								'name',
								'/customers/unlimited/edit/?id=',
								'',
								'',
								$scope.dtype,
								$scope.dnumber
							);
							all_subitems.update_routing_timegroup_select = _dests_select(
								$scope.field,
								'update_routing_timegroup',
								$scope.timegroups,
								'id',
								'name',
								'/features/times/groups/edit/?id=',
								'',
								'',
								$scope.dtype,
								$scope.dnumber
							);
							all_subitems.url_select = _dests_select(
								$scope.field,
								'url',
								$scope.urls,
								'id',
								'name',
								'/features/urls/edit/?id=',
								'',
								'',
								$scope.dtype,
								$scope.dnumber
							);
							all_subitems.voicemailbox_select = _dests_select(
								$scope.field,
								'voicemailbox',
								$scope.mailboxes,
								'mailbox',
								'display',
								'/features/mailboxes/edit/?mailbox=',
								'',
								'',
								$scope.dtype,
								$scope.dnumber
							);
							all_subitems.voicemailboxpin_select = _dests_select(
								$scope.field,
								'voicemailboxpin',
								$scope.mailboxes,
								'mailbox',
								'display',
								'/features/mailboxes/edit/?mailbox=',
								'',
								'',
								$scope.dtype,
								$scope.dnumber
							);

							var nonNullItems = items.filter(angular.identity); // get rid of nulls

							// sort all sections alphabetically
							for (var i = 0; i < nonNullItems.length; i++) {
								while (nonNullItems[i].role === 'section') i++;
								while (
									i < nonNullItems.length &&
									(i == nonNullItems.length - 1 || nonNullItems[i + 1].role !== 'section')
								) {
									for (var j = i + 1; j < nonNullItems.length && nonNullItems[j].role !== 'section'; j++) {
										if (nonNullItems[i].display.localeCompare(nonNullItems[j].display) > 0) {
											var temp = nonNullItems[i];
											nonNullItems[i] = nonNullItems[j];
											nonNullItems[j] = temp;
										}
									}
									i++;
								}
							}

							$timeout(function() {
								// set up initial selections, allow primitives as selected item and subitem, 'Hangup' is default
								$scope.items = nonNullItems;

								$scope.$broadcast('$$rebind::destination_items');
								//console.log('items: ', $scope.items);

								if ($scope.selecteditem) {
									var is_input =
										['callback', 'faxtoemail', 'forward', 'peer', 'redirect_message', 'sipuri'].indexOf(
											$scope.selecteditem.value || $scope.selecteditem
										) > -1;

									if ($scope.selectedsubitem) {
										if ($scope.selectedsubitem instanceof Object && !is_input) {
											if (!$scope.selectedsubitem.value) {
												$scope.selectedsubitem = null;
											}
										} else {
											var item =
												$scope.selecteditem instanceof Object ? $scope.selecteditem.value : $scope.selecteditem;

											$scope.selectedsubitem = $scope.selectedsubitem.value || $scope.selectedsubitem;

											if (is_input) {
												if (item == 'peer') {
													//var found = $scope.selectedsubitem.match(/^([\s\S]*\@)(\d+)$/) || [];

													//var n = found[1] || '';
													//var p = found[2] || '';

													//$scope.inputs[item] = n;
													//console.log('$scope.inputs.peer (2)', $scope.inputs.peer);
													$scope.subitems = all_subitems.peer_select;
													$scope.selectedsubitem =
														angular.copy(
															all_subitems.peer_select.filter(function(item) {
																return item.value == $scope.dnumber;
															})[0]
														) || null;
												} else {
													$scope.inputs[item] = $scope.selectedsubitem;
													$scope.selectedsubitem = null;
												}

												$scope.options.show_input[item] = true;
											} else {
												var arr = all_subitems[item + '_select'];

												if (arr && arr.length) {
													$scope.selectedsubitem =
														angular.copy(
															arr.filter(function(item) {
																return item.value == $scope.selectedsubitem;
															})[0]
														) || null;
												} else {
													$scope.selectedsubitem = null;
												}
											}

											$scope.select_item(
												$scope.items.filter(function(_item) {
													return item.value == _item;
												})[0] || {
													value: 'hangup',
													display: $rootScope.languageString('dtype_hangup'),
													role: 'menuitem',
												},
												$scope.selectedsubitem
											);
										}
									}

									if ($scope.selecteditem instanceof Object) {
										if ($scope.selecteditem.value) {
											$scope.select_item($scope.selecteditem, $scope.selectedsubitem);
										} else {
											$scope.select_item(
												{
													value: 'hangup',
													display: $rootScope.languageString('dtype_hangup'),
													role: 'menuitem',
												},
												$scope.selectedsubitem
											);
										}
									} else {
										$scope.select_item(
											$scope.items.filter(function(item) {
												return item.value == $scope.selecteditem;
											})[0] || {
												value: 'hangup',
												display: $rootScope.languageString('dtype_hangup'),
												role: 'menuitem',
											},
											$scope.selectedsubitem
										);
									}
								} else {
									$scope.selectedsubitem = null;
									$scope.select_item(
										{
											value: 'hangup',
											display: $rootScope.languageString('dtype_hangup'),
											role: 'menuitem',
										},
										$scope.selectedsubitem
									);
								}

								//$log.debug('selected: ', $scope.selecteditem, $scope.selectedsubitem);
							});

							if (errors.length) {
								//// ????
								cache = null;
								_cache = null;
							}
						}, ApiService.defaultErrorHandler);
					};
				},

				link: {
					post: function(scope, elem, attrs, formCtrl) {
						var maxTries = 0;

						var unregister = scope.$watch('dtype', function(newValue, oldValue, scope) {
							//$log.debug('dtype $watch: ', newValue, typeof(newValue));

							if (scope.loaded || ++maxTries >= 3) {
								unregister();

								if (!scope.dtype) {
									scope.selecteditem = scope.selecteditem || '';
									scope.selectedsubitem = scope.selectedsubitem || '';
									scope.field = scope.field || 'destination';
									scope.stype = scope.stype || '';
									scope.snumber = scope.snumber || '';
									//scope.dtype = scope.dtype || '';
									scope.dnumber = scope.dnumber || '';
									scope.special = scope.special || '';

									scope.dtype = 'hangup';

									scope.loadData();
								}

								return;
							}

							scope.selecteditem = scope.selecteditem || '';
							scope.selectedsubitem = scope.selectedsubitem || '';
							scope.field = scope.field || 'destination';
							scope.stype = scope.stype || '';
							scope.snumber = scope.snumber || '';
							//scope.dtype = scope.dtype || '';
							scope.dnumber = scope.dnumber || '';
							scope.special = scope.special || '';

							if (typeof scope.loadData != 'function') {
								var u = scope.$watch('loadData', function(newValue) {
									if (typeof newValue == 'function') {
										newValue();
										u();
									}
								});
							} else {
								scope.loadData();
							}
						});

						elem.parent().addClass('form-group');
						elem.addClass('destination-select');

						var hasForm = !!formCtrl;
						var formName = hasForm ? formCtrl.$name : '';

						if (hasForm && formName && formCtrl) {
							scope.formCtrl = formCtrl;
						} else {
							scope.formCtrl = {
								$submitted: true,
							};
						}

						scope.$on('$destroy', function() {
							scope.items = null;
							scope.subitems = null;
						});

						/*
						scope.$on('$destroy', function() {
							(unregister || angular.noop)();
						});
						*/
					},
				},

				templateUrl: 'app/components/common/destinationSelect.html',
			};
		},
	])

	.directive('textDestinationSelect', [
		'CoreApiService',
		'SessionService',
		'UtilsService',
		'$rootScope',
		'$q',
		'$timeout',
		'variables',
		'$log',
		function(ApiService, SessionService, UtilsService, $rootScope, $q, $timeout, variables, $log) {
			var cache = null;

			var clearCache = function() {
				cache = null;
				return true;
			};

			$rootScope.$on('AuthSuccess', clearCache);
			$rootScope.$on('WillLogOut', clearCache);

			var isLoading = false;
			var waitForResponse;

			var lang = $rootScope.languageString;

			return {
				restrict: 'E',
				replace: true,

				require: '?^form',

				priority: 1,

				scope: {
					field: '@',
					dtype: '@',
					dnumber: '@',
					selecteditem: '=',
					selectedsubitem: '=',
				},

				controller: function($scope, $element) {
					var me = SessionService.getSession();

					if (!me) {
						return;
					} // reload on AuthSucces

					var _dests_type = function(type, label, ref, key) {
						if (typeof key == 'undefined') {
							key = '';
						}

						if (!ref || !ref.length) {
							return null;
						}

						var r = {
							role: 'menuitem',
							field: $scope.field,
							type: type,
							key: key,
						};

						if (label) {
							r.value = type;
							r.display = label;

							return r;
						}

						r.value = type;
						r.display = lang('dtype_' + type);

						return r;
					};

					var _dests_select = function(field, type, ref, key, display, url, stype, snumber, dtype, dnumber) {
						if (!ref || !ref.length) {
							return null;
						}
						display = display || 'display';

						var options = [];

						ref.forEach(function(item) {
							if (stype && stype == type && snumber == item[key]) {
								return;
							}

							options.push({
								type: type,
								value: item[key],
								display: item[display],
								role: 'menuitem',
								url: url,
								owner: item.owner,
								display_key: display,
								link: UtilsService.getLink(field + '_' + type, url, item[key]),
							});
						});

						return options;
					};

					var all_subitems = {};

					$scope.options = {};

					$scope.options.show_input = {
						email: false,
						forward: false,
					};

					$scope.inputs = {};

					var sortByKey = function(key) {
						return function(a, b) {
							return (a[key] || '').localeCompare(b[key] || '');
						};
					};

					this.add_subitem = function(item) {
						return $scope.selecteditem
							? $timeout(function() {
									var u = ($scope.selectedsubitem || {}).url || '';
									var t = $scope.selecteditem.type || '';
									var value = item[$scope.selecteditem.key] || '';
									item.link = u + value;
									var display_key = ($scope.selectedsubitem || {}).display_key || 'display';
									item.display = item[display_key];
									item.display_key = display_key;
									item.value = value;
									var subitems = all_subitems[t + '_select'];
									if (subitems) {
										subitems.push(item);
										subitems.sort(sortByKey('display'));
										clearCache();
										$scope.$broadcast('$$rebind::destination_subitems');
									}
									return item;
							  })
							: $q.resolve(item);
					};

					this.select_subitem = $scope.select_subitem = function(subitem) {
						// console.log('select_subitem: ', subitem);
						$timeout(function() {
							$scope.selectedsubitem = angular.copy(subitem);
						});

						return true;
					};

					this.getType = function() {
						return ($scope.selecteditem || { value: '' }).value || '';
					};

					this.getSelectedSubitem = function() {
						return $scope.selectedsubitem || { link: '' };
					};

					this.getLink = function() {
						return this.getSelectedSubitem().link || '';
					};

					$scope.select_item = function(item, subitem) {
						// console.log('select_item: ', item, subitem);
						if (typeof subitem == 'undefined') {
							subitem = null;
						}

						$timeout(function() {
							$scope.selecteditem = angular.copy(item);

							switch (item.value) {
								case 'email':
								case 'forward': {
									$scope.subitems = [];

									$scope.inputs[item.value] = $scope.inputs[item.value] || all_subitems[item.value] || '';
									$scope.selectedsubitem = angular.copy(subitem || $scope.inputs[item.value]);

									for (var key in $scope.options.show_input) {
										$scope.options.show_input[key] = key == item.value;
									}

									break;
								}

								default: {
									for (var key in $scope.options.show_input) {
										$scope.options.show_input[key] = false;
									}

									$scope.subitems = all_subitems[item.value + '_select'] || [];

									if ($scope.subitems && $scope.subitems.length) {
										$scope.select_subitem(subitem || $scope.subitems[0]);
									} else {
										$scope.selectedsubitem = null;
									}

									break;
								}
							}
						});
					};

					var errors = [];

					var pushError = function(e) {
						errors.push(e);
						return e || {};
					};

					var loadApiData = function(method, endpoint, params, data) {
						return ApiService.makeApiCall(method, endpoint, params, data).then(angular.identity, pushError);
					};

					$scope.loadData = function() {
						if ($scope.loaded) {
							return;
						}

						errors = [];

						if (!$scope.dtype) {
							// prevent multiple loading
							//console.log('not ready to initialize yet!');
							return;
						}

						$scope.loaded = !!$scope.dtype;

						$scope.selecteditem = $scope.dtype;
						$scope.selectedsubitem = $scope.dnumber;

						var _cache;

						(function() {
							_cache = cache; //angular.copy(cache);

							if (_cache) {
								//$log.debug('Found cached values!');
								return $timeout(function() {
									return _cache;
								});
							}

							if (isLoading) {
								//$log.debug('Waiting for response!');
								return waitForResponse;
							}

							isLoading = true;

							return (waitForResponse = $q
								.all({
									wholesale: loadApiData('POST', 'roles/access/get/', {
										role: me.effective_role || me.role,
										privilege: 'wholesale',
									}),
									mailboxes: loadApiData('POST', 'mailboxes/list/', {}),
									phones: loadApiData('POST', 'phones/list/', {
										owner: '-1',
									}),
								})
								.then(
									function(responses) {
										//$log.debug('Finished loading from api!');
										//_cache = responses;
										//cache = responses;
										isLoading = false;
										return responses;
									},
									function(error) {
										isLoading = false;
										ApiService.defaultErrorHandler(error);
										return null;
									}
								));
						})().then(function(_responses) {
							if (!_cache && !cache) {
								//$log.debug('Loaded from api!');
								setTimeout(clearCache, 60000);

								cache = _responses;
								_cache = _responses;
							} else {
								if (!_cache) {
									_cache = cache; //angular.copy(cache);
									//$log.debug('Copied cache!');
								}

								//$log.debug('Used value from cache: ', _cache);
							}

							var responses = _cache;

							for (var key in responses) {
								$scope[key] = responses[key].data;
							}

							var items = [
								{
									value: 'email',
									display: lang('dtype_email'),
									role: 'menuitem',
								},
							];

							items.push({
								value: 'forward',
								display: lang('dtype_forward'),
								role: 'menuitem',
							});

							items.push(_dests_type('mailbox', '', $scope.mailboxes, 'mailbox'));

							items.push({
								value: '',
								display: lang('dtype_none'),
								role: 'menuitem',
							});

							items.push(
								_dests_type(
									'phone',
									lang(Number($scope.wholesale) ? 'dtype_trunk' : 'dtype_phone'),
									$scope.phones,
									'name'
								)
							);

							all_subitems.mailbox_select = _dests_select(
								$scope.field,
								'mailbox',
								$scope.mailboxes,
								'mailbox',
								'display',
								'/features/mailboxes/edit/?mailbox=',
								'',
								'',
								$scope.dtype,
								$scope.dnumber
							);
							all_subitems.phone_select = _dests_select(
								$scope.field,
								'phone',
								$scope.phones,
								'name',
								'display',
								'/devices/phones/edit/?name=',
								'',
								'',
								$scope.dtype,
								$scope.dnumber
							);

							var nonNullItems = items.filter(angular.identity); // get rid of nulls

							// sort all sections alphabetically
							for (var i = 0; i < nonNullItems.length; i++) {
								while (nonNullItems[i].role === 'section') i++;
								while (
									i < nonNullItems.length &&
									(i == nonNullItems.length - 1 || nonNullItems[i + 1].role !== 'section')
								) {
									for (var j = i + 1; j < nonNullItems.length && nonNullItems[j].role !== 'section'; j++) {
										if (nonNullItems[i].display.localeCompare(nonNullItems[j].display) > 0) {
											var temp = nonNullItems[i];
											nonNullItems[i] = nonNullItems[j];
											nonNullItems[j] = temp;
										}
									}
									i++;
								}
							}

							$timeout(function() {
								// set up initial selections, allow primitives as selected item and subitem, '' is default
								$scope.items = nonNullItems;

								if ($scope.selecteditem) {
									var is_input = ['email', 'forward'].indexOf($scope.selecteditem.value || $scope.selecteditem) > -1;

									if ($scope.selectedsubitem) {
										if ($scope.selectedsubitem instanceof Object && !is_input) {
											if (!$scope.selectedsubitem.value) {
												$scope.selectedsubitem = null;
											}
										} else {
											var item =
												$scope.selecteditem instanceof Object ? $scope.selecteditem.value : $scope.selecteditem;

											$scope.selectedsubitem = $scope.selectedsubitem.value || $scope.selectedsubitem;

											if (is_input) {
												$scope.inputs[item] = $scope.selectedsubitem;
												$scope.selectedsubitem = null;
												$scope.options.show_input[item] = true;
											} else {
												var arr = all_subitems[item + '_select'];

												if (arr && arr.length) {
													$scope.selectedsubitem =
														angular.copy(
															arr.filter(function(item) {
																return item.value == $scope.selectedsubitem;
															})[0]
														) || null;
												} else {
													$scope.selectedsubitem = null;
												}
											}

											$scope.select_item(
												$scope.items.filter(function(_item) {
													return item.value == _item;
												})[0] || {
													value: 'none',
													display: lang('dtype_none'),
													role: 'menuitem',
												},
												$scope.selectedsubitem
											);
										}
									}

									if ($scope.selecteditem instanceof Object) {
										if ($scope.selecteditem.value) {
											$scope.select_item($scope.selecteditem, $scope.selectedsubitem);
										} else {
											$scope.select_item(
												{
													value: 'none',
													display: lang('dtype_none'),
													role: 'menuitem',
												},
												$scope.selectedsubitem
											);
										}
									} else {
										$scope.select_item(
											$scope.items.filter(function(item) {
												return item.value == $scope.selecteditem;
											})[0] || {
												value: 'none',
												display: lang('dtype_none'),
												role: 'menuitem',
											},
											$scope.selectedsubitem
										);
									}
								} else {
									$scope.selectedsubitem = null;
									$scope.select_item(
										{
											value: 'none',
											display: lang('dtype_none'),
											role: 'menuitem',
										},
										$scope.selectedsubitem
									);
								}

								//$log.debug('selected: ', $scope.selecteditem, $scope.selectedsubitem);
							});

							if (errors.length) {
								//// ????
								cache = null;
								_cache = null;
							}
						}, ApiService.defaultErrorHandler);
					};
				},

				link: {
					post: function(scope, elem, attrs, formCtrl) {
						var maxTries = 0;

						var unregister = scope.$watch('dtype', function(newValue, oldValue, scope) {
							//$log.debug('text dtype $watch: ', newValue, typeof(newValue));

							if (scope.loaded || ++maxTries >= 3) {
								unregister();

								if (!scope.dtype) {
									scope.selecteditem = scope.selecteditem || '';
									scope.selectedsubitem = scope.selectedsubitem || '';
									scope.field = scope.field || 'destination';
									//scope.dtype = scope.dtype || '';
									scope.dnumber = scope.dnumber || '';

									scope.dtype = '';

									scope.loadData();
								}

								return;
							}

							scope.selecteditem = scope.selecteditem || '';
							scope.selectedsubitem = scope.selectedsubitem || '';
							scope.field = scope.field || 'destination';
							//scope.dtype = scope.dtype || '';
							scope.dnumber = scope.dnumber || '';

							if (typeof scope.loadData != 'function') {
								var u = scope.$watch('loadData', function(newValue) {
									if (typeof newValue == 'function') {
										newValue();
										u();
									}
								});
							} else {
								scope.loadData();
							}
						});

						elem.parent().addClass('form-group');

						var hasForm = !!formCtrl;
						var formName = hasForm ? formCtrl.$name : '';

						if (hasForm && formName && formCtrl) {
							scope.formCtrl = formCtrl;
						} else {
							scope.formCtrl = {
								$submitted: true,
							};
						}

						scope.$on('$destroy', function() {
							scope.items = null;
							scope.subitems = null;
						});
					},
				},

				templateUrl: 'app/components/common/textDestinationSelect.html',
			};
		},
	])

	.directive('editLink', [
		'UtilsService',
		'SessionService',
		'CoreApiService',
		'$compile',
		'$timeout',
		'$rootScope',
		'$state',
		'$q',
		function(UtilsService, SessionService, CoreApiService, $compile, $timeout, $rootScope, $state, $q) {
			var cache = null;

			var clearCache = function() {
				cache = null;
			};

			$rootScope.$on('AuthSuccess', clearCache);
			$rootScope.$on('WillLogOut', clearCache);

			var allPrivileges = [
				'admin',
				'wholesale',
				'user',
				'commerce',
				'residential',
				'urls',
				'record' /*'system', 'domains', */,
			]; // plugins?

			var privilegesRequired = {
				conference: {
					create: ['user'],
					update: ['admin'],
				},
				code: {
					create: ['admin|wholesale'],
					update: ['admin|wholesale'],
				},
				customer: {
					create: ['commerce'],
					update: ['admin|commerce|wholesale'],
				},
				huntgroup: {
					create: ['admin'],
					update: ['residential|admin'],
				},
				ivr: {
					create: ['admin'],
					update: ['admin|wholesale'],
				},
				mailbox: {
					create: ['admin'],
					update: ['admin|residential'],
				},
				people: {
					create: ['admin|wholesale'],
					update: ['admin|wholesale'],
				},
				phone: {
					create: ['admin|wholesale'],
					update: ['admin|residential|wholesale'],
				},
				queue: {
					create: ['admin'],
					update: ['admin'],
				},
				pagegroup: {
					create: ['admin'],
					update: ['admin|wholesale'],
				},
				patternmenu: {
					create: ['admin'],
					update: ['admin|wholesale'],
				},
				unlimited: {
					create: ['commmerce'],
					update: ['commerce'],
				},
				url: {
					create: ['urls'],
					update: ['urls'],
				},
				timegroup: {
					create: ['admin'],
					update: ['admin'],
				},
				recordgroup: {
					create: ['admin'],
					update: ['record'],
				},
				plan: {
					create: ['commerce'],
					update: ['commerce'],
				},
				default: {
					create: ['admin|wholesale'], // only admin?
					update: ['admin|wholesale'], // only admin? plus user?
				},
			};

			var isLoading = false;
			var waitForResponse;

			return {
				restrict: 'A',
				priority: 2000,
				require: ['?^form', '?^destinationSelect', '?^textDestinationSelect'],

				scope: {
					editLinkType: '@',
					editLinkUrl: '@',
					editLinkObj: '=',
					editLinkKey: '@',
					editLinkText: '@',
					newLinkText: '@',
					editLinkHide: '@',
				},

				link: function(scope, element, attrs, ctrls) {
					var formCtrl = ctrls[0];
					var destinationSelectCtrl = ctrls[1] || ctrls[2];
					//console.log('destinationSelectCtrl: ', destinationSelectCtrl);
					//element.css('overflow', 'visible');

					var editLinkObj = element[0].getAttribute('edit-link-obj');

					scope.options = {
						editLinkHide: String(scope.editLinkHide) === 'true',
					};

					var me = SessionService.getSession();
					if (!me) return;
					var lang = $rootScope.languageString;
					scope.editString = lang('edit');
					scope.newString = lang('create_new');

					scope.havePrivileges = false;

					var privilegesReadyDeferred = $q.defer();
					var privilegesReady = privilegesReadyDeferred.promise;
					var privileges;

					var checkAnyPrivilege = function(p) {
						var _privileges = p.split('|');
						//console.log('checkAnyPrivilege: ', privileges);
						if (!_privileges || !_privileges.length) return false;
						for (var p in _privileges)
							if (_privileges.hasOwnProperty(p) && (privileges || cache || {})[_privileges[p]]) return true;
						return false;
					};

					var checkPrivilege = function(feature, action) {
						var privileges = (privilegesRequired[feature || 'default'] || privilegesRequired['default'])[action] || [
							'admin',
						];
						//console.log('checkPrivilege: ', feature, action, privileges);
						return checkAnyPrivilege(privileges[0]);
					};

					(function() {
						if (cache) {
							return $q.resolve(cache);
						} else if (isLoading) {
							return waitForResponse;
						} else {
							isLoading = true;
							return (waitForResponse = $q.all(
								allPrivileges.map(function(privilege) {
									return CoreApiService.makeApiCall('POST', 'roles/access/get/', {
										role: me.effective_role || me.role,
										privilege: privilege,
									}).then(
										function(response) {
											return {
												privilege: privilege,
												access: !!Number(response.data),
											};
										},
										function() {
											return {
												privilege: privilege,
												access: false,
											};
										}
									);
								})
							));
						}
					})().then(function(responses) {
						isLoading = false;
						if (!cache) {
							var obj = {};
							responses.forEach(function(item) {
								obj[item.privilege] = item.access;
							});
							cache = obj;
						}
						privileges = cache;
						privilegesReadyDeferred.resolve();
						setTimeout(clearCache, 60000);
						// scope.$on('$destroy', function() {
						// 	clearCacheTimeout && $timeout.cancel(clearCacheTimeout);
						// });
					});

					var checkOwner = function(owner) {
						if (!me) return false;
						return owner == me.id || owner == me.login_id || owner == me.effective_id;
					};

					var updateLinks = function(newValues, oldValues) {
						$timeout(function() {
							var obj = scope.editLinkObj || {};
							var val = obj[scope.editLinkKey || 'id'];

							scope.href = destinationSelectCtrl
								? destinationSelectCtrl.getLink()
								: UtilsService.getLink(scope.editLinkType || '', scope.editLinkUrl || '', val);
							scope.newHref = scope.href
								.replace(/^\#/, '')
								.replace(/\?.*?$/, '')
								.replace(/\/$/, '')
								.replace(/\/edit$/, '/new')
								.replace(/^\//, '');
							scope.editParams = {};
							scope.isPeer = false;

							var owner;

							if (destinationSelectCtrl) {
								if (destinationSelectCtrl.getType() == 'peer') {
									scope.href = '';
									scope.isPeer = true;
								} else if (/\?.+\=/.test(scope.href)) {
									// should always be true
									var key = /\?(.+?)\=/.exec(scope.href)[1];
									var subitem = destinationSelectCtrl.getSelectedSubitem();
									var _value = String(
										(subitem instanceof Object
											? _.startsWith(subitem.type, 'conference')
												? subitem.conferenceId
												: subitem.value
											: subitem) || ''
									);
									val = _value.replace(/timegroup_/, '');
									//console.log('key: ', key, val);
									scope.editParams[key] = val;
									owner = subitem.owner;
								}
								// console.log('href: ', scope.href);
							} else {
								scope.editParams[scope.editLinkKey || 'id'] = val;
								owner = obj.owner;
							}

							owner = owner || '';

							//if (newValues[1] && newValues[1] !== oldValues[1]) { // changed type
							privilegesReady.then(function() {
								var feature = '';
								var dtype = destinationSelectCtrl ? destinationSelectCtrl.getType() : scope.editLinkType;
								switch (dtype) {
									case 'faxbox': {
										feature = 'mailbox';
										break;
									}
									case 'npickup': {
										feature = 'phone';
										break;
									}
									case 'owner': {
										feature = 'people';
										break;
									}
									default: {
										feature = dtype.replace(/_.*$/, '');
										if (feature == 'spy') {
											feature = 'phone';
										}
										break;
										// timegroup?
									}
								}
								scope.haveCreatePrivilege = checkPrivilege(feature, 'create');
								scope.haveUpdatePrivilege = checkPrivilege(feature, 'update') || checkOwner(owner);
								scope.havePrivileges = scope.haveCreatePrivilege || scope.haveUpdatePrivilege;
								scope.options.editLinkHide = String(scope.editLinkHide) === 'true';
							});
							//}

							scope.$broadcast('$$rebind::editLink');
						});
					};

					scope.$watchGroup(['editLinkObj', 'editLinkType', 'editLinkUrl', 'editLinkKey'], updateLinks);

					var sortByDisplayOrName = function(a, b) {
						return (a.display || a.username || a.mailbox || a.code || a.number || a.name).localeCompare(
							b.display || b.username || b.mailbox || b.code || b.number || b.name
						);
					};

					var newFeatureCreated = function(type, data) {
						if (destinationSelectCtrl) {
							destinationSelectCtrl.add_subitem(data).then(function(new_item) {
								destinationSelectCtrl.select_subitem(new_item).then(function() {
									if (formCtrl) {
										formCtrl.$dirty || formCtrl.$setDirty();
										if ('uibDropdownToggle' in attrs && !element.hasClass('ng-dirty')) {
											element.addClass('ng-dirty');
										}
									}
									updateLinks();
								});
							});
							return;
						}

						var currentState = UtilsService.getCurrentState();
						var controllerAs = currentState.controllerAs;
						if (controllerAs) {
							// console.log('controllerAs: ', controllerAs);
							var _scope = scope;
							var controllerRef = _scope[controllerAs];
							while (!controllerRef && _scope && _scope !== $rootScope) {
								_scope = _scope.$parent;
								controllerRef = _scope[controllerAs];
							}
							var _obj = editLinkObj.replace(controllerAs + '.', '');
							var _arr = _obj.split('.');
							var editLinkObj1 = _arr[0];
							var editLinkObj2 = _arr[1];
							// @TODO: handle case with depth > 2

							// console.log('parent scope: ', controllerRef, scope);
							if (controllerRef) {
								$timeout(function() {
									var arrName = type;
									switch (
										type // check all features for special cases
									) {
										case 'recording/groups': {
											arrName = 'recordgroups';
											break;
										}
										case 'times/groups': {
											arrName = 'timegroups';
											break;
										}
										case 'cos':
										case 'prefix':
										case 'mailbox':
										case 'access':
										case 'address':
										case 'class': {
											arrName += 'es';
											break;
										}
										case 'people':
										case 'customers':
											break;
										default: {
											arrName += 's';
											break;
										}
									}

									controllerRef[arrName] = controllerRef[arrName] || [{}];
									controllerRef[arrName] = [controllerRef[arrName][0]].concat(
										(controllerRef[arrName].slice(1) || []).concat([data]).sort(sortByDisplayOrName)
									);
									controllerRef[editLinkObj1][editLinkObj2] = data;

									if (formCtrl) {
										formCtrl.$dirty || formCtrl.$setDirty();
										if ('uibDropdownToggle' in attrs && !element.hasClass('ng-dirty')) {
											element.addClass('ng-dirty');
										}
									}
								});
							} else {
								$state.reload();
							}
						} else {
							$state.reload();
						}
					};

					var modalCallback = function(response, originalParams) {
						if (response || originalParams) {
							//var modalInfo = response.modalInfo;
							var createdFeatureId = response && response.data ? response.data.id : originalParams[scope.editLinkKey];
							var featurePath = (scope.newHref || scope.editLinkUrl.replace(/\?.*$/, '').replace(/^\//, ''))
								.replace(/^customers\//, '')
								.replace(/^global\//, '')
								.replace(/^features\//, '')
								.replace(/^reports\//, '')
								.replace(/^devices\//, '')
								.replace(/^users\//, '')
								.replace(/\/(new|edit)\/?$/, '/get/')
								.replace(/^recordings\//, 'recording/') // special case;
								.replace('times/groups', 'timegroups')
								.replace(/^users\//, 'people/');
							var params = {};
							params[scope.editLinkKey] = createdFeatureId;
							CoreApiService.makeApiCall('POST', featurePath, createdFeatureId ? params : originalParams).then(function(
								response
							) {
								var featureType = featurePath.replace(/\/get\/$/, '');
								var createdFeature = response.data;
								newFeatureCreated(featureType, createdFeature);
							},
							angular.identity);
						}
					};

					scope.openNewModal = function() {
						var stateName = $rootScope
							.pathToState(scope.newHref || scope.editLinkUrl)
							.replace(/\.new$/, '-new')
							.replace(/-edit$/, '-new');
						var state = $state.get(stateName);
						me &&
							state &&
							UtilsService.openEditPageInModal(
								state,
								{
									customer: me.effective_customer || me.customer,
								},
								{
									updating: false,
								},
								modalCallback
							); // plugin?
					};

					scope.openEditModal = function() {
						var stateName = $rootScope.pathToState(scope.newHref).replace(/(\.|-)new$/, '-edit');
						var state;
						if (
							me &&
							stateName == 'index.customers.customers-edit' &&
							scope.editParams.id == (me.effective_customer || me.customer)
						) {
							state = $state.get('index.users.customer');
						} else {
							state = $state.get(stateName);
						}
						me &&
							state &&
							UtilsService.openEditPageInModal(
								state,
								angular.extend(
									{
										customer: me.effective_customer || me.customer,
									},
									scope.editParams
								),
								{
									updating: true,
								},
								angular.noop
							); // plugin?
					};

					// ng-href="{{:editLink:href}}"
					var linkDropdown = angular.element(
						'<div ng-hide="!havePrivileges||!(haveCreatePrivilege||(haveUpdatePrivilege&&!options.editLinkHide))||isPeer" class="link-dropdown"><button type="button" aria-haspopup="true" class="link-dropdown-trigger" ng-click="openLinkDropdown()"><i></i></button></div>'
					);
					$compile(linkDropdown)(scope);
					element.after(linkDropdown);
					element.addClass('with-actions');

					var handleClickOutside = function(e) {
						if (linkDropdown.hasClass('open')) {
							$timeout(function() {
								linkDropdown.removeClass('open');
							});
							document.removeEventListener('click', handleClickOutside);
							document.removeEventListener('touchend', handleClickOutside);
						}
					};

					scope.openLinkDropdown = function() {
						if (!linkDropdown.hasClass('open')) {
							$timeout(function() {
								linkDropdown.addClass('open');
							});
							document.addEventListener('click', handleClickOutside);
							document.addEventListener('touchend', handleClickOutside);
						}
					};

					var linkDropdownList = angular.element(
						'<ul ng-hide="!havePrivileges||!(haveCreatePrivilege||(haveUpdatePrivilege&&!options.editLinkHide))||isPeer" class="link-dropdown-menu"></ul>'
					);
					$compile(linkDropdownList)(scope);
					linkDropdown.append(linkDropdownList);

					var link = angular.element(
						'<li ng-if="haveUpdatePrivilege&&href" ng-hide="options.editLinkHide"><a class="form-addnew" ng-click="openEditModal()">{{::(editLinkText||editString)}}</a></li>'
					);
					$compile(link)(scope);
					linkDropdownList.append(link);

					var newLink = angular.element(
						'<li ng-if="haveCreatePrivilege"><a class="form-addnew" ng-click="openNewModal()">{{::(newLinkText||newString)}}</a></li>'
					);
					$compile(newLink)(scope);
					linkDropdownList.append(newLink);

					scope.$on('$destroy', function() {
						document.removeEventListener('click', handleClickOutside);
						document.removeEventListener('touchend', handleClickOutside);
						linkDropdown && linkDropdown.remove();
						link = null;
						linkDropdownList = null;
						link = null;
						newLink = null;
						destinationSelectCtrl = null;
					});
				},
			};
		},
	])

	.directive('ifShowSelectAll', [
		'$state',
		'$timeout',
		'$rootScope',
		function($state, $timeout, $rootScope) {
			return {
				restrict: 'A',
				scope: false,

				link: {
					pre: function(scope, element) {
						element.hide();
					},

					post: function(scope, element) {
						$timeout(function() {
							if ($rootScope.show_select_all) {
								element.show();
							} else {
								element.remove();
							}
						});

						/*
					var fn;

					(fn = function() {

						return ConfigsApiService.getConfig({name: 'show_select_all', default: '0'}).then(function(response) {

							if (Number(response.data.value)) {
								element.show();
							} else {
								element.remove();
							}

						}, function(error) {

							if (!navigator.onLine || typeof(error) == 'undefined') {

								var unsubscribe = scope.$on('navigator-online', function() {
									fn().then(unsubscribe, fn, unsubscribe);
								});

							} else {

								ConfigsApiService.defaultErrorHandler(error);
							}
						});

					})();
					*/
					},
				},
			};
		},
	])

	.directive('form', [
		'$rootScope',
		'$window',
		'$state',
		'UtilsService',
		'SwalService',
		'$timeout',
		'$log',
		function($rootScope, $window, $state, UtilsService, SwalService, $timeout, $log) {
			var getOffsetTop = UtilsService.getOffsetTop;

			return {
				restrict: 'E',
				replace: false,

				link: {
					post: function(scope, element, attrs) {
						var formCtrl = {};
						var formName = '';

						var authChanged = false;

						scope.$on('WillLogOut', function() {
							authChanged = true;
						});

						scope.$on('AuthSucces', function() {
							authChanged = true;
						});

						scope.$on('WillSwitchUser', function() {
							authChanged = true;
						});

						if ('name' in attrs && attrs.name) {
							formName = attrs.name;

							if (formName == '_xclick') {
								// paypal payment confirmation form!
								return;
							}

							formCtrl = scope[formName];

							var handleSubmit = function(e) {
								$timeout(function() {
									scope.$broadcast('$$rebind::' + formName);
								});
								e.preventDefault();
								return false;
							};

							element.bind('submit', handleSubmit);

							scope.$on('$destroy', function() {
								element && element.unbind('submit', handleSubmit);
							});
						}

						var submitFunction = function() {
							if (!element.find('.step-form-root').length && formCtrl.$invalid) {
								// && $('.modal.in').length == 0 // not steps, not in modal
								var minTop = 100000;

								var topEl;

								var inputs = element.find('input, textarea');

								angular.forEach(inputs, function(input) {
									var el = angular.element(input);

									var elName = el.attr('name');
									//console.log(formCtrl[elName]);

									if (elName && formCtrl[elName] && (formCtrl[elName].$invalid || el.hasClass('ng-invalid'))) {
										if (el.attr('type') == 'file') {
											input = input.parentElement.parentElement;
										}
										var offsetTop = getOffsetTop(input, $('.modal.in').last()[0]);
										if (offsetTop < minTop) {
											minTop = offsetTop;
											topEl = input;
										}
									}

									el = null;
								});

								if (minTop == 100000) {
									minTop = 0; // special case for numbers bulk change
								} else {
									minTop -= 50;
								}

								//minTop = Math.min(document.body.scrollTop, minTop);
								//console.log('test', minTop, topEl);
								($('.modal.in').length ? $('.modal.in').last() : $('html, body')).animate(
									{
										scrollTop: Math.max(minTop, 0),
									},
									{
										duration: 750 * $rootScope.animationDurationMultiplier,
										complete: function() {
											if (topEl) {
												try {
													angular.element(topEl).focus();
												} catch (e) {}
												topEl = null;
											}
										},
									}
								);
							} else if (formCtrl && !formCtrl.$invalid && formName) {
								formCtrl.$setPristine();
								element.removeClass('navigation-cancelled');
								element.find('.ng-dirty').removeClass('ng-dirty');
							}

							return true;
						};

						element.bind('submit', submitFunction);
						scope.$on('$destroy', function() {
							element && element.unbind('submit', submitFunction);
						});

						var submitButton;
						var wasHidden = false;
						if (formName && !enswitchGlobals.unitTesting) {
							// tests will sometimes throw an error when trying to use angular.getTestability
							submitButton = element.find('button[type="submit"]').first();
							if (submitButton && submitButton.length) {
								wasHidden = submitButton.is(':hidden') || submitButton.css('display') == 'none';
								wasHidden || submitButton.hide();
							}
							$timeout(function() {
								if (submitButton && submitButton.length && !wasHidden) {
									submitButton.show();
								}
								submitButton = element.find('button[type="submit"]').first();
								if (submitButton && submitButton.length) {
									var wasDisabled = submitButton.prop('disabled');
									wasDisabled || submitButton.prop('disabled', true);
									angular.getTestability(element).whenStable(function() {
										submitButton.prop('disabled', wasDisabled && submitButton.prop('disabled'));
										submitButton = null;
									});
								}
							});
						}

						var check_unsaved = !attrs['disablePrompt'] && !!Number($rootScope.web_check_unsaved);

						if (check_unsaved && formName) {
							var confirmed = false;

							scope.$on('NavigationConfirmed', function() {
								confirmed = true;
							});

							var u = scope.$on('$stateChangeStart', function(
								event,
								toState,
								toParams,
								fromState,
								fromParams,
								options
							) {
								//console.log('form $stateChangeStart', arguments);
								var defaultPrevented =
									event.defaultPrevented && (typeof event.defaultPrevented !== 'function' || event.defaultPrevented());
								if (String(toParams.modal) === '1' || String(toParams.modal) === 'true' || defaultPrevented) {
									return true;
								}

								if (!authChanged && !formCtrl.$pristine && !confirmed) {
									event.preventDefault();

									SwalService.popup({
										title: $rootScope.languageString('form_leave_prompt'),
										type: 'question',
										showCancelButton: true,
									})
										.then(
											function() {
												confirmed = true;

												u();

												/* // this is broken for some reason, use location: replace instead
									// console.log(event, options);

									if (!options.relative && !options.location && !options.reload && !options.inherit) { // check if back

										if ($rootScope.previousState) {
											$rootScope.goBack();
										} else {
											history.back();
										}

									} else {
									*/
												$state.go(toState, toParams, {
													location: 'replace',
												});
												//}
											},
											function(e) {
												// state still gets added to history!!
												element.addClass('navigation-cancelled');
											}
										)
										.done();
								} else {
									u();
								}

								return confirmed || formCtrl.$pristine || authChanged;
							});

							//var reloadConfirmed = false;

							/*
						var checkReload = function (event) {

							var returnValue = '';

							if (!formCtrl.$pristine && !reloadConfirmed) {
								//event.preventDefault();
								returnValue = 'aaa';
								event.returnValue = returnValue;
								reloadConfirmed = true;

								// doesn't work, browser automatically opens confirmation alert! (use it in production?)
								//SwalService.popup({title: 'You have unsaved changes. Are you sure you want to leave?', type: 'question', showCancelButton: true}).then(function() {
								//	reloadConfirmed = true;
								//	location.reload();
								//}).done();

								return returnValue;
							}

							//return //true;//false;//reloadConfirmed || formCtrl.$pristine;
						};
						*/

							//var windowElement = angular.element($window);
							//windowElement.on('beforeunload', checkReload);

							scope.$on('$destroy', function() {
								//windowElement.off('beforeunload', checkReload);
								(u || angular.noop)();
							});
						}
					}, // end post
				}, // end link
			}; // end return
		},
	])

	.directive('input', inputDirective)
	.directive('textarea', inputDirective)

	.directive('apiValidation', [
		'$compile',
		'CoreApiService',
		'$timeout',
		'$rootScope',
		'$q',
		function($compile, CoreApiService, $timeout, $rootScope, $q) {
			return {
				restrict: 'A',

				require: 'ngModel',

				link: {
					post: function(scope, element, attrs, ngModelCtrl) {
						if (attrs['apiValidationInitialized']) {
							return;
						}

						var el = angular.element(element);

						el.attr('api-validation-initialized', 'true');

						var inputName = el.attr('name');

						if (!inputName) {
							return;
						}

						var isDate = false;

						var input = el[0];

						ngModelCtrl.$options = {
							updateOn: 'default',
							updateOnDefault: true,
							allowInvalid: true,
							debounce: 500,
						};

						var validatedValue;
						var validate = function(modelValue, viewValue) {
							var _value = modelValue || viewValue || '';

							if (!_value || validatedValue === _value) {
								el.parent().removeClass('error-apivalidate');
								return $q.resolve(_value);
							}

							var endpoint = attrs.endpoint;

							if (!endpoint) {
								el.parent().removeClass('error-apivalidate');
								return $q.resolve(_value);
							}

							var method = attrs.method || 'POST';
							var paramName = attrs.paramName || 'name';

							//console.log(attrs.otherParams, typeof(attrs.otherParams));
							var otherParams = JSON.parse(attrs.otherParams || '{}');
							var params = otherParams;

							var values =
								String(attrs.multiple) === 'true'
									? _value
											.split(attrs.separator || ' ')
											.map(function(s) {
												return s.trim();
											})
											.filter(function(s) {
												return s;
											})
									: [_value];

							//params[paramName] = _value;

							if (
								attrs.apiValidation === 'false' ||
								attrs.apiValidation === false ||
								_value.toLowerCase() == (attrs.allowValue || '').toLowerCase()
							) {
								$timeout(function() {
									el && el.parent().removeClass('error-apivalidate');
								});

								return $q.resolve(_value);
							}

							var valid = true;

							validatedValue = _value;
							var errorMessage;

							return $q.all(
								values.map(function(value) {
									params[paramName] = value;

									return CoreApiService.makeApiCall(method, endpoint, {}, { ...params })
										.then(
											function(response) {
												var shouldFail = attrs.validIf == 'error';
												var freshValue = ngModelCtrl.$modelValue || ngModelCtrl.$viewValue || value || '';

												valid =
													valid &&
													((!shouldFail && !(attrs.validIf == 'not_found' && Number(response.data.found) === 1)) ||
														(attrs.allowValue || '').toLowerCase() == freshValue.toLowerCase() ||
														String(attrs.apiValidation) === 'false');

												if (!errorMessage) {
													if (valid) {
														errorMessage = '';
													} else {
														errorMessage = attrs.errorMessage;
													}
												}
											},
											function(error) {
												// console.log(error);
												var shouldFail = attrs.validIf == 'error' || attrs.validIf == 'not_found';

												var freshValue = ngModelCtrl.$modelValue || ngModelCtrl.$viewValue || value || '';
												valid =
													valid &&
													(shouldFail ||
														(attrs.allowValue || '').toLowerCase() == freshValue.toLowerCase() ||
														String(attrs.apiValidation) === 'false');
												if (!errorMessage) {
													if (valid) {
														errorMessage = '';
													} else {
														var str = String(attrs.useErrorMessage);
														errorMessage =
															!shouldFail && (str == 'true' || str == '1')
																? CoreApiService.getErrorMessage(error).replace(/.+?\: /, '')
																: attrs.errorMessage;
														errorMessage = errorMessage || $rootScope.languageString(error.key);
													}
												}
											}
										)
										.then(function() {
											$timeout(function() {
												el && el.parent().toggleClass('error-apivalidate', !valid);
												scope.errorMessage = errorMessage;
												scope.$broadcast('$$rebind::' + inputName);
											});

											return valid ? $q.resolve(value) : $q.reject(errorMessage);
										});
								})
							);
						};

						scope.$watch(
							function() {
								return attrs.apiValidation;
							},
							function(newValue) {
								//console.log(el[0].name, newValue);
								if (newValue !== undefined) {
									if ((newValue && newValue !== 'false') || newValue === '') {
										validate();
									} else {
										el.parent().removeClass('error-apivalidate');
									}
								}
							}
						);

						var ap = angular.element(
							'<p class="apivalidate-error-message help-block" style="min-height: 18px; height: auto; min-width:180px; width:auto; max-width: 100%;">{{errorMessage}}</p>'
						);

						$compile(ap)(scope);
						if (input.type == 'checkbox') {
							el.parent().append(ap);
						} else {
							(input.type == 'file' ? el.parent() : isDate ? el.next() : el).after(ap);
						}
						scope.$on('$destroy', function() {
							ap.remove();
							ap = null;
							el = null;
						});

						ngModelCtrl.$asyncValidators.apivalidate = validate;

						var v = scope.$watch(
							function() {
								return attrs.allowValue;
							},
							function(newValue) {
								if (newValue) {
									v();
									$timeout(function() {
										ngModelCtrl.$validate();
									});
								}
							}
						);

						ngModelCtrl.$validators.zzzzzzzzzzzz = function(modelValue, viewValue) {
							// has to run last!
							if (ngModelCtrl.$invalid) {
								validate(modelValue, viewValue);
							}
							return true;
						};
					},
				},
			};
		},
	])

	.directive('formRowLabel', [
		function() {
			return {
				restrict: 'C',
				link: function(scope, element) {
					element.parent().addClass('form-row');
				},
			};
		},
	])

	.directive('uibDatepickerPopupWrap', [
		function() {
			return {
				restrict: 'A',
				priority: 0,

				link: function(scope, element) {
					element.addClass('uib-datepicker-popup-wrap');
				},
			};
		},
	])

	.directive('uibTime', [
		function() {
			return {
				restrict: 'C',

				link: function(scope, element) {
					angular
						.element(element)
						.find('input')
						.addClass('timegroup-input');
				},
			};
		},
	])

	// use date-picker-min instead of ng-min on the input[type=date]
	.directive('ngMin', function() {
		return {
			restrict: 'A',
			require: 'ngModel',

			link: function(scope, elem, attr, ctrl) {
				scope.$watch(attr.ngMin, function() {
					if (ctrl.$isDirty) ctrl.$setViewValue(ctrl.$viewValue);
				});

				var isEmpty = function(value) {
					return angular.isUndefined(value) || !value;
				};

				var isInvalid = function(value) {
					var n = Number(value);
					return isNaN(n) || !isFinite(n);
				};

				var minValidator = function(value) {
					var isDate = value instanceof Date;

					var min = Number(scope.$eval(attr.ngMin)) || Number(attr.ngMin) || 0;

					if (isDate && !(min instanceof Date)) {
						min = new Date(min);
					}

					if (!isEmpty(value) && !isInvalid(value) && Number(value) < Number(min)) {
						ctrl.$setValidity('ngMin', false);
						var decimalPlaces = 0;
						if (/\.\d+$/.test(String(value))) {
							decimalPlaces = /\.(\d+)$/.exec(String(value))[1].length;
						}
						var res = Number(min);
						return isDate ? new Date(res) : res.toFixed(decimalPlaces);
					} else {
						ctrl.$setValidity('ngMin', true);
						return value;
					}
				};

				ctrl.$parsers.push(minValidator);
				ctrl.$formatters.push(minValidator);
			},
		};
	})

	// use date-picker-max instead of ng-max on the input[type=date]
	.directive('ngMax', function() {
		return {
			restrict: 'A',
			require: 'ngModel',

			link: function(scope, elem, attr, ctrl) {
				scope.$watch(attr.ngMax, function() {
					if (ctrl.$isDirty) ctrl.$setViewValue(ctrl.$viewValue);
				});

				var isEmpty = function(value) {
					return angular.isUndefined(value) || !value;
				};

				var isInvalid = function(value) {
					var n = Number(value);
					return isNaN(n) || !isFinite(n);
				};

				var maxValidator = function(value) {
					var isDate = value instanceof Date;

					var max = Number(scope.$eval(attr.ngMax)) || Number(attr.ngMax) || Infinity;

					if (isDate && !(max instanceof Date)) {
						max = new Date(max);
					}

					if (!isEmpty(value) && !isInvalid(value) && Number(value) > Number(max)) {
						ctrl.$setValidity('ngMax', false);
						var decimalPlaces = 0;
						if (/\.\d+$/.test(String(value))) {
							decimalPlaces = /\.(\d+)$/.exec(String(value))[1].length;
						}
						var res = Number(max);
						return isDate ? new Date(res) : res.toFixed(decimalPlaces);
					} else {
						ctrl.$setValidity('ngMax', true);
						return value;
					}
				};

				ctrl.$parsers.push(maxValidator);
				ctrl.$formatters.push(maxValidator);
			},
		};
	})

	.directive('reloadFunction', [
		'$interval',
		'$parse',
		'$timeout',
		'$compile',
		'$rootScope',
		function($interval, $parse, $timeout, $compile, $rootScope) {
			return {
				restrict: 'A',

				scope: {
					fn: '&reloadFunction',
					period: '@',
					showRefreshButton: '@',
					refreshButtonStyle: '=',
				},

				link: {
					post: function(scope, element, attrs) {
						var cancelledTime;

						var applyFilterTimeout;

						var p = scope.period ? Number(scope.period) : 0;

						if (isNaN(p) || !isFinite(p)) {
							p = 0;
						}

						var interval = (p || 60) * 1000;

						var cancelInterval = function(e) {
							if (e) {
								cancelledTime = new Date();
							} else {
								cancelledTime = 0;
							}

							if (applyFilterTimeout) {
								$interval.cancel(applyFilterTimeout);
							}
						};

						var setInterval = function() {
							var _cancelledTime = angular.copy(cancelledTime); //(cancelledTime || 0) + 0;

							cancelInterval();

							if (!$rootScope.offline && interval > 0 && !(document.hidden || document.visibilityState == 'hidden')) {
								var now = new Date();

								if (_cancelledTime && now - _cancelledTime > interval) {
									$timeout(function() {
										scope.fn();
									});
								}

								applyFilterTimeout = $interval(function() {
									$timeout(function() {
										scope.fn();
									});
								}, interval);
							}
						};

						var c2 = scope.$on('navigator-offline', cancelInterval);
						var c3 = scope.$on('navigator-online', setInterval);

						var documentVisibilityChanged = function(event) {
							if (document.hidden || document.visibilityState == 'hidden') {
								cancelInterval(true);
							} else {
								//$timeout(function() { scope.fn(); }); //??
								setInterval();
							}
						};

						var properties = {
							hidden: 'visibilitychange',
							mozHidden: 'mozvisibilitychange',
							webkitHidden: 'webkitvisibilitychange',
							msHidden: 'msvisibilitychange',
							oHidden: 'ovisibilitychange',
						};

						var start = function() {
							var value = null;

							for (var prop in properties) {
								if (properties.hasOwnProperty(prop) && prop in document) {
									value = properties[prop];
									break;
								}
							}

							if (value) {
								document.addEventListener(value, documentVisibilityChanged);
							} else if (/*@cc_on!@*/ false) {
								// IE 9 and earlier
								document.onfocusin = document.onfocusout = documentVisibilityChanged;
							} else {
								window.onfocus = window.onblur = documentVisibilityChanged;
							}

							setInterval();
						};

						var removeListeners = function() {
							var value = null;

							for (var prop in properties) {
								if (properties.hasOwnProperty(prop) && prop in document) {
									value = properties[prop];
									break;
								}
							}

							if (value) {
								document.removeEventListener(value, documentVisibilityChanged);
							} else if (/*@cc_on!@*/ false) {
								document.removeEventListener('focusin', documentVisibilityChanged);
								document.removeEventListener('focusout', documentVisibilityChanged);
							} else {
								document.removeEventListener('focus', documentVisibilityChanged);
								document.removeEventListener('blur', documentVisibilityChanged);
							}
						};

						var c1 = scope.$on('$stateChangeStart', function(event, toState, toParams) {
							var isModal = toParams.modal && toParams.modal !== '0' && toParams.modal !== 'false';
							var defaultPrevented =
								event.defaultPrevented && (typeof event.defaultPrevented !== 'function' || event.defaultPrevented());

							if (isModal || defaultPrevented) {
								return !defaultPrevented;
							}

							removeListeners();

							cancelInterval();

							c3();
							c2();
							c1();
						});

						scope.$on('$destroy', function() {
							//(watch || angular.noop)();

							removeListeners();

							c1();
							c2();
							c3();

							cancelInterval();
						});

						start();

						scope.$watch(
							function() {
								return scope.period;
							},
							function(newValue, oldValue, scope) {
								if (oldValue && newValue && Number(oldValue) == Number(newValue)) {
									return;
								}

								cancelInterval();

								$timeout(function() {
									var p = newValue ? Number(newValue) : 0;

									if (isNaN(p) || !isFinite(p)) {
										p = 0;
									}

									interval = (p || 60) * 1000;

									setInterval();
								});
							}
						);

						scope.refresh = function() {
							cancelInterval();
							$timeout(function() {
								scope.fn();
							});
							setInterval();
						};

						// @TODO: make compatible with table filters (position)
						var refreshBtn = angular.element(
							'<button ng-show="showRefreshButton" style="background-image: url(assets/images/common/refresh.svg); background-size: cover; background-color: transparent; border: 0px; height: 24px; width: 24px; opacity: 0.6; float: left; margin-top: 10px;" ng-style="refreshButtonStyle" ng-click="refresh()"></button>'
						);

						$compile(refreshBtn)(scope);

						element.before(refreshBtn);

						scope.$on('$destroy', function() {
							refreshBtn.remove();
							refreshBtn = null;
						});
					},
				},
			};
		},
	])

	.directive('autoFill', [
		'$log',
		'$window',
		'$timeout',
		function($log, $window, $timeout) {
			return {
				restrict: 'A',
				require: 'ngModel',

				link: function(scope, element, attrs, ctrl) {
					var el = element;

					if (el.is('input') && el.attr('name')) {
						var form = el;
						var obj;
						//var createDate = function(s) { return new Date(s); };
						//var parseValue = element.type == 'date' ? createDate : (element.type == 'number' ? Number : angular.identity);

						var iterations = 0;
						while ((form = form.parent()).length && !form.is('form') && ++iterations < 7);
						//element.form?

						var hasForm;
						var formName;

						if ((hasForm = form && form.length && form.attr('name'))) {
							formName = form.attr('name');
							obj = JSON.parse($window.localStorage[formName] || '{}');
						} else {
							obj = $window.localStorage;
						}

						var fieldName = el.attr('name');

						if (obj[fieldName] && String(obj[fieldName]) != ctrl.$viewValue) {
							$timeout(function() {
								ctrl.$setViewValue(String(obj[fieldName]));
								ctrl.$commitViewValue();
								ctrl.$render();
							});
						}

						var saveValue = function() {
							if (String(ctrl.$viewValue) != String(ctrl.$modelValue)) {
								// test this
								ctrl.$commitViewValue(); // $render()?
							}

							var _obj;

							if (hasForm) {
								_obj = JSON.parse($window.localStorage[formName] || '{}');
							}

							if (ctrl.$viewValue === undefined) {
								delete _obj[fieldName];
							} else {
								_obj[fieldName] = String(ctrl.$viewValue);
							}

							if (hasForm && (scope[formName] || scope.$parent[formName]).$valid) {
								$window.localStorage[formName] = JSON.stringify(_obj);
							}
						};

						if (hasForm) {
							form.bind('submit', saveValue);

							scope.$on('$destroy', function() {
								form && form.unbind('submit', saveValue);
							});
						} else {
							el.bind('blur', saveValue);

							scope.$on('$destroy', function() {
								el && el.unbind('blur', saveValue);
							});
						}
					}
				},
			};
		},
	])

	.directive('footable', [
		'$parse',
		'UtilsService',
		'$timeout',
		'$compile',
		'$location',
		'$rootScope',
		'$window',
		function($parse, UtilsService, $timeout, $compile, $location, $rootScope, $window) {
			var events = {
				beforeFiltering: 'footable_filtering',
			};
			var extractSpecOpts = function(opts, scope, attrs) {
				var extracted = {},
					k;
				for (k in opts) {
					if (k !== 'filter' && !angular.isUndefined(events[k])) {
						if (!angular.isFunction(scope.$eval(attrs[k]))) {
							extracted[k] = attrs[k];
						}
					}
				}
				return extracted;
			};

			var bindEventHandler = function(tableObj, scope, attrs) {
				var k;
				for (k in attrs) {
					if (k !== 'filter' && !angular.isUndefined(events[k])) {
						var targetEventName = events[k];
						if (angular.isFunction(scope.$eval(attrs[k]))) {
							// console.log('binding: ', targetEventName);
							tableObj.bind(targetEventName, scope.$eval(attrs[k]));
						}
					}
				}
			};

			var unbindEventHandler = function(tableObj, scope, attrs) {
				var k;
				for (k in attrs) {
					if (k !== 'filter' && !angular.isUndefined(events[k])) {
						var targetEventName = events[k];
						// console.log('unbinding: ', targetEventName);
						tableObj.unbind(targetEventName);
					}
				}
			};

			return {
				restrict: 'C',

				link: function(scope, element, attrs) {
					var $table = $(element[0]);

					element.wrap('<div class="table-wrapper"></div>');

					scope.options = {};

					$table.data('page-size', 1000000); // initial, later set to results_per_page config for paginated tables

					$table.data('filter-minimum', 1);

					$table.data('limit-navigation', $rootScope.pagination_max_pages);

					if (attrs['sorting'] === undefined) {
						$table.data('sort', true);
					} else {
						$table.data('sort', attrs['sort'] && attrs['sort'] !== 'false');
					}

					var handlePaging = function(event) {
						if (isNaN(event.page) || !isFinite(event.page)) {
							return;
						}

						$timeout(function() {
							if ($rootScope.previousState && $location.hash() != 'page_' + String(event.page + 1)) {
								$location.hash('page_' + String(event.page + 1)).replace();
								//console.log('replace1');
							} else {
								$location.hash('page_' + String(event.page + 1));
							}

							if (!attrs['preventScrollTop']) {
								var offsetTop = Math.max(UtilsService.getOffsetTop(element[0]) - 40, 0);
								if (Math.max(document.documentElement.scrollTop, document.body.scrollTop) > offsetTop) {
									//document.documentElement.scrollTop = document.body.scrollTop = offsetTop;

									$('html, body').animate(
										{
											scrollTop: offsetTop,
										},
										{
											duration: 350 * $rootScope.animationDurationMultiplier,
										}
									);
								}
							}
						});
					};

					$table.bind('footable_paging', handlePaging);

					var unbinded = false;

					if (attrs['customSortFunction']) {
						unbinded = true;
						$table.unbind('footable_initialized.sorting');
						$table.unbind('footable_redrawn.sorting');
						$table.unbind('footable_column_data.sorting');
					}

					var handleSorting = function(event) {
						if (!attrs['customSortFunction']) {
							return true;
						}

						if (!unbinded) {
							unbinded = true;
							$table.unbind('footable_initialized.sorting');
							$table.unbind('footable_redrawn.sorting');
							$table.unbind('footable_column_data.sorting');
						}

						var fn = $parse(attrs['customSortFunction']);

						$timeout(function() {
							fn(scope, {
								$event: event,
							});
							// event: {column, direction, ft, delegateTarget($table), target($table), result, type(footable_sorting), ...}
							// redraw?

							if (attrs.apiSorting) {
								return;
							}

							var ft = event.ft,
								direction = event.direction,
								column = event.column;

							var columnIndex = column.index;

							var //$tbody = $table.find('> tbody'),
								$th = $table.find('> thead > tr:last-child > th:eq(' + columnIndex + ')'),
								cls = ft.options.classes.sort,
								evt = ft.options.events.sort;

							var ascending = direction !== 'DESC';

							$table.data('sorted', column.index);

							$table
								.find('> thead > tr:last-child > th, > thead > tr:last-child > td')
								.not($th)
								.removeClass(cls.sorted + ' ' + cls.descending);

							if (ascending === undefined) {
								ascending = $th.hasClass(cls.sorted);
							}

							if (ascending) {
								$th.removeClass(cls.descending).addClass(cls.sorted);
							} else {
								$th.removeClass(cls.sorted).addClass(cls.descending);
							}

							ft.bindToggleSelectors();
							//ft.raise(evt.sorted, { column: column, direction: direction }); // ??

							$th = null;
						});

						event.result = false;
						return false;
					};

					$table.bind('footable_sorting', handleSorting);

					//var iterations = 0;
					var goToPage = function(page) {
						//if (++iterations > 50) {
						//	return;
						//}

						var pageLink = $table.find('.footable-page a').filter('[data-page="' + String(page - 1) + '"]');

						if (pageLink.length) {
							//pageLink.show(0, function() {
							pageLink.click();
							//});
						} else {
							var moreLink = $table
								.find('.footable-page-arrow a')
								.filter('[data-page="limit-next"]')
								.first();

							if (moreLink.length && moreLink.parent().css('display') != 'none') {
								moreLink.click();
								$timeout(function() {
									goToPage(page);
								});
							} else {
								var lastLink = $table.find('.footable-page-arrow a').filter('[data-page="last"]');
								lastLink.click();
								lastLink = null;
							}
							moreLink = null;
						}

						pageLink = null;
						//$table.trigger('footable_paging', { page: page - 1, size: $table.data('page-size') });
					};

					var checkPage = function() {
						var hash = $location.hash();
						if (hash && /^page_\d+$/.test(hash)) {
							var found = hash.match(/^page_(\d+)$/);
							var page = Number(found[1] || 1);

							if (page > 1) {
								$timeout(function() {
									goToPage(page);
								}, 50);
							}
						}
					};

					$table.bind('footable_initialized', checkPage);

					var loader = angular.element(
						'<div class="col-xs-12" style="margin-bottom: 8px;" ng-if="options.showProgress"><div class="sk-spinner sk-spinner-wave" ng-if="options.showProgress" style="display: block;"><div class="sk-rect1"></div><div class="sk-rect2"></div><div class="sk-rect3"></div><div class="sk-rect4"></div><div class="sk-rect5"></div></div></div>'
					);

					$timeout(function() {
						scope.options.showProgress = String(attrs.hideLoader) !== 'true';
					});

					var firstLoad = true;

					var hideLoader = function() {
						if (firstLoad) {
							firstLoad = false;
							return;
						}

						$timeout(function() {
							//console.log('hiding loader...');
							scope.options.showProgress = false;
							element.addClass('initialized');
						});
					};

					$table.bind('footable_initialized', hideLoader);

					$compile(loader)(scope);

					$table.before(loader);

					var stopWatch = scope.$watch(
						function() {
							return attrs.hideLoader;
						},
						function(newValue) {
							$timeout(function() {
								scope.options.showProgress = !(String(newValue) === 'true' || element.hasClass('initialized'));
							});
						}
					);

					$table.bind('footable_initialized', stopWatch);

					////
					var tableOpts = {
						'event-filtering': null,
					};
					var _attrs = angular.copy(attrs);
					angular.extend(tableOpts, footable.options);
					angular.extend(tableOpts, extractSpecOpts(tableOpts, scope, _attrs));

					$table.footable(tableOpts);

					bindEventHandler($table, scope, _attrs);
					////

					// move table control buttons from footer to header
					var $newHeaderRow = angular.element('<tr></tr>');
					$timeout(function() {
						if (!$newHeaderRow) return; // scope has been destroyed
						var $firstFooterRow = $table
							.find('tfoot')
							.first()
							.find('tr')
							.first();
						var $firstFooterRowCols = $firstFooterRow.children('td');
						var controlsLeft = 0;
						var controlsMoved = 0;
						angular.forEach($firstFooterRowCols, function(col) {
							var $col = angular.element(col);
							var $th = angular.element('<th></th>');
							$.each($col.prop('attributes'), function() {
								$th.attr(this.name, this.value);
							});
							$compile($th)(scope);
							var $colChildren = $col.children();
							$colChildren = $colChildren.not('.pagination');
							$colChildren = $colChildren.not('custom-pagination');
							$colChildren = $colChildren.not('custom-pagination2');
							$colChildren.remove().prependTo($th);
							$compile($colChildren)(scope);
							$th.prependTo($newHeaderRow);
							controlsMoved += $th.children().length;
							controlsLeft += $col.children().length;
							$colChildren = null;
							$th = null;
							$col = null;
						});
						if (controlsMoved) {
							$newHeaderRow.prependTo($table.find('thead').first());
							if (!controlsLeft) $firstFooterRow.remove();
							$newHeaderRow = null;
						}
						$firstFooterRow = null;
						$firstFooterRowCols = null;
					});

					scope.$on('$destroy', function() {
						$newHeaderRow && $newHeaderRow.remove();
						$newHeaderRow = null;
						//console.log('clearing table...');
						unbindEventHandler($table, scope, _attrs);
						_attrs = null;
						hideLoader();
						$table.unbind('footable_sorting', handleSorting);
						$table.unbind('footable_initialized', hideLoader);
						$table.unbind('footable_initialized', checkPage);
						$table.unbind('footable_initialized', stopWatch);
						$table.unbind('footable_paging', handlePaging);
						$table.unbind('footable_paging');
						$table.unbind('resize');
						[
							'footable_initialize',
							'footable_resize',
							'footable_redraw',
							'footable_toggle_row',
							'footable_expand_first_row',
							'footable_expand_all',
							'footable_collapse_all',
							'footable_already_initialized',
							'footable_initializing',
							'footable_initialized',
							'footable_resizing',
							'footable_resized',
							'footable_redrawn',
							'footable_breakpoint',
							'footable_column_data',
							'footable_row_detail_updating',
							'footable_row_detail_updated',
							'footable_row_collapsed',
							'footable_row_expanded',
							'footable_row_removed',
							'footable_reset',
							'footable_sorting',
						].forEach(function(evtName) {
							$table.unbind(evtName);
						});
						angular.element($window).unbind('resize.footable');
						$table.off();
						$table.remove();
						$table = null;
						loader.remove();
						loader = null;
					});
				},
			};
		},
	])

	.directive('uibDropdownToggle', [
		'$rootScope',
		'$timeout',
		'$document',
		'$parse',
		'uibDropdownService',
		'UtilsService',
		'$log',
		function($rootScope, $timeout, $document, $parse, uibDropdownService, UtilsService, $log) {
			return {
				restrict: 'A',

				require: ['?^uibDropdown', '?^form'],
				priority: 2001,

				link: {
					pre: function(scope, element) {
						if (element.parents('.modal').length) {
							element.parent().attr('dropdown-append-to-body', 'false');
						}
					},

					post: function(scope, element, attrs, ctrls) {
						var dropdownCtrl = ctrls[0],
							formCtrl = ctrls[1];

						var ul;
						var selected = null;
						var inModal = element.parents('.modal').length;

						//var check_unsaved = !!Number($rootScope.web_check_unsaved);

						//var form = check_unsaved ? angular.element(el) : {parent: function() { return[]; }, is: function() { return false; }, attr: angular.identity};

						var hasForm = !!formCtrl;
						var formName = hasForm ? formCtrl.$name : '';

						element.parent().is('.btn-group') && element.parent().addClass('form-row-input');
						!element.parent().is('.btn-group') &&
							element
								.parent()
								.parent()
								.is('.btn-group') &&
							element
								.parent()
								.parent()
								.addClass('form-row-input');

						var itemClicked = function(e) {
							// old value, new value?
							// ngChange?
							if (!formCtrl) {
								return true;
							}

							if (formCtrl.$pristine) {
								formCtrl.$setDirty();
							}

							if (!element.hasClass('ng-dirty')) {
								element.addClass('ng-dirty');
							}

							return true;
						};

						var setupFormEvents = function() {
							if (!formCtrl) {
								return true;
							}

							if (hasForm && formName && formCtrl) {
								ul &&
									angular.forEach(ul.find('li[role!="section"]:not(.disabled)'), function(li, i) {
										var item = angular
											.element(li)
											.find('a')
											.first();

										item.off('click', itemClicked);
										item.on('click', itemClicked);

										item.on('$destroy', function() {
											item.off('click', itemClicked);
											item = null;
										});
									});
							}

							return true;
						};

						var unsetFormEvents = function() {
							// not needed?
							if (!formCtrl) {
								return true;
							}

							if (ul && hasForm && formName && formCtrl) {
								angular.forEach(ul.find('li[role!="section"]:not(.disabled)'), function(li, i) {
									angular
										.element(li)
										.find('a')
										.first()
										.off('click', itemClicked);
								});
							}

							return true;
						};

						var refreshSelection = function(newValue) {
							'noSelection' in attrs ||
								$timeout(function() {
									if (selected) {
										selected.removeClass('active');
										selected = null;
									}

									var done = false;

									ul &&
										angular.forEach(ul.find('li[role!="section"]'), function(li, i) {
											if (!done) {
												if ((angular.element(li).text() || '').trim() == (newValue || '').trim()) {
													selected = angular.element(li);
													dropdownCtrl.selectedOption = i;
													done = true;
												}
											}
										});

									if (selected) {
										selected.addClass('active');
									}
								});

							return true;
						};

						var mainWatch, focusElementByIndex;

						var v = scope.$watch('attrs.id', function(newValue, oldValue, scope) {
							// not needed any more?
							if (attrs.id && !('noSelection' in attrs)) {
								if (inModal) {
									// change id, handle that lower in getPreselectOptions...
								}
								v();

								if (attrs.id == 'domain-dropdown-toggle') {
									// domain dropdown fix (temp)
									var dm = document.getElementById('domain-dropdown');
									ul = angular.element(dm);

									dropdownCtrl.dropdownMenu = angular.element(dm);
									//dropdownCtrl.init();

									var displayed = false;

									var clickHandler = function(e) {
										// off?
										//console.log(e);
										ul.css('width', element.css('width'));
										ul.css('display', (displayed = !displayed) ? 'block' : 'none');
									};

									element.on('click', clickHandler);
									element.on('$destroy', function() {
										element.off('click', clickHandler);
									});
								} else {
									ul = angular.element(dropdownCtrl.dropdownMenu);
									if (String(attrs.id).indexOf('-toggle') > -1) {
										ul.attr('id', attrs.id.replace('-toggle', ''));
									}
								}

								//ul.attr('keyboard-nav', 'true');

								refreshSelection(element.text());

								setupFormEvents();

								$timeout(function() {
									scope.$watch(
										function() {
											return ul[0] && ul[0].children ? ul[0].children.length : 0;
										},
										function(newValue, oldValue, scope) {
											if (newValue) {
												//console.log('ul.children.length: ' + String(newValue));

												ul = angular.element(dropdownCtrl.dropdownMenu);

												if (!ul.attr('id') && String(attrs.id).indexOf('-toggle') > -1) {
													ul.attr('id', attrs.id.replace('-toggle', ''));
												}

												$timeout(function() {
													setupFormEvents();

													refreshSelection(element.text());

													mainWatch =
														mainWatch ||
														scope.$watch(
															function() {
																return element.text();
															},
															function(newValue) {
																element.attr('title', newValue);

																ul = angular.element(dropdownCtrl.dropdownMenu);

																refreshSelection(newValue);
															}
														);

													UtilsService.getPreselectOptions().some(function(item) {
														if (item.name + '-dropdown-toggle' == attrs.id) {
															// @TODO: handle destination select in destination-select directive
															var index = 0;
															var done = false;
															angular.forEach(ul.find('li[role!="section"]:not(.disabled)'), function(li, i) {
																if (!done) {
																	var text = (angular.element(li).text() || '').trim().toLowerCase();

																	if (text == item.value.toLowerCase()) {
																		index = i;
																		done = true;
																	}
																}
															});
															focusElementByIndex(index);
															if (formCtrl) {
																formCtrl.$setDirty();
																element.addClass('ng-dirty');
															}
															return true;
														}
														return false;
													});
												});
											}
										}
									);
								});
							}
						});

						// fix scoll position for initial selection

						var checkOffset = function() {
							ul &&
								('noSelection' in attrs ||
									$timeout(function() {
										var el = ul ? ul[0] : null;

										if (!el || !selected) {
											return;
										}

										if (
											el.scrollTop + el.offsetHeight < selected[0].offsetTop ||
											el.scrollTop > selected[0].offsetTop
										) {
											var top = Math.max(
												Math.min(
													el.scrollHeight - el.offsetHeight,
													selected[0].offsetTop - (el.offsetHeight - selected[0].offsetHeight) / 2
												),
												0
											);
											$(el).scrollTop(top);
										}
									}));
						};

						var v3 = scope.$watch(
							function() {
								return selected;
							},
							function(newValue, oldValue, scope) {
								if (newValue) {
									v3();
								} else {
									return;
								}

								if (ul && dropdownCtrl.isOpen) {
									checkOffset();
								} else {
									var v = scope.$watch(dropdownCtrl.isOpen, function(isOpen) {
										if (isOpen) {
											ul && v();
											checkOffset();
										}
									});
								}
							}
						);

						scope.$on('$destroy', unsetFormEvents);

						// handle typing

						var currentText = '';

						focusElementByIndex = function(index) {
							var elems = ul ? ul.find('li[role!="section"]:not(.disabled)') : [];

							if (index >= elems.length) {
								return;
							}

							dropdownCtrl.selectedOption = index;
							//elems[dropdownCtrl.selectedOption].focus();

							var newText = angular.element(elems[dropdownCtrl.selectedOption]).text();
							refreshSelection(newText);
							//element.text(newText);

							// fire ng-click event (to update model in controller)
							var link = angular.element(
								angular.element(angular.element(elems[dropdownCtrl.selectedOption]).find('a'))[0]
							);
							if (link) {
								var clickFn = $parse(link.attr('ng-click'));

								if (clickFn) {
									if (link.parent().attr('ng-repeat')) {
										var li = link.parent()[0];
										//console.log(li);
										clickFn(typeof li.scope == 'function' ? li.scope() : scope);
									} else {
										clickFn(scope);
									}
								}
							}

							link = null;

							if (formCtrl) {
								if (formCtrl.$pristine) {
									formCtrl.$setDirty();
								}
								if (!element.hasClass('ng-dirty')) {
									element.addClass('ng-dirty');
								}
							}

							$timeout(function() {
								checkOffset();
							});
						};

						var findMatching = function() {
							if (!ul || !currentText) {
								focusElementByIndex(0);
							} else {
								var index = 0;

								var done = false;

								angular.forEach(ul.find('li[role!="section"]:not(.disabled)'), function(li, i) {
									if (!done) {
										var text = (angular.element(li).text() || '').trim().toLowerCase();

										if (text.indexOf(currentText) == 0) {
											index = i;
											done = true;
										}
									}
								});

								focusElementByIndex(index);
							}
						};

						var deleteChar = function() {
							if (currentText) {
								currentText = currentText.substring(0, currentText.length - 1);
								findMatching();
							}
						};

						var clearText = function() {
							currentText = '';
						};

						var clearTimeout;

						var cancelClear = function() {
							if (clearTimeout) {
								$timeout.cancel(clearTimeout);
							}
						};

						var postponeClear = function() {
							cancelClear();
							clearTimeout = $timeout(clearText, 2000);
						};

						var handleKey = function(event) {
							//$log.debug(event);
							postponeClear();

							// if delete
							var key = event.keyCode || event.charCode;
							if (key == 8) {
								deleteChar();
								return false;
							}

							if ([38, 40].indexOf(event.which) !== -1) {
								var elems = ul ? ul.find('li[role!="section"]:not(.disabled)') : [];

								if (!elems.length) {
									return false;
								}

								event.preventDefault();
								clearText();
								postponeClear();

								dropdownCtrl.selectedOption += event.which == 40 ? 1 : -1;

								if (dropdownCtrl.selectedOption >= elems.length) {
									dropdownCtrl.selectedOption = 0;
								} else if (dropdownCtrl.selectedOption < 0) {
									dropdownCtrl.selectedOption = elems.length - 1;
								}

								focusElementByIndex(dropdownCtrl.selectedOption);

								return false;
							}

							if (event.key && event.key.length == 1 && /[A-Za-z0-9 _]/.test(event.key)) {
								currentText += event.key.toLowerCase();
								findMatching();
							}

							return true;
						};

						'noSelection' in attrs ||
							'hasFilter' in attrs ||
							scope.$watch(dropdownCtrl.isOpen, function(isOpen) {
								if (isOpen) {
									/* not working
							$timeout(function() {
								ul && ul.css({'width': String(element.innerWidth()) + 'px'});
							});
							*/
									// @TODO: only if in modal!
									/*ul && ul.css({
								'z-index': '5000',
							});*/
									$document.on('keydown', handleKey);
								} else {
									cancelClear();
									$document.off('keydown', handleKey);
									clearText();
								}
							});

						/*
					var controlClick = function(e) { // Destination select fix (click being triggered twice)
						var defaultPrevented = e.isDefaultPrevented();
						if (defaultPrevented) {
							e.stopPropagation();
							e.preventDefault();
							dropdownCtrl.toggle();
						}
						return !defaultPrevented;
					};
					*/
						//element.bind('click', controlClick);

						scope.$on('$destroy', function() {
							cancelClear();
							$document.off('keydown', handleKey);
							clearText();
							//element && element.unbind('click', controlClick);
							selected = null;
							ul = null;
						});
					}, // post
				}, // link
			};
		},
	])

	.directive('li', [
		'$timeout',
		function($timeout) {
			// https://stackoverflow.com/questions/29509496/is-there-a-way-to-get-a-scope-of-a-dom-element-when-debug-info-is-disabled
			return {
				restrict: 'E',

				require: '?^^uibDropdown',

				priority: -2,

				link: {
					post: function(scope, element, attrs, dropdownCtrl) {
						//$timeout(function() {

						//console.log(dropdownCtrl);

						//if (dropdownCtrl) { // null for some reason

						element[0].scope = function() {
							return scope;
						};
						//}
						//});
					},
				},
			};
		},
	])

	.directive('autoFocus', [
		function() {
			return {
				restrict: 'AC',

				link: {
					post: function(scope, element) {
						try {
							element.focus();
						} catch (e) {}
					},
				},
			};
		},
	])

	.directive('customPagination', [
		'$rootScope',
		'$state',
		'$stateParams',
		'$timeout',
		'$log',
		'UtilsService',
		function($rootScope, $state, $stateParams, $timeout, $log, UtilsService) {
			return {
				restrict: 'E',

				scope: {
					totalItems: '@',
					firstText: '@',
					prevText: '@',
					nextText: '@',
					lastText: '@',
					useInput: '=',
					limitNavigation: '@',
					pageDescriptions: '=',
					itemsPerPage: '@',
					onPagesChange: '&',
				},

				controller: function($scope) {
					$scope.options = {};

					$scope.firstText = $scope.firstText || '«';
					$scope.prevText = $scope.prevText || '‹';
					$scope.nextText = $scope.nextText || '›';
					$scope.lastText = $scope.lastText || '»';
					$scope.onPagesChange = $scope.onPagesChange || angular.identity;

					$scope.pageSize = $scope.itemsPerPage ? Number($scope.itemsPerPage) : $rootScope.results_per_page || 100;

					$scope.limitNavigation = Number($scope.limitNavigation || $rootScope.pagination_max_pages);

					var currentState = UtilsService.getCurrentState();
					var stateParams = UtilsService.getCurrentStateParams();

					var getPages = function(start, end) {
						var max = $scope.limitNavigation;
						var total = end - start + 1;
						if (total > max) {
							start = Math.max($scope.currentPage - 3, 0);
							end = Math.min(start + max - 1, $scope.maxPages - 1);
							if (end - start < max - 1) {
								start -= max - 1 - end + start;
							}
						}

						return UtilsService.numArray(start, end);
					};

					$scope.goToPage = function(page) {
						page = Number(page);

						// $log.debug(page);

						if (isNaN(page) || !isFinite(page)) {
							return;
						}

						if (page < 1 || page > $scope.maxPages || page == $scope.currentPage) {
							return;
						}

						var params = angular.copy(stateParams);
						params.offset = (page - 1) * $scope.pageSize;
						params.offset = params.offset || '';
						// $log.debug(params);

						$timeout(function() {
							$state.go(currentState.name, params, {
								location: 'replace',
								notify: true,
								inherit: false,
							});
						});
					};

					$scope.incPage = function() {
						var page = Number($scope.options.pageToGoTo || $scope.currentPage);

						if (isNaN(page) || !isFinite(page)) {
							page = $scope.currentPage;
						}

						$timeout(function() {
							$scope.options.pageToGoTo = Math.min(page + 1, $scope.maxPages);
						});
					};

					$scope.decPage = function() {
						var page = Number($scope.options.pageToGoTo || $scope.currentPage);

						if (isNaN(page) || !isFinite(page)) {
							page = $scope.currentPage;
						}

						$timeout(function() {
							$scope.options.pageToGoTo = Math.max(page - 1, 1);
						});
					};

					$scope.$watch('totalItems', function(newValue) {
						//$log.debug('totalItems: ', newValue);

						var offset = 0;
						var page = 1;

						$timeout(function() {
							if (stateParams.offset) {
								offset = Number(stateParams.offset);
								page += Math.floor(offset / $scope.pageSize);
							}

							$scope.currentPage = page;
							$scope.options.pageToGoTo = page;

							//$log.debug('currentPage: ', $scope.currentPage);

							var maxPage = Math.floor(newValue / $scope.pageSize) + ((newValue % $scope.pageSize != 0) | 0);

							$scope.maxPages = maxPage;
							$scope.pages = getPages(0, maxPage - 1);

							$scope.options.hasLeft = $scope.pages[0] > 0;
							$scope.options.hasRight =
								maxPage > $scope.limitNavigation && $scope.pages[$scope.limitNavigation - 1] < maxPage - 1;
							$scope.onPagesChange({ pages: $scope.pages.slice() });
							//$log.debug('useInput', $scope.useInput);
						});
					});

					$scope.moreLeft = function() {
						var max = $scope.limitNavigation;
						var first = $scope.pages[0] || 0;
						first = Math.max(first - max, 0);

						$timeout(function() {
							for (var i = 0; i < $scope.pages.length; i++) {
								$scope.pages[i] = first + i;
							}
							$scope.options.hasLeft = $scope.pages[0] > 0;
							$scope.options.hasRight = $scope.maxPages > max && $scope.pages[max - 1] < $scope.maxPages - 1;
							$scope.onPagesChange({ pages: $scope.pages.slice() });
						});
					};

					$scope.moreRight = function() {
						var max = $scope.limitNavigation;
						var first = $scope.pages[0] || 0;
						first = Math.min(first + max, $scope.maxPages - max);

						$timeout(function() {
							for (var i = 0; i < $scope.pages.length; i++) {
								$scope.pages[i] = first + i;
							}
							$scope.options.hasLeft = $scope.pages[0] > 0;
							$scope.options.hasRight = $scope.maxPages > max && $scope.pages[max - 1] < $scope.maxPages - 1;
							$scope.onPagesChange({ pages: $scope.pages.slice() });
						});
					};

					$scope.goString = $rootScope.languageString('go');
					$scope.enterPageString = $rootScope.languageString('or_enter_page');

					$scope.options.pageDescriptions = angular.copy($scope.pageDescriptions || []);

					var dv = $scope.$watch(
						'pageDescriptions',
						function(newValue) {
							$scope.options.pageDescriptions = angular.copy(newValue || []);
						},
						true
					);
				},

				template:
					'<div ng-hide="!totalItems||totalItems<=pageSize">\
	<ul class="custom-pagination">\
		<li class="footable-page-arrow" ng-if="currentPage>1"><a data-page="first" ng-click="goToPage(1)">{{firstText}}</a></li>\
		<li class="footable-page-arrow" ng-if="currentPage>1"><a data-page="prev" ng-click="goToPage(currentPage-1)">{{prevText}}</a></li>\
		<li class="footable-page"><a ng-click="moreLeft()" ng-show="options.hasLeft" class="col-xs-0 col-sm-0">...</a></li>\
		<li ng-repeat="page in pages" class="footable-page" ng-class="{\'active\': page+1==currentPage, \'col-xs-0\': page+1!=currentPage, \'col-sm-0\': page+1!=currentPage}"><a data-page="{{page}}" ng-click="goToPage(page+1)" ng-disabled="page+1==currentPage" data-toggle="tooltip" uib-tooltip="{{options.pageDescriptions[page]}}" tooltip-placement="top">{{page+1}}</a></li>\
		<li class="footable-page"><a ng-click="moreRight()" ng-show="options.hasRight" class="col-xs-0 col-sm-0">...</a></li>\
		<li class="footable-page-arrow" ng-if="currentPage<maxPages"><a data-page="next" ng-click="goToPage(currentPage+1)">{{nextText}}</a></li>\
		<li class="footable-page-arrow" ng-if="currentPage<maxPages"><a data-page="last" ng-click="goToPage(maxPages)">{{lastText}} ({{maxPages}})</a></li>\
	</ul>\
	<span ng-if="useInput" style="float: left; padding: 5px;">{{enterPageString}}:</span>\
	<div ng-if="useInput" class="input-group" style="float: left;"><span class="input-group-btn" style="padding: 0px; height: 30px;"><button class="btn btn-sm btn-white bootstrap-touchspin-down" type="button" ng-click="decPage()">-</button></span><input type="text" class="form-control custom-pagination-input" ng-model="options.pageToGoTo" style="width: 80px; height: 30px; text-align: center; font-size: 12px;"/><span class="input-group-btn style="padding: 0px; height: 30px;"><button class="btn btn-sm btn-white bootstrap-touchspin-up" type="button" ng-click="incPage()">+</button><button type="button" class="btn btn-sm btn-default" ng-click="goToPage(options.pageToGoTo)">{{goString}}</button></span></div>\
</div></div>',
			};
		},
	])

	.directive('customPagination2', [
		'$rootScope',
		'$state',
		'$stateParams',
		'$timeout',
		'$location',
		'UtilsService',
		'$log',
		function($rootScope, $state, $stateParams, $timeout, $location, UtilsService, $log) {
			return {
				restrict: 'E',

				scope: {
					totalItems: '=',
					firstText: '@',
					prevText: '@',
					nextText: '@',
					lastText: '@',
					useInput: '=',
					mainArray: '=',
					slicedArray: '=',
					currentPage: '=',
					limitNavigation: '@',
				},

				controller: function($scope) {
					$scope.currentPage = $scope.currentPage || 1;

					$scope.options = {};

					$scope.firstText = $scope.firstText || '«';
					$scope.prevText = $scope.prevText || '‹';
					$scope.nextText = $scope.nextText || '›';
					$scope.lastText = $scope.lastText || '»';

					$scope.pageSize = $rootScope.results_per_page || 100;

					$scope.limitNavigation = Number($scope.limitNavigation || $rootScope.pagination_max_pages);

					var getPages = function(start, end) {
						var max = $scope.limitNavigation;
						var total = end - start + 1;
						if (total > max) {
							start = Math.max($scope.currentPage - 3, 0);
							end = Math.min(start + max - 1, $scope.maxPages - 1);
							if (end - start < max - 1) {
								start -= max - 1 - end + start;
							}
						}

						return UtilsService.numArray(start, end);
					};

					$scope.goToPage = function(page, noReplace) {
						page = Number(page);

						if (isNaN(page) || !isFinite(page)) {
							return;
						}

						if (page < 1 || page > $scope.maxPages || page == $scope.currentPage) {
							return;
						}

						$timeout(function() {
							$scope.currentPage = page;

							$scope.scrollToTopIfNeeded();

							if (!noReplace && $rootScope.previousState && $location.hash() != 'page_' + String(page)) {
								$location.hash('page_' + String(page)).replace();
								//console.log('replace2');
							} else {
								$location.hash('page_' + String(page));
							}
						});
					};

					$scope.incPage = function() {
						var page = Number($scope.options.pageToGoTo || $scope.currentPage);

						if (isNaN(page) || !isFinite(page)) {
							page = $scope.currentPage;
						}

						$timeout(function() {
							$scope.options.pageToGoTo = Math.min(page + 1, $scope.maxPages);
						});
					};

					$scope.decPage = function() {
						var page = Number($scope.options.pageToGoTo || $scope.currentPage);

						if (isNaN(page) || !isFinite(page)) {
							page = $scope.currentPage;
						}

						$timeout(function() {
							$scope.options.pageToGoTo = Math.max(page - 1, 1);
						});
					};

					$scope.$watch('totalItems', function(newValue) {
						$timeout(function() {
							var maxPage = Math.floor(newValue / $scope.pageSize) + ((newValue % $scope.pageSize != 0) | 0);

							$scope.maxPages = maxPage;
							$scope.pages = getPages(0, maxPage - 1);

							$scope.options.hasLeft = $scope.pages[0] > 0;
							$scope.options.hasRight =
								maxPage > $scope.limitNavigation && $scope.pages[$scope.limitNavigation - 1] < maxPage - 1;

							//$log.debug('useInput', $scope.useInput); // update useInput automatically?

							if (!$scope.slicedArray || !$scope.slicedArray.length) {
								$scope.options.pageToGoTo = $scope.currentPage;

								$scope.pages = getPages(0, $scope.maxPages - 1);

								$scope.options.hasLeft = $scope.pages[0] > 0;
								$scope.options.hasRight =
									$scope.maxPages > $scope.limitNavigation &&
									$scope.pages[$scope.limitNavigation - 1] < $scope.maxPages - 1;

								$scope.slicedArray = ($scope.mainArray || []).slice(
									$scope.pageSize * ($scope.currentPage - 1),
									Math.min($scope.pageSize * $scope.currentPage, ($scope.mainArray || []).length)
								);
							}
						});
					});

					$scope.$watch('currentPage', function(newValue) {
						$timeout(function() {
							$scope.options.pageToGoTo = newValue;

							$scope.pages = getPages(0, $scope.maxPages - 1);

							$scope.options.hasLeft = $scope.pages[0] > 0;
							$scope.options.hasRight =
								$scope.maxPages > $scope.limitNavigation &&
								$scope.pages[$scope.limitNavigation - 1] < $scope.maxPages - 1;

							$scope.slicedArray = ($scope.mainArray || []).slice(
								$scope.pageSize * ($scope.currentPage - 1),
								Math.min($scope.pageSize * $scope.currentPage, ($scope.mainArray || []).length)
							);
						});
					});

					$scope.moreLeft = function() {
						var max = $scope.limitNavigation;
						var first = $scope.pages[0] || 0;
						first = Math.max(first - max, 0);

						$timeout(function() {
							for (var i = 0; i < $scope.pages.length; i++) {
								$scope.pages[i] = first + i;
							}
							$scope.options.hasLeft = $scope.pages[0] > 0;
							$scope.options.hasRight = $scope.maxPages > max && $scope.pages[max - 1] < $scope.maxPages - 1;
						});
					};

					$scope.moreRight = function() {
						var max = $scope.limitNavigation;
						var first = $scope.pages[0] || 0;
						first = Math.min(first + max, $scope.maxPages - max);

						$timeout(function() {
							for (var i = 0; i < $scope.pages.length; i++) {
								$scope.pages[i] = first + i;
							}
							$scope.options.hasLeft = $scope.pages[0] > 0;
							$scope.options.hasRight = $scope.maxPages > max && $scope.pages[max - 1] < $scope.maxPages - 1;
						});
					};

					$scope.goString = $rootScope.languageString('go');
					$scope.enterPageString = $rootScope.languageString('or_enter_page');
				},

				link: function(scope, element, attrs) {
					scope.scrollToTopIfNeeded = function() {
						if (!attrs['preventScrollTop']) {
							// animated?
							var table = element.closest('table')[0];
							var offsetTop = Math.max(UtilsService.getOffsetTop(table) - 40, 0);
							table = null;

							if (Math.max(document.documentElement.scrollTop, document.body.scrollTop) > offsetTop) {
								//document.documentElement.scrollTop = document.body.scrollTop = offsetTop;

								$('html, body').animate(
									{
										scrollTop: offsetTop,
									},
									{
										duration: 350 * $rootScope.animationDurationMultiplier,
									}
								);
							}
						}
					};

					var checkPage = function() {
						var hash = $location.hash();
						if (hash && /^page_\d+$/.test(hash)) {
							var found = hash.match(/^page_(\d+)$/);
							var page = Number(found[1] || 1);

							if (page > 1) {
								$timeout(function() {
									(scope.goToPage || angular.noop)(page, true);
								}, 50);
							}
						}
					};

					var $table = $(element.closest('table')[0]);

					$table.bind('footable_initialized', checkPage);

					scope.$on('$destroy', function() {
						$table && $table.unbind('footable_initialized', checkPage);
						$table.remove();
						$table = null;
					});
				},

				template:
					'<div class="multi-pagination-wrapper" ng-hide="!mainArray||mainArray.length<=pageSize">\
	<ul class="custom-pagination">\
		<li class="footable-page-arrow" ng-if="currentPage>1"><a data-page="first" ng-click="goToPage(1)">{{firstText}}</a></li>\
		<li class="footable-page-arrow" ng-if="currentPage>1"><a data-page="prev" ng-click="goToPage(currentPage-1)">{{prevText}}</a></li>\
		<li class="footable-page"><a ng-click="moreLeft()" ng-show="options.hasLeft" class="col-xs-0 col-sm-0">...</a></li>\
		<li ng-repeat="page in pages" class="footable-page" ng-class="{\'active\': page+1==currentPage, \'col-xs-0\': page+1!=currentPage, \'col-sm-0\': page+1!=currentPage}"><a data-page="{{page}}" ng-click="goToPage(page+1)" ng-disabled="page+1==currentPage">{{page+1}}</a></li>\
		<li class="footable-page"><a ng-click="moreRight()" ng-show="options.hasRight" class="col-xs-0 col-sm-0">...</a></li>\
		<li class="footable-page-arrow" ng-if="currentPage<maxPages"><a data-page="next" ng-click="goToPage(currentPage+1)">{{nextText}}</a></li>\
		<li class="footable-page-arrow" ng-if="currentPage<maxPages"><a data-page="last" ng-click="goToPage(maxPages)">{{lastText}} ({{maxPages}})</a></li>\
	</ul>\
	<span ng-if="useInput" style="padding: 5px;">{{enterPageString}}:</span>\
	<div ng-if="useInput" class="input-group"><div class="input-group-btn"><button class="btn btn-sm btn-white bootstrap-touchspin-down" type="button" ng-click="decPage()" style="height: 40px; margin-bottom: 0;">-</button></div><input type="text" class="form-control custom-pagination-input" ng-model="options.pageToGoTo" style="width: 80px; height: 40px; text-align: center; font-size: 12px;"/><div class="input-group-btn"><button class="btn btn-sm btn-white bootstrap-touchspin-up" type="button" ng-click="incPage()" style="height: 40px; margin-bottom: 0;">+</button><button type="button" class="btn btn-sm btn-default" ng-click="goToPage(options.pageToGoTo)" style="height: 40px; margin-bottom: 0;">{{goString}}</button></div></div>\
</div>',
			};
		},
	])

	.directive('tableFilter', [
		'$rootScope',
		function($rootScope) {
			return {
				restrict: 'E',

				scope: {
					ngModel: '=',
					placeholder: '@',
				},

				require: 'ngModel',

				link: function(scope, element, attrs, ngModelController) {
					var input = angular
						.element(element)
						.find('input')
						.first();

					scope.focusInput = function() {
						input[0].focus();
					};

					scope.id_prefix = attrs.id || '';
					scope.placeholder = scope.placeholder || $rootScope.languageString('filter');

					scope.$on('$destroy', function() {
						input = null;
					});
				},

				template:
					'<div class="col-xs-12" style="padding: 0px;">\
	<div class="table-filter-wrapper">\
		<input id="{{id_prefix}}-table-filter" type="text" name="{{id_prefix}}_filter" placeholder="{{placeholder}}" ng-model="ngModel" ng-model-options="{debounce: 300}"/><img ng-click="focusInput()" src="assets/images/panel/search.svg"/>\
	</div>\
</div>',
			};
		},
	])

	.directive('liveClock', [
		'$interval',
		'$timeout',
		function($interval, $timeout) {
			return {
				priority: 999,

				restrict: 'AE',

				link: function(scope, element, attrs) {
					var updateTime;
					(updateTime = function() {
						$timeout(function() {
							scope.time = new Date();
						});
					})();

					var loop = $interval(updateTime, 1000);

					scope.$on('AuthSucces', function() {
						$interval.cancel(loop);
						loop = $interval(updateTime, 1000);
					});

					scope.$on('$destroy', function() {
						if (loop) {
							$interval.cancel(loop);
						}
					});
				},

				template: '<span class="live-clock">{{time | enswitchDateTimeFormat}}</span>',
			};
		},
	])

	.directive('customAudioControls', [
		'$timeout',
		'$interval',
		'$rootScope',
		function($timeout, $interval, $rootScope) {
			var lang = $rootScope.languageString;

			return {
				restrict: 'AE',
				replace: true,
				scope: {
					audioId: '=',
					haveFile: '=',
					fileLoading: '=',
					autoplay: '@',
					estimatedDuration: '@',
				},
				link: function($scope) {
					$scope.isPlaying = false;
					$scope.isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
					$scope.pauseStr = ' ' + lang('audio_pause');
					$scope.playStr = ' ' + lang('audio_play');

					$scope.data = {};
					$scope.data.currentTime = $scope.data._currentTime = 0;
					$scope.duration = 0;

					var audioCtrl;

					var playbackEnded = function(e) {
						$timeout(function() {
							$scope.isPlaying = false;
							$scope.data.currentTime = $scope.data._currentTime = audioCtrl.currentTime = 0;
						});
					};

					var updateDuration = function(e) {
						$timeout(
							function() {
								$scope.duration = Number(audioCtrl.duration);
							},
							$scope.isFirefox ? 100 : 10
						);
					};

					var seekTimeout;
					$scope.userSeeked = function(e) {
						$scope.data.currentTime = $scope.data._currentTime;
						seekTimeout && $timeout.cancel(seekTimeout);
						$scope.isPlaying && audioCtrl.pause();
						audioCtrl.currentTime = Number($scope.data.currentTime || 0);
						seekTimeout = $timeout(function() {
							try {
								$scope.data.currentTime = $scope.data._currentTime;
								$scope.isPlaying && audioCtrl.play();
							} catch (e) {}
						}, 10);
					};

					var updateTime = function(e) {
						$timeout(function() {
							$scope.data.currentTime = $scope.data._currentTime = audioCtrl.currentTime;
						});
					};

					$scope.playPause = function() {
						if ($scope.haveFile && audioCtrl) {
							audioCtrl[$scope.isPlaying ? 'pause' : 'play']();
							$scope.isPlaying = !$scope.isPlaying;
						}
					};

					var hasBeenAutoplayed = false;
					var autoplayIfNeeded = function() {
						//console.log('canplaythrough');
						if ($scope.autoplay !== undefined && String($scope.autoplay) !== 'false' && !hasBeenAutoplayed) {
							hasBeenAutoplayed = true;
							$timeout(function() {
								audioCtrl.play();
								$scope.isPlaying = true;
							}, 550);
						}
					};

					var updateDurationInterval;
					var cancelUpdateDurationTimeout;
					var cancelUpdateDurationInterval = function() {
						updateDurationInterval && $interval.cancel(updateDurationInterval);
					};

					var startLoadDurationLoop = function() {
						$timeout(
							function() {
								cancelUpdateDurationInterval();
								updateDurationInterval = $interval(updateDuration, 500);
								cancelUpdateDurationTimeout && $timeout.cancel(cancelUpdateDurationTimeout);
								cancelUpdateDurationTimeout = $timeout(cancelUpdateDurationInterval, 2000);
							},
							$scope.isFirefox ? 150 : 60
						);
					};

					var clearEvents = function() {
						if (audioCtrl) {
							angular.element(audioCtrl).off('timeupdate', updateTime);
							angular.element(audioCtrl).off('canplaythrough', startLoadDurationLoop);
							angular.element(audioCtrl).off('canplaythrough', autoplayIfNeeded);
							angular.element(audioCtrl).off('canplaythrough', updateDuration); //  durationchange loadeddata loadedmetadata
							angular.element(audioCtrl).off('ended', playbackEnded);
							angular.element(audioCtrl).off('stop', playbackEnded);
							audioCtrl = null;
							cancelUpdateDurationInterval();
							cancelUpdateDurationTimeout && $timeout.cancel(cancelUpdateDurationTimeout);
						}
					};

					var unregister = $scope.$watch('haveFile', function(newValue) {
						if (newValue && $scope.audioId) {
							$timeout(function() {
								audioCtrl = document.getElementById($scope.audioId);
								if (audioCtrl) {
									hasBeenAutoplayed = false;
									audioCtrl.volume = 1.0;
									angular.element(audioCtrl).on('stop', playbackEnded);
									angular.element(audioCtrl).on('ended', playbackEnded);
									angular.element(audioCtrl).on('canplaythrough', updateDuration); //  durationchange loadeddata loadedmetadata
									angular.element(audioCtrl).on('canplaythrough', autoplayIfNeeded);
									angular.element(audioCtrl).on('canplaythrough', startLoadDurationLoop);
									angular.element(audioCtrl).on('timeupdate', updateTime);
									$scope.data.currentTime = $scope.data._currentTime = 0;
								}
							});
						} else {
							clearEvents();
							$timeout(function() {
								$scope.isPlaying = false;
							});
						}
					});

					$scope.$on('$destroy', unregister);
					$scope.$on('$destroy', clearEvents);
				},
				template:
					'<div ng-show="!$root.isIEOrEdge&&(haveFile||fileLoading)" id="{{audioId}}-controls" class="btn btn-sm btn-primary in-group custom-audio-controls" ng-style="{ \'width\': isFirefox && !estimatedDuration ? \'200px\' : \'280px\' }">\
	<div ng-if="!$root.isIEOrEdge&&!haveFile&&fileLoading">\
		<div class="sk-spinner sk-spinner-wave" ng-if="!haveFile&&fileLoading"><div class="sk-rect1"></div><div class="sk-rect2"></div><div class="sk-rect3"></div><div class="sk-rect4"></div><div class="sk-rect5"></div></div>\
	</div>\
	<div ng-if="!$root.isIEOrEdge" ng-show="haveFile">\
		<div ng-click="playPause()" class="play-button">\
			<i class="fa" ng-class="isPlaying?{\'fa-pause\': true}:{\'fa-play\': true}"></i>\
			<span>{{isPlaying?pauseStr:playStr}}</span>\
		</div>\
		<input ng-if="::(!isFirefox||estimatedDuration)" ng-style="::{\'width\': \'100px\'}" type="range" min="0" max="{{isFirefox?estimatedDuration:duration}}" step="any" ng-model="data._currentTime" ng-change="userSeeked($event)" class="col-xs-0"/>\
		<span>{{data._currentTime|secondsToTime}}<span ng-if="::(!isFirefox||estimatedDuration)">&nbsp;/&nbsp;{{(isFirefox?estimatedDuration:duration)|secondsToTime}}</span></span>\
	</div>\
</div>',
			};
		},
	])

	.directive('howlerAudioControls', [
		'$timeout',
		function($timeout) {
			return {
				restrict: 'E',
				replace: true,
				scope: {
					fileUrl: '=',
					autoplay: '=?',
				},
				link: function($scope, $element) {
					var playAudio;
					var sound;

					var loader = Ladda.create(angular.element($element).find('.howler-loader')[0]);
					loader.start();

					$scope.isFileLoaded = false;
					$scope.isFilePlaying = false;

					$scope.$watch('fileUrl', function(newValue) {
						if (!newValue) {
							return;
						}

						if (sound) {
							sound.stop();
							$scope.isFilePlaying = false;
							$scope.isFileLoaded = false;
							$scope.file = '';
							sound.unload();
							sound = undefined;
							if (newValue === 'delete') {
								return;
							}
						}

						$scope.waveformbarElement = angular.element($element).find('#waveformbar');
						$scope.progressElement = angular.element($element).find('#progress');
						$scope.file = {
							fileUrl: newValue,
						};
						var soundId;
						playAudio = {
							play: function(index) {
								var self = this;
								if (!sound) {
									sound = new Howl({
										src: newValue,
										html5: true,
										format: ['wav'],
										volume: 1.0,
										onplay: function() {
											$scope.duration = formatTime(Math.round(sound.duration()));
											requestAnimationFrame(self.step.bind(self));
											$scope.isFilePlaying = true;
											$scope.$apply();
										},
										onload: function() {
											soundId = sound._sounds[0]._id;
											$scope.duration = formatTime(Math.round(sound.duration(soundId)));
											$scope.timer = formatTime(0);
											$scope.isFileLoaded = true;
											$scope.progressElement.css('width', ((0 / sound.duration()) * 100 || 0) + '%');
											if (Boolean($scope.autoplay)) {
												$scope.isFilePlaying = true;
												sound.play(soundId);
											}
											$scope.$apply();
										},
										onend: function() {
											$scope.isFilePlaying = false;
										},
									});
								} else {
									sound.play(soundId);
								}
							},

							pause: function() {
								sound.pause(soundId);
								$scope.isFilePlaying = false;
							},

							stop: function() {
								sound.stop(soundId);
								$scope.isFilePlaying = false;
							},

							seek: function(per) {
								if (sound.playing()) {
									sound.pause(soundId);
									sound.seek(sound.duration() * per);
									$scope.timer = formatTime(Math.round(getSoundSeekNumber(sound)));
									sound.play(soundId);
								} else {
									sound.seek(sound.duration() * per);
									$scope.timer = formatTime(Math.round(getSoundSeekNumber(sound)));
									$scope.progressElement.css(
										'width',
										((getSoundSeekNumber(sound) / sound.duration()) * 100 || 0) + '%'
									);
								}
								$timeout(function() {
									$scope.$apply();
								});
							},
							step: function() {
								if (sound) {
									var self = this;
									var seek = getSoundSeekNumber(sound) || 0;
									$scope.timer = formatTime(Math.round(seek));
									$scope.progressElement.css('width', ((seek / sound.duration()) * 100 || 0) + '%');
									if (sound.playing(soundId)) {
										requestAnimationFrame(self.step.bind(self));
									}
									$scope.$apply();
								}
							},
						};
						if (newValue && newValue != 'delete') {
							playAudio.play();
						}
					});
					$scope.play = function() {
						playAudio.play();
					};
					$scope.pause = function() {
						playAudio.pause();
					};
					$scope.seek = function(event) {
						var progressBarPositionLeft = $scope.waveformbarElement[0].getBoundingClientRect().left + window.scrollX;
						var progressBarPositionRight = $scope.waveformbarElement[0].getBoundingClientRect().right + window.scrollX;
						playAudio.seek(
							Number(
								(
									(event.clientX - progressBarPositionLeft) /
									(progressBarPositionRight - progressBarPositionLeft)
								).toFixed(2)
							)
						);
					};
					var formatTime = function(secs) {
						var minutes = Math.floor(secs / 60) || 0;
						var seconds = secs - minutes * 60 || 0;

						return minutes + ':' + (seconds < 10 ? '0' : '') + seconds;
					};

					var getSoundSeekNumber = function(sound) {
						if (sound) {
							var time = Number(sound.seek());
							if (isNaN(time)) {
								time = Number(sound._sounds[0]._seek);
							}
							return time;
						}
					};
					$scope.$on('$destroy', () => {
						if (sound) {
							sound.stop();
							$scope.isFilePlaying = false;
							sound.unload();
							sound = undefined;
						}
					});
				},
				templateUrl: 'app/components/common/howlerAudioControls.html',
			};
		},
	])

	/*
	.directive('onScrollBottom', ['$window', function($window) {

		var getScrollParent = function(node) {

			if (!node) {
				return null;
			}

			if (node.scrollHeight > node.clientHeight) {
				return node;
			} else {
				return getScrollParent(node.parentNode);
			}
		}

		return {

			restrict: 'A',

			scope: {fn: '&onScrollBottom'},

			link: {

				post: function(scope, element, attrs) {

					var getWindowHeight = "innerHeight" in $window ? function() { return $window.innerHeight; } : function() { return document.documentElement.offsetHeight; };

					var windowHeight = getWindowHeight();
					var docHeight = 0;

					var enabled = true;
					var lastHeight = 0;

					var body = document.body, html = document.documentElement;

					var handleResize = function() {
						windowHeight = getWindowHeight();
					};

					var handler = function(evt) {

						docHeight = docHeight || Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight,  html.scrollHeight, html.offsetHeight);
						var windowBottom = windowHeight + $window.pageYOffset;
						if (windowBottom >= Math.max(docHeight - windowHeight / 2, 1)) {
							if (enabled) {
								enabled = false;
								scope.fn();
							}
						}
					};

					scope.$watch(function() {
						return Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight,  html.scrollHeight, html.offsetHeight);
					}, function(newValue) {

						docHeight = newValue;

						if (newValue != lastHeight) {
							enabled = true;
							lastHeight = newValue;
						}
					});

					angular.element($window).on('scroll', handler);
					angular.element($window).on('resize', handleResize);

					scope.$on('$destroy', function() {
						angular.element($window).off('scroll', handler);
						angular.element($window).off('resize', handleResize);
					});

				}
			}
		};

	}])
	*/

	/*
	.directive('convertUserTimezone', ['$timeout', 'UtilsService', function($timeout, UtilsService) {

		return {

			restrict: 'E',

			require: 'ngModel',

			link: {

				post: function(scope, element, attrs, ngModelController) {

					if (attrs.type == 'date' && attrs.shouldConvert === 'true') {

						var convertToUsersTimezone = function() {

							var original = ngModelController.$modelValue;

							var converted = UtilsService.newDate(original);
							converted.setHours(original.getHours(), original.getMinutes(), original.getSeconds(), original.getMilliseconds()); // keep same time, we're just interested in the date

							ngModelController.$formatters.forEach(function(f) {
								converted = f(converted);
							});

							ngModelController.$setViewValue(converted);
							ngModelController.$commitViewValue();
							ngModelController.$render();

							ngModelController.$setPristine();
						};

						$timeout(function() {

							if (!ngModelController.$isEmpty(ngModelController.$modelValue)) {
								convertToUsersTimezone();
							} else {

								var w = scope.$watch(function() {
									return ngModelController.$modelValue;
								}, function(newValue) {

									if (!ngModelController.$isEmpty(newValue) && ngModelController.$pristine) { // not user changed!
										w();
										convertToUsersTimezone();
									}
								});
							}
						});
					}
				}
			}
		};
	}])
	*/

	.directive('stepByStep', [
		'$compile',
		'$rootScope',
		'$timeout',
		'$parse',
		function($compile, $rootScope, $timeout, $parse) {
			var lang = $rootScope.languageString;

			return {
				restrict: 'AC',

				require: '^form',

				priority: -1000,

				controller: function($scope, $element) {
					$timeout(function() {
						var iboxes = $element.find('.ibox.step:not(.ng-hide)');

						$scope.last = $scope.stepsCount < 2;

						var validateStep = function() {
							var valid = true;
							angular.forEach(iboxes.eq($scope.currentStep - 1).find('input, textarea'), function(control) {
								if (valid && angular.element(control).hasClass('ng-invalid')) {
									valid = false;
									$timeout(function() {
										try {
											angular.element(control).focus();
											$scope.formCtrl[angular.element(control).attr('name')].$setDirty();
											$scope.$broadcast('$$rebind::' + angular.element(control).attr('name'));
										} catch (e) {}
									});
								}
							});
							return valid;
						};

						var focusFirstInputInStep = function(currentStep) {
							$timeout(function() {
								try {
									iboxes
										.eq(currentStep - 1)
										.find('input, textarea')
										.first()
										.focus();
								} catch (e) {}
							}, 420);
						};

						$scope.checkValidityOnSave = function() {
							if ($scope.formCtrl.$invalid) {
								var invalidIndex = 0;
								var invalidField;
								var found = false;
								angular.forEach(iboxes, function(_ibox, index) {
									if (found) return;
									angular.forEach(angular.element(_ibox).find('input, textarea'), function(input) {
										if (found) return;
										if (angular.element(input).hasClass('ng-invalid')) {
											found = true;
											invalidIndex = index;
											invalidField = input;
										}
									});
								});
								invalidIndex++;
								if (invalidIndex != $scope.currentStep) {
									$timeout(function() {
										$scope.last = invalidIndex == $scope.stepsCount;
										iboxes
											.eq($scope.currentStep - 1)
											.find('.ibox-content')
											.slideUp(400 * $rootScope.animationDurationMultiplier) &&
											iboxes
												.eq(invalidIndex - 1)
												.find('.ibox-content')
												.slideDown(400 * $rootScope.animationDurationMultiplier);
										if (!invalidField) {
											$scope.currentStep = invalidIndex;
										}
									});
								}
								if (invalidField) {
									$timeout(
										function() {
											try {
												angular.element(invalidField).focus();
											} catch (e) {}
											$scope.currentStep = invalidIndex;
										},
										invalidIndex != $scope.currentStep ? 420 : 20
									);
								}
							}
							$timeout(function() {
								$scope.finished = true;
							});
						};

						$scope.prev = function() {
							$scope.currentStep > 1 &&
								$timeout(function() {
									$scope.last = false;
									iboxes
										.eq($scope.currentStep - 1)
										.find('.ibox-content')
										.slideUp(400 * $rootScope.animationDurationMultiplier) &&
										iboxes
											.eq(--$scope.currentStep - 1)
											.find('.ibox-content')
											.slideDown(400 * $rootScope.animationDurationMultiplier);
									focusFirstInputInStep($scope.currentStep);
								});
						};

						$scope.next = function() {
							!$scope.last &&
								$timeout(function() {
									$scope.formCtrl.$submitted = true;
									$scope.formCtrl.$setDirty();
									if ($scope.last) {
										$scope.finished = $scope.finished || $scope.completedSteps == $scope.currentStep;
										$scope.completedSteps = Math.max($scope.completedSteps, $scope.currentStep);
									}
									if (validateStep()) {
										$parse(iboxes.eq($scope.currentStep - 1)[0].getAttribute('onNext'))($scope);
										$scope.formCtrl.$submitted = false;
										$scope.last = $scope.currentStep == $scope.stepsCount - 1;
										$scope.completedSteps = Math.max($scope.completedSteps, $scope.currentStep);
										iboxes
											.eq($scope.currentStep - 1)
											.find('.ibox-content')
											.slideUp(400 * $rootScope.animationDurationMultiplier) &&
											iboxes
												.eq(++$scope.currentStep - 1)
												.find('.ibox-content')
												.slideDown(400 * $rootScope.animationDurationMultiplier);
										focusFirstInputInStep($scope.currentStep);
									}
								});
						};

						$scope.headerClicked = function(step) {
							step &&
								($scope.finished || $scope.completedSteps >= step) &&
								$scope.currentStep != step &&
								validateStep() &&
								$timeout(function() {
									for (var i = $scope.currentStep; i < step; i++) {
										$parse(iboxes.eq(i - 1)[0].getAttribute('onNext'))($scope);
									}
									$scope.last = false;
									iboxes
										.eq($scope.currentStep - 1)
										.find('.ibox-content')
										.slideUp(400 * $rootScope.animationDurationMultiplier) &&
										iboxes
											.eq(step - 1)
											.find('.ibox-content')
											.slideDown(400 * $rootScope.animationDurationMultiplier);
									$scope.currentStep = step;
									focusFirstInputInStep(step);
								});
						};

						$scope.$on('$destroy', function() {
							$scope.formCtrl = null;
							iboxes = null;
						});
					});
				},

				link: {
					post: function(scope, element, attrs, formCtrl) {
						$timeout(function() {
							var finished = String(attrs['finished']) == '1' || String(attrs['finished']) == 'true';
							var completedSteps = finished ? scope.stepsCount : 0;
							scope.stepsCount = element.find('.ibox.step:not(.ng-hide)').length;
							scope.completedSteps = completedSteps;
							scope.currentStep = 1;
							scope.finished = finished;

							var iboxes = element.find('.ibox.step:not(.ng-hide)');
							scope.formCtrl = formCtrl;
							// apply onkeypress="return event.keyCode != 13;" to inputs?

							element.addClass('step-form-root');

							angular.forEach(iboxes, function(_ibox, index) {
								var step = String(index + 1);

								var header;
								var ibox = angular.element(_ibox);
								var hasTitle = ibox.find('.ibox-title').length;

								if (hasTitle) {
									header = ibox.find('.ibox-title').first();
								} else {
									header = angular.element('<div class="ibox-title"><h2>Step ' + step + '</h2></div>');
									ibox.prepend(header);
								}

								header.attr(
									'ng-class',
									"{'current': currentStep==" +
										step +
										", 'completed': currentStep!=" +
										step +
										'&&(finished||completedSteps>=' +
										step +
										')}'
								);
								header.attr('ng-click', 'headerClicked(' + step + ')');
								var statusIcon = angular.element(
									'<i class="fa pull-right" ng-class="{\'fa-check\': (finished||completedSteps>=' +
										step +
										'&&currentStep!=' +
										step +
										"), 'fa-edit': !finished&&currentStep==" +
										step +
										", 'fa-minus': !finished&&completedSteps<" +
										step +
										'&&currentStep!=' +
										step +
										'}"></i>'
								);
								$compile(statusIcon)(scope);
								header
									.find('h2')
									.first()
									.after(statusIcon);
								$compile(header)(scope);

								index &&
									ibox
										.find('div.ibox-content')
										.first()
										.slideUp(1);

								scope.backStr = lang('back');
								scope.nextStr = lang('next');
								scope.finishStr = lang('finish');
								var footer = angular.element(
									'<div ng-if="currentStep==' +
										step +
										'" class="next-button-container"><button type="button" class="btn btn-default" ng-click="prev()" ng-if="currentStep>1">{{backStr}}</button>' +
										(finished && index >= iboxes.length - 1
											? ''
											: '<button type="' +
											  (index >= iboxes.length - 1 ? 'submit' : 'button') +
											  '" class="btn btn-primary' +
											  (index >= iboxes.length - 1 && attrs['submitButtonClass']
													? ' ' + attrs['submitButtonClass']
													: '') +
											  '" ng-click="next()">{{' +
											  (index >= iboxes.length - 1 ? 'finishStr' : 'nextStr') +
											  '}}</button></div>')
								);
								$compile(footer)(scope);
								ibox.after(footer);

								ibox.attr('margin-top', '20px');

								ibox = null;
								if (!hasTitle) {
									scope.$on('$destroy', function() {
										if (statusIcon) {
											statusIcon.remove();
											statusIcon = null;
										}
										header.remove();
										header = null;
									});
								} else {
									header = null;
								}

								scope.$on('$destroy', function() {
									if (statusIcon) {
										statusIcon.remove();
										statusIcon = null;
									}
									footer.remove();
									footer = null;
								});
							});

							if (finished) {
								var saveContainer = angular.element(
									'<div class="row submit-button-container col-sm-7 col-xs-12 col-sm-offset-5"><button type="submit" class="btn btn-success confirm-button ladda-button' +
										(attrs['submitButtonClass'] ? ' ' + attrs['submitButtonClass'] : '') +
										'" data-style="zoom-out" data-spinner-size="24" data-size="s" data-spinner-color="white" ng-click="checkValidityOnSave()">Save</button></div>'
								);
								$compile(saveContainer)(scope);
								element.append(saveContainer);
								scope.$on('$destroy', function() {
									saveContainer.remove();
									saveContainer = null;
								});
							}

							scope.$on('StepFormReturnedError', function(event, data) {
								if (data && data.formName && data.formName === formCtrl.$name) {
									$timeout(function() {
										formCtrl.$submitted = false;
										scope.completedSteps = completedSteps;
										scope.finished = finished;
										scope.last = scope.stepsCount < 2 || scope.currentStep >= scope.stepsCount;
										iboxes
											.eq(scope.currentStep - 1)
											.find('.ibox-content')
											.slideUp(400 * $rootScope.animationDurationMultiplier);
										scope.currentStep = 1;
										iboxes
											.eq(0)
											.find('.ibox-content')
											.slideDown(400 * $rootScope.animationDurationMultiplier);
										$timeout(function() {
											try {
												iboxes
													.eq(0)
													.find('input, textarea')
													.first()
													.focus();
											} catch (e) {
												// console.log(e);
											}
										}, 420);
									});
								}
							});

							scope.$on('$destroy', function() {
								iboxes = null;
							});
						});
					},
				},
			};
		},
	])

	.directive('alert', [
		'SwalService',
		'$rootScope',
		'$window',
		'SessionService',
		'PreferencesApiService',
		'$timeout',
		function(SwalService, $rootScope, $window, SessionService, PreferencesApiService, $timeout) {
			return {
				restrict: 'C',
				scope: true,
				transclude: true,
				replace: true,
				template: '<div><span class="sr-only">Error:</span><span class="alert-message" ng-transclude></span></div>',
				link: function(scope, element, attrs) {
					if (element.hasClass('alert-dismissible')) {
						var dismissOnce = 'dismissOnce' in attrs && String(attrs.dismissOnce) !== 'false';
						var dismissOnceKey = (attrs.dismissOnceKey && String(attrs.dismissOnceKey)) || attrs.id;
						var wasDismissed = false;

						if (dismissOnce && dismissOnceKey) {
							element.hide();
							$timeout(function() {
								if (dismissOnceKey) {
									PreferencesApiService.getPreference({
										name: dismissOnceKey,
									}).then(
										function(response) {
											wasDismissed = !!Number(response.data.value);
											if (!wasDismissed) {
												element.show();
											} else {
												element.remove();
												return;
											}
										},
										function() {
											element.show();
										}
									);
								}
							});
						} else if (dismissOnce) {
							dismissOnce = false; // key is required!
						}

						var lang = $rootScope.languageString;

						var closeButton;
						var dismissStr = lang('dismiss');
						if (element.find('button.btn--error').length) {
							closeButton = element.find('button.btn--error').last();
						} else {
							closeButton = angular.element('<button class="btn btn--error">' + dismissStr + '</button>');
							element.append(closeButton);
						}

						var dismiss = function() {
							element.fadeTo(275 * $rootScope.animationDurationMultiplier, 0.00001, function() {
								element.slideUp(225 * $rootScope.animationDurationMultiplier, function() {
									scope.$destroy();
									element.remove();
								});
							});
							return true;
						};

						var capitalize = $rootScope.capitalize;

						var dismissClicked = function() {
							if (dismissOnce) {
								return SwalService.popup({
									title: lang('dismiss_prompt'),
									type: 'question',
									showCancelButton: true,
									confirmButtonColor: '#1c84c6',
									confirmButtonText: capitalize(lang('yes')),
									cancelButtonText: capitalize(lang('no')),
								}).then(function(inputValue) {
									PreferencesApiService.setPreference({
										name: dismissOnceKey,
										value: '1',
									});
									return dismiss();
								}, dismiss);
							}
							return dismiss();
						};

						closeButton.bind('click', dismissClicked);

						scope.$on('$destroy', function() {
							closeButton && closeButton.unbind('click', dismissClicked);
							closeButton && closeButton.remove();
							closeButton = null;
						});
					}
				},
			};
		},
	])

	.directive('showLoader', [
		'$compile',
		function($compile) {
			return {
				restrict: 'A',
				scope: {
					showLoader: '=showLoader',
				},
				link: function(scope, element, attrs) {
					var loader = angular.element(
						'<div class="col-xs-12" style="margin-bottom: 8px;" ng-if="showLoader"><div class="sk-spinner sk-spinner-wave" ng-if="showLoader" style="display: block;"><div class="sk-rect1"></div><div class="sk-rect2"></div><div class="sk-rect3"></div><div class="sk-rect4"></div><div class="sk-rect5"></div></div></div>'
					);
					$compile(loader)(scope);
					element.before(loader);
					scope.$on('$destroy', function() {
						loader.remove();
						loader = null;
					});
				},
			};
		},
	])

	.directive('star', [
		'UtilsService',
		'$rootScope',
		'$timeout',
		'$q',
		function(UtilsService, $rootScope, $timeout, $q) {
			return {
				restrict: 'E',
				replace: true,
				scope: {
					dtype: '@',
					dnumber: '@',
					ref: '=',
					onSuccess: '&',
				},
				link: function(scope) {
					var lang = $rootScope.languageString;
					scope.remove_str = lang('favorites_remove');
					scope.add_str = lang('favorites_add');
					scope.toggleStarred = function() {
						var isStarred = scope.ref && scope.ref.isStarred;
						return UtilsService.starFeature(scope.dtype, scope.dnumber, !isStarred, scope.ref).then(
							scope.onSuccess || angular.identity
						);
					};
					var u = scope.$watch('dnumber', function(newValue) {
						if (newValue) {
							u();
							var alreadySet =
								scope.ref &&
								scope.ref.isStarred &&
								(String(scope.ref.isStarred) === '1' || String(scope.ref.isStarred) === 'true');
							(alreadySet ? $q.resolve(true) : UtilsService.checkStarred(scope.dtype, newValue)).then(function(
								isStarred
							) {
								scope.ref &&
									$timeout(function() {
										scope.ref.isStarred = isStarred;
										scope.$watch('ref.isStarred', function(newValue, oldValue) {
											if (newValue === undefined && (oldValue || oldValue === false)) {
												// handle automatic list reload
												$timeout(function() {
													scope.ref.isStarred = oldValue;
												});
											}
										});
									});
							},
							angular.identity);
						}
					});
				},
				template:
					'<div class="star-icon"><a ng-if="dnumber&&ref" ng-click="toggleStarred()"><img ng-if="!ref.isStarred" src="assets/images/icons/favorite-w.svg" /><img ng-if="!!ref.isStarred" src="assets/images/icons/favorite-y.svg" /><a></div class="star-icon">',
			};
		},
	])

	.directive('hamburger', [
		'$window',
		function($window) {
			return {
				restrict: 'E',
				replace: true,
				link: function(scope, element, attrs) {
					scope.toggleNav = function() {
						element.toggleClass('change');
						angular.element('.navbar-static-side').toggleClass('show-nav');
						angular.element('nav').toggleClass('full-width');
					};
					var removeClass = function() {
						if (element.hasClass('change')) {
							element.removeClass('change');
							angular.element('.navbar-static-side').removeClass('show-nav');
							angular.element('nav').removeClass('full-width');
						}
					};
					scope.$on('$stateChangeStart', removeClass);
					scope.$on('$destroy', function() {
						$window.removeEventListener('resize', removeClass);
					});
				},
				template:
					'<div class="hamburger" ng-click="toggleNav()"><div class="bar1"></div><div class="bar2"></div><div class="bar3"></div></div>',
			};
		},
	])

	// .directive('dashboardMasonry', ['$timeout', function($timeout) {
	// 	return {
	// 		restrict: 'C',
	// 		link: function(scope, element, attrs) {
	// 			var msnry = new Masonry(element[0], {
	// 				itemSelector: '.dashboard-grid__item',
	// 				columnWidth: '.dashboard-grid__item',
	// 				transitionDuration: '0s',
	// 				stagger: 0,
	// 				gutter: 0,
	// 				percentPosition: true,
	// 				horizontalOrder: false,
	// 				initLayout: true,
	// 			});
	// 			scope.$on('ResizeDashboard', function() {
	// 				$timeout(function() {
	// 					msnry && msnry.layout();
	// 				}, 20);
	// 			});
	// 			$timeout(function() {
	// 				msnry && msnry.layout();
	// 			}, 320);
	// 			$timeout(function() {
	// 				msnry && msnry.layout();
	// 			}, 2000);
	// 			scope.$on('$destroy', function() {
	// 				msnry.destroy();
	// 				msnry = null;
	// 			});
	// 		},
	// 	};
	// }, ])

	.directive('dismissible', [
		'SwalService',
		'PreferencesApiService',
		'$timeout',
		'$rootScope',
		'$compile',
		function(SwalService, PreferencesApiService, $timeout, $rootScope, $compile) {
			return {
				restrict: 'A',
				link: function(scope, element, attrs) {
					$timeout(function() {
						var dismissOnce = 'dismissOnce' in attrs && String(attrs.dismissOnce) !== 'false';
						var dismissOnceKey = (attrs.dismissOnceKey && String(attrs.dismissOnceKey)) || attrs.id;
						var wasDismissed = false;
						var removed = false;

						if (dismissOnce && dismissOnceKey) {
							element.hide();
							$timeout(function() {
								if (dismissOnceKey) {
									PreferencesApiService.getPreference({
										name: dismissOnceKey,
									}).then(
										function(response) {
											if (!removed) {
												wasDismissed = !!Number(response.data.value);
												if (!wasDismissed) {
													element.show();
												} else {
													element.remove();
													return;
												}
											}
										},
										function() {
											removed || element.show();
										}
									);
								}
							});
						} else if (dismissOnce) {
							dismissOnce = false; // key is required!
						}

						var lang = $rootScope.languageString;
						scope.dismissStr = lang('dismiss');

						var dismissLink;
						if (element.find('a.dismiss-link').length) {
							dismissLink = element.find('a.dismiss-link').last();
						} else {
							dismissLink = angular.element(
								'<a data-toggle="tooltip" uib-tooltip="{{dismissStr}}" tooltip-placement="auto" class="dismiss-link"><img svg-image src="assets/images/icons/close.svg" /></a>'
							);
							$compile(dismissLink)(scope);
							element.append(dismissLink);
						}

						var dismiss = function() {
							element.fadeTo(275 * $rootScope.animationDurationMultiplier, 0.00001, function() {
								element.slideUp(225 * $rootScope.animationDurationMultiplier, function() {
									dismissOnce && dismissOnceKey && $rootScope.$broadcast(dismissOnceKey);
									scope.$destroy(); // remove?
									element.remove();
								});
							});
							return true;
						};

						var capitalize = $rootScope.capitalize;

						var dismissClicked = function() {
							if (dismissOnce) {
								return SwalService.popup({
									title: lang('dismiss_prompt'),
									type: 'question',
									showCancelButton: true,
									confirmButtonColor: '#1c84c6',
									confirmButtonText: capitalize(lang('yes')),
									cancelButtonText: capitalize(lang('no')),
								}).then(function() {
									PreferencesApiService.setPreference({
										name: dismissOnceKey,
										value: '1',
									});
									return dismiss();
								}, dismiss);
							}
							return dismiss();
						};

						dismissLink.bind('click', dismissClicked);

						scope.$on('$destroy', function() {
							dismissLink && dismissLink.unbind('click', dismissClicked);
							dismissLink && dismissLink.remove();
							dismissLink = null;
						});

						element.on('$destroy', function() {
							removed = true;
						});
					});
				},
			};
		},
	])

	.directive('help', [
		'CustomsApiService',
		'RolesApiService',
		'SessionService',
		'UtilsService',
		'$timeout',
		'$rootScope',
		'$state',
		'$compile',
		function(CustomsApiService, RolesApiService, SessionService, UtilsService, $timeout, $rootScope, $state, $compile) {
			return {
				restrict: 'E',
				scope: true,
				replace: true,
				link: function(scope, element, attrs) {
					element.hide();

					var currentState = UtilsService.getCurrentState();
					var path =
						attrs.key ||
						currentState.url
							.replace(/\?.*$/, '')
							.replace(/\/$/, '')
							.replace(/^\/?(users|customers|features|global|reports|devices|calls)\//, '')
							.replace(/\//g, '_')
							.replace(/_list$/, '')
							.replace(/_new$/, '')
							.replace(/_groups$/, '')
							.replace(/_batches$/, '');

					var fullHelpKey = 'help_' + path + '_body';
					scope.dismissOnceKey = 'help_' + path + '_summary_dismissed';

					var removed = false;
					var removeElement = function() {
						//scope.$destroy();
						removed || element.remove();
					};

					$timeout(function() {
						var me = SessionService.getSession();
						me || removeElement();

						me &&
							RolesApiService.getAccessForRole({
								role: me.effective_role || me.role,
								privilege: 'help',
							}).then(function(response) {
								var havePermission = !!Number(response.data);
								havePermission || removeElement();
								havePermission &&
									CustomsApiService.get({
										name: 'help_' + path + '_summary',
										value: 1,
										template: 1,
									}).then(function(response) {
										$timeout(function() {
											if (!response || !response.data || !response.data.value) return removeElement();
											var helpStateName = currentState.name.replace(/-list$/, '');
											if (helpStateName != 'index.features.recordings-groups') {
												// special case
												helpStateName = helpStateName.replace(/-.+$/, '');
											}
											helpStateName += '-help';
											var linkHtml = $compile(
												'<a ui-sref="' +
													helpStateName +
													"({name: '" +
													fullHelpKey +
													'\', language: $root.currentLanguage})">&nbsp;&nbsp;' +
													$rootScope.languageString('see_more') +
													'</a>'
											)(scope)[0].outerHTML;
											var helpHtml = response.data.value.trim();
											var lastParagraphIndex = UtilsService.regexLastIndexOf(helpHtml, /<\/(p|div|span)>/gm);
											if (lastParagraphIndex < 0) {
												lastParagraphIndex = helpHtml.length;
											}
											scope.helpText = [
												helpHtml.slice(0, lastParagraphIndex),
												linkHtml,
												helpHtml.slice(lastParagraphIndex),
											].join('');
											scope.$broadcast('$$rebind::helpText');
											//element.show();
										});
									}, removeElement);
							});

						scope.$on('$stateChangeStart', function(event) {
							var defaultPrevented =
								event.defaultPrevented && (typeof event.defaultPrevented !== 'function' || event.defaultPrevented());
							if (!defaultPrevented) removeElement();
						});
						// scope.$on('$destroy', function(e) {
						// 	console.log('help destroy.......');
						// });

						element.on('$destroy', function() {
							removed = true;
						});
					});
				},
				template:
					'<div class="info-text-box help-summary" dismissible dismiss-once dismiss-once-key="{{dismissOnceKey}}"><div ng-bind-html=":helpText:$root.parseHTML(helpText)"></div></div>',
			};
		},
	])

	.directive('helpLink', [
		'CustomsApiService',
		'RolesApiService',
		'SessionService',
		'UtilsService',
		'$timeout',
		'$rootScope',
		'$state',
		'PreferencesApiService',
		function(
			CustomsApiService,
			RolesApiService,
			SessionService,
			UtilsService,
			$timeout,
			$rootScope,
			$state,
			PreferencesApiService
		) {
			return {
				restrict: 'E',
				scope: true,
				replace: true,
				link: function(scope, element, attrs) {
					element.hide();

					$timeout(function() {
						var currentState = UtilsService.getCurrentState();
						var path =
							attrs.key ||
							currentState.url
								.replace(/\?.*$/, '')
								.replace(/\/$/, '')
								.replace(/^\/?(users|customers|features|global|reports|devices|calls)\//, '')
								.replace(/\//g, '_')
								.replace(/_list$/, '')
								.replace(/_new$/, '')
								.replace(/_groups$/, '')
								.replace(/_batches$/, '');

						var helpStateName = currentState.name.replace(/-list$/, '');
						if (helpStateName != 'index.recordings-groups') {
							// special case
							helpStateName = helpStateName.replace(/-.+$/, '');
						}
						helpStateName += '-help';
						var fullHelpKey = 'help_' + path + '_body';

						scope.goToHelp = function() {
							$state.go(helpStateName, {
								name: fullHelpKey,
								// modal: '1',
							});
						};

						var dismissOnceKey = 'help_' + path + '_summary_dismissed';

						var removed = false;

						var removeElement = function() {
							removed || element.remove();
						};

						var me = SessionService.getSession();
						me || removeElement();

						me &&
							RolesApiService.getAccessForRole({
								role: me.effective_role || me.role,
								privilege: 'help',
							}).then(function(response) {
								var havePermission = !!Number(response.data);
								havePermission || removeElement();
								havePermission &&
									CustomsApiService.get({
										name: 'help_' + path + '_summary',
										value: 1,
										template: 1,
									}).then(function(response) {
										$timeout(function() {
											if (!response || !response.data || !response.data.value) return removeElement();
											PreferencesApiService.getPreference({
												name: dismissOnceKey,
											}).then(
												function(response) {
													if (Number(response.data.value)) {
														removed || element.show();
													} else {
														removed ||
															scope.$on(dismissOnceKey, function() {
																removed || element.show();
															});
													}
												},
												function() {
													removed ||
														scope.$on(dismissOnceKey, function() {
															removed || element.show();
														});
												}
											);
										});
									}, removeElement);
							});

						scope.$on('$stateChangeStart', function(event) {
							var defaultPrevented =
								event.defaultPrevented && (typeof event.defaultPrevented !== 'function' || event.defaultPrevented());
							if (!defaultPrevented) removeElement();
						});

						element.on('$destroy', function() {
							removed = true;
						});
					});
				},
				template: '<a class="help-link" ng-click="goToHelp()"><img svg-image src="assets/images/icons/info.svg" /></a>',
			};
		},
	])

	.directive('maintenanceWarning', [
		'$interval',
		'ConfigsApiService',
		'$rootScope',
		'$q',
		function($interval, ConfigsApiService, $rootScope, $q) {
			return {
				restrict: 'E',
				scope: false,
				link: function(scope) {
					scope.isMaintenanceOn = false;

					var getMaintenanceData = function() {
						ConfigsApiService.getConfig({ name: 'system_maintenance_mode' }, false)
							.then(function(response) {
								if (response.data && response.data.value !== 'warn_web') {
									scope.isMaintenanceOn = false;
								} else if (response.data && response.data.value === 'warn_web') {
									if ($rootScope.systemMaintenanceMessage) {
										return $q.when($rootScope.systemMaintenanceMessage);
									} else {
										return ConfigsApiService.getConfig({ name: 'system_maintenance_message' });
									}
								} else {
									scope.isMaintenanceOn = false;
								}
							})
							.then(function(response) {
								if (response && response.data && response.data.value) {
									$rootScope.systemMaintenanceMessage = response.data.value;
								}
								if (response) {
									scope.warningMessage = $rootScope.systemMaintenanceMessage;
									scope.isMaintenanceOn = true;
								}
							});
					};

					$rootScope.$on('$stateChangeSuccess', function() {
						getMaintenanceData();
					});
				},
				template:
					'<div ng-if="isMaintenanceOn" id="system-maintenance-indicator"><span class="vertical-centered">{{warningMessage}}</span></div>',
			};
		},
	])

	.directive('inmodal', [
		'$rootScope',
		'$timeout',
		function($rootScope, $timeout) {
			return {
				restrict: 'C',
				link: function(scope, element) {
					// modals fix;
					element
						.children()
						.first()
						.is('.modal-header') &&
						element.wrapInner('<div style="display: block; margin: 0px; overflow-y: visible;"></div>');
					element
						.children()
						.first()
						.is('form') &&
						element
							.children()
							.first()
							.css({
								'overflow-y': 'scroll',
							});
					var w = $timeout(function() {
						if (!/edit-features-modal-\d+/.test(element.attr('id')) && $rootScope.openEditModalsCount) {
							element
								.parent()
								.parent()
								.parent()[0]
								.style.setProperty('z-index', String(2050 + $rootScope.openEditModalsCount * 10 + 1), 'important');
							// .css({
							// 	'z-index': String(2050 + $rootScope.openEditModalsCount * 10 + 1),
							// });
						}
					}, 25);
					scope.$on('$destroy', function() {
						$timeout.cancel(w);
					});
				},
			};
		},
	])

	/* ******** Filters ******** */

	.filter('bytes', function() {
		return function(bytes, precision) {
			if (!bytes || isNaN(parseFloat(bytes)) || !isFinite(bytes)) {
				return '0 bytes';
			}

			if (typeof precision === 'undefined') {
				precision = 1;
			}

			var units = [' bytes', 'kB', 'MB', 'GB', 'TB', 'PB'],
				number = Math.floor(Math.log(bytes) / Math.log(1024));

			var val = (bytes / Math.pow(1024, Math.floor(number))).toFixed(precision);

			if (number > 5) {
				// fallback if too large
				number = 0;
				val = bytes;
			}

			val = String(val);

			return (val.match(/\.0*$/) ? val.substr(0, val.indexOf('.')) : val) + units[number];
		};
	})

	.filter('secondsToTime', function() {
		function padTime(t) {
			return t < 10 ? '0' + t : t;
		}

		return function(_seconds) {
			_seconds = Number(_seconds);

			if (typeof _seconds !== 'number' || _seconds <= 0 || isNaN(_seconds) || !isFinite(_seconds)) return '00:00';

			var hours = Math.floor(_seconds / 3600),
				minutes = Math.floor((_seconds % 3600) / 60),
				seconds = Math.floor(_seconds % 60);

			return (hours ? String(hours) + ':' : '') + padTime(minutes) + ':' + padTime(seconds);
		};
	})

	.filter('enswitchDateTimeFormat', function(UtilsService) {
		return function(time) {
			return UtilsService.format_date_time(time);
		};
	})

	.filter('enswitchDateFormat', function(UtilsService) {
		return function(time) {
			return UtilsService.format_date(time);
		};
	})

	.filter('enswitchTimeFormat', function(UtilsService) {
		return function(time) {
			return UtilsService.format_time(time);
		};
	})

	.filter('currencyFormat', function(UtilsService, $rootScope) {
		return function(amount, round, currency, hideCurrency) {
			return (hideCurrency ? '' : $rootScope.currencyString(currency)) + UtilsService.trim_money(amount, round);
		};
	})

	.filter('orderObjectBy', function() {
		return function(items, field, reverse) {
			var filtered = [];

			angular.forEach(items, function(item) {
				filtered.push(item);
			});

			return filtered.sort(function(a, b) {
				return (a[field] || '').localeCompare(b[field] || '') * (reverse ? -1 : 1);
			});
		};
	})

	.filter('customerFilter', function() {
		return function(items, filter) {
			var lcFilter = (filter || '').toLowerCase();
			return filter
				? (items || []).filter(function(item) {
						return item.name.toLowerCase().indexOf(lcFilter) > -1;
				  })
				: items;
		};
	})

	.filter('userFilter', function() {
		var getLCFullName = function(item) {
			if (item.full_name) return item.full_name.replace(/\s+/, ' ').toLowerCase();
			var forename = item.forename;
			var surname = String(item.surname || '');
			var fullname = forename;
			if (forename && surname) {
				fullname += ' ';
			}
			fullname += surname;
			return fullname
				.trim()
				.replace(/\s+/, ' ')
				.toLowerCase();
		};
		return function(items, filter) {
			var lcFilter = (filter || '').toLowerCase();
			return filter
				? (items || []).filter(function(item) {
						return item.username.toLowerCase().indexOf(lcFilter) > -1 || getLCFullName(item).indexOf(lcFilter) > -1;
				  })
				: items;
		};
	});

'use strict';

(function(window, angular) {
	function debugInfoConfig($compileProvider, $logProvider) {
		var isDebug = (Number(location.port || 0) || (location.protocol == 'https' ? 443 : 80)) >= 3000;
		$compileProvider.debugInfoEnabled(isDebug); // disable this in production for significant performance boost
		//$compileProvider.commentDirectivesEnabled(false); // (1.6.0+)
		$logProvider.debugEnabled(isDebug);
		if (!isDebug) {
			console.log = angular.noop;
		}
	}

	angular.module('new-web').config(debugInfoConfig);
})(window, window.angular);

'use strict';

(function(angular) {
	angular
		.module('new-web')

		.value('config', {
			apiUrl: location.protocol + '//' + location.hostname + '/api/json/',
		})

		.constant('variables', {
			versionTimestamp: 0,

			emailRegex: /^[-a-z0-9~!$%^&*_=+}{\'?]+(\.[-a-z0-9~!$%^&*_=+}{\'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.(aero|arpa|biz|com|coop|edu|gov|info|int|mil|museum|name|net|org|pro|travel|mobi|[a-z][a-z])|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i,

			prefix_dtypes: [
				'access',
				'callerid',
				'conference',
				'conference_admin',
				'conference_listen',
				'conference_talk',
				'external',
				'hidecallerid',
				'media_fax',
				'media_voice',
				'mailbox',
				'page',
				'park',
				'phone',
				'plugin',
				'record',
				'replace',
				'setforward',
				'sip_domain',
				'spy',
				'spy_conference',
				'spy_talk',
				'spy_talk_called',
				'voucher',
			],

			configured_languages: [],

			currencies: {
				AUD: {
					sound_major: 'dollar',
					sound_major_plural: 'dollars',
					sound_minor: 'cent',
					sound_minor_plural: 'cents',
					symbol: '$',
					symbol_html: '$',
				},
				BWP: {
					sound_major: 'pula',
					sound_major_plural: 'pula',
					sound_minor: 'thebe',
					sound_minor_plural: 'thebe',
					symbol: 'P',
					symbol_html: 'P',
				},
				CAD: {
					sound_major: 'dollar',
					sound_major_plural: 'dollars',
					sound_minor: 'cent',
					sound_minor_plural: 'cents',
					symbol: '$',
					symbol_html: '$',
				},
				CHF: {
					sound_major: 'franc',
					sound_major_plural: 'francs',
					sound_minor: 'cent',
					sound_minor_plural: 'cents',
					symbol: 'SFr.',
					symbol_html: 'SFr.',
				},
				CNY: {
					sound_major: 'yuan',
					sound_major_plural: 'yuan',
					sound_minor: 'fen',
					sound_minor_plural: 'fen',
					symbol: 'Â¥',
					symbol_html: '&yen;',
				},
				CZK: {
					sound_major: 'koruna',
					sound_major_plural: 'koruny',
					sound_minor: 'haler',
					sound_minor_plural: 'halere',
					symbol: 'Kc',
					symbol_at_end: 1,
					symbol_html: 'K&#269;',
				},
				DKK: {
					sound_major: 'krone',
					sound_major_plural: 'kroner',
					sound_minor: 'ore',
					sound_minor_plural: 'ore',
					symbol: 'kr.',
					symbol_html: 'kr.',
				},
				DZD: {
					sound_major: 'dinar',
					sound_major_plural: 'dinar',
					sound_minor: 'centime',
					sound_minor_plural: 'centimes',
					symbol: 'DZD',
					symbol_html: 'DZD',
				},
				EUR: {
					sound_major: 'euro',
					sound_major_plural: 'euros',
					sound_minor: 'cent',
					sound_minor_plural: 'cents',
					symbol: 'EUR',
					symbol_html: '&euro;',
				},
				GBP: {
					sound_major: 'pound',
					sound_major_plural: 'pounds',
					sound_minor: 'penny',
					sound_minor_plural: 'pence',
					symbol: '£',
					symbol_html: '&pound;',
				},
				HUF: {
					sound_major: 'forint',
					sound_major_plural: 'forint',
					sound_minor: 'filler',
					sound_minor_plural: 'filler',
					symbol: 'Ft',
					symbol_html: 'Ft',
				},
				ILS: {
					sound_major: 'shekel',
					sound_major_plural: 'shekels',
					sound_minor: 'agora',
					sound_minor_plural: 'agorot',
					symbol: 'ILS',
					symbol_html: '&#x20aa;',
				},
				INR: {
					sound_major: 'rupee',
					sound_major_plural: 'rupees',
					sound_minor: 'paisa',
					sound_minor_plural: 'paise',
					symbol: 'Rs',
					symbol_html: 'Rs',
				},
				JPY: {
					sound_major: 'yen',
					sound_major_plural: 'yen',
					sound_minor: 'sen',
					sound_minor_plural: 'sen',
					symbol: 'Â¥',
					symbol_html: '&yen;',
				},
				KES: {
					sound_major: 'shilling',
					sound_major_plural: 'shilling',
					sound_minor: 'cent',
					sound_minor_plural: 'cents',
					symbol: 'KSh',
					symbol_html: 'KSh',
				},
				LSL: {
					sound_major: 'loti',
					sound_major_plural: 'maloti',
					sound_minor: 'sente',
					sound_minor_plural: 'lisente',
					symbol: 'LSL',
					symbol_html: 'L',
				},
				MXN: {
					sound_major: 'peso',
					sound_major_plural: 'pesos',
					sound_minor: 'centavo',
					sound_minor_plural: 'centavos',
					symbol: '$',
					symbol_html: '$',
				},
				NAD: {
					sound_major: 'dollar',
					sound_major_plural: 'dollars',
					sound_minor: 'cent',
					sound_minor_plural: 'cents',
					symbol: 'N$',
					symbol_html: 'N$',
				},
				NOK: {
					sound_major: 'krone',
					sound_major_plural: 'kroner',
					sound_minor: 'ore',
					sound_minor_plural: 'ore',
					symbol: 'kr',
					symbol_html: 'kr',
				},
				NZD: {
					sound_major: 'dollar',
					sound_major_plural: 'dollars',
					sound_minor: 'cent',
					sound_minor_plural: 'cents',
					symbol: '$',
					symbol_html: '$',
				},
				RUB: {
					sound_major: 'ruble',
					sound_major_plural: 'rubles',
					sound_minor: 'kopek',
					sound_minor_plural: 'kopeks',
					symbol: 'R',
					symbol_html: 'R',
				},
				SEK: {
					sound_major: 'krona',
					sound_major_plural: 'kronor',
					sound_minor: 'ore',
					sound_minor_plural: 'ore',
					symbol: 'kr',
					symbol_at_end: 1,
					symbol_html: 'kr',
				},
				SGD: {
					sound_major: 'dollar',
					sound_major_plural: 'dollars',
					sound_minor: 'cent',
					sound_minor_plural: 'cents',
					symbol: '$',
					symbol_html: '$',
				},
				THB: {
					sound_major: 'baht',
					sound_major_plural: 'baht',
					sound_minor: 'satang',
					sound_minor_plural: 'satang',
					symbol: '฿',
					symbol_html: '฿',
				},
				TRY: {
					sound_major: 'lira',
					sound_major_plural: 'lira',
					sound_minor: 'kurus',
					sound_minor_plural: 'kurus',
					symbol: 'YTL',
					symbol_html: 'YTL',
				},
				USD: {
					sound_major: 'dollar',
					sound_major_plural: 'dollars',
					sound_minor: 'cent',
					sound_minor_plural: 'cents',
					symbol: '$',
					symbol_html: '$',
				},
				ZAR: {
					sound_major: 'rand',
					sound_major_plural: 'rand',
					sound_minor: 'cent',
					sound_minor_plural: 'cents',
					symbol: 'R',
					symbol_html: 'R',
				},
			},

			csvFields: {
				customers: [
					{
						name: 'id',
						display: 'ID',
					},
					{
						name: 'name',
						display: 'Name',
					},
					{
						name: 'description',
						display: 'Description',
					},
					{
						name: 'account',
						display: 'Account',
					},
					{
						name: 'prefix',
						display: 'Prefix',
					},
					{
						name: 'locked',
						display: 'Locked web',
					},
					{
						name: 'locked_telephony',
						display: 'Locked telephony',
					},
					{
						name: 'deleted',
						display: 'Deleted',
					},
					{
						name: 'directory',
						display: 'Directory',
					},
					{
						name: 'contact_username',
						display: 'Contact',
					},
					{
						name: 'plan',
						display: 'Plan ID',
					},
					{
						name: 'plan_name',
						display: 'Plan name',
					},
					{
						name: 'balance',
						display: 'Balance',
					},
					{
						name: 'email_low_balance_display',
						display: 'Email on low balance',
					},
					{
						name: 'low_balance',
						display: 'Low balance',
					},
					{
						name: 'auto_topup',
						display: 'Auto topup',
					},
					{
						name: 'credit',
						display: 'Credit',
					},
					{
						name: 'credit_extra',
						display: 'Extra credit',
					},
					{
						name: 'credit_extra_timegroup_name',
						display: 'Extra credit time group',
					},
					{
						name: 'seconds_left',
						display: 'Call time',
					},
					{
						name: 'messages_left',
						display: 'Messages',
					},
					{
						name: 'payment_type',
						display: 'Payment type',
					},
					{
						name: 'bill_type',
						display: 'Billing type',
					},
					{
						name: 'bill_ref',
						display: 'Billing reference',
					},
					{
						name: 'tax_number',
						display: 'Tax number',
					},
					{
						name: 'invoices',
						display: 'Invoices',
					},
					{
						name: 'invoices_detail',
						display: 'Invoices detail',
					},
					{
						name: 'region_name',
						display: 'Region',
					},
					{
						name: 'currency',
						display: 'Currency',
					},
					{
						name: 'dialplan_name',
						display: 'Dial plan',
					},
					{
						name: 'expires_date',
						display: 'Expires date',
					},
					{
						name: 'expires_time',
						display: 'Expires time',
					},
					{
						name: 'affiliate_type',
						display: 'Affiliate type',
					},
					{
						name: 'affiliate_customer',
						display: 'Affiliate customer ID',
					},
					{
						name: 'affiliate_customer_name',
						display: 'Affiliate customer name',
					},
					{
						name: 'affiliate_percentage',
						display: 'Affiliate percentage',
					},
					{
						name: 'address1',
						display: 'Address 1',
					},
					{
						name: 'address2',
						display: 'Address 2',
					},
					{
						name: 'address3',
						display: 'Address 3',
					},
					{
						name: 'address_city',
						display: 'City',
					},
					{
						name: 'address_state',
						display: 'State',
					},
					{
						name: 'address_code',
						display: 'Code',
					},
					{
						name: 'country_name',
						display: 'Country',
					},
					{
						name: 'address_other',
						display: 'Other address information',
					},
					{
						name: 'email',
						display: 'Email',
					},
					{
						name: 'telephone',
						display: 'Telephone',
					},
					{
						name: 'fax',
						display: 'Fax',
					},
					{
						name: 'inmaximum',
						display: 'Inbound maximum',
					},
					{
						name: 'outmaximum',
						display: 'Outbound maximum',
					},
					{
						name: 'totalmaximum',
						display: 'Total maximum',
					},
					{
						name: 'overmax',
						display: 'Allow calls on over maximum',
					},
				],

				speed_dials: [
					{
						name: 'sdial',
						display: 'Dial',
					},
					{
						name: 'description',
						display: 'Description',
					},
					{
						name: 'dnumber',
						display: 'Destination',
					},
					{
						name: 'dname',
						display: 'Caller name',
					},
					{
						name: 'button',
						display: 'Button',
					},
				],

				alert_events: [
					{
						name: 'date_time',
						display: 'Date and time',
					},
					{
						name: 'type',
						display: 'Type',
					},
					{
						name: 'data',
						display: 'Data',
					},
				],

				alerts: [
					{
						name: 'name',
						display: 'Name',
					},
					{
						name: 'description',
						display: 'Description',
					},
					{
						name: 'search',
						display: 'Search',
					},
					{
						name: 'type',
						display: 'Type',
					},
					{
						name: 'email',
						display: 'Email',
					},
					{
						name: 'message',
						display: 'Message',
					},
					{
						name: 'period',
						display: 'Period',
					},
					{
						name: 'last',
						display: 'Last',
					},
					{
						name: 'starthour',
						display: 'Start hour',
					},
					{
						name: 'startminute',
						display: 'Start minute',
					},
					{
						name: 'startsecond',
						display: 'Start second',
					},
					{
						name: 'endhour',
						display: 'End hour',
					},
					{
						name: 'endminute',
						display: 'End minute',
					},
					{
						name: 'endsecond',
						display: 'End second',
					},
					{
						name: 'days_week',
						display: 'Week days',
					},
					{
						name: 'talktime',
						display: 'Talktime',
					},
					{
						name: 'cost',
						display: 'Cost',
					},
					{
						name: 'destination',
						display: 'Destination',
					},
					{
						name: 'times',
						display: 'Times',
					},
					{
						name: 'times_period',
						display: 'Times period',
					},
					{
						name: 'idle_seconds',
						display: 'Idle seconds',
					},
					{
						name: 'dnd_seconds',
						display: 'DND seconds',
					},
					{
						name: 'minimum_affected',
						display: 'Minimum affected',
					},
					{
						name: 'minimum_duration',
						display: 'Minimum duration',
					},
					{
						name: 'percent_fail',
						display: 'Percent fail',
					},
					{
						name: 'minimum_calls',
						display: 'Minimum calls',
					},
					{
						name: 'peer',
						display: 'Peer',
					},
					{
						name: 'calls',
						display: 'Calls',
					},
					{
						name: 'events',
						display: 'Events',
					},
				],

				recordings: [
					{
						name: 'uniqueid',
						display: 'Unique ID',
					},
					{
						name: 'callid',
						display: 'Call ID',
					},
					{
						name: 'machine',
						display: 'Machine',
					},
					{
						name: 'recordid',
						display: 'Recordid',
					},
					{
						name: 'recordgroup',
						display: 'Record group',
					},
					{
						name: 'status',
						display: 'Status',
					},
					{
						name: 'complete',
						display: 'Complete',
					},
					{
						name: 'start',
						display: 'Start timestamp',
					},
					{
						name: 'start_date',
						display: 'Start date',
					},
					{
						name: 'start_time',
						display: 'Start time',
					},
					{
						name: 'end',
						display: 'End timestamp',
					},
					{
						name: 'end_date',
						display: 'End date',
					},
					{
						name: 'end_time',
						display: 'End time',
					},
					{
						name: 'totaltime',
						display: 'Total time',
					},
					{
						name: 'talktime',
						display: 'Billable time',
					},
					{
						name: 'expires',
						display: 'Expires timestamp',
					},
					{
						name: 'expires_date',
						display: 'Expires date',
					},
					{
						name: 'expires_time',
						display: 'Expires time',
					},
					{
						name: 'scustomer',
						display: 'Source customer',
					},
					{
						name: 'stype',
						display: 'Source type',
					},
					{
						name: 'snumber',
						display: 'Source number',
					},
					{
						name: 'ctype',
						display: 'Called type',
					},
					{
						name: 'cnumber',
						display: 'Called number',
					},
					{
						name: 'dcustomer',
						display: 'Destination customer',
					},
					{
						name: 'dtype',
						display: 'Destination type',
					},
					{
						name: 'dnumber',
						display: 'Destination number',
					},
					{
						name: 'callerid_internal',
						display: 'Internal callerid',
					},
					{
						name: 'path',
						display: 'Path',
					},
				],

				feature_codes: [
					{
						name: 'code',
						display: 'Feature code',
					},
					{
						name: 'description',
						display: 'Description',
					},
					{
						name: 'owner_display',
						display: 'Owner',
					},
					{
						name: 'display_play_message',
						display: 'Announcement',
					},
					{
						name: 'display_screen',
						display: 'Screen',
					},
					{
						name: 'sname',
						display: 'Force name',
					},
					{
						name: 'maximum_minutes',
						display: 'Force hangup after minutes',
					},
					{
						name: 'routing_display',
						display: 'Temporary routing',
					},
					{
						name: 'dtype',
						display: 'Destination type',
					},
					{
						name: 'dnumber',
						display: 'Destination',
					},
					{
						name: 'dtype_display',
						display: 'Destination type name',
					},
					{
						name: 'dnumber_display',
						display: 'Destination name',
					},
				],

				huntgroup_destinations: [
					{
						name: 'level',
						display: 'Level',
					},
					{
						name: 'dtype',
						display: 'Destination type',
					},
					{
						name: 'dnumber',
						display: 'Destination',
					},
					{
						name: 'available_display',
						display: 'Available',
					},
					{
						name: 'append_callerid',
						display: 'Append to callerid',
					},
					{
						name: 'screen_display',
						display: 'Screen',
					},
				],

				huntgroup_destination_statistics: [
					{
						name: 'dtype',
						display: 'Type',
					},
					{
						name: 'dnumber',
						display: 'Number',
					},
					{
						name: 'dtype_display',
						display: 'Type name',
					},
					{
						name: 'dnumber_display',
						display: 'Number name',
					},
					{
						name: 'calls',
						display: 'Calls answered',
					},
					{
						name: 'talktime_sum_hms',
						display: 'Total talk time',
					},
					{
						name: 'talktime_mean_hms',
						display: 'Average talk time',
					},
				],

				users: [
					{
						name: 'title',
						display: 'Title',
					},
					{
						name: 'forename',
						display: 'First name',
					},
					{
						name: 'surname',
						display: 'Last name',
					},
					{
						name: 'role_name',
						display: 'Role',
					},
					{
						name: 'email',
						display: 'Email',
					},
					{
						name: 'username',
						display: 'Web username',
					},
					{
						name: 'person_password',
						display: 'Web password',
					},
					{
						name: 'phone',
						display: 'Telephone line',
					},
					{
						name: 'hardware_address',
						display: 'Telephone MAC address',
					},
					{
						name: 'phone_password',
						display: 'Telephone password',
					},
					{
						name: 'cos_name',
						display: 'Class of service',
					},
					{
						name: 'recordgroup_name',
						display: 'Record group',
					},
					{
						name: 'use_huntgroup',
						display: 'Use hunt group',
					},
					{
						name: 'mailbox',
						display: 'Mailbox',
					},
					{
						name: 'mailbox_password',
						display: 'Mailbox PIN',
					},
					{
						name: 'number',
						display: 'Number',
					},
					{
						name: 'callerid_location',
						display: 'Location callerid',
					},
					{
						name: 'code',
						display: 'Feature code',
					},
					{
						name: 'mailbox_code',
						display: 'Mailbox feature code',
					},
					{
						name: 'pagegroup_code',
						display: 'Page group feature code',
					},
					{
						name: 'phone_utype',
						display: 'Unregistered type',
					},
					{
						name: 'phone_unumber',
						display: 'Unregistered destination',
					},
				],

				numbers: [
					{
						name: 'number',
						display: 'Number',
					},
					{
						name: 'description',
						display: 'Description',
					},
					{
						name: 'owner_display',
						display: 'Owner',
					},
					{
						name: 'display_directory',
						display: 'Directory',
					},
					{
						name: 'display_play_message',
						display: 'Announcement',
					},
					{
						name: 'display_screen',
						display: 'Screen',
					},
					{
						name: 'callerid',
						display: 'Force callerid',
					},
					{
						name: 'sname',
						display: 'Force name',
					},
					{
						name: 'maximum_minutes',
						display: 'Force hangup',
					},
					{
						name: 'routing_display',
						display: 'Temporary routing',
					},
					{
						name: 'dtype',
						display: 'Destination type',
					},
					{
						name: 'dnumber',
						display: 'Destination',
					},
					{
						name: 'dtype_display',
						display: 'Destination type name',
					},
					{
						name: 'dnumber_display',
						display: 'Destination name',
					},
				],

				pagegroup_destinations: [
					{
						name: 'dtype',
						display: 'Destination type',
					},
					{
						name: 'dnumber',
						display: 'Destination',
					},
				],

				patterns: [
					{
						name: 'description',
						display: 'Description',
					},
					{
						name: 'type',
						display: 'Type',
					},
					{
						name: 'snumber',
						display: 'Calling number',
					},
					{
						name: 'cnumber',
						display: 'Called number',
					},
					{
						name: 'digits',
						display: 'Digits entered',
					},
					{
						name: 'priority',
						display: 'Priority',
					},
					{
						name: 'dtype',
						display: 'Destination type',
					},
					{
						name: 'dnumber',
						display: 'Destination ID or number',
					},
				],

				queue_destinations: [
					{
						name: 'dtype',
						display: 'Destination type',
					},
					{
						name: 'dnumber',
						display: 'Destination',
					},
					{
						name: 'available_display',
						display: 'Available',
					},
					{
						name: 'priority',
						display: 'Priority',
					},
				],

				queue_destination_statistics: [
					{
						name: 'dtype',
						display: 'Type',
					},
					{
						name: 'dnumber',
						display: 'Number',
					},
					{
						name: 'dtype_display',
						display: 'Type name',
					},
					{
						name: 'dnumber_display',
						display: 'Number name',
					},
					{
						name: 'calls',
						display: 'Calls answered',
					},
					{
						name: 'talktime_sum_hms',
						display: 'Total talk time',
					},
					{
						name: 'talktime_mean_hms',
						display: 'Average talk time',
					},
				],

				queue_holding_all: [
					{
						name: 'queue',
						display: 'Queue',
					},
					{
						name: 'queue_name',
						display: 'Queue name',
					},
					{
						name: 'callerid_internal',
						display: 'Calling number',
					},
					{
						name: 'duration_hms',
						display: 'Hold time',
					},
				],

				queue_holding_queue: [
					{
						name: 'callerid_internal',
						display: 'Calling number',
					},
					{
						name: 'duration_hms',
						display: 'Hold time',
					},
				],

				missed_calls: [
					{
						name: 'time',
						display: 'Timestamp',
					},
					{
						name: 'calldate',
						display: 'Date',
					},
					{
						name: 'calltime',
						display: 'Time',
					},
					{
						name: 'callerid',
						display: 'Calling number',
					},
					{
						name: 'callername',
						display: 'Calling name',
					},
				],

				cards: [
					{
						name: 'card',
						display: 'Card',
					},
					{
						name: 'cardgroup',
						display: 'Card group',
					},
					{
						name: 'batch',
						display: 'Batch',
					},
					{
						name: 'serial',
						display: 'Serial',
					},
					{
						name: 'pin',
						display: 'PIN',
					},
					{
						name: 'caller',
						display: 'Callerid',
					},
					{
						name: 'locked',
						display: 'Locked',
					},
					{
						name: 'created',
						display: 'Created',
					},
					{
						name: 'created_date',
						display: 'Created date',
					},
					{
						name: 'created_time',
						display: 'Created time',
					},
					{
						name: 'firstuse',
						display: 'First use',
					},
					{
						name: 'firstuse_date',
						display: 'First use date',
					},
					{
						name: 'firstuse_time',
						display: 'First use time',
					},
					{
						name: 'lastcalled',
						display: 'Last called number',
					},
					{
						name: 'lastcalledtime',
						display: 'Last called',
					},
					{
						name: 'lastcalledtime_date',
						display: 'Last called date',
					},
					{
						name: 'lastcalledtime_time',
						display: 'Last called time',
					},
					{
						name: 'display_balance',
						display: 'Balance',
					},
				],

				card_usage: [
					{
						name: 'cardgroup',
						display: 'Card group ID',
					},
					{
						name: 'cardgroup_name',
						display: 'Card group name',
					},
					{
						name: 'batch',
						display: 'Batch ID',
					},
					{
						name: 'batch_name',
						display: 'Batch name',
					},
					{
						name: 'used',
						display: 'Cards used',
					},
					{
						name: 'unused',
						display: 'Card never used',
					},
					{
						name: 'total',
						display: 'Total cards',
					},
				],

				inbound_costs: [
					{
						name: 'ingroup_name',
						display: 'Group',
					},
					{
						name: 'ingroup_time_name',
						display: 'Time',
					},
					{
						name: 'start_date_time',
						display: 'Start',
					},
					{
						name: 'end_date_time',
						display: 'End',
					},
					{
						name: 'priority',
						display: 'Priority',
					},
					{
						name: 'connectfee',
						display: 'Connect fee',
					},
					{
						name: 'included',
						display: 'Included seconds',
					},
					{
						name: 'cost',
						display: 'Cost per minute',
					},
					{
						name: 'increment',
						display: 'Increment',
					},
					{
						name: 'minimum',
						display: 'Minimum cost',
					},
					{
						name: 'message',
						display: 'Message',
					},
				],

				inbound_costs_report: [
					{
						name: 'ingroup_name',
						display: 'Group',
					},
					{
						name: 'ingroup_time_name',
						display: 'Time',
					},
					{
						name: 'connectfee',
						display: 'Connect fee',
					},
					{
						name: 'included',
						display: 'Included seconds',
					},
					{
						name: 'cost',
						display: 'Cost per minute',
					},
					{
						name: 'increment',
						display: 'Increment',
					},
					{
						name: 'minimum',
						display: 'Minimum cost',
					},
				],

				inbound_groups: [
					{
						name: 'name',
						display: 'Inbound group',
					},
					{
						name: 'display_included',
						display: 'Counts towards included call time',
					},
				],

				outbound_costs: [
					{
						name: 'outgroup_name',
						display: 'Group',
					},
					{
						name: 'outgroup_time_name',
						display: 'Time',
					},
					{
						name: 'start_date_time',
						display: 'Start',
					},
					{
						name: 'end_date_time',
						display: 'End',
					},
					{
						name: 'priority',
						display: 'Priority',
					},
					{
						name: 'connectfee',
						display: 'Connect fee',
					},
					{
						name: 'included',
						display: 'Included seconds',
					},
					{
						name: 'cost',
						display: 'Cost per minute',
					},
					{
						name: 'increment',
						display: 'Increment',
					},
					{
						name: 'minimum',
						display: 'Minimum cost',
					},
					{
						name: 'message',
						display: 'Message',
					},
				],

				outbound_costs_report: [
					{
						name: 'outgroup_name',
						display: 'Group',
					},
					{
						name: 'outgroup_description',
						display: 'Group description',
						show_if: 'show_outgroup_description',
					},
					{
						name: 'name',
						display: 'Time',
					},
					{
						name: 'connectfee',
						display: 'Connect fee',
					},
					{
						name: 'included',
						display: 'Included seconds',
					},
					{
						name: 'cost',
						display: 'Cost per minute',
					},
					{
						name: 'increment',
						display: 'Increment',
					},
					{
						name: 'minimum',
						display: 'Minimum cost',
					},
					{
						name: 'message',
						display: 'Message',
					},
				],

				outbound_groups: [
					{
						name: 'name',
						display: 'Outbound group',
					},
					{
						name: 'display_included',
						display: 'Counts towards included call time',
					},
				],

				peer_costs: [
					{
						name: 'id',
						display: 'ID',
					},
					{
						name: 'description',
						display: 'Description',
					},
					{
						name: 'called_prefix',
						display: 'Called prefix',
					},
					{
						name: 'called_min',
						display: 'Called minimum',
					},
					{
						name: 'called_max',
						display: 'Called maximum',
					},
					{
						name: 'caller_prefix',
						display: 'Caller prefix',
					},
					{
						name: 'media',
						display: 'Media type',
					},
					{
						name: 'start_date_time',
						display: 'Start',
					},
					{
						name: 'end_date_time',
						display: 'End',
					},
					{
						name: 'days',
						display: 'Days',
					},
					{
						name: 'starthour',
						display: 'Start hour',
					},
					{
						name: 'startminute',
						display: 'Start minute',
					},
					{
						name: 'endhour',
						display: 'End hour',
					},
					{
						name: 'endminute',
						display: 'End minute',
					},
					{
						name: 'priority',
						display: 'Priority',
					},
					{
						name: 'connectfee',
						display: 'Connect fee',
					},
					{
						name: 'included',
						display: 'Included seconds',
					},
					{
						name: 'cost',
						display: 'Cost per minute',
					},
					{
						name: 'increment',
						display: 'Increment',
					},
					{
						name: 'minimum',
						display: 'Minimum cost',
					},
					{
						name: 'message',
						display: 'Message',
					},
				],

				routes: [
					{
						name: 'prefix',
						display: 'Prefix',
					},
					{
						name: 'media',
						display: 'Media type',
					},
					{
						name: 'description',
						display: 'Description',
					},
					{
						name: 'allow_display_csv',
						display: 'Allow',
					},
					{
						name: 'peer1_display',
						display: 'Peer',
					},
					{
						name: 'peer2_display',
						display: 'Backup peer',
					},
					{
						name: 'peer3_display',
						display: 'Second backup peer',
					},
				],

				vouchers: [
					{
						name: 'serial',
						display: 'Serial number',
					},
					{
						name: 'name',
						display: 'Batch name',
					},
					{
						name: 'batch',
						display: 'Batch number',
					},
					{
						name: 'display_status',
						display: 'Status',
					},
					{
						name: 'currency',
						display: 'Currency',
					},
					{
						name: 'display_value',
						display: 'Value',
					},
					{
						name: 'created',
						display: 'Created timestamp',
					},
					{
						name: 'created_date',
						display: 'Created date',
					},
					{
						name: 'created_time',
						display: 'Created time',
					},
					{
						name: 'used',
						display: 'Used timestamp',
					},
					{
						name: 'used_date',
						display: 'Used date',
					},
					{
						name: 'used_time',
						display: 'Used time',
					},
				],

				ingroup_numbers: [
					{
						name: 'snumber',
						display: 'Number',
					},
					{
						name: 'ingroup',
						display: 'Inbound group ID',
					},
					{
						name: 'ingroup_name',
						display: 'Inbound group name',
					},
					{
						name: 'customer',
						display: 'Customer ID',
					},
					{
						name: 'customer_name',
						display: 'Customer name',
					},
					{
						name: 'class',
						display: 'Class ID',
					},
					{
						name: 'class_name',
						display: 'Class name',
					},
					{
						name: 'region',
						display: 'Region ID',
					},
					{
						name: 'region_name',
						display: 'Region name',
					},
					{
						name: 'shortcut',
						display: 'Shortcut',
					},
					{
						name: 'alias',
						display: 'Alias',
					},
					{
						name: 'directory',
						display: 'Directory',
					},
				],

				sys_outbound_groups: [
					{
						name: 'outgroup_name',
						display: 'Group',
					},
					{
						name: 'outgroup_description',
						display: 'Group description',
					},
					{
						name: 'outgroup_name_invoices',
						display: 'Shown on invoices as',
					},
					{
						name: 'outgroup_tags',
						display: 'Tags',
					},
					{
						name: 'outgroup_included_display',
						display: 'Counts towards included minutes',
					},
					{
						name: 'name',
						display: 'Time',
					},
					{
						name: 'description',
						display: 'Time description',
					},
					{
						name: 'priority',
						display: 'Time priority',
					},
					{
						name: 'days',
						display: 'Time days',
					},
					{
						name: 'starthour',
						display: 'Time start hour',
					},
					{
						name: 'startminute',
						display: 'Time start minute',
					},
					{
						name: 'startsecond',
						display: 'Time start second',
					},
					{
						name: 'endhour',
						display: 'Time end hour',
					},
					{
						name: 'endminute',
						display: 'Time end minute',
					},
					{
						name: 'endsecond',
						display: 'Time end second',
					},
				],

				outroutes: [
					{
						name: 'called_prefix',
						display: 'Called prefix',
					},
					{
						name: 'called_min',
						display: 'Called minimum length',
					},
					{
						name: 'called_max',
						display: 'Called maximum length',
					},
					{
						name: 'caller_prefix',
						display: 'Callerid prefix',
					},
					{
						name: 'media',
						display: 'Media type',
					},
					{
						name: 'description',
						display: 'Description',
					},
					{
						name: 'outgroup_name',
						display: 'Group',
					},
					{
						name: 'allow_plan_peers_display',
						display: 'Allow override',
					},
					{
						name: 'peer1_name',
						display: 'Peer',
					},
					{
						name: 'peer2_name',
						display: 'Backup peer',
					},
					{
						name: 'peer3_name',
						display: 'Second backup peer',
					},
				],

				audit: [
					{
						name: 'date_display',
						display: 'Date',
					},
					{
						name: 'time_display',
						display: 'Time',
					},
					{
						name: 'customer_name',
						display: 'Customer',
						show_if: 'show_customer_names',
					},
					{
						name: 'person',
						display: 'Person',
					},
					//{name: 'source', display: 'Source'},
					{
						name: 'action',
						display: 'Action',
					},
					{
						name: 'object',
						display: 'Object',
					},
					{
						name: 'id',
						display: 'ID',
					},
					{
						name: 'name',
						display: 'Name',
					},
					{
						name: 'field',
						display: 'Field',
					},
					{
						name: 'old',
						display: 'Old value',
					},
					{
						name: 'new',
						display: 'New value',
					},
				],

				cdrs: [
					{
						name: 'status',
						display: 'Status',
					},
					{
						name: 'start',
						display: 'Start',
					},
					{
						name: 'start_date',
						display: 'Start date',
					},
					{
						name: 'start_time',
						display: 'Start time',
					},
					{
						name: 'end',
						display: 'End',
					},
					{
						name: 'end_date',
						display: 'End date',
					},
					{
						name: 'end_time',
						display: 'End time',
					},
					{
						name: 'scustomer',
						display: 'Calling customer',
					},
					{
						name: 'stype',
						display: 'Calling type',
					},
					{
						name: 'snumber_name',
						display: 'Calling number',
					},
					{
						name: 'ctype',
						display: 'Called type',
					},
					{
						name: 'cnumber_name',
						display: 'Called number',
					},
					{
						name: 'dcustomer',
						display: 'Destination customer',
					},
					{
						name: 'dtype',
						display: 'Destination type',
					},
					{
						name: 'dnumber_name',
						display: 'Destination number',
					},
					{
						name: 'callerid_internal',
						display: 'Internal callerid',
					},
					{
						name: 'callerid_external',
						display: 'External callerid',
					},
					{
						name: 'callername_internal',
						display: 'Internal caller name',
					},
					{
						name: 'callername_external',
						display: 'External caller name',
					},
					{
						name: 'outgroup',
						display: 'Destination group ID',
					},
					{
						name: 'outgroup_name',
						display: 'Destination group name',
					},
					{
						name: 'stype_in',
						display: 'Inbound calling type',
					},
					{
						name: 'snumber_in',
						display: 'Inbound calling number',
					},
					{
						name: 'ctype_in',
						display: 'Inbound called type',
					},
					{
						name: 'cnumber_in',
						display: 'Inbound called number',
					},
					{
						name: 'dtype_in',
						display: 'Inbound destination type',
					},
					{
						name: 'dnumber_in',
						display: 'Inbound destination number',
					},
					{
						name: 'stype_out',
						display: 'Outbound calling type',
					},
					{
						name: 'snumber_out',
						display: 'Outbound calling number',
					},
					{
						name: 'ctype_out',
						display: 'Outbound called type',
					},
					{
						name: 'cnumber_out',
						display: 'Outbound called number',
					},
					{
						name: 'dtype_out',
						display: 'Outbound destination type',
					},
					{
						name: 'dnumber_out',
						display: 'Outbound destination number',
					},
					{
						name: 'stype_user',
						display: 'Internal calling type',
					},
					{
						name: 'snumber_user',
						display: 'Internal calling number',
					},
					{
						name: 'ctype_user',
						display: 'Internal called type',
					},
					{
						name: 'cnumber_user',
						display: 'Internal called number',
					},
					{
						name: 'dtype_user',
						display: 'Internal destination type',
					},
					{
						name: 'dnumber_user',
						display: 'Internal destination number',
					},
					{
						name: 'totaltime',
						display: 'Total seconds',
					},
					{
						name: 'ringtime',
						display: 'Ring seconds',
					},
					{
						name: 'talktime',
						display: 'Billable seconds',
					},
					{
						name: 'cost_excluding_tax_export_display',
						display: 'Cost excluding taxes',
					},
					{
						name: 'cost_including_tax_export_display',
						display: 'Cost including taxes',
					},
					{
						name: 'customer',
						display: 'Billing customer',
					},
					{
						name: 'customer_name',
						display: 'Billing customer name',
					},
					{
						name: 'bill_type',
						display: 'Billing type',
					},
					{
						name: 'bill_ref',
						display: 'Billing reference',
					},
					{
						name: 'balance_display',
						display: 'New balance',
					},
					{
						name: 'peer',
						display: 'Peer',
						show_if: 'allow_system',
					},
					{
						name: 'peer name',
						display: 'Peer name',
						show_if: 'allow_system',
					},
					{
						name: 'channel',
						display: 'Channel',
						show_if: 'allow_system',
					},
					{
						name: 'machine',
						display: 'Machine',
						show_if: 'allow_system',
					},
					{
						name: 'uniqueid',
						display: 'Unique ID',
						show_if: 'allow_system',
					},
					{
						name: 'callid',
						display: 'Call ID',
						show_if: 'allow_system',
					},
				],

				cdrs_group: [
					{
						name: 'day',
						display: 'Day',
						show_if: 'is_day',
					},
					{
						name: 'month',
						display: 'Month',
						show_if: 'is_month',
					},
					{
						name: 'customer',
						display: 'Customer',
						show_if: 'is_customer',
					},
					{
						name: 'customer',
						display: 'Customer',
						show_if: 'is_customer_type',
					},
					{
						name: 'type',
						display: 'Type',
						show_if: 'is_customer_type',
					},
					{
						name: 'customer',
						display: 'Customer',
						show_if: 'is_customer_type_number',
					},
					{
						name: 'type',
						display: 'Type',
						show_if: 'is_customer_type_number',
					},
					{
						name: 'number',
						display: 'Number',
						show_if: 'is_customer_type_number',
					},
					{
						name: 'type',
						display: 'Type',
						show_if: 'is_type',
					},
					{
						name: 'type',
						display: 'Type',
						show_if: 'is_type_number',
					},
					{
						name: 'number',
						display: 'Number',
						show_if: 'is_type_number',
					},
					{
						name: 'ingroup',
						display: 'Inbound group',
						show_if: 'is_ingroup',
					},
					{
						name: 'outgroup',
						display: 'Outbound group',
						show_if: 'is_outgroup',
					},
					{
						name: 'peer',
						display: 'Peer',
						show_if: 'is_peer',
					},
					{
						name: 'count',
						display: 'Calls',
					},
					{
						name: 'sum_totaltime',
						display: 'Total duration',
					},
					{
						name: 'sum_talktime',
						display: 'Total billable time',
					},
					{
						name: 'percent_answered',
						display: 'Answered',
					},
					{
						name: 'cost_excluding_tax_export_display',
						display: 'Cost excluding taxes',
					},
					{
						name: 'cost_including_tax_export_display',
						display: 'Cost including taxes',
					},
				],

				people: [
					{
						name: 'username',
						display: 'Username',
					},
					{
						name: 'description',
						display: 'Description',
					},
					{
						name: 'customer_name',
						display: 'Customer',
					},
					{
						name: 'role_name',
						display: 'Role',
					},
					{
						name: 'locked_display',
						display: 'Locked',
					},
					{
						name: 'last_login_time',
						display: 'Last access',
					},
				],

				people_export: [
					{
						name: 'username',
						display: 'Username',
					},
					{
						name: 'password',
						display: 'Password',
					},
					{
						name: 'description',
						display: 'Description',
					},
					{
						name: 'role',
						display: 'Role',
					},
					{
						name: 'title',
						display: 'Title',
					},
					{
						name: 'forename',
						display: 'Forename',
					},
					{
						name: 'surname',
						display: 'Surname',
					},
					{
						name: 'company',
						display: 'Company',
					},
					{
						name: 'email',
						display: 'email',
					},
					{
						name: 'telephone',
						display: 'Telephone',
					},
					{
						name: 'extension',
						display: 'Extension',
					},
					{
						name: 'mobile',
						display: 'Mobile',
					},
					{
						name: 'fax',
						display: 'Fax',
					},
					{
						name: 'address1',
						display: 'Address 1',
					},
					{
						name: 'address2',
						display: 'Address 2',
					},
					{
						name: 'address3',
						display: 'Address 3',
					},
					{
						name: 'address_city',
						display: 'City',
					},
					{
						name: 'address_state',
						display: 'State',
					},
					{
						name: 'address_code',
						display: 'Code',
					},
					{
						name: 'country',
						display: 'Country',
					},
					{
						name: 'address_other',
						display: 'Address other',
					},
					{
						name: 'language',
						display: 'Language',
					},
					{
						name: 'timezone',
						display: 'Timezone',
					},
					{
						name: 'dialplan',
						display: 'Dialplan',
					},
					{
						name: 'date_format',
						display: 'Date format',
					},
					{
						name: 'time_format',
						display: 'Time format',
					},
					{
						name: 'digit_name',
						display: 'Dial by name order',
					},
					{
						name: 'source',
						display: 'Only allow web access from IP address(es)',
					},
				],

				telephones: [
					{
						name: 'name',
						display: 'Name',
					},
					{
						name: 'description',
						display: 'Description',
					},
					{
						name: 'user_agent',
						display: 'Model',
					},
					{
						name: 'received_address_port',
						display: 'Registered from',
					},
					{
						name: 'contact_address',
						display: 'Internal IP address',
					},
					{
						name: 'updated_date_time',
						display: 'Last registration',
					},
					{
						name: 'interlocutor',
						display: 'Call',
					},
				],

				transactions: [
					{
						name: 'id',
						display: 'ID',
					},
					{
						name: 'display_date',
						display: 'Date',
					},
					{
						name: 'display_time',
						display: 'Time',
					},
					{
						name: 'customer',
						display: 'Customer',
					},
					{
						name: 'customer_name_csv',
						display: 'Customer name',
					},
					{
						name: 'currency',
						display: 'Currency',
					},
					{
						name: 'display_amount_excluding_tax',
						display: 'Amount excluding taxes',
					},
					{
						name: 'display_amount_including_tax',
						display: 'Amount including taxes',
					},
					{
						name: 'type',
						display: 'Type',
					},
					{
						name: 'description',
						display: 'Description',
					},
					{
						name: 'person',
						display: 'Person',
					},
					{
						name: 'source',
						display: 'Source',
					},
					{
						name: 'reference',
						display: 'Reference',
					},
					{
						name: 'display_balance',
						display: 'New balance (zero if unknown)',
					},
				],
			},

			features: [
				'accessmenu',
				'attendant',
				'attendant_noannounce',
				'back',
				'busy',
				'cancelforward',
				'conferencelogin',
				'congestion',
				'cardlogin',
				'dial_by_name',
				'dndtoggle',
				'dndtoggle_noanswer',
				'dtmf',
				'echo',
				'hangup',
				'hear_last_caller',
				'huntgroups_login',
				'huntgroups_logout',
				'huntgroups_toggle',
				'music',
				'numbermenu',
				'phonelogin',
				'phonemenu',
				'play_balance',
				'queues_login',
				'queues_logout',
				'queues_toggle',
				'rdnis_mailbox',
				'record_sound',
				'redial',
				'redirect_message',
				'return',
				'voicemail',
				'voicemaillogin',
				'voicemailpin',
				'vouchertopup',
			],

			features_ivr: ['ignore', 'ivrsetup', 'replaymenu'],

			features_code: ['holding', 'park', 'parking'],

			mailbox_greetings: ['unavail', 'busy', 'temp', 'greet'],

			countries: [
				'AD',
				'AE',
				'AF',
				'AG',
				'AI',
				'AL',
				'AM',
				'AN',
				'AO',
				'AR',
				'AS',
				'AT',
				'AU',
				'AW',
				'AZ',
				'BA',
				'BB',
				'BD',
				'BE',
				'BF',
				'BG',
				'BH',
				'BI',
				'BJ',
				'BL',
				'BM',
				'BN',
				'BO',
				'BR',
				'BS',
				'BT',
				'BW',
				'BY',
				'BZ',
				'CA',
				'CC',
				'CD',
				'CF',
				'CG',
				'CH',
				'CI',
				'CK',
				'CL',
				'CM',
				'CN',
				'CO',
				'CR',
				'CU',
				'CV',
				'CW',
				'CX',
				'CY',
				'CZ',
				'DE',
				'DJ',
				'DK',
				'DM',
				'DO',
				'DZ',
				'EC',
				'EE',
				'EG',
				'EH',
				'ER',
				'ES',
				'ET',
				'FI',
				'FJ',
				'FK',
				'FM',
				'FO',
				'FR',
				'GA',
				'GD',
				'GE',
				'GG',
				'GH',
				'GI',
				'GL',
				'GM',
				'GN',
				'GQ',
				'GR',
				'GT',
				'GU',
				'GW',
				'GY',
				'HK',
				'HN',
				'HR',
				'HT',
				'HU',
				'ID',
				'IE',
				'IL',
				'IM',
				'IN',
				'IO',
				'IQ',
				'IR',
				'IS',
				'IT',
				'JE',
				'JM',
				'JO',
				'JP',
				'KE',
				'KG',
				'KH',
				'KI',
				'KM',
				'KN',
				'KP',
				'KR',
				'KW',
				'KY',
				'KZ',
				'LA',
				'LB',
				'LC',
				'LI',
				'LK',
				'LR',
				'LS',
				'LT',
				'LU',
				'LV',
				'LY',
				'MA',
				'MC',
				'MD',
				'ME',
				'MF',
				'MG',
				'MH',
				'MK',
				'ML',
				'MM',
				'MN',
				'MO',
				'MP',
				'MR',
				'MS',
				'MT',
				'MU',
				'MV',
				'MW',
				'MX',
				'MY',
				'MZ',
				'NA',
				'NC',
				'NE',
				'NG',
				'NI',
				'NL',
				'NO',
				'NP',
				'NR',
				'NU',
				'NZ',
				'OM',
				'PA',
				'PE',
				'PF',
				'PG',
				'PH',
				'PK',
				'PL',
				'PM',
				'PN',
				'PR',
				'PS',
				'PT',
				'PW',
				'PY',
				'QA',
				'RE',
				'RO',
				'RS',
				'RU',
				'RW',
				'SA',
				'SB',
				'SC',
				'SD',
				'SE',
				'SG',
				'SH',
				'SI',
				'SJ',
				'SK',
				'SL',
				'SM',
				'SN',
				'SO',
				'SR',
				'SS',
				'ST',
				'SV',
				'SX',
				'SY',
				'SZ',
				'TC',
				'TD',
				'TG',
				'TH',
				'TJ',
				'TK',
				'TL',
				'TM',
				'TN',
				'TO',
				'TR',
				'TT',
				'TV',
				'TW',
				'TZ',
				'UA',
				'UG',
				'UK',
				'US',
				'UY',
				'UZ',
				'VA',
				'VC',
				'VE',
				'VG',
				'VI',
				'VN',
				'VU',
				'WF',
				'WS',
				'XK',
				'YE',
				'YT',
				'ZA',
				'ZM',
				'ZW',
			],

			dialplans: [
				'ar',
				'at',
				'au',
				'bd',
				'be',
				'bg',
				'bh',
				'br',
				'ca',
				'ch',
				'cn',
				'co',
				'cv',
				'cy',
				'cz',
				'de',
				'dk',
				'e164',
				'e164plus',
				'ee',
				'es',
				'fi',
				'fr',
				'gr',
				'hk',
				'hr',
				'id',
				'ie',
				'il',
				'in',
				'it',
				'jp',
				'lk',
				'ls',
				'lu',
				'md',
				'me',
				'mo',
				'mx',
				'my',
				'na',
				'nanp',
				'nl',
				'no',
				'nz',
				'pg',
				'pk',
				'pl',
				'pt',
				'ro',
				'rs',
				'se',
				'sg',
				'sk',
				'th',
				'tp',
				'tr',
				'uk',
				'us',
				'vn',
				'ye',
				'za',
				'zerozero',
			],

			speeddial_types: [
				'blf',
				'blfxfer',
				'callers',
				'directory',
				'icom',
				'line',
				'services',
				'speeddial',
				'speeddialxfer',
			],

			codecs: ['alaw', 'ulaw', 'gsm', 'g722', 'g726', 'g729', 'ilbc', 'lpc10', 'speex', 'slin'],

			provision_models: [
				'aastra',
				'android',
				'cisco_79xx',
				'cisco_spa',
				'custom_http',
				'custom_tftp',
				'digium',
				'grandstream',
				'grandstream_ht502',
				'grandstream_ht503',
				'htek',
				'mitel',
				'snom',
				'snom_190',
				'snom_300',
				'snom_320',
				'snom_360',
				'snom_370',
				'snom_820',
				'snom_870',
				'snom_m3',
				'spa',
				'polycom_http',
				'polycom_tftp',
				'yealink',
				'yealink_t12p',
				'yealink_t18p',
				'yealink_t20p',
				'yealink_t22p',
				'yealink_t26p',
				'yealink_t28p',
				'yealink_t41p',
				'yealink_t42g',
				'yealink_t46g',
				'yealink_w52p',
			],

			bill_types: {
				callshop: 'bill_type_callshop',
				external: 'bill_type_external',
				none: 'bill_type_none',
				postpaid: 'bill_type_postpaid',
				prepaid: 'bill_type_prepaid',
				prepaid_calls: 'bill_type_prepaid_calls',
				prepaid_invoices: 'bill_type_prepaid_invoices',
			},

			invoices_due: [-1, 0, 7, 10, 14, 15, 20, 25, 28, 30, 60, 90, 180, 365],

			increments: [1, 6, 12, 18, 30, 60, 90, 120, 180, 240],

			timezones: [
				'',
				'Pacific/Auckland',
				'Pacific/Norfolk',
				'Australia/Sydney',
				'Australia/Brisbane',
				'Australia/Adelaide',
				'Australia/Darwin',
				'Japan',
				'Australia/Perth',
				'Asia/Shanghai',
				'Asia/Singapore',
				'Asia/Bangkok',
				'Asia/Katmandu',
				'Asia/Calcutta',
				'Asia/Karachi',
				'Asia/Dubai',
				'Europe/Moscow',
				'Asia/Riyadh',
				'Israel',
				'EET',
				'Africa/Johannesburg',
				'CET',
				'Africa/Algiers',
				'Europe/London',
				'Africa/Dakar',
				'UTC',
				'America/Sao_Paulo',
				'America/Buenos_Aires',
				'Canada/Newfoundland',
				'Canada/Atlantic',
				'America/Santiago',
				'America/Caracas',
				'EST5EDT',
				'EST',
				'America/Lima',
				'CST6CDT',
				'America/Panama',
				'America/Mexico_City',
				'MST7MDT',
				'MST',
				'America/Mazatlan',
				'America/Tijuana',
				'PST8PDT',
				'US/Alaska',
				'US/Hawaii',
			],

			date_formats: ['YYYY-MM-DD', 'DD/MM/YYYY', 'MM/DD/YYYY'],

			time_formats: ['12', '24'],

			plan_features_boolean: [
				'acr',
				'actions',
				'add_user',
				'aoc',
				'callback',
				'calls',
				'callshop_phones',
				'callshops',
				'commerce_settings',
				'customer_settings',
				'dnd',
				'events_url',
				'faxboxes',
				'faxtoemails',
				'features',
				'free_internal_calls',
				'import_features',
				'messages',
				'no_number_signup',
				'numbers_signup',
				'original_callerid',
				'payment_settings',
				'peers',
				'phone_delivery',
				'phone_passwords',
				'port_numbers_in',
				'provision',
				'provision_speeddials',
				'purchase',
				'queue_events',
				'reports',
				'send_emails',
				'send_faxes',
				'set_currency',
				'set_overmax',
				'signup',
				'sipuris',
				'speeddials',
				'texts',
				'tickets',
				'view',
				'view_active',
				'view_cdrs',
				'view_invoices',
				'view_transactions',
				'virtual_phones',
			],

			plan_features_integer: [
				'access',
				'addresses',
				'alerts',
				'bulk_campaigns',
				'cardgroups',
				'codes',
				'conferences',
				'cos',
				'customers',
				'huntgroups',
				'ivrs',
				'mailboxes',
				'music',
				'numbers',
				'pagegroups',
				'patternmenus',
				'people',
				'pickupgroups',
				'phones',
				'plans',
				'prefixes',
				'products',
				'provisioning',
				'queues',
				'recordgroups',
				'sounds',
				'timegroups',
				'urls',
				'unlimited_access',
				'vouchers',
			],

			plan_features_forbidden_by_default: [
				'aoc',
				'events_url',
				'free_internal_calls',
				'music',
				'no_number_signup',
				'original_callerid',
				'peers',
				'port_numbers_in',
				'queue_events',
				'set_currency',
				'set_overmax',
				'signup',
			],

			plan_features_included: {
				access: 'access',
				address: 'addresses',
				alert: 'alerts',
				bulk_campaign: 'bulk_campaigns',
				conference: 'conferences',
				cos: 'cos',
				code: 'codes',
				huntgroup: 'huntgroups',
				ivr: 'ivrs',
				mailbox: 'mailboxes',
				music: 'music',
				pagegroup: 'pagegroups',
				patternmenu: 'patternmenus',
				person: 'people',
				phone: 'phones',
				pickupgroup: 'pickupgroups',
				prefix: 'prefixes',
				provisioning: 'provisioning',
				queue: 'queues',
				sound: 'sounds',
				timegroup: 'timegroups',
				url: 'urls',
			},

			plan_fees: [
				{
					feature: 'account',
					occurs: 'create',
				},
				{
					feature: 'account',
					occurs: 'period',
				},
				{
					feature: 'address',
					occurs: 'create',
				},
				{
					feature: 'address',
					occurs: 'period',
				},
				{
					feature: 'alert',
					occurs: 'create',
				},
				{
					feature: 'alert',
					occurs: 'period',
				},
				{
					feature: 'bulk',
					occurs: 'connectfee',
				},
				{
					feature: 'bulk',
					occurs: 'cost',
				},
				{
					feature: 'bulk_campaign',
					occurs: 'create',
				},
				{
					feature: 'bulk_campaign',
					occurs: 'period',
				},
				{
					feature: 'cos',
					occurs: 'create',
				},
				{
					feature: 'cos',
					occurs: 'period',
				},
				{
					feature: 'conference',
					occurs: 'create',
				},
				{
					feature: 'conference',
					occurs: 'period',
				},
				{
					feature: 'code',
					occurs: 'create',
				},
				{
					feature: 'code',
					occurs: 'period',
				},
				{
					feature: 'huntgroup',
					occurs: 'create',
				},
				{
					feature: 'huntgroup',
					occurs: 'period',
				},
				{
					feature: 'invoice_minimum',
					occurs: 'period',
				},
				{
					feature: 'ivr',
					occurs: 'create',
				},
				{
					feature: 'ivr',
					occurs: 'period',
				},
				{
					feature: 'mailbox',
					occurs: 'create',
				},
				{
					feature: 'mailbox',
					occurs: 'period',
				},
				{
					feature: 'music',
					occurs: 'create',
				},
				{
					feature: 'music',
					occurs: 'period',
				},
				{
					feature: 'number_emergency_register',
					occurs: 'period',
				},
				{
					feature: 'pagegroup',
					occurs: 'create',
				},
				{
					feature: 'pagegroup',
					occurs: 'period',
				},
				{
					feature: 'patternmenu',
					occurs: 'create',
				},
				{
					feature: 'patternmenu',
					occurs: 'period',
				},
				{
					feature: 'person',
					occurs: 'create',
				},
				{
					feature: 'person',
					occurs: 'period',
				},
				{
					feature: 'pickupgroup',
					occurs: 'create',
				},
				{
					feature: 'pickupgroup',
					occurs: 'period',
				},
				{
					feature: 'queue',
					occurs: 'create',
				},
				{
					feature: 'queue',
					occurs: 'period',
				},
				{
					feature: 'access',
					occurs: 'create',
				},
				{
					feature: 'access',
					occurs: 'period',
				},
				{
					feature: 'overmax',
					occurs: 'connectfee',
				},
				{
					feature: 'overmax',
					occurs: 'cost',
				},
				{
					feature: 'phone',
					occurs: 'create',
				},
				{
					feature: 'phone',
					occurs: 'period',
				},
				{
					feature: 'prefix',
					occurs: 'create',
				},
				{
					feature: 'prefix',
					occurs: 'period',
				},
				{
					feature: 'provisioning',
					occurs: 'create',
				},
				{
					feature: 'provisioning',
					occurs: 'period',
				},
				{
					feature: 'record',
					occurs: 'record',
				},
				{
					feature: 'record_storage',
					occurs: 'period',
				},
				{
					feature: 'sound',
					occurs: 'create',
				},
				{
					feature: 'sound',
					occurs: 'period',
				},
				{
					feature: 'timegroup',
					occurs: 'create',
				},
				{
					feature: 'timegroup',
					occurs: 'period',
				},
				{
					feature: 'url',
					occurs: 'create',
				},
				{
					feature: 'url',
					occurs: 'period',
				},
			],

			role_defaults: {
				user: '1',
				admin: '0',
				callshop: '0',
				residential: '0',
				wholesale: '0',
				panel: '0',
				actions: '1',
				actions_phones: '0',
				archive: '0',
				calls: '1',
				purchase: '0',
				send_emails: '0',
				send_fax: '1',
				send_message: '1',
				messages: '1',
				texts: '1',
				features: '1',
				add_user: '0',
				addresses: '0',
				alerts: '0',
				bulk: '1',
				record: '0',
				cos: '0',
				conferences: '1',
				conference_maximum: '1',
				codes: '1',
				prefixes: '0',
				huntgroups: '1',
				import_features: '0',
				ivrs: '0',
				mailboxes: '0',
				music: '0',
				numbers: '1',
				people: '1',
				pagegroups: '0',
				patternmenus: '1',
				pickupgroups: '1',
				queues: '1',
				access: '0',
				sounds: '0',
				speeddials: '0',
				phones: '1',
				phone_cos: '1',
				phone_dialplan: '1',
				phone_password: '1',
				phone_plan: '1',
				times: '0',
				settings: '0',
				commerce_settings: '0',
				customer_settings: '0',
				payment: '0',
				commerce: '0',
				cards: '0',
				callshop_phones: '0',
				customers: '0',
				files: '0',
				help: '1',
				products: '0',
				plans: '0',
				provisioning: '0',
				requests: '0',
				search: '0',
				taxes: '0',
				unlimited: '0',
				vouchers: '0',
				system: '0',
				config: '0',
				fields: '0',
				domains: '0',
				ingroups: '0',
				machines: '0',
				menus: '0',
				classes: '0',
				outgroups: '0',
				peers: '0',
				plugins: '0',
				roles: '0',
				outroutes: '0',
				regions: '0',
				reports: '0',
				active: '0',
				audit: '0',
				cdrs: '0',
				commerce_reports: '0',
				customer_reports: '0',
				invoices: '0',
				statistics: '0',
				people_reports: '0',
				phone_reports: '0',
				top_lists: '0',
				transaction_reports: '0',
				urls: '0',
				view: '0',
				default_user: '0',
				default_residential: '0',
				default_pseudo: '0',
				import: '0',
				export: '0',
				view_access_pins: '0',
				view_code_pins: '0',
				view_ivr_pins: '0',
				view_mailbox_pins: '0',
				view_number_pins: '0',
				view_person_passwords: '0',
				view_phone_passwords: '0',
			},

			role_readwrites: ['cards', 'conference_maximum', 'panel', 'phone_cos', 'phone_dialplan', 'phone_plan', 'record'],

			group_types: [
				'day',
				'month',
				'customer',
				'customer_type',
				'customer_type_number',
				'type',
				'type_number',
				'ingroup',
				'outgroup',
				'peer',
			],

			check_patterns: {
				address: /^[^\\<>&|`$\n]{0,255}$/,
				address_req: /^[^\\<>&|`$\n]{1,255}$/,
				address_user_req: /^[A-Za-z][\w\-\.]{0,99}$/,
				boolean: /^(0|1)$/,
				callerid: /^[\d\*#]{0,100}$/,
				callerid_internal: /^([\d*#]{0,100}|default|original|original_own_number)$/,
				callerid_external: /^([\d*#]{0,100}|default|original|original_own_number)$/,
				callid: /^[\w\.\-\@\:]{0,100}$/,
				callid_req: /^[\w\.\-\@\:]{1,100}$/,
				cardgroup_greeting: /^(destination|connecting|dest-invalid|in-use|locked|expired|no-credit|no-permission-to-dial-number|balance|goodbye)$/,
				constant: /^\w{0,100}$/,
				constant_req: /^\w{1,100}$/,
				context: /^[\w\.\-]{0,100}$/,
				context_req: /^[\w\.\-]{1,100}$/,
				cos_allow: /^(0|1|2|3)$/,
				country_code: /^(\w\w)?$/,
				country_code_req: /^\w\w$/,
				creditcard_issue: /^\d{0,4}$/,
				creditcard_month: /^(([1-9]|1[0-2])|0)$/,
				creditcard_name: /^[\w\. ]{0,100}$/,
				creditcard_name_req: /^[\w\. ]{1,100}$/,
				creditcard_number: /^(\d{15,18}|)$/,
				creditcard_number_req: /^\d{15,18}$/,
				creditcard_type: /^[\w\. \/]{0,100}$/,
				creditcard_type_req: /^[\w\. \/]{1,100}$/,
				creditcard_verification: /^(\d{3,4})?$/,
				creditcard_year: /^(\d{4}|0)$/,
				custom: /^[^\n]{0,255}$/,
				custom_model_http_req: /^custom_\w{1,93}$/,
				custom_model_tftp_req: /^[\w\.\-]*MAC[\w\.\-]*$/,
				day: /^(\d|[12]\d|3[01])$/,
				description: /^[^\n]{0,255}$/,
				dnumber: /^\+?[\w\-\.\@\:*#, \/]{0,255}$/,
				dnumber_auto: /^\+?[\w\-\.\@\:*#, \/\(\)\.]{0,255}$/,
				dnumber_external: /^[\d\*#xw]{0,255}$/,
				dnumber_external_req: /^[\d\*#xw]{1,255}$/,
				dnumber_req: /^\+?[\w\-\.\@\:*#, \/\(\)]{1,255}$/,
				domain: /^[\w\.\-]{0,100}$/,
				domain_req: /^[\w\.\:\-]{1,100}$/,
				dtmf: /^[0-9a-d\*\#]{0,100}$/,
				dtype: /^\w{0,100}$/,
				dtype_req: /^\w{1,100}$/,
				email: /^[^\\|`\s\,\n$]{0,100}$/,
				email_req: /^[^\\|`\s\,\n$]{1,100}$/,
				emails: /^[^\\|`\n$]{0,255}$/,
				emails_req: /^[^\\|`\n$]{1,255}$/,
				fax_header: /^(customer_name|blank)$/,
				folder_req: /^[\w]{1,100}$/,
				hardware_addresses: /^[\w\.\-\:, ]{0,255}$/,
				hhmm: /^[012]\d:[0-5]\d$/,
				hour: /^(\d|1\d|2[0-3])$/,
				ip_address: /^(\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}|[A-Za-z\d\:]{0,39})$/,
				ip_address_range: /^(\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}|[A-Za-z\d\:]{0,39})(\/\d{1,2})?$/,
				ip_address_req: /^(\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}|[A-Za-z\d\:]{1,39})$/,
				key: /^[\w\s\n-.:\(\)+\/=]{0,32000}$/,
				language: /^\w{0,100}$/,
				limit: /^(-1|\d{1,10})$/,
				line: /^[^\\`\n]{0,255}$/,
				line_req: /^[^\\`\n]{1,255}$/,
				line_short: /^[^\\`\n]{0,100}$/,
				line_short_req: /^[^\\`\n]{1,100}$/,
				mailbox: /^(|\d{2,70})$/,
				mailbox_req: /^\d{2,70}$/,
				mailbox_password: /^\d{0,100}$/,
				markup: /^-?\d{1,8}$/,
				minute: /^[0-5]?\d$/,
				money: /^-?\d{1,14}(\.\d{1,20})?$/,
				money_positive: /^\d{1,14}(\.\d{1,6})?$/,
				month: /^(0?\d|10|11|12)$/,
				name: /^[^\\<>|`\n]{0,100}$/,
				name_req: /^[^\\|`\n]{1,100}$/,
				natural: /^[1-9]\d{0,19}$/,
				number_callerid: /^([\d\*\#]{0,100}|ask|ask_prepend_original|ask_append_original)$/,
				number_req: /^\-?\d{1,10}$/,
				number_password: /^\d{0,100}$/,
				options: /^[\w\(\)]{1,100}$/,
				offset: /^\d{1,10}$/,
				password: /^[^\\<>&|`\n$]{0,100}$/,
				password_req: /^[^\\<>&|`\n$]{1,100}$/,
				patternmenu_greeting: /^(digits|invalid|goodbye)$/,
				phone_req: /^\+?\d{1,70}$/,
				pin: /^\d{0,100}$/,
				pin_req: /^\d{1,100}$/,
				positive: /^\d{1,20}$/,
				presentation: /^(1|32)$/,
				regexp: /^[^\n]{0,100}$/,
				screen: /^(\-1|0|1|2|3|4)$/,
				second: /^[0-5]?\d$/,
				server: /^[A-Za-z0-9\-]{0,100}$/,
				server_req: /^[A-Za-z0-9][A-Za-z0-9-]{0,99}$/,
				sip_domain: /^[\w\.\-\:]{0,100}$/,
				sipuri_req: /^[\w\:\@\.\-]{1,100}/,
				snumber: /^[\d\*#]{0,100}$/,
				snumber_req: /^[\d\*#]{1,100}$/,
				sound_format_req: /^(gsm|wav)$/,
				stype: /^(number|code)$/,
				tag: /^\w{0,255}$/,
				tags: /^[\w ,]{0,255}$/,
				telephone: /^[\d\+\(\)\-\s]{0,100}$/,
				telephone_req: /^[\d\+\(\)\-\s]{1,100}$/,
				text: /^[^`]*$/,
				text_req: /^[^`]+$/,
				timestamp: /^\d{1,20}$/,
				title: /^[^\n]{0,100}$/,
				uniqueid: /^[\w\.\-]{0,100}$/,
				uniqueid_req: /^[\w\.\-]{1,100}$/,
				unlimited_access_greeting: /^(welcome|destination|connecting|invalid|timeout)$/,
				url: /^[\w\:\/\-\%\@\.\+\?\&\;\=\<\>\s]{0,255}$/,
				url_req: /^[\w\:\/\-\%\@\.\+\?\&\;\=\<\>\s]{1,255}$/,
				year: /^20\d{2}$/,
			},

			ringtones: [
				'auto-callback',
				'call-waiting',
				'delayed',
				'external',
				'forward',
				'hold-recall',
				'internal',
				'normal',
				'priority',
				'short',
				'transfer-recall',
			],

			custom_field_objects: ['customer', 'phone'],
			custom_field_types: ['allowed', 'boolean', 'text'],

			dashboard_roles: ['user', 'callshop', 'admin', 'cdrs', 'commerce', 'messages', 'texts'],
		});
})(window.angular);

(function(e,t,undefined){function a(t){var a=e(t.table),i=a.data();this.pageNavigation=i.pageNavigation||t.options.pageNavigation,this.pageSize=i.pageSize||t.options.pageSize,this.firstText=i.firstText||t.options.firstText,this.previousText=i.previousText||t.options.previousText,this.nextText=i.nextText||t.options.nextText,this.lastText=i.lastText||t.options.lastText,this.limitNavigation=parseInt(i.limitNavigation||t.options.limitNavigation||o.limitNavigation,10),this.limitPreviousText=i.limitPreviousText||t.options.limitPreviousText,this.limitNextText=i.limitNextText||t.options.limitNextText,this.limit=this.limitNavigation>0,this.currentPage=i.currentPage||0,this.pages=[],this.control=!1}function i(){var t=this;t.name="Footable Paginate",t.init=function(a){if(a.options.paginate===!0){if(e(a.table).data("page")===!1)return;t.footable=a,e(a.table).unbind(".paging").bind({"footable_initialized.paging footable_row_removed.paging footable_redrawn.paging footable_sorted.paging footable_filtered.paging":function(){t.setupPaging()}}).data("footable-paging",t)}},t.setupPaging=function(){var i=t.footable,o=e(i.table).find("> tbody");i.pageInfo=new a(i),t.createPages(i,o),t.createNavigation(i,o),t.fillPage(i,o,i.pageInfo.currentPage)},t.createPages=function(t,a){var i=1,o=t.pageInfo,n=i*o.pageSize,r=[],l=[];o.pages=[];var d=a.find("> tr:not(.footable-filtered,.footable-row-detail)");d.each(function(e,t){r.push(t),e===n-1?(o.pages.push(r),i++,n=i*o.pageSize,r=[]):e>=d.length-d.length%o.pageSize&&l.push(t)}),l.length>0&&o.pages.push(l),o.currentPage>=o.pages.length&&(o.currentPage=o.pages.length-1),0>o.currentPage&&(o.currentPage=0),1===o.pages.length?e(t.table).addClass("no-paging"):e(t.table).removeClass("no-paging")},t.createNavigation=function(a){var i=e(a.table).find(a.pageInfo.pageNavigation);if(0===i.length){if(i=e(a.pageInfo.pageNavigation),i.parents("table:first").length>0&&i.parents("table:first")!==e(a.table))return;i.length>1&&a.options.debug===!0&&console.error("More than one pagination control was found!")}if(0!==i.length){i.is("ul")||(0===i.find("ul:first").length&&i.append("<ul />"),i=i.find("ul")),i.find("li").remove();var o=a.pageInfo;o.control=i,o.pages.length>0&&(i.append('<li class="footable-page-arrow"><a data-page="first" href="#first">'+a.pageInfo.firstText+"</a>"),i.append('<li class="footable-page-arrow"><a data-page="prev" href="#prev">'+a.pageInfo.previousText+"</a></li>"),o.limit&&i.append('<li class="footable-page-arrow"><a data-page="limit-prev" href="#limit-prev">'+a.pageInfo.limitPreviousText+"</a></li>"),o.limit||e.each(o.pages,function(e,t){t.length>0&&i.append('<li class="footable-page"><a data-page="'+e+'" href="#">'+(e+1)+"</a></li>")}),o.limit&&(i.append('<li class="footable-page-arrow"><a data-page="limit-next" href="#limit-next">'+a.pageInfo.limitNextText+"</a></li>"),t.createLimited(i,o,0)),i.append('<li class="footable-page-arrow"><a data-page="next" href="#next">'+a.pageInfo.nextText+"</a></li>"),i.append('<li class="footable-page-arrow"><a data-page="last" href="#last">'+a.pageInfo.lastText+"</a></li>")),i.off("click","a[data-page]").on("click","a[data-page]",function(n){n.preventDefault();var r=e(this).data("page"),l=o.currentPage;if("first"===r)l=0;else if("prev"===r)l>0&&l--;else if("next"===r)o.pages.length-1>l&&l++;else if("last"===r)l=o.pages.length-1;else if("limit-prev"===r){l=-1;var d=i.find(".footable-page:first a").data("page");t.createLimited(i,o,d-o.limitNavigation),t.setPagingClasses(i,o.currentPage,o.pages.length)}else if("limit-next"===r){l=-1;var s=i.find(".footable-page:last a").data("page");t.createLimited(i,o,s+1),t.setPagingClasses(i,o.currentPage,o.pages.length)}else l=r;if(l>=0){if(o.limit&&o.currentPage!=l){for(var f=l;0!==f%o.limitNavigation;)f-=1;t.createLimited(i,o,f)}t.paginate(a,l)}}),t.setPagingClasses(i,o.currentPage,o.pages.length)}},t.createLimited=function(e,t,a){a=a||0,e.find("li.footable-page").remove();var i,o,n=e.find('li.footable-page-arrow > a[data-page="limit-prev"]').parent(),r=e.find('li.footable-page-arrow > a[data-page="limit-next"]').parent();for(i=t.pages.length-1;i>=0;i--)o=t.pages[i],i>=a&&a+t.limitNavigation>i&&o.length>0&&n.after('<li class="footable-page"><a data-page="'+i+'" href="#">'+(i+1)+"</a></li>");0===a?n.hide():n.show(),a+t.limitNavigation>=t.pages.length?r.hide():r.show()},t.paginate=function(a,i){var o=a.pageInfo;if(o.currentPage!==i){var n=e(a.table).find("> tbody"),r=a.raise("footable_paging",{page:i,size:o.pageSize});if(r&&r.result===!1)return;t.fillPage(a,n,i),o.control.find("li").removeClass("active disabled"),t.setPagingClasses(o.control,o.currentPage,o.pages.length)}},t.setPagingClasses=function(e,t,a){e.find("li.footable-page > a[data-page="+t+"]").parent().addClass("active"),t>=a-1&&(e.find('li.footable-page-arrow > a[data-page="next"]').parent().addClass("disabled"),e.find('li.footable-page-arrow > a[data-page="last"]').parent().addClass("disabled")),1>t&&(e.find('li.footable-page-arrow > a[data-page="first"]').parent().addClass("disabled"),e.find('li.footable-page-arrow > a[data-page="prev"]').parent().addClass("disabled"))},t.fillPage=function(a,i,o){a.pageInfo.currentPage=o,e(a.table).data("currentPage",o),i.find("> tr").hide(),e(a.pageInfo.pages[o]).each(function(){t.showRow(this,a)}),a.raise("footable_page_filled")},t.showRow=function(t,a){var i=e(t),o=i.next(),n=e(a.table);n.hasClass("breakpoint")&&i.hasClass("footable-detail-show")&&o.hasClass("footable-row-detail")?(i.add(o).show(),a.createOrUpdateDetailRow(t)):i.show()}}if(t.footable===undefined||null===t.footable)throw Error("Please check and make sure footable.js is included in the page and is loaded prior to this script.");var o={paginate:!0,pageSize:10,pageNavigation:".pagination",firstText:"&laquo;",previousText:"&lsaquo;",nextText:"&rsaquo;",lastText:"&raquo;",limitNavigation:0,limitPreviousText:"...",limitNextText:"..."};t.footable.plugins.register(i,o)})(jQuery,window);
(function(t,e,undefined){function a(){var e=this;e.name="Footable Filter",e.init=function(a){if(e.footable=a,a.options.filter.enabled===!0){if(t(a.table).data("filter")===!1)return;a.timers.register("filter"),t(a.table).unbind(".filtering").bind({"footable_initialized.filtering":function(){var i=t(a.table),o={input:i.data("filter")||a.options.filter.input,timeout:i.data("filter-timeout")||a.options.filter.timeout,minimum:i.data("filter-minimum")||a.options.filter.minimum,disableEnter:i.data("filter-disable-enter")||a.options.filter.disableEnter};o.disableEnter&&t(o.input).keypress(function(t){return window.event?13!==window.event.keyCode:13!==t.which}),i.bind("footable_clear_filter",function(){t(o.input).val(""),e.clearFilter()}),i.bind("footable_filter",function(t,a){e.filter(a.filter)}),t(o.input).keyup(function(i){a.timers.filter.stop(),27===i.which&&t(o.input).val(""),a.timers.filter.start(function(){var a=t(o.input).val()||"";e.filter(a)},o.timeout)})},"footable_redrawn.filtering":function(){var i=t(a.table),o=i.data("filter-string");o&&e.filter(o)}}).data("footable-filter",e)}},e.filter=function(a){var i=e.footable,o=t(i.table),n=o.data("filter-minimum")||i.options.filter.minimum,r=!a,l=i.raise("footable_filtering",{filter:a,clear:r});if(!(l&&l.result===!1||l.filter&&n>l.filter.length))if(l.clear)e.clearFilter();else{var d=l.filter.split(" ");o.find("> tbody > tr").hide().addClass("footable-filtered");var s=o.find("> tbody > tr:not(.footable-row-detail)");t.each(d,function(t,e){e&&e.length>0&&(o.data("current-filter",e),s=s.filter(i.options.filter.filterFunction))}),s.each(function(){e.showRow(this,i),t(this).removeClass("footable-filtered")}),o.data("filter-string",l.filter),i.raise("footable_filtered",{filter:l.filter,clear:!1})}},e.clearFilter=function(){var a=e.footable,i=t(a.table);i.find("> tbody > tr:not(.footable-row-detail)").removeClass("footable-filtered").each(function(){e.showRow(this,a)}),i.removeData("filter-string"),a.raise("footable_filtered",{clear:!0})},e.showRow=function(e,a){var i=t(e),o=i.next(),n=t(a.table);i.is(":visible")||(n.hasClass("breakpoint")&&i.hasClass("footable-detail-show")&&o.hasClass("footable-row-detail")?(i.add(o).show(),a.createOrUpdateDetailRow(e)):i.show())}}if(e.footable===undefined||null===e.footable)throw Error("Please check and make sure footable.js is included in the page and is loaded prior to this script.");var i={filter:{enabled:!0,input:".footable-filter",timeout:300,minimum:2,disableEnter:!1,filterFunction:function(){var e=t(this),a=e.parents("table:first"),i=a.data("current-filter").toUpperCase(),o=e.find("td").text();return a.data("filter-text-only")||e.find("td[data-value]").each(function(){o+=t(this).data("value")}),o.toUpperCase().indexOf(i)>=0}}};e.footable.plugins.register(a,i)})(jQuery,window);
(function(t,e,undefined){function a(){var e=this;e.name="Footable Sortable",e.init=function(a){e.footable=a,a.options.sort===!0&&t(a.table).unbind(".sorting").bind({"footable_initialized.sorting":function(){var i,o,n=t(a.table),r=(n.find("> tbody"),a.options.classes.sort);if(n.data("sort")!==!1){n.find("> thead > tr:last-child > th, > thead > tr:last-child > td").each(function(){var e=t(this),i=a.columns[e.index()];i.sort.ignore===!0||e.hasClass(r.sortable)||(e.addClass(r.sortable),t("<span />").addClass(r.indicator).appendTo(e))}),n.find("> thead > tr:last-child > th."+r.sortable+", > thead > tr:last-child > td."+r.sortable).unbind("click.footable").bind("click.footable",function(a){a.preventDefault(),o=t(this);var i=!o.hasClass(r.sorted);return e.doSort(o.index(),i),!1});var l=!1;for(var s in a.columns)if(i=a.columns[s],i.sort.initial){var d="descending"!==i.sort.initial;e.doSort(i.index,d);break}l&&a.bindToggleSelectors()}},"footable_redrawn.sorting":function(){var i=t(a.table),o=a.options.classes.sort;i.data("sorted")>=0&&i.find("> thead > tr:last-child > th").each(function(a){var i=t(this);return i.hasClass(o.sorted)||i.hasClass(o.descending)?(e.doSort(a),undefined):undefined})},"footable_column_data.sorting":function(e){var a=t(e.column.th);e.column.data.sort=e.column.data.sort||{},e.column.data.sort.initial=a.data("sort-initial")||!1,e.column.data.sort.ignore=a.data("sort-ignore")||!1,e.column.data.sort.selector=a.data("sort-selector")||null;var i=a.data("sort-match")||0;i>=e.column.data.matches.length&&(i=0),e.column.data.sort.match=e.column.data.matches[i]}}).data("footable-sort",e)},e.doSort=function(a,i){var o=e.footable;if(t(o.table).data("sort")!==!1){var n=t(o.table),r=n.find("> tbody"),l=o.columns[a],s=n.find("> thead > tr:last-child > th:eq("+a+")"),d=o.options.classes.sort,f=o.options.events.sort;if(i=i===undefined?s.hasClass(d.sorted):"toggle"===i?!s.hasClass(d.sorted):i,l.sort.ignore===!0)return!0;var u=o.raise(f.sorting,{column:l,direction:i?"ASC":"DESC"});u&&u.result===!1||(n.data("sorted",l.index),n.find("> thead > tr:last-child > th, > thead > tr:last-child > td").not(s).removeClass(d.sorted+" "+d.descending),i===undefined&&(i=s.hasClass(d.sorted)),i?s.removeClass(d.descending).addClass(d.sorted):s.removeClass(d.sorted).addClass(d.descending),e.sort(o,r,l,i),o.bindToggleSelectors(),o.raise(f.sorted,{column:l,direction:i?"ASC":"DESC"}))}},e.rows=function(e,a,i){var o=[];return a.find("> tr").each(function(){var a=t(this),n=null;if(a.hasClass(e.options.classes.detail))return!0;a.next().hasClass(e.options.classes.detail)&&(n=a.next().get(0));var r={row:a,detail:n};return i!==undefined&&(r.value=e.parse(this.cells[i.sort.match],i)),o.push(r),!0}).detach(),o},e.sort=function(t,a,i,o){var n=e.rows(t,a,i),r=t.options.sorters[i.type]||t.options.sorters.alpha;n.sort(function(t,e){return o?r(t.value,e.value):r(e.value,t.value)});for(var l=0;n.length>l;l++)a.append(n[l].row),null!==n[l].detail&&a.append(n[l].detail)}}if(e.footable===undefined||null===e.footable)throw Error("Please check and make sure footable.js is included in the page and is loaded prior to this script.");var i={sort:!0,sorters:{alpha:function(t,e){return"string"==typeof t&&(t=t.toLowerCase()),"string"==typeof e&&(e=e.toLowerCase()),t===e?0:e>t?-1:1},numeric:function(t,e){return t-e}},classes:{sort:{sortable:"footable-sortable",sorted:"footable-sorted",descending:"footable-sorted-desc",indicator:"footable-sort-indicator"}},events:{sort:{sorting:"footable_sorting",sorted:"footable_sorted"}}};e.footable.plugins.register(a,i)})(jQuery,window);